(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4759"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4759"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7HZRt", function(module, exports) {

$parcel$export(module.exports, "_config", function () { return _config; });
$parcel$export(module.exports, "_isString", function () { return _isString; });
$parcel$export(module.exports, "_isUndefined", function () { return _isUndefined; });
$parcel$export(module.exports, "_numExp", function () { return _numExp; });
$parcel$export(module.exports, "_numWithUnitExp", function () { return _numWithUnitExp; });
$parcel$export(module.exports, "_relExp", function () { return _relExp; });
$parcel$export(module.exports, "gsap", function () { return gsap; });
$parcel$export(module.exports, "_missingPlugin", function () { return _missingPlugin; });
$parcel$export(module.exports, "_plugins", function () { return _plugins; });
$parcel$export(module.exports, "GSCache", function () { return GSCache; });
$parcel$export(module.exports, "_getCache", function () { return _getCache; });
$parcel$export(module.exports, "_getProperty", function () { return _getProperty; });
$parcel$export(module.exports, "_forEachName", function () { return _forEachName; });
$parcel$export(module.exports, "_round", function () { return _round; });
$parcel$export(module.exports, "_parseRelative", function () { return _parseRelative; });
$parcel$export(module.exports, "_ticker", function () { return _ticker; });
$parcel$export(module.exports, "getUnit", function () { return getUnit; });
$parcel$export(module.exports, "_replaceRandom", function () { return _replaceRandom; });
$parcel$export(module.exports, "_getSetter", function () { return _getSetter; });
$parcel$export(module.exports, "PropTween", function () { return PropTween; });
$parcel$export(module.exports, "_colorExp", function () { return _colorExp; });
$parcel$export(module.exports, "_colorStringFilter", function () { return _colorStringFilter; });
$parcel$export(module.exports, "_renderComplexString", function () { return _renderComplexString; });
$parcel$export(module.exports, "_checkPlugin", function () { return _checkPlugin; });
$parcel$export(module.exports, "_sortPropTweensByPriority", function () { return _sortPropTweensByPriority; });
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
/*!
 * GSAP 3.12.5
 * https://gsap.com
 *
 * @license Copyright 2008-2024, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var _config = {
    autoSleep: 120,
    force3D: "auto",
    nullTargetWarn: 1,
    units: {
        lineHeight: ""
    }
}, _defaults = {
    duration: .5,
    overwrite: false,
    delay: 0
}, _suppressOverwrites, _reverting, _context, _bigNum = 1e8, _tinyNum = 1 / _bigNum, _2PI = Math.PI * 2, _HALF_PI = _2PI / 4, _gsID = 0, _sqrt = Math.sqrt, _cos = Math.cos, _sin = Math.sin, _isString = function _isString(value) {
    return typeof value === "string";
}, _isFunction = function _isFunction(value) {
    return typeof value === "function";
}, _isNumber = function _isNumber(value) {
    return typeof value === "number";
}, _isUndefined = function _isUndefined(value) {
    return typeof value === "undefined";
}, _isObject = function _isObject(value) {
    return typeof value === "object";
}, _isNotFalse = function _isNotFalse(value) {
    return value !== false;
}, _windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, _isFuncOrString = function _isFuncOrString(value) {
    return _isFunction(value) || _isString(value);
}, _isTypedArray = typeof ArrayBuffer === "function" && ArrayBuffer.isView || function() {}, // note: IE10 has ArrayBuffer, but NOT ArrayBuffer.isView().
_isArray = Array.isArray, _strictNumExp = /(?:-?\.?\d|\.)+/gi, //only numbers (including negatives and decimals) but NOT relative values.
_numExp = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g, //finds any numbers, including ones that start with += or -=, negative numbers, and ones in scientific notation like 1e-8.
_numWithUnitExp = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g, _complexStringNumExp = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi, //duplicate so that while we're looping through matches from exec(), it doesn't contaminate the lastIndex of _numExp which we use to search for colors too.
_relExp = /[+-]=-?[.\d]+/, _delimitedValueExp = /[^,'"\[\]\s]+/gi, // previously /[#\-+.]*\b[a-z\d\-=+%.]+/gi but didn't catch special characters.
_unitExp = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i, _globalTimeline, _win, _coreInitted, _doc, _globals = {}, _installScope = {}, _coreReady, _install = function _install(scope) {
    return (_installScope = _merge(scope, _globals)) && gsap;
}, _missingPlugin = function _missingPlugin(property, value) {
    return console.warn("Invalid property", property, "set to", value, "Missing plugin? gsap.registerPlugin()");
}, _warn = function _warn(message, suppress) {
    return !suppress && console.warn(message);
}, _addGlobal = function _addGlobal(name, obj) {
    return name && (_globals[name] = obj) && _installScope && (_installScope[name] = obj) || _globals;
}, _emptyFunc = function _emptyFunc() {
    return 0;
}, _startAtRevertConfig = {
    suppressEvents: true,
    isStart: true,
    kill: false
}, _revertConfigNoKill = {
    suppressEvents: true,
    kill: false
}, _revertConfig = {
    suppressEvents: true
}, _reservedProps = {}, _lazyTweens = [], _lazyLookup = {}, _lastRenderedFrame, _plugins = {}, _effects = {}, _nextGCFrame = 30, _harnessPlugins = [], _callbackNames = "", _harness = function _harness(targets) {
    var target = targets[0], harnessPlugin, i;
    _isObject(target) || _isFunction(target) || (targets = [
        targets
    ]);
    if (!(harnessPlugin = (target._gsap || {}).harness)) {
        // find the first target with a harness. We assume targets passed into an animation will be of similar type, meaning the same kind of harness can be used for them all (performance optimization)
        i = _harnessPlugins.length;
        while(i-- && !_harnessPlugins[i].targetTest(target));
        harnessPlugin = _harnessPlugins[i];
    }
    i = targets.length;
    while(i--)targets[i] && (targets[i]._gsap || (targets[i]._gsap = new GSCache(targets[i], harnessPlugin))) || targets.splice(i, 1);
    return targets;
}, _getCache = function _getCache(target) {
    return target._gsap || _harness(toArray(target))[0]._gsap;
}, _getProperty = function _getProperty(target, property, v) {
    return (v = target[property]) && _isFunction(v) ? target[property]() : _isUndefined(v) && target.getAttribute && target.getAttribute(property) || v;
}, _forEachName = function _forEachName(names, func) {
    return (names = names.split(",")).forEach(func) || names;
}, //split a comma-delimited list of names into an array, then run a forEach() function and return the split array (this is just a way to consolidate/shorten some code).
_round = function _round(value) {
    return Math.round(value * 100000) / 100000 || 0;
}, _roundPrecise = function _roundPrecise(value) {
    return Math.round(value * 10000000) / 10000000 || 0;
}, // increased precision mostly for timing values.
_parseRelative = function _parseRelative(start, value) {
    var operator = value.charAt(0), end = parseFloat(value.substr(2));
    start = parseFloat(start);
    return operator === "+" ? start + end : operator === "-" ? start - end : operator === "*" ? start * end : start / end;
}, _arrayContainsAny = function _arrayContainsAny(toSearch, toFind) {
    //searches one array to find matches for any of the items in the toFind array. As soon as one is found, it returns true. It does NOT return all the matches; it's simply a boolean search.
    var l = toFind.length, i = 0;
    for(; toSearch.indexOf(toFind[i]) < 0 && ++i < l;);
    return i < l;
}, _lazyRender = function _lazyRender() {
    var l = _lazyTweens.length, a = _lazyTweens.slice(0), i, tween;
    _lazyLookup = {};
    _lazyTweens.length = 0;
    for(i = 0; i < l; i++){
        tween = a[i];
        tween && tween._lazy && (tween.render(tween._lazy[0], tween._lazy[1], true)._lazy = 0);
    }
}, _lazySafeRender = function _lazySafeRender(animation, time, suppressEvents, force) {
    _lazyTweens.length && !_reverting && _lazyRender();
    animation.render(time, suppressEvents, force || _reverting && time < 0 && (animation._initted || animation._startAt));
    _lazyTweens.length && !_reverting && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when someone calls seek() or time() or progress(), they expect an immediate render.
}, _numericIfPossible = function _numericIfPossible(value) {
    var n = parseFloat(value);
    return (n || n === 0) && (value + "").match(_delimitedValueExp).length < 2 ? n : _isString(value) ? value.trim() : value;
}, _passThrough = function _passThrough(p) {
    return p;
}, _setDefaults = function _setDefaults(obj, defaults) {
    for(var p in defaults)p in obj || (obj[p] = defaults[p]);
    return obj;
}, _setKeyframeDefaults = function _setKeyframeDefaults(excludeDuration) {
    return function(obj, defaults) {
        for(var p in defaults)p in obj || p === "duration" && excludeDuration || p === "ease" || (obj[p] = defaults[p]);
    };
}, _merge = function _merge(base, toMerge) {
    for(var p in toMerge)base[p] = toMerge[p];
    return base;
}, _mergeDeep = function _mergeDeep(base, toMerge) {
    for(var p in toMerge)p !== "__proto__" && p !== "constructor" && p !== "prototype" && (base[p] = _isObject(toMerge[p]) ? _mergeDeep(base[p] || (base[p] = {}), toMerge[p]) : toMerge[p]);
    return base;
}, _copyExcluding = function _copyExcluding(obj, excluding) {
    var copy = {}, p;
    for(p in obj)p in excluding || (copy[p] = obj[p]);
    return copy;
}, _inheritDefaults = function _inheritDefaults(vars) {
    var parent = vars.parent || _globalTimeline, func = vars.keyframes ? _setKeyframeDefaults(_isArray(vars.keyframes)) : _setDefaults;
    if (_isNotFalse(vars.inherit)) while(parent){
        func(vars, parent.vars.defaults);
        parent = parent.parent || parent._dp;
    }
    return vars;
}, _arraysMatch = function _arraysMatch(a1, a2) {
    var i = a1.length, match = i === a2.length;
    while(match && i-- && a1[i] === a2[i]);
    return i < 0;
}, _addLinkedListItem = function _addLinkedListItem(parent, child, firstProp, lastProp, sortBy) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = parent[lastProp], t;
    if (sortBy) {
        t = child[sortBy];
        while(prev && prev[sortBy] > t)prev = prev._prev;
    }
    if (prev) {
        child._next = prev._next;
        prev._next = child;
    } else {
        child._next = parent[firstProp];
        parent[firstProp] = child;
    }
    if (child._next) child._next._prev = child;
    else parent[lastProp] = child;
    child._prev = prev;
    child.parent = child._dp = parent;
    return child;
}, _removeLinkedListItem = function _removeLinkedListItem(parent, child, firstProp, lastProp) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = child._prev, next = child._next;
    if (prev) prev._next = next;
    else if (parent[firstProp] === child) parent[firstProp] = next;
    if (next) next._prev = prev;
    else if (parent[lastProp] === child) parent[lastProp] = prev;
    child._next = child._prev = child.parent = null; // don't delete the _dp just so we can revert if necessary. But parent should be null to indicate the item isn't in a linked list.
}, _removeFromParent = function _removeFromParent(child, onlyIfParentHasAutoRemove) {
    child.parent && (!onlyIfParentHasAutoRemove || child.parent.autoRemoveChildren) && child.parent.remove && child.parent.remove(child);
    child._act = 0;
}, _uncache = function _uncache(animation, child) {
    if (animation && (!child || child._end > animation._dur || child._start < 0)) {
        // performance optimization: if a child animation is passed in we should only uncache if that child EXTENDS the animation (its end time is beyond the end)
        var a = animation;
        while(a){
            a._dirty = 1;
            a = a.parent;
        }
    }
    return animation;
}, _recacheAncestors = function _recacheAncestors(animation) {
    var parent = animation.parent;
    while(parent && parent.parent){
        //sometimes we must force a re-sort of all children and update the duration/totalDuration of all ancestor timelines immediately in case, for example, in the middle of a render loop, one tween alters another tween's timeScale which shoves its startTime before 0, forcing the parent timeline to shift around and shiftChildren() which could affect that next tween's render (startTime). Doesn't matter for the root timeline though.
        parent._dirty = 1;
        parent.totalDuration();
        parent = parent.parent;
    }
    return animation;
}, _rewindStartAt = function _rewindStartAt(tween, totalTime, suppressEvents, force) {
    return tween._startAt && (_reverting ? tween._startAt.revert(_revertConfigNoKill) : tween.vars.immediateRender && !tween.vars.autoRevert || tween._startAt.render(totalTime, true, force));
}, _hasNoPausedAncestors = function _hasNoPausedAncestors(animation) {
    return !animation || animation._ts && _hasNoPausedAncestors(animation.parent);
}, _elapsedCycleDuration = function _elapsedCycleDuration(animation) {
    return animation._repeat ? _animationCycle(animation._tTime, animation = animation.duration() + animation._rDelay) * animation : 0;
}, // feed in the totalTime and cycleDuration and it'll return the cycle (iteration minus 1) and if the playhead is exactly at the very END, it will NOT bump up to the next cycle.
_animationCycle = function _animationCycle(tTime, cycleDuration) {
    var whole = Math.floor(tTime /= cycleDuration);
    return tTime && whole === tTime ? whole - 1 : whole;
}, _parentToChildTotalTime = function _parentToChildTotalTime(parentTime, child) {
    return (parentTime - child._start) * child._ts + (child._ts >= 0 ? 0 : child._dirty ? child.totalDuration() : child._tDur);
}, _setEnd = function _setEnd(animation) {
    return animation._end = _roundPrecise(animation._start + (animation._tDur / Math.abs(animation._ts || animation._rts || _tinyNum) || 0));
}, _alignPlayhead = function _alignPlayhead(animation, totalTime) {
    // adjusts the animation's _start and _end according to the provided totalTime (only if the parent's smoothChildTiming is true and the animation isn't paused). It doesn't do any rendering or forcing things back into parent timelines, etc. - that's what totalTime() is for.
    var parent = animation._dp;
    if (parent && parent.smoothChildTiming && animation._ts) {
        animation._start = _roundPrecise(parent._time - (animation._ts > 0 ? totalTime / animation._ts : ((animation._dirty ? animation.totalDuration() : animation._tDur) - totalTime) / -animation._ts));
        _setEnd(animation);
        parent._dirty || _uncache(parent, animation); //for performance improvement. If the parent's cache is already dirty, it already took care of marking the ancestors as dirty too, so skip the function call here.
    }
    return animation;
}, /*
_totalTimeToTime = (clampedTotalTime, duration, repeat, repeatDelay, yoyo) => {
	let cycleDuration = duration + repeatDelay,
		time = _round(clampedTotalTime % cycleDuration);
	if (time > duration) {
		time = duration;
	}
	return (yoyo && (~~(clampedTotalTime / cycleDuration) & 1)) ? duration - time : time;
},
*/ _postAddChecks = function _postAddChecks(timeline, child) {
    var t;
    if (child._time || !child._dur && child._initted || child._start < timeline._time && (child._dur || !child.add)) {
        // in case, for example, the _start is moved on a tween that has already rendered, or if it's being inserted into a timeline BEFORE where the playhead is currently. Imagine it's at its end state, then the startTime is moved WAY later (after the end of this timeline), it should render at its beginning. Special case: if it's a timeline (has .add() method) and no duration, we can skip rendering because the user may be populating it AFTER adding it to a parent timeline (unconventional, but possible, and we wouldn't want it to get removed if the parent's autoRemoveChildren is true).
        t = _parentToChildTotalTime(timeline.rawTime(), child);
        if (!child._dur || _clamp(0, child.totalDuration(), t) - child._tTime > _tinyNum) child.render(t, true);
    } //if the timeline has already ended but the inserted tween/timeline extends the duration, we should enable this timeline again so that it renders properly. We should also align the playhead with the parent timeline's when appropriate.
    if (_uncache(timeline, child)._dp && timeline._initted && timeline._time >= timeline._dur && timeline._ts) {
        //in case any of the ancestors had completed but should now be enabled...
        if (timeline._dur < timeline.duration()) {
            t = timeline;
            while(t._dp){
                t.rawTime() >= 0 && t.totalTime(t._tTime); //moves the timeline (shifts its startTime) if necessary, and also enables it. If it's currently zero, though, it may not be scheduled to render until later so there's no need to force it to align with the current playhead position. Only move to catch up with the playhead.
                t = t._dp;
            }
        }
        timeline._zTime = -_tinyNum; // helps ensure that the next render() will be forced (crossingStart = true in render()), even if the duration hasn't changed (we're adding a child which would need to get rendered). Definitely an edge case. Note: we MUST do this AFTER the loop above where the totalTime() might trigger a render() because this _addToTimeline() method gets called from the Animation constructor, BEFORE tweens even record their targets, etc. so we wouldn't want things to get triggered in the wrong order.
    }
}, _addToTimeline = function _addToTimeline(timeline, child, position, skipChecks) {
    child.parent && _removeFromParent(child);
    child._start = _roundPrecise((_isNumber(position) ? position : position || timeline !== _globalTimeline ? _parsePosition(timeline, position, child) : timeline._time) + child._delay);
    child._end = _roundPrecise(child._start + (child.totalDuration() / Math.abs(child.timeScale()) || 0));
    _addLinkedListItem(timeline, child, "_first", "_last", timeline._sort ? "_start" : 0);
    _isFromOrFromStart(child) || (timeline._recent = child);
    skipChecks || _postAddChecks(timeline, child);
    timeline._ts < 0 && _alignPlayhead(timeline, timeline._tTime); // if the timeline is reversed and the new child makes it longer, we may need to adjust the parent's _start (push it back)
    return timeline;
}, _scrollTrigger = function _scrollTrigger(animation, trigger) {
    return (_globals.ScrollTrigger || _missingPlugin("scrollTrigger", trigger)) && _globals.ScrollTrigger.create(trigger, animation);
}, _attemptInitTween = function _attemptInitTween(tween, time, force, suppressEvents, tTime) {
    _initTween(tween, time, tTime);
    if (!tween._initted) return 1;
    if (!force && tween._pt && !_reverting && (tween._dur && tween.vars.lazy !== false || !tween._dur && tween.vars.lazy) && _lastRenderedFrame !== _ticker.frame) {
        _lazyTweens.push(tween);
        tween._lazy = [
            tTime,
            suppressEvents
        ];
        return 1;
    }
}, _parentPlayheadIsBeforeStart = function _parentPlayheadIsBeforeStart(_ref) {
    var parent = _ref.parent;
    return parent && parent._ts && parent._initted && !parent._lock && (parent.rawTime() < 0 || _parentPlayheadIsBeforeStart(parent));
}, // check parent's _lock because when a timeline repeats/yoyos and does its artificial wrapping, we shouldn't force the ratio back to 0
_isFromOrFromStart = function _isFromOrFromStart(_ref2) {
    var data = _ref2.data;
    return data === "isFromStart" || data === "isStart";
}, _renderZeroDurationTween = function _renderZeroDurationTween(tween, totalTime, suppressEvents, force) {
    var prevRatio = tween.ratio, ratio = totalTime < 0 || !totalTime && (!tween._start && _parentPlayheadIsBeforeStart(tween) && !(!tween._initted && _isFromOrFromStart(tween)) || (tween._ts < 0 || tween._dp._ts < 0) && !_isFromOrFromStart(tween)) ? 0 : 1, // if the tween or its parent is reversed and the totalTime is 0, we should go to a ratio of 0. Edge case: if a from() or fromTo() stagger tween is placed later in a timeline, the "startAt" zero-duration tween could initially render at a time when the parent timeline's playhead is technically BEFORE where this tween is, so make sure that any "from" and "fromTo" startAt tweens are rendered the first time at a ratio of 1.
    repeatDelay = tween._rDelay, tTime = 0, pt, iteration, prevIteration;
    if (repeatDelay && tween._repeat) {
        // in case there's a zero-duration tween that has a repeat with a repeatDelay
        tTime = _clamp(0, tween._tDur, totalTime);
        iteration = _animationCycle(tTime, repeatDelay);
        tween._yoyo && iteration & 1 && (ratio = 1 - ratio);
        if (iteration !== _animationCycle(tween._tTime, repeatDelay)) {
            // if iteration changed
            prevRatio = 1 - ratio;
            tween.vars.repeatRefresh && tween._initted && tween.invalidate();
        }
    }
    if (ratio !== prevRatio || _reverting || force || tween._zTime === _tinyNum || !totalTime && tween._zTime) {
        if (!tween._initted && _attemptInitTween(tween, totalTime, force, suppressEvents, tTime)) // if we render the very beginning (time == 0) of a fromTo(), we must force the render (normal tweens wouldn't need to render at a time of 0 when the prevTime was also 0). This is also mandatory to make sure overwriting kicks in immediately.
        return;
        prevIteration = tween._zTime;
        tween._zTime = totalTime || (suppressEvents ? _tinyNum : 0); // when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
        suppressEvents || (suppressEvents = totalTime && !prevIteration); // if it was rendered previously at exactly 0 (_zTime) and now the playhead is moving away, DON'T fire callbacks otherwise they'll seem like duplicates.
        tween.ratio = ratio;
        tween._from && (ratio = 1 - ratio);
        tween._time = 0;
        tween._tTime = tTime;
        pt = tween._pt;
        while(pt){
            pt.r(ratio, pt.d);
            pt = pt._next;
        }
        totalTime < 0 && _rewindStartAt(tween, totalTime, suppressEvents, true);
        tween._onUpdate && !suppressEvents && _callback(tween, "onUpdate");
        tTime && tween._repeat && !suppressEvents && tween.parent && _callback(tween, "onRepeat");
        if ((totalTime >= tween._tDur || totalTime < 0) && tween.ratio === ratio) {
            ratio && _removeFromParent(tween, 1);
            if (!suppressEvents && !_reverting) {
                _callback(tween, ratio ? "onComplete" : "onReverseComplete", true);
                tween._prom && tween._prom();
            }
        }
    } else if (!tween._zTime) tween._zTime = totalTime;
}, _findNextPauseTween = function _findNextPauseTween(animation, prevTime, time) {
    var child;
    if (time > prevTime) {
        child = animation._first;
        while(child && child._start <= time){
            if (child.data === "isPause" && child._start > prevTime) return child;
            child = child._next;
        }
    } else {
        child = animation._last;
        while(child && child._start >= time){
            if (child.data === "isPause" && child._start < prevTime) return child;
            child = child._prev;
        }
    }
}, _setDuration = function _setDuration(animation, duration, skipUncache, leavePlayhead) {
    var repeat = animation._repeat, dur = _roundPrecise(duration) || 0, totalProgress = animation._tTime / animation._tDur;
    totalProgress && !leavePlayhead && (animation._time *= dur / animation._dur);
    animation._dur = dur;
    animation._tDur = !repeat ? dur : repeat < 0 ? 1e10 : _roundPrecise(dur * (repeat + 1) + animation._rDelay * repeat);
    totalProgress > 0 && !leavePlayhead && _alignPlayhead(animation, animation._tTime = animation._tDur * totalProgress);
    animation.parent && _setEnd(animation);
    skipUncache || _uncache(animation.parent, animation);
    return animation;
}, _onUpdateTotalDuration = function _onUpdateTotalDuration(animation) {
    return animation instanceof Timeline ? _uncache(animation) : _setDuration(animation, animation._dur);
}, _zeroPosition = {
    _start: 0,
    endTime: _emptyFunc,
    totalDuration: _emptyFunc
}, _parsePosition = function _parsePosition(animation, position, percentAnimation) {
    var labels = animation.labels, recent = animation._recent || _zeroPosition, clippedDuration = animation.duration() >= _bigNum ? recent.endTime(false) : animation._dur, //in case there's a child that infinitely repeats, users almost never intend for the insertion point of a new child to be based on a SUPER long value like that so we clip it and assume the most recently-added child's endTime should be used instead.
    i, offset, isPercent;
    if (_isString(position) && (isNaN(position) || position in labels)) {
        //if the string is a number like "1", check to see if there's a label with that name, otherwise interpret it as a number (absolute value).
        offset = position.charAt(0);
        isPercent = position.substr(-1) === "%";
        i = position.indexOf("=");
        if (offset === "<" || offset === ">") {
            i >= 0 && (position = position.replace(/=/, ""));
            return (offset === "<" ? recent._start : recent.endTime(recent._repeat >= 0)) + (parseFloat(position.substr(1)) || 0) * (isPercent ? (i < 0 ? recent : percentAnimation).totalDuration() / 100 : 1);
        }
        if (i < 0) {
            position in labels || (labels[position] = clippedDuration);
            return labels[position];
        }
        offset = parseFloat(position.charAt(i - 1) + position.substr(i + 1));
        if (isPercent && percentAnimation) offset = offset / 100 * (_isArray(percentAnimation) ? percentAnimation[0] : percentAnimation).totalDuration();
        return i > 1 ? _parsePosition(animation, position.substr(0, i - 1), percentAnimation) + offset : clippedDuration + offset;
    }
    return position == null ? clippedDuration : +position;
}, _createTweenType = function _createTweenType(type, params, timeline) {
    var isLegacy = _isNumber(params[1]), varsIndex = (isLegacy ? 2 : 1) + (type < 2 ? 0 : 1), vars = params[varsIndex], irVars, parent;
    isLegacy && (vars.duration = params[1]);
    vars.parent = timeline;
    if (type) {
        irVars = vars;
        parent = timeline;
        while(parent && !("immediateRender" in irVars)){
            // inheritance hasn't happened yet, but someone may have set a default in an ancestor timeline. We could do vars.immediateRender = _isNotFalse(_inheritDefaults(vars).immediateRender) but that'd exact a slight performance penalty because _inheritDefaults() also runs in the Tween constructor. We're paying a small kb price here to gain speed.
            irVars = parent.vars.defaults || {};
            parent = _isNotFalse(parent.vars.inherit) && parent.parent;
        }
        vars.immediateRender = _isNotFalse(irVars.immediateRender);
        type < 2 ? vars.runBackwards = 1 : vars.startAt = params[varsIndex - 1]; // "from" vars
    }
    return new Tween(params[0], vars, params[varsIndex + 1]);
}, _conditionalReturn = function _conditionalReturn(value, func) {
    return value || value === 0 ? func(value) : func;
}, _clamp = function _clamp(min, max, value) {
    return value < min ? min : value > max ? max : value;
}, getUnit = function getUnit(value, v) {
    return !_isString(value) || !(v = _unitExp.exec(value)) ? "" : v[1];
}, // note: protect against padded numbers as strings, like "100.100". That shouldn't return "00" as the unit. If it's numeric, return no unit.
clamp = function clamp(min, max, value) {
    return _conditionalReturn(value, function(v) {
        return _clamp(min, max, v);
    });
}, _slice = [].slice, _isArrayLike = function _isArrayLike(value, nonEmpty) {
    return value && _isObject(value) && "length" in value && (!nonEmpty && !value.length || value.length - 1 in value && _isObject(value[0])) && !value.nodeType && value !== _win;
}, _flatten = function _flatten(ar, leaveStrings, accumulator) {
    if (accumulator === void 0) accumulator = [];
    return ar.forEach(function(value) {
        var _accumulator;
        return _isString(value) && !leaveStrings || _isArrayLike(value, 1) ? (_accumulator = accumulator).push.apply(_accumulator, toArray(value)) : accumulator.push(value);
    }) || accumulator;
}, //takes any value and returns an array. If it's a string (and leaveStrings isn't true), it'll use document.querySelectorAll() and convert that to an array. It'll also accept iterables like jQuery objects.
toArray = function toArray(value, scope, leaveStrings) {
    return _context && !scope && _context.selector ? _context.selector(value) : _isString(value) && !leaveStrings && (_coreInitted || !_wake()) ? _slice.call((scope || _doc).querySelectorAll(value), 0) : _isArray(value) ? _flatten(value, leaveStrings) : _isArrayLike(value) ? _slice.call(value, 0) : value ? [
        value
    ] : [];
}, selector = function selector(value) {
    value = toArray(value)[0] || _warn("Invalid scope") || {};
    return function(v) {
        var el = value.current || value.nativeElement || value;
        return toArray(v, el.querySelectorAll ? el : el === value ? _warn("Invalid scope") || _doc.createElement("div") : value);
    };
}, shuffle = function shuffle(a) {
    return a.sort(function() {
        return .5 - Math.random();
    });
}, // alternative that's a bit faster and more reliably diverse but bigger:   for (let j, v, i = a.length; i; j = Math.floor(Math.random() * i), v = a[--i], a[i] = a[j], a[j] = v); return a;
//for distributing values across an array. Can accept a number, a function or (most commonly) a function which can contain the following properties: {base, amount, from, ease, grid, axis, length, each}. Returns a function that expects the following parameters: index, target, array. Recognizes the following
distribute = function distribute(v) {
    if (_isFunction(v)) return v;
    var vars = _isObject(v) ? v : {
        each: v
    }, //n:1 is just to indicate v was a number; we leverage that later to set v according to the length we get. If a number is passed in, we treat it like the old stagger value where 0.1, for example, would mean that things would be distributed with 0.1 between each element in the array rather than a total "amount" that's chunked out among them all.
    ease = _parseEase(vars.ease), from = vars.from || 0, base = parseFloat(vars.base) || 0, cache = {}, isDecimal = from > 0 && from < 1, ratios = isNaN(from) || isDecimal, axis = vars.axis, ratioX = from, ratioY = from;
    if (_isString(from)) ratioX = ratioY = ({
        center: .5,
        edges: .5,
        end: 1
    })[from] || 0;
    else if (!isDecimal && ratios) {
        ratioX = from[0];
        ratioY = from[1];
    }
    return function(i, target, a) {
        var l = (a || vars).length, distances = cache[l], originX, originY, x, y, d, j, max, min, wrapAt;
        if (!distances) {
            wrapAt = vars.grid === "auto" ? 0 : (vars.grid || [
                1,
                _bigNum
            ])[1];
            if (!wrapAt) {
                max = -_bigNum;
                while(max < (max = a[wrapAt++].getBoundingClientRect().left) && wrapAt < l);
                wrapAt < l && wrapAt--;
            }
            distances = cache[l] = [];
            originX = ratios ? Math.min(wrapAt, l) * ratioX - .5 : from % wrapAt;
            originY = wrapAt === _bigNum ? 0 : ratios ? l * ratioY / wrapAt - .5 : from / wrapAt | 0;
            max = 0;
            min = _bigNum;
            for(j = 0; j < l; j++){
                x = j % wrapAt - originX;
                y = originY - (j / wrapAt | 0);
                distances[j] = d = !axis ? _sqrt(x * x + y * y) : Math.abs(axis === "y" ? y : x);
                d > max && (max = d);
                d < min && (min = d);
            }
            from === "random" && shuffle(distances);
            distances.max = max - min;
            distances.min = min;
            distances.v = l = (parseFloat(vars.amount) || parseFloat(vars.each) * (wrapAt > l ? l - 1 : !axis ? Math.max(wrapAt, l / wrapAt) : axis === "y" ? l / wrapAt : wrapAt) || 0) * (from === "edges" ? -1 : 1);
            distances.b = l < 0 ? base - l : base;
            distances.u = getUnit(vars.amount || vars.each) || 0; //unit
            ease = ease && l < 0 ? _invertEase(ease) : ease;
        }
        l = (distances[i] - distances.min) / distances.max || 0;
        return _roundPrecise(distances.b + (ease ? ease(l) : l) * distances.v) + distances.u; //round in order to work around floating point errors
    };
}, _roundModifier = function _roundModifier(v) {
    //pass in 0.1 get a function that'll round to the nearest tenth, or 5 to round to the closest 5, or 0.001 to the closest 1000th, etc.
    var p = Math.pow(10, ((v + "").split(".")[1] || "").length); //to avoid floating point math errors (like 24 * 0.1 == 2.4000000000000004), we chop off at a specific number of decimal places (much faster than toFixed())
    return function(raw) {
        var n = _roundPrecise(Math.round(parseFloat(raw) / v) * v * p);
        return (n - n % 1) / p + (_isNumber(raw) ? 0 : getUnit(raw)); // n - n % 1 replaces Math.floor() in order to handle negative values properly. For example, Math.floor(-150.00000000000003) is 151!
    };
}, snap = function snap(snapTo, value) {
    var isArray = _isArray(snapTo), radius, is2D;
    if (!isArray && _isObject(snapTo)) {
        radius = isArray = snapTo.radius || _bigNum;
        if (snapTo.values) {
            snapTo = toArray(snapTo.values);
            if (is2D = !_isNumber(snapTo[0])) radius *= radius; //performance optimization so we don't have to Math.sqrt() in the loop.
        } else snapTo = _roundModifier(snapTo.increment);
    }
    return _conditionalReturn(value, !isArray ? _roundModifier(snapTo) : _isFunction(snapTo) ? function(raw) {
        is2D = snapTo(raw);
        return Math.abs(is2D - raw) <= radius ? is2D : raw;
    } : function(raw) {
        var x = parseFloat(is2D ? raw.x : raw), y = parseFloat(is2D ? raw.y : 0), min = _bigNum, closest = 0, i = snapTo.length, dx, dy;
        while(i--){
            if (is2D) {
                dx = snapTo[i].x - x;
                dy = snapTo[i].y - y;
                dx = dx * dx + dy * dy;
            } else dx = Math.abs(snapTo[i] - x);
            if (dx < min) {
                min = dx;
                closest = i;
            }
        }
        closest = !radius || min <= radius ? snapTo[closest] : raw;
        return is2D || closest === raw || _isNumber(raw) ? closest : closest + getUnit(raw);
    });
}, random = function random(min, max, roundingIncrement, returnFunction) {
    return _conditionalReturn(_isArray(min) ? !max : roundingIncrement === true ? (roundingIncrement = 0, false) : !returnFunction, function() {
        return _isArray(min) ? min[~~(Math.random() * min.length)] : (roundingIncrement = roundingIncrement || 1e-5, returnFunction = roundingIncrement < 1 ? Math.pow(10, (roundingIncrement + "").length - 2) : 1) && Math.floor(Math.round((min - roundingIncrement / 2 + Math.random() * (max - min + roundingIncrement * .99)) / roundingIncrement) * roundingIncrement * returnFunction) / returnFunction;
    });
}, pipe = function pipe() {
    for(var _len = arguments.length, functions = new Array(_len), _key = 0; _key < _len; _key++)functions[_key] = arguments[_key];
    return function(value) {
        return functions.reduce(function(v, f) {
            return f(v);
        }, value);
    };
}, unitize = function unitize(func, unit) {
    return function(value) {
        return func(parseFloat(value)) + (unit || getUnit(value));
    };
}, normalize = function normalize(min, max, value) {
    return mapRange(min, max, 0, 1, value);
}, _wrapArray = function _wrapArray(a, wrapper, value) {
    return _conditionalReturn(value, function(index) {
        return a[~~wrapper(index)];
    });
}, wrap = function wrap(min, max, value) {
    // NOTE: wrap() CANNOT be an arrow function! A very odd compiling bug causes problems (unrelated to GSAP).
    var range = max - min;
    return _isArray(min) ? _wrapArray(min, wrap(0, min.length), max) : _conditionalReturn(value, function(value) {
        return (range + (value - min) % range) % range + min;
    });
}, wrapYoyo = function wrapYoyo(min, max, value) {
    var range = max - min, total = range * 2;
    return _isArray(min) ? _wrapArray(min, wrapYoyo(0, min.length - 1), max) : _conditionalReturn(value, function(value) {
        value = (total + (value - min) % total) % total || 0;
        return min + (value > range ? total - value : value);
    });
}, _replaceRandom = function _replaceRandom(value) {
    //replaces all occurrences of random(...) in a string with the calculated random value. can be a range like random(-100, 100, 5) or an array like random([0, 100, 500])
    var prev = 0, s = "", i, nums, end, isArray;
    while(~(i = value.indexOf("random(", prev))){
        end = value.indexOf(")", i);
        isArray = value.charAt(i + 7) === "[";
        nums = value.substr(i + 7, end - i - 7).match(isArray ? _delimitedValueExp : _strictNumExp);
        s += value.substr(prev, i - prev) + random(isArray ? nums : +nums[0], isArray ? 0 : +nums[1], +nums[2] || 1e-5);
        prev = end + 1;
    }
    return s + value.substr(prev, value.length - prev);
}, mapRange = function mapRange(inMin, inMax, outMin, outMax, value) {
    var inRange = inMax - inMin, outRange = outMax - outMin;
    return _conditionalReturn(value, function(value) {
        return outMin + ((value - inMin) / inRange * outRange || 0);
    });
}, interpolate = function interpolate(start, end, progress, mutate) {
    var func = isNaN(start + end) ? 0 : function(p) {
        return (1 - p) * start + p * end;
    };
    if (!func) {
        var isString = _isString(start), master = {}, p, i, interpolators, l, il;
        progress === true && (mutate = 1) && (progress = null);
        if (isString) {
            start = {
                p: start
            };
            end = {
                p: end
            };
        } else if (_isArray(start) && !_isArray(end)) {
            interpolators = [];
            l = start.length;
            il = l - 2;
            for(i = 1; i < l; i++)interpolators.push(interpolate(start[i - 1], start[i])); //build the interpolators up front as a performance optimization so that when the function is called many times, it can just reuse them.
            l--;
            func = function func(p) {
                p *= l;
                var i = Math.min(il, ~~p);
                return interpolators[i](p - i);
            };
            progress = end;
        } else if (!mutate) start = _merge(_isArray(start) ? [] : {}, start);
        if (!interpolators) {
            for(p in end)_addPropTween.call(master, start, p, "get", end[p]);
            func = function func(p) {
                return _renderPropTweens(p, master) || (isString ? start.p : start);
            };
        }
    }
    return _conditionalReturn(progress, func);
}, _getLabelInDirection = function _getLabelInDirection(timeline, fromTime, backward) {
    //used for nextLabel() and previousLabel()
    var labels = timeline.labels, min = _bigNum, p, distance, label;
    for(p in labels){
        distance = labels[p] - fromTime;
        if (distance < 0 === !!backward && distance && min > (distance = Math.abs(distance))) {
            label = p;
            min = distance;
        }
    }
    return label;
}, _callback = function _callback(animation, type, executeLazyFirst) {
    var v = animation.vars, callback = v[type], prevContext = _context, context = animation._ctx, params, scope, result;
    if (!callback) return;
    params = v[type + "Params"];
    scope = v.callbackScope || animation;
    executeLazyFirst && _lazyTweens.length && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onUpdate on a timeline that reports/checks tweened values.
    context && (_context = context);
    result = params ? callback.apply(scope, params) : callback.call(scope);
    _context = prevContext;
    return result;
}, _interrupt = function _interrupt(animation) {
    _removeFromParent(animation);
    animation.scrollTrigger && animation.scrollTrigger.kill(!!_reverting);
    animation.progress() < 1 && _callback(animation, "onInterrupt");
    return animation;
}, _quickTween, _registerPluginQueue = [], _createPlugin = function _createPlugin(config) {
    if (!config) return;
    config = !config.name && config["default"] || config; // UMD packaging wraps things oddly, so for example MotionPathHelper becomes {MotionPathHelper:MotionPathHelper, default:MotionPathHelper}.
    if (_windowExists() || config.headless) {
        // edge case: some build tools may pass in a null/undefined value
        var name = config.name, isFunc = _isFunction(config), Plugin = name && !isFunc && config.init ? function() {
            this._props = [];
        } : config, //in case someone passes in an object that's not a plugin, like CustomEase
        instanceDefaults = {
            init: _emptyFunc,
            render: _renderPropTweens,
            add: _addPropTween,
            kill: _killPropTweensOf,
            modifier: _addPluginModifier,
            rawVars: 0
        }, statics = {
            targetTest: 0,
            get: 0,
            getSetter: _getSetter,
            aliases: {},
            register: 0
        };
        _wake();
        if (config !== Plugin) {
            if (_plugins[name]) return;
            _setDefaults(Plugin, _setDefaults(_copyExcluding(config, instanceDefaults), statics)); //static methods
            _merge(Plugin.prototype, _merge(instanceDefaults, _copyExcluding(config, statics))); //instance methods
            _plugins[Plugin.prop = name] = Plugin;
            if (config.targetTest) {
                _harnessPlugins.push(Plugin);
                _reservedProps[name] = 1;
            }
            name = (name === "css" ? "CSS" : name.charAt(0).toUpperCase() + name.substr(1)) + "Plugin"; //for the global name. "motionPath" should become MotionPathPlugin
        }
        _addGlobal(name, Plugin);
        config.register && config.register(gsap, Plugin, PropTween);
    } else _registerPluginQueue.push(config);
}, /*
 * --------------------------------------------------------------------------------------
 * COLORS
 * --------------------------------------------------------------------------------------
 */ _255 = 255, _colorLookup = {
    aqua: [
        0,
        _255,
        _255
    ],
    lime: [
        0,
        _255,
        0
    ],
    silver: [
        192,
        192,
        192
    ],
    black: [
        0,
        0,
        0
    ],
    maroon: [
        128,
        0,
        0
    ],
    teal: [
        0,
        128,
        128
    ],
    blue: [
        0,
        0,
        _255
    ],
    navy: [
        0,
        0,
        128
    ],
    white: [
        _255,
        _255,
        _255
    ],
    olive: [
        128,
        128,
        0
    ],
    yellow: [
        _255,
        _255,
        0
    ],
    orange: [
        _255,
        165,
        0
    ],
    gray: [
        128,
        128,
        128
    ],
    purple: [
        128,
        0,
        128
    ],
    green: [
        0,
        128,
        0
    ],
    red: [
        _255,
        0,
        0
    ],
    pink: [
        _255,
        192,
        203
    ],
    cyan: [
        0,
        _255,
        _255
    ],
    transparent: [
        _255,
        _255,
        _255,
        0
    ]
}, // possible future idea to replace the hard-coded color name values - put this in the ticker.wake() where we set the _doc:
// let ctx = _doc.createElement("canvas").getContext("2d");
// _forEachName("aqua,lime,silver,black,maroon,teal,blue,navy,white,olive,yellow,orange,gray,purple,green,red,pink,cyan", color => {ctx.fillStyle = color; _colorLookup[color] = splitColor(ctx.fillStyle)});
_hue = function _hue(h, m1, m2) {
    h += h < 0 ? 1 : h > 1 ? -1 : 0;
    return (h * 6 < 1 ? m1 + (m2 - m1) * h * 6 : h < .5 ? m2 : h * 3 < 2 ? m1 + (m2 - m1) * (2 / 3 - h) * 6 : m1) * _255 + .5 | 0;
}, splitColor = function splitColor(v, toHSL, forceAlpha) {
    var a = !v ? _colorLookup.black : _isNumber(v) ? [
        v >> 16,
        v >> 8 & _255,
        v & _255
    ] : 0, r, g, b, h, s, l, max, min, d, wasHSL;
    if (!a) {
        if (v.substr(-1) === ",") //sometimes a trailing comma is included and we should chop it off (typically from a comma-delimited list of values like a textShadow:"2px 2px 2px blue, 5px 5px 5px rgb(255,0,0)" - in this example "blue," has a trailing comma. We could strip it out inside parseComplex() but we'd need to do it to the beginning and ending values plus it wouldn't provide protection from other potential scenarios like if the user passes in a similar value.
        v = v.substr(0, v.length - 1);
        if (_colorLookup[v]) a = _colorLookup[v];
        else if (v.charAt(0) === "#") {
            if (v.length < 6) {
                //for shorthand like #9F0 or #9F0F (could have alpha)
                r = v.charAt(1);
                g = v.charAt(2);
                b = v.charAt(3);
                v = "#" + r + r + g + g + b + b + (v.length === 5 ? v.charAt(4) + v.charAt(4) : "");
            }
            if (v.length === 9) {
                // hex with alpha, like #fd5e53ff
                a = parseInt(v.substr(1, 6), 16);
                return [
                    a >> 16,
                    a >> 8 & _255,
                    a & _255,
                    parseInt(v.substr(7), 16) / 255
                ];
            }
            v = parseInt(v.substr(1), 16);
            a = [
                v >> 16,
                v >> 8 & _255,
                v & _255
            ];
        } else if (v.substr(0, 3) === "hsl") {
            a = wasHSL = v.match(_strictNumExp);
            if (!toHSL) {
                h = +a[0] % 360 / 360;
                s = +a[1] / 100;
                l = +a[2] / 100;
                g = l <= .5 ? l * (s + 1) : l + s - l * s;
                r = l * 2 - g;
                a.length > 3 && (a[3] *= 1); //cast as number
                a[0] = _hue(h + 1 / 3, r, g);
                a[1] = _hue(h, r, g);
                a[2] = _hue(h - 1 / 3, r, g);
            } else if (~v.indexOf("=")) {
                //if relative values are found, just return the raw strings with the relative prefixes in place.
                a = v.match(_numExp);
                forceAlpha && a.length < 4 && (a[3] = 1);
                return a;
            }
        } else a = v.match(_strictNumExp) || _colorLookup.transparent;
        a = a.map(Number);
    }
    if (toHSL && !wasHSL) {
        r = a[0] / _255;
        g = a[1] / _255;
        b = a[2] / _255;
        max = Math.max(r, g, b);
        min = Math.min(r, g, b);
        l = (max + min) / 2;
        if (max === min) h = s = 0;
        else {
            d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            h = max === r ? (g - b) / d + (g < b ? 6 : 0) : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
            h *= 60;
        }
        a[0] = ~~(h + .5);
        a[1] = ~~(s * 100 + .5);
        a[2] = ~~(l * 100 + .5);
    }
    forceAlpha && a.length < 4 && (a[3] = 1);
    return a;
}, _colorOrderData = function _colorOrderData(v) {
    // strips out the colors from the string, finds all the numeric slots (with units) and returns an array of those. The Array also has a "c" property which is an Array of the index values where the colors belong. This is to help work around issues where there's a mis-matched order of color/numeric data like drop-shadow(#f00 0px 1px 2px) and drop-shadow(0x 1px 2px #f00). This is basically a helper function used in _formatColors()
    var values = [], c = [], i = -1;
    v.split(_colorExp).forEach(function(v) {
        var a = v.match(_numWithUnitExp) || [];
        values.push.apply(values, a);
        c.push(i += a.length + 1);
    });
    values.c = c;
    return values;
}, _formatColors = function _formatColors(s, toHSL, orderMatchData) {
    var result = "", colors = (s + result).match(_colorExp), type = toHSL ? "hsla(" : "rgba(", i = 0, c, shell, d, l;
    if (!colors) return s;
    colors = colors.map(function(color) {
        return (color = splitColor(color, toHSL, 1)) && type + (toHSL ? color[0] + "," + color[1] + "%," + color[2] + "%," + color[3] : color.join(",")) + ")";
    });
    if (orderMatchData) {
        d = _colorOrderData(s);
        c = orderMatchData.c;
        if (c.join(result) !== d.c.join(result)) {
            shell = s.replace(_colorExp, "1").split(_numWithUnitExp);
            l = shell.length - 1;
            for(; i < l; i++)result += shell[i] + (~c.indexOf(i) ? colors.shift() || type + "0,0,0,0)" : (d.length ? d : colors.length ? colors : orderMatchData).shift());
        }
    }
    if (!shell) {
        shell = s.split(_colorExp);
        l = shell.length - 1;
        for(; i < l; i++)result += shell[i] + colors[i];
    }
    return result + shell[l];
}, _colorExp = function() {
    var s = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b", //we'll dynamically build this Regular Expression to conserve file size. After building it, it will be able to find rgb(), rgba(), # (hexadecimal), and named color values like red, blue, purple, etc.,
    p;
    for(p in _colorLookup)s += "|" + p + "\\b";
    return new RegExp(s + ")", "gi");
}(), _hslExp = /hsl[a]?\(/, _colorStringFilter = function _colorStringFilter(a) {
    var combined = a.join(" "), toHSL;
    _colorExp.lastIndex = 0;
    if (_colorExp.test(combined)) {
        toHSL = _hslExp.test(combined);
        a[1] = _formatColors(a[1], toHSL);
        a[0] = _formatColors(a[0], toHSL, _colorOrderData(a[1])); // make sure the order of numbers/colors match with the END value.
        return true;
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TICKER
 * --------------------------------------------------------------------------------------
 */ _tickerActive, _ticker = function() {
    var _getTime = Date.now, _lagThreshold = 500, _adjustedLag = 33, _startTime = _getTime(), _lastUpdate = _startTime, _gap = 1000 / 240, _nextTime = _gap, _listeners = [], _id, _req, _raf, _self, _delta, _i, _tick = function _tick(v) {
        var elapsed = _getTime() - _lastUpdate, manual = v === true, overlap, dispatch, time, frame;
        (elapsed > _lagThreshold || elapsed < 0) && (_startTime += elapsed - _adjustedLag);
        _lastUpdate += elapsed;
        time = _lastUpdate - _startTime;
        overlap = time - _nextTime;
        if (overlap > 0 || manual) {
            frame = ++_self.frame;
            _delta = time - _self.time * 1000;
            _self.time = time = time / 1000;
            _nextTime += overlap + (overlap >= _gap ? 4 : _gap - overlap);
            dispatch = 1;
        }
        manual || (_id = _req(_tick)); //make sure the request is made before we dispatch the "tick" event so that timing is maintained. Otherwise, if processing the "tick" requires a bunch of time (like 15ms) and we're using a setTimeout() that's based on 16.7ms, it'd technically take 31.7ms between frames otherwise.
        if (dispatch) for(_i = 0; _i < _listeners.length; _i++)// use _i and check _listeners.length instead of a variable because a listener could get removed during the loop, and if that happens to an element less than the current index, it'd throw things off in the loop.
        _listeners[_i](time, _delta, frame, v);
    };
    _self = {
        time: 0,
        frame: 0,
        tick: function tick() {
            _tick(true);
        },
        deltaRatio: function deltaRatio(fps) {
            return _delta / (1000 / (fps || 60));
        },
        wake: function wake() {
            if (_coreReady) {
                if (!_coreInitted && _windowExists()) {
                    _win = _coreInitted = window;
                    _doc = _win.document || {};
                    _globals.gsap = gsap;
                    (_win.gsapVersions || (_win.gsapVersions = [])).push(gsap.version);
                    _install(_installScope || _win.GreenSockGlobals || !_win.gsap && _win || {});
                    _registerPluginQueue.forEach(_createPlugin);
                }
                _raf = typeof requestAnimationFrame !== "undefined" && requestAnimationFrame;
                _id && _self.sleep();
                _req = _raf || function(f) {
                    return setTimeout(f, _nextTime - _self.time * 1000 + 1 | 0);
                };
                _tickerActive = 1;
                _tick(2);
            }
        },
        sleep: function sleep() {
            (_raf ? cancelAnimationFrame : clearTimeout)(_id);
            _tickerActive = 0;
            _req = _emptyFunc;
        },
        lagSmoothing: function lagSmoothing(threshold, adjustedLag) {
            _lagThreshold = threshold || Infinity; // zero should be interpreted as basically unlimited
            _adjustedLag = Math.min(adjustedLag || 33, _lagThreshold);
        },
        fps: function fps(_fps) {
            _gap = 1000 / (_fps || 240);
            _nextTime = _self.time * 1000 + _gap;
        },
        add: function add(callback, once, prioritize) {
            var func = once ? function(t, d, f, v) {
                callback(t, d, f, v);
                _self.remove(func);
            } : callback;
            _self.remove(callback);
            _listeners[prioritize ? "unshift" : "push"](func);
            _wake();
            return func;
        },
        remove: function remove(callback, i) {
            ~(i = _listeners.indexOf(callback)) && _listeners.splice(i, 1) && _i >= i && _i--;
        },
        _listeners: _listeners
    };
    return _self;
}(), _wake = function _wake() {
    return !_tickerActive && _ticker.wake();
}, //also ensures the core classes are initialized.
/*
* -------------------------------------------------
* EASING
* -------------------------------------------------
*/ _easeMap = {}, _customEaseExp = /^[\d.\-M][\d.\-,\s]/, _quotesExp = /["']/g, _parseObjectInString = function _parseObjectInString(value) {
    //takes a string like "{wiggles:10, type:anticipate})" and turns it into a real object. Notice it ends in ")" and includes the {} wrappers. This is because we only use this function for parsing ease configs and prioritized optimization rather than reusability.
    var obj = {}, split = value.substr(1, value.length - 3).split(":"), key = split[0], i = 1, l = split.length, index, val, parsedVal;
    for(; i < l; i++){
        val = split[i];
        index = i !== l - 1 ? val.lastIndexOf(",") : val.length;
        parsedVal = val.substr(0, index);
        obj[key] = isNaN(parsedVal) ? parsedVal.replace(_quotesExp, "").trim() : +parsedVal;
        key = val.substr(index + 1).trim();
    }
    return obj;
}, _valueInParentheses = function _valueInParentheses(value) {
    var open = value.indexOf("(") + 1, close = value.indexOf(")"), nested = value.indexOf("(", open);
    return value.substring(open, ~nested && nested < close ? value.indexOf(")", close + 1) : close);
}, _configEaseFromString = function _configEaseFromString(name) {
    //name can be a string like "elastic.out(1,0.5)", and pass in _easeMap as obj and it'll parse it out and call the actual function like _easeMap.Elastic.easeOut.config(1,0.5). It will also parse custom ease strings as long as CustomEase is loaded and registered (internally as _easeMap._CE).
    var split = (name + "").split("("), ease = _easeMap[split[0]];
    return ease && split.length > 1 && ease.config ? ease.config.apply(null, ~name.indexOf("{") ? [
        _parseObjectInString(split[1])
    ] : _valueInParentheses(name).split(",").map(_numericIfPossible)) : _easeMap._CE && _customEaseExp.test(name) ? _easeMap._CE("", name) : ease;
}, _invertEase = function _invertEase(ease) {
    return function(p) {
        return 1 - ease(1 - p);
    };
}, // allow yoyoEase to be set in children and have those affected when the parent/ancestor timeline yoyos.
_propagateYoyoEase = function _propagateYoyoEase(timeline, isYoyo) {
    var child = timeline._first, ease;
    while(child){
        if (child instanceof Timeline) _propagateYoyoEase(child, isYoyo);
        else if (child.vars.yoyoEase && (!child._yoyo || !child._repeat) && child._yoyo !== isYoyo) {
            if (child.timeline) _propagateYoyoEase(child.timeline, isYoyo);
            else {
                ease = child._ease;
                child._ease = child._yEase;
                child._yEase = ease;
                child._yoyo = isYoyo;
            }
        }
        child = child._next;
    }
}, _parseEase = function _parseEase(ease, defaultEase) {
    return !ease ? defaultEase : (_isFunction(ease) ? ease : _easeMap[ease] || _configEaseFromString(ease)) || defaultEase;
}, _insertEase = function _insertEase(names, easeIn, easeOut, easeInOut) {
    if (easeOut === void 0) easeOut = function easeOut(p) {
        return 1 - easeIn(1 - p);
    };
    if (easeInOut === void 0) easeInOut = function easeInOut(p) {
        return p < .5 ? easeIn(p * 2) / 2 : 1 - easeIn((1 - p) * 2) / 2;
    };
    var ease = {
        easeIn: easeIn,
        easeOut: easeOut,
        easeInOut: easeInOut
    }, lowercaseName;
    _forEachName(names, function(name) {
        _easeMap[name] = _globals[name] = ease;
        _easeMap[lowercaseName = name.toLowerCase()] = easeOut;
        for(var p in ease)_easeMap[lowercaseName + (p === "easeIn" ? ".in" : p === "easeOut" ? ".out" : ".inOut")] = _easeMap[name + "." + p] = ease[p];
    });
    return ease;
}, _easeInOutFromOut = function _easeInOutFromOut(easeOut) {
    return function(p) {
        return p < .5 ? (1 - easeOut(1 - p * 2)) / 2 : .5 + easeOut((p - .5) * 2) / 2;
    };
}, _configElastic = function _configElastic(type, amplitude, period) {
    var p1 = amplitude >= 1 ? amplitude : 1, //note: if amplitude is < 1, we simply adjust the period for a more natural feel. Otherwise the math doesn't work right and the curve starts at 1.
    p2 = (period || (type ? .3 : .45)) / (amplitude < 1 ? amplitude : 1), p3 = p2 / _2PI * (Math.asin(1 / p1) || 0), easeOut = function easeOut(p) {
        return p === 1 ? 1 : p1 * Math.pow(2, -10 * p) * _sin((p - p3) * p2) + 1;
    }, ease = type === "out" ? easeOut : type === "in" ? function(p) {
        return 1 - easeOut(1 - p);
    } : _easeInOutFromOut(easeOut);
    p2 = _2PI / p2; //precalculate to optimize
    ease.config = function(amplitude, period) {
        return _configElastic(type, amplitude, period);
    };
    return ease;
}, _configBack = function _configBack(type, overshoot) {
    if (overshoot === void 0) overshoot = 1.70158;
    var easeOut = function easeOut(p) {
        return p ? --p * p * ((overshoot + 1) * p + overshoot) + 1 : 0;
    }, ease = type === "out" ? easeOut : type === "in" ? function(p) {
        return 1 - easeOut(1 - p);
    } : _easeInOutFromOut(easeOut);
    ease.config = function(overshoot) {
        return _configBack(type, overshoot);
    };
    return ease;
}; // a cheaper (kb and cpu) but more mild way to get a parameterized weighted ease by feeding in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEase = ratio => {
// 	let y = 0.5 + ratio / 2;
// 	return p => (2 * (1 - p) * p * y + p * p);
// },
// a stronger (but more expensive kb/cpu) parameterized weighted ease that lets you feed in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEaseStrong = ratio => {
// 	ratio = .5 + ratio / 2;
// 	let o = 1 / 3 * (ratio < .5 ? ratio : 1 - ratio),
// 		b = ratio - o,
// 		c = ratio + o;
// 	return p => p === 1 ? p : 3 * b * (1 - p) * (1 - p) * p + 3 * c * (1 - p) * p * p + p * p * p;
// };
_forEachName("Linear,Quad,Cubic,Quart,Quint,Strong", function(name, i) {
    var power = i < 5 ? i + 1 : i;
    _insertEase(name + ",Power" + (power - 1), i ? function(p) {
        return Math.pow(p, power);
    } : function(p) {
        return p;
    }, function(p) {
        return 1 - Math.pow(1 - p, power);
    }, function(p) {
        return p < .5 ? Math.pow(p * 2, power) / 2 : 1 - Math.pow((1 - p) * 2, power) / 2;
    });
});
_easeMap.Linear.easeNone = _easeMap.none = _easeMap.Linear.easeIn;
_insertEase("Elastic", _configElastic("in"), _configElastic("out"), _configElastic());
(function(n, c) {
    var n1 = 1 / c, n2 = 2 * n1, n3 = 2.5 * n1, easeOut = function easeOut(p) {
        return p < n1 ? n * p * p : p < n2 ? n * Math.pow(p - 1.5 / c, 2) + .75 : p < n3 ? n * (p -= 2.25 / c) * p + .9375 : n * Math.pow(p - 2.625 / c, 2) + .984375;
    };
    _insertEase("Bounce", function(p) {
        return 1 - easeOut(1 - p);
    }, easeOut);
})(7.5625, 2.75);
_insertEase("Expo", function(p) {
    return p ? Math.pow(2, 10 * (p - 1)) : 0;
});
_insertEase("Circ", function(p) {
    return -(_sqrt(1 - p * p) - 1);
});
_insertEase("Sine", function(p) {
    return p === 1 ? 1 : -_cos(p * _HALF_PI) + 1;
});
_insertEase("Back", _configBack("in"), _configBack("out"), _configBack());
_easeMap.SteppedEase = _easeMap.steps = _globals.SteppedEase = {
    config: function config(steps, immediateStart) {
        if (steps === void 0) steps = 1;
        var p1 = 1 / steps, p2 = steps + (immediateStart ? 0 : 1), p3 = immediateStart ? 1 : 0, max = 1 - _tinyNum;
        return function(p) {
            return ((p2 * _clamp(0, max, p) | 0) + p3) * p1;
        };
    }
};
_defaults.ease = _easeMap["quad.out"];
_forEachName("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function(name) {
    return _callbackNames += name + "," + name + "Params,";
});
var GSCache = function GSCache(target, harness) {
    this.id = _gsID++;
    target._gsap = this;
    this.target = target;
    this.harness = harness;
    this.get = harness ? harness.get : _getProperty;
    this.set = harness ? harness.getSetter : _getSetter;
};
var Animation = /*#__PURE__*/ function() {
    function Animation(vars) {
        this.vars = vars;
        this._delay = +vars.delay || 0;
        if (this._repeat = vars.repeat === Infinity ? -2 : vars.repeat || 0) {
            // TODO: repeat: Infinity on a timeline's children must flag that timeline internally and affect its totalDuration, otherwise it'll stop in the negative direction when reaching the start.
            this._rDelay = vars.repeatDelay || 0;
            this._yoyo = !!vars.yoyo || !!vars.yoyoEase;
        }
        this._ts = 1;
        _setDuration(this, +vars.duration, 1, 1);
        this.data = vars.data;
        if (_context) {
            this._ctx = _context;
            _context.data.push(this);
        }
        _tickerActive || _ticker.wake();
    }
    var _proto = Animation.prototype;
    _proto.delay = function delay(value) {
        if (value || value === 0) {
            this.parent && this.parent.smoothChildTiming && this.startTime(this._start + value - this._delay);
            this._delay = value;
            return this;
        }
        return this._delay;
    };
    _proto.duration = function duration(value) {
        return arguments.length ? this.totalDuration(this._repeat > 0 ? value + (value + this._rDelay) * this._repeat : value) : this.totalDuration() && this._dur;
    };
    _proto.totalDuration = function totalDuration(value) {
        if (!arguments.length) return this._tDur;
        this._dirty = 0;
        return _setDuration(this, this._repeat < 0 ? value : (value - this._repeat * this._rDelay) / (this._repeat + 1));
    };
    _proto.totalTime = function totalTime(_totalTime, suppressEvents) {
        _wake();
        if (!arguments.length) return this._tTime;
        var parent = this._dp;
        if (parent && parent.smoothChildTiming && this._ts) {
            _alignPlayhead(this, _totalTime);
            !parent._dp || parent.parent || _postAddChecks(parent, this); // edge case: if this is a child of a timeline that already completed, for example, we must re-activate the parent.
            //in case any of the ancestor timelines had completed but should now be enabled, we should reset their totalTime() which will also ensure that they're lined up properly and enabled. Skip for animations that are on the root (wasteful). Example: a TimelineLite.exportRoot() is performed when there's a paused tween on the root, the export will not complete until that tween is unpaused, but imagine a child gets restarted later, after all [unpaused] tweens have completed. The start of that child would get pushed out, but one of the ancestors may have completed.
            while(parent && parent.parent){
                if (parent.parent._time !== parent._start + (parent._ts >= 0 ? parent._tTime / parent._ts : (parent.totalDuration() - parent._tTime) / -parent._ts)) parent.totalTime(parent._tTime, true);
                parent = parent.parent;
            }
            if (!this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && _totalTime < this._tDur || this._ts < 0 && _totalTime > 0 || !this._tDur && !_totalTime)) //if the animation doesn't have a parent, put it back into its last parent (recorded as _dp for exactly cases like this). Limit to parents with autoRemoveChildren (like globalTimeline) so that if the user manually removes an animation from a timeline and then alters its playhead, it doesn't get added back in.
            _addToTimeline(this._dp, this, this._start - this._delay);
        }
        if (this._tTime !== _totalTime || !this._dur && !suppressEvents || this._initted && Math.abs(this._zTime) === _tinyNum || !_totalTime && !this._initted && (this.add || this._ptLookup)) {
            // check for _ptLookup on a Tween instance to ensure it has actually finished being instantiated, otherwise if this.reverse() gets called in the Animation constructor, it could trigger a render() here even though the _targets weren't populated, thus when _init() is called there won't be any PropTweens (it'll act like the tween is non-functional)
            this._ts || (this._pTime = _totalTime); // otherwise, if an animation is paused, then the playhead is moved back to zero, then resumed, it'd revert back to the original time at the pause
            //if (!this._lock) { // avoid endless recursion (not sure we need this yet or if it's worth the performance hit)
            //   this._lock = 1;
            _lazySafeRender(this, _totalTime, suppressEvents); //   this._lock = 0;
        //}
        }
        return this;
    };
    _proto.time = function time(value, suppressEvents) {
        return arguments.length ? this.totalTime(Math.min(this.totalDuration(), value + _elapsedCycleDuration(this)) % (this._dur + this._rDelay) || (value ? this._dur : 0), suppressEvents) : this._time; // note: if the modulus results in 0, the playhead could be exactly at the end or the beginning, and we always defer to the END with a non-zero value, otherwise if you set the time() to the very end (duration()), it would render at the START!
    };
    _proto.totalProgress = function totalProgress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.totalDuration() * value, suppressEvents) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.rawTime() > 0 ? 1 : 0;
    };
    _proto.progress = function progress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.duration() * (this._yoyo && !(this.iteration() & 1) ? 1 - value : value) + _elapsedCycleDuration(this), suppressEvents) : this.duration() ? Math.min(1, this._time / this._dur) : this.rawTime() > 0 ? 1 : 0;
    };
    _proto.iteration = function iteration(value, suppressEvents) {
        var cycleDuration = this.duration() + this._rDelay;
        return arguments.length ? this.totalTime(this._time + (value - 1) * cycleDuration, suppressEvents) : this._repeat ? _animationCycle(this._tTime, cycleDuration) + 1 : 1;
    } // potential future addition:
    ;
    _proto.timeScale = function timeScale(value, suppressEvents) {
        if (!arguments.length) return this._rts === -_tinyNum ? 0 : this._rts; // recorded timeScale. Special case: if someone calls reverse() on an animation with timeScale of 0, we assign it -_tinyNum to remember it's reversed.
        if (this._rts === value) return this;
        var tTime = this.parent && this._ts ? _parentToChildTotalTime(this.parent._time, this) : this._tTime; // make sure to do the parentToChildTotalTime() BEFORE setting the new _ts because the old one must be used in that calculation.
        // future addition? Up side: fast and minimal file size. Down side: only works on this animation; if a timeline is reversed, for example, its childrens' onReverse wouldn't get called.
        //(+value < 0 && this._rts >= 0) && _callback(this, "onReverse", true);
        // prioritize rendering where the parent's playhead lines up instead of this._tTime because there could be a tween that's animating another tween's timeScale in the same rendering loop (same parent), thus if the timeScale tween renders first, it would alter _start BEFORE _tTime was set on that tick (in the rendering loop), effectively freezing it until the timeScale tween finishes.
        this._rts = +value || 0;
        this._ts = this._ps || value === -_tinyNum ? 0 : this._rts; // _ts is the functional timeScale which would be 0 if the animation is paused.
        this.totalTime(_clamp(-Math.abs(this._delay), this._tDur, tTime), suppressEvents !== false);
        _setEnd(this); // if parent.smoothChildTiming was false, the end time didn't get updated in the _alignPlayhead() method, so do it here.
        return _recacheAncestors(this);
    };
    _proto.paused = function paused(value) {
        if (!arguments.length) return this._ps;
        if (this._ps !== value) {
            this._ps = value;
            if (value) {
                this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()); // if the pause occurs during the delay phase, make sure that's factored in when resuming.
                this._ts = this._act = 0; // _ts is the functional timeScale, so a paused tween would effectively have a timeScale of 0. We record the "real" timeScale as _rts (recorded time scale)
            } else {
                _wake();
                this._ts = this._rts; //only defer to _pTime (pauseTime) if tTime is zero. Remember, someone could pause() an animation, then scrub the playhead and resume(). If the parent doesn't have smoothChildTiming, we render at the rawTime() because the startTime won't get updated.
                this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, this.progress() === 1 && Math.abs(this._zTime) !== _tinyNum && (this._tTime -= _tinyNum)); // edge case: animation.progress(1).pause().play() wouldn't render again because the playhead is already at the end, but the call to totalTime() below will add it back to its parent...and not remove it again (since removing only happens upon rendering at a new time). Offsetting the _tTime slightly is done simply to cause the final render in totalTime() that'll pop it off its timeline (if autoRemoveChildren is true, of course). Check to make sure _zTime isn't -_tinyNum to avoid an edge case where the playhead is pushed to the end but INSIDE a tween/callback, the timeline itself is paused thus halting rendering and leaving a few unrendered. When resuming, it wouldn't render those otherwise.
            }
        }
        return this;
    };
    _proto.startTime = function startTime(value) {
        if (arguments.length) {
            this._start = value;
            var parent = this.parent || this._dp;
            parent && (parent._sort || !this.parent) && _addToTimeline(parent, this, value - this._delay);
            return this;
        }
        return this._start;
    };
    _proto.endTime = function endTime(includeRepeats) {
        return this._start + (_isNotFalse(includeRepeats) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
    };
    _proto.rawTime = function rawTime(wrapRepeats) {
        var parent = this.parent || this._dp; // _dp = detached parent
        return !parent ? this._tTime : wrapRepeats && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : !this._ts ? this._tTime : _parentToChildTotalTime(parent.rawTime(wrapRepeats), this);
    };
    _proto.revert = function revert(config) {
        if (config === void 0) config = _revertConfig;
        var prevIsReverting = _reverting;
        _reverting = config;
        if (this._initted || this._startAt) {
            this.timeline && this.timeline.revert(config);
            this.totalTime(-0.01, config.suppressEvents);
        }
        this.data !== "nested" && config.kill !== false && this.kill();
        _reverting = prevIsReverting;
        return this;
    };
    _proto.globalTime = function globalTime(rawTime) {
        var animation = this, time = arguments.length ? rawTime : animation.rawTime();
        while(animation){
            time = animation._start + time / (Math.abs(animation._ts) || 1);
            animation = animation._dp;
        }
        return !this.parent && this._sat ? this._sat.globalTime(rawTime) : time; // the _startAt tweens for .fromTo() and .from() that have immediateRender should always be FIRST in the timeline (important for context.revert()). "_sat" stands for _startAtTween, referring to the parent tween that created the _startAt. We must discern if that tween had immediateRender so that we can know whether or not to prioritize it in revert().
    };
    _proto.repeat = function repeat(value) {
        if (arguments.length) {
            this._repeat = value === Infinity ? -2 : value;
            return _onUpdateTotalDuration(this);
        }
        return this._repeat === -2 ? Infinity : this._repeat;
    };
    _proto.repeatDelay = function repeatDelay(value) {
        if (arguments.length) {
            var time = this._time;
            this._rDelay = value;
            _onUpdateTotalDuration(this);
            return time ? this.time(time) : this;
        }
        return this._rDelay;
    };
    _proto.yoyo = function yoyo(value) {
        if (arguments.length) {
            this._yoyo = value;
            return this;
        }
        return this._yoyo;
    };
    _proto.seek = function seek(position, suppressEvents) {
        return this.totalTime(_parsePosition(this, position), _isNotFalse(suppressEvents));
    };
    _proto.restart = function restart(includeDelay, suppressEvents) {
        return this.play().totalTime(includeDelay ? -this._delay : 0, _isNotFalse(suppressEvents));
    };
    _proto.play = function play(from, suppressEvents) {
        from != null && this.seek(from, suppressEvents);
        return this.reversed(false).paused(false);
    };
    _proto.reverse = function reverse(from, suppressEvents) {
        from != null && this.seek(from || this.totalDuration(), suppressEvents);
        return this.reversed(true).paused(false);
    };
    _proto.pause = function pause(atTime, suppressEvents) {
        atTime != null && this.seek(atTime, suppressEvents);
        return this.paused(true);
    };
    _proto.resume = function resume() {
        return this.paused(false);
    };
    _proto.reversed = function reversed(value) {
        if (arguments.length) {
            !!value !== this.reversed() && this.timeScale(-this._rts || (value ? -_tinyNum : 0)); // in case timeScale is zero, reversing would have no effect so we use _tinyNum.
            return this;
        }
        return this._rts < 0;
    };
    _proto.invalidate = function invalidate() {
        this._initted = this._act = 0;
        this._zTime = -_tinyNum;
        return this;
    };
    _proto.isActive = function isActive() {
        var parent = this.parent || this._dp, start = this._start, rawTime;
        return !!(!parent || this._ts && this._initted && parent.isActive() && (rawTime = parent.rawTime(true)) >= start && rawTime < this.endTime(true) - _tinyNum);
    };
    _proto.eventCallback = function eventCallback(type, callback, params) {
        var vars = this.vars;
        if (arguments.length > 1) {
            if (!callback) delete vars[type];
            else {
                vars[type] = callback;
                params && (vars[type + "Params"] = params);
                type === "onUpdate" && (this._onUpdate = callback);
            }
            return this;
        }
        return vars[type];
    };
    _proto.then = function then(onFulfilled) {
        var self = this;
        return new Promise(function(resolve) {
            var f = _isFunction(onFulfilled) ? onFulfilled : _passThrough, _resolve = function _resolve() {
                var _then = self.then;
                self.then = null; // temporarily null the then() method to avoid an infinite loop (see https://github.com/greensock/GSAP/issues/322)
                _isFunction(f) && (f = f(self)) && (f.then || f === self) && (self.then = _then);
                resolve(f);
                self.then = _then;
            };
            if (self._initted && self.totalProgress() === 1 && self._ts >= 0 || !self._tTime && self._ts < 0) _resolve();
            else self._prom = _resolve;
        });
    };
    _proto.kill = function kill() {
        _interrupt(this);
    };
    return Animation;
}();
_setDefaults(Animation.prototype, {
    _time: 0,
    _start: 0,
    _end: 0,
    _tTime: 0,
    _tDur: 0,
    _dirty: 0,
    _repeat: 0,
    _yoyo: false,
    parent: null,
    _initted: false,
    _rDelay: 0,
    _ts: 1,
    _dp: 0,
    ratio: 0,
    _zTime: -_tinyNum,
    _prom: 0,
    _ps: false,
    _rts: 1
});
var Timeline = /*#__PURE__*/ function(_Animation) {
    _inheritsLoose(Timeline, _Animation);
    function Timeline(vars, position) {
        var _this;
        if (vars === void 0) vars = {};
        _this = _Animation.call(this, vars) || this;
        _this.labels = {};
        _this.smoothChildTiming = !!vars.smoothChildTiming;
        _this.autoRemoveChildren = !!vars.autoRemoveChildren;
        _this._sort = _isNotFalse(vars.sortChildren);
        _globalTimeline && _addToTimeline(vars.parent || _globalTimeline, _assertThisInitialized(_this), position);
        vars.reversed && _this.reverse();
        vars.paused && _this.paused(true);
        vars.scrollTrigger && _scrollTrigger(_assertThisInitialized(_this), vars.scrollTrigger);
        return _this;
    }
    var _proto2 = Timeline.prototype;
    _proto2.to = function to(targets, vars, position) {
        _createTweenType(0, arguments, this);
        return this;
    };
    _proto2.from = function from(targets, vars, position) {
        _createTweenType(1, arguments, this);
        return this;
    };
    _proto2.fromTo = function fromTo(targets, fromVars, toVars, position) {
        _createTweenType(2, arguments, this);
        return this;
    };
    _proto2.set = function set(targets, vars, position) {
        vars.duration = 0;
        vars.parent = this;
        _inheritDefaults(vars).repeatDelay || (vars.repeat = 0);
        vars.immediateRender = !!vars.immediateRender;
        new Tween(targets, vars, _parsePosition(this, position), 1);
        return this;
    };
    _proto2.call = function call(callback, params, position) {
        return _addToTimeline(this, Tween.delayedCall(0, callback, params), position);
    } //ONLY for backward compatibility! Maybe delete?
    ;
    _proto2.staggerTo = function staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.duration = duration;
        vars.stagger = vars.stagger || stagger;
        vars.onComplete = onCompleteAll;
        vars.onCompleteParams = onCompleteAllParams;
        vars.parent = this;
        new Tween(targets, vars, _parsePosition(this, position));
        return this;
    };
    _proto2.staggerFrom = function staggerFrom(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.runBackwards = 1;
        _inheritDefaults(vars).immediateRender = _isNotFalse(vars.immediateRender);
        return this.staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.staggerFromTo = function staggerFromTo(targets, duration, fromVars, toVars, stagger, position, onCompleteAll, onCompleteAllParams) {
        toVars.startAt = fromVars;
        _inheritDefaults(toVars).immediateRender = _isNotFalse(toVars.immediateRender);
        return this.staggerTo(targets, duration, toVars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._dirty ? this.totalDuration() : this._tDur, dur = this._dur, tTime = totalTime <= 0 ? 0 : _roundPrecise(totalTime), // if a paused timeline is resumed (or its _start is updated for another reason...which rounds it), that could result in the playhead shifting a **tiny** amount and a zero-duration child at that spot may get rendered at a different ratio, like its totalTime in render() may be 1e-17 instead of 0, for example.
        crossingStart = this._zTime < 0 !== totalTime < 0 && (this._initted || !dur), time, child, next, iteration, cycleDuration, prevPaused, pauseTween, timeScale, prevStart, prevIteration, yoyo, isYoyo;
        this !== _globalTimeline && tTime > tDur && totalTime >= 0 && (tTime = tDur);
        if (tTime !== this._tTime || force || crossingStart) {
            if (prevTime !== this._time && dur) {
                //if totalDuration() finds a child with a negative startTime and smoothChildTiming is true, things get shifted around internally so we need to adjust the time accordingly. For example, if a tween starts at -30 we must shift EVERYTHING forward 30 seconds and move this timeline's startTime backward by 30 seconds so that things align with the playhead (no jump).
                tTime += this._time - prevTime;
                totalTime += this._time - prevTime;
            }
            time = tTime;
            prevStart = this._start;
            timeScale = this._ts;
            prevPaused = !timeScale;
            if (crossingStart) {
                dur || (prevTime = this._zTime); //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
                (totalTime || !suppressEvents) && (this._zTime = totalTime);
            }
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                yoyo = this._yoyo;
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && totalTime < 0) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
                    iteration = this._repeat;
                    time = dur;
                } else {
                    iteration = ~~(tTime / cycleDuration);
                    if (iteration && iteration === tTime / cycleDuration) {
                        time = dur;
                        iteration--;
                    }
                    time > dur && (time = dur);
                }
                prevIteration = _animationCycle(this._tTime, cycleDuration);
                !prevTime && this._tTime && prevIteration !== iteration && this._tTime - prevIteration * cycleDuration - this._dur <= 0 && (prevIteration = iteration); // edge case - if someone does addPause() at the very beginning of a repeating timeline, that pause is technically at the same spot as the end which causes this._time to get set to 0 when the totalTime would normally place the playhead at the end. See https://gsap.com/forums/topic/23823-closing-nav-animation-not-working-on-ie-and-iphone-6-maybe-other-older-browser/?tab=comments#comment-113005 also, this._tTime - prevIteration * cycleDuration - this._dur <= 0 just checks to make sure it wasn't previously in the "repeatDelay" portion
                if (yoyo && iteration & 1) {
                    time = dur - time;
                    isYoyo = 1;
                }
                /*
        make sure children at the end/beginning of the timeline are rendered properly. If, for example,
        a 3-second long timeline rendered at 2.9 seconds previously, and now renders at 3.2 seconds (which
        would get translated to 2.8 seconds if the timeline yoyos or 0.2 seconds if it just repeats), there
        could be a callback or a short tween that's at 2.95 or 3 seconds in which wouldn't render. So
        we need to push the timeline to the end (and/or beginning depending on its yoyo value). Also we must
        ensure that zero-duration tweens at the very beginning or end of the Timeline work.
        */ if (iteration !== prevIteration && !this._lock) {
                    var rewinding = yoyo && prevIteration & 1, doesWrap = rewinding === (yoyo && iteration & 1);
                    iteration < prevIteration && (rewinding = !rewinding);
                    prevTime = rewinding ? 0 : tTime % dur ? dur : tTime; // if the playhead is landing exactly at the end of an iteration, use that totalTime rather than only the duration, otherwise it'll skip the 2nd render since it's effectively at the same time.
                    this._lock = 1;
                    this.render(prevTime || (isYoyo ? 0 : _roundPrecise(iteration * cycleDuration)), suppressEvents, !dur)._lock = 0;
                    this._tTime = tTime; // if a user gets the iteration() inside the onRepeat, for example, it should be accurate.
                    !suppressEvents && this.parent && _callback(this, "onRepeat");
                    this.vars.repeatRefresh && !isYoyo && (this.invalidate()._lock = 1);
                    if (prevTime && prevTime !== this._time || prevPaused !== !this._ts || this.vars.onRepeat && !this.parent && !this._act) // if prevTime is 0 and we render at the very end, _time will be the end, thus won't match. So in this edge case, prevTime won't match _time but that's okay. If it gets killed in the onRepeat, eject as well.
                    return this;
                    dur = this._dur; // in case the duration changed in the onRepeat
                    tDur = this._tDur;
                    if (doesWrap) {
                        this._lock = 2;
                        prevTime = rewinding ? dur : -0.0001;
                        this.render(prevTime, true);
                        this.vars.repeatRefresh && !isYoyo && this.invalidate();
                    }
                    this._lock = 0;
                    if (!this._ts && !prevPaused) return this;
                     //in order for yoyoEase to work properly when there's a stagger, we must swap out the ease in each sub-tween.
                    _propagateYoyoEase(this, isYoyo);
                }
            }
            if (this._hasPause && !this._forcing && this._lock < 2) {
                pauseTween = _findNextPauseTween(this, _roundPrecise(prevTime), _roundPrecise(time));
                if (pauseTween) tTime -= time - (time = pauseTween._start);
            }
            this._tTime = tTime;
            this._time = time;
            this._act = !timeScale; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
            if (!this._initted) {
                this._onUpdate = this.vars.onUpdate;
                this._initted = 1;
                this._zTime = totalTime;
                prevTime = 0; // upon init, the playhead should always go forward; someone could invalidate() a completed timeline and then if they restart(), that would make child tweens render in reverse order which could lock in the wrong starting values if they build on each other, like tl.to(obj, {x: 100}).to(obj, {x: 0}).
            }
            if (!prevTime && time && !suppressEvents && !iteration) {
                _callback(this, "onStart");
                if (this._tTime !== tTime) // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
                return this;
            }
            if (time >= prevTime && totalTime >= 0) {
                child = this._first;
                while(child){
                    next = child._next;
                    if ((child._act || time >= child._start) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (time - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (time - child._start) * child._ts, suppressEvents, force);
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            next && (tTime += this._zTime = -_tinyNum); // it didn't finish rendering, so flag zTime as negative so that so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            } else {
                child = this._last;
                var adjustedTime = totalTime < 0 ? totalTime : time; //when the playhead goes backward beyond the start of this timeline, we must pass that information down to the child animations so that zero-duration tweens know whether to render their starting or ending values.
                while(child){
                    next = child._prev;
                    if ((child._act || adjustedTime <= child._end) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (adjustedTime - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (adjustedTime - child._start) * child._ts, suppressEvents, force || _reverting && (child._initted || child._startAt)); // if reverting, we should always force renders of initted tweens (but remember that .fromTo() or .from() may have a _startAt but not _initted yet). If, for example, a .fromTo() tween with a stagger (which creates an internal timeline) gets reverted BEFORE some of its child tweens render for the first time, it may not properly trigger them to revert.
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            next && (tTime += this._zTime = adjustedTime ? -_tinyNum : _tinyNum); // it didn't finish rendering, so adjust zTime so that so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            }
            if (pauseTween && !suppressEvents) {
                this.pause();
                pauseTween.render(time >= prevTime ? 0 : -_tinyNum)._zTime = time >= prevTime ? 1 : -1;
                if (this._ts) {
                    //the callback resumed playback! So since we may have held back the playhead due to where the pause is positioned, go ahead and jump to where it's SUPPOSED to be (if no pause happened).
                    this._start = prevStart; //if the pause was at an earlier time and the user resumed in the callback, it could reposition the timeline (changing its startTime), throwing things off slightly, so we make sure the _start doesn't shift.
                    _setEnd(this);
                    return this.render(totalTime, suppressEvents, force);
                }
            }
            this._onUpdate && !suppressEvents && _callback(this, "onUpdate", true);
            if (tTime === tDur && this._tTime >= this.totalDuration() || !tTime && prevTime) {
                if (prevStart === this._start || Math.abs(timeScale) !== Math.abs(this._ts)) {
                    if (!this._lock) {
                        // remember, a child's callback may alter this timeline's playhead or timeScale which is why we need to add some of these checks.
                        (totalTime || !dur) && (tTime === tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                        if (!suppressEvents && !(totalTime < 0 && !prevTime) && (tTime || prevTime || !tDur)) {
                            _callback(this, tTime === tDur && totalTime >= 0 ? "onComplete" : "onReverseComplete", true);
                            this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                        }
                    }
                }
            }
        }
        return this;
    };
    _proto2.add = function add(child, position) {
        var _this2 = this;
        _isNumber(position) || (position = _parsePosition(this, position, child));
        if (!(child instanceof Animation)) {
            if (_isArray(child)) {
                child.forEach(function(obj) {
                    return _this2.add(obj, position);
                });
                return this;
            }
            if (_isString(child)) return this.addLabel(child, position);
            if (_isFunction(child)) child = Tween.delayedCall(0, child);
            else return this;
        }
        return this !== child ? _addToTimeline(this, child, position) : this; //don't allow a timeline to be added to itself as a child!
    };
    _proto2.getChildren = function getChildren(nested, tweens, timelines, ignoreBeforeTime) {
        if (nested === void 0) nested = true;
        if (tweens === void 0) tweens = true;
        if (timelines === void 0) timelines = true;
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = -_bigNum;
        var a = [], child = this._first;
        while(child){
            if (child._start >= ignoreBeforeTime) {
                if (child instanceof Tween) tweens && a.push(child);
                else {
                    timelines && a.push(child);
                    nested && a.push.apply(a, child.getChildren(true, tweens, timelines));
                }
            }
            child = child._next;
        }
        return a;
    };
    _proto2.getById = function getById(id) {
        var animations = this.getChildren(1, 1, 1), i = animations.length;
        while(i--){
            if (animations[i].vars.id === id) return animations[i];
        }
    };
    _proto2.remove = function remove(child) {
        if (_isString(child)) return this.removeLabel(child);
        if (_isFunction(child)) return this.killTweensOf(child);
        _removeLinkedListItem(this, child);
        if (child === this._recent) this._recent = this._last;
        return _uncache(this);
    };
    _proto2.totalTime = function totalTime(_totalTime2, suppressEvents) {
        if (!arguments.length) return this._tTime;
        this._forcing = 1;
        if (!this._dp && this._ts) //special case for the global timeline (or any other that has no parent or detached parent).
        this._start = _roundPrecise(_ticker.time - (this._ts > 0 ? _totalTime2 / this._ts : (this.totalDuration() - _totalTime2) / -this._ts));
        _Animation.prototype.totalTime.call(this, _totalTime2, suppressEvents);
        this._forcing = 0;
        return this;
    };
    _proto2.addLabel = function addLabel(label, position) {
        this.labels[label] = _parsePosition(this, position);
        return this;
    };
    _proto2.removeLabel = function removeLabel(label) {
        delete this.labels[label];
        return this;
    };
    _proto2.addPause = function addPause(position, callback, params) {
        var t = Tween.delayedCall(0, callback || _emptyFunc, params);
        t.data = "isPause";
        this._hasPause = 1;
        return _addToTimeline(this, t, _parsePosition(this, position));
    };
    _proto2.removePause = function removePause(position) {
        var child = this._first;
        position = _parsePosition(this, position);
        while(child){
            if (child._start === position && child.data === "isPause") _removeFromParent(child);
            child = child._next;
        }
    };
    _proto2.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        var tweens = this.getTweensOf(targets, onlyActive), i = tweens.length;
        while(i--)_overwritingTween !== tweens[i] && tweens[i].kill(targets, props);
        return this;
    };
    _proto2.getTweensOf = function getTweensOf(targets, onlyActive) {
        var a = [], parsedTargets = toArray(targets), child = this._first, isGlobalTime = _isNumber(onlyActive), // a number is interpreted as a global time. If the animation spans
        children;
        while(child){
            if (child instanceof Tween) {
                if (_arrayContainsAny(child._targets, parsedTargets) && (isGlobalTime ? (!_overwritingTween || child._initted && child._ts) && child.globalTime(0) <= onlyActive && child.globalTime(child.totalDuration()) > onlyActive : !onlyActive || child.isActive())) // note: if this is for overwriting, it should only be for tweens that aren't paused and are initted.
                a.push(child);
            } else if ((children = child.getTweensOf(parsedTargets, onlyActive)).length) a.push.apply(a, children);
            child = child._next;
        }
        return a;
    } // potential future feature - targets() on timelines
    ;
    _proto2.tweenTo = function tweenTo(position, vars) {
        vars = vars || {};
        var tl = this, endTime = _parsePosition(tl, position), _vars = vars, startAt = _vars.startAt, _onStart = _vars.onStart, onStartParams = _vars.onStartParams, immediateRender = _vars.immediateRender, initted, tween = Tween.to(tl, _setDefaults({
            ease: vars.ease || "none",
            lazy: false,
            immediateRender: false,
            time: endTime,
            overwrite: "auto",
            duration: vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale()) || _tinyNum,
            onStart: function onStart() {
                tl.pause();
                if (!initted) {
                    var duration = vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale());
                    tween._dur !== duration && _setDuration(tween, duration, 0, 1).render(tween._time, true, true);
                    initted = 1;
                }
                _onStart && _onStart.apply(tween, onStartParams || []); //in case the user had an onStart in the vars - we don't want to overwrite it.
            }
        }, vars));
        return immediateRender ? tween.render(0) : tween;
    };
    _proto2.tweenFromTo = function tweenFromTo(fromPosition, toPosition, vars) {
        return this.tweenTo(toPosition, _setDefaults({
            startAt: {
                time: _parsePosition(this, fromPosition)
            }
        }, vars));
    };
    _proto2.recent = function recent() {
        return this._recent;
    };
    _proto2.nextLabel = function nextLabel(afterTime) {
        if (afterTime === void 0) afterTime = this._time;
        return _getLabelInDirection(this, _parsePosition(this, afterTime));
    };
    _proto2.previousLabel = function previousLabel(beforeTime) {
        if (beforeTime === void 0) beforeTime = this._time;
        return _getLabelInDirection(this, _parsePosition(this, beforeTime), 1);
    };
    _proto2.currentLabel = function currentLabel(value) {
        return arguments.length ? this.seek(value, true) : this.previousLabel(this._time + _tinyNum);
    };
    _proto2.shiftChildren = function shiftChildren(amount, adjustLabels, ignoreBeforeTime) {
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = 0;
        var child = this._first, labels = this.labels, p;
        while(child){
            if (child._start >= ignoreBeforeTime) {
                child._start += amount;
                child._end += amount;
            }
            child = child._next;
        }
        if (adjustLabels) {
            for(p in labels)if (labels[p] >= ignoreBeforeTime) labels[p] += amount;
        }
        return _uncache(this);
    };
    _proto2.invalidate = function invalidate(soft) {
        var child = this._first;
        this._lock = 0;
        while(child){
            child.invalidate(soft);
            child = child._next;
        }
        return _Animation.prototype.invalidate.call(this, soft);
    };
    _proto2.clear = function clear(includeLabels) {
        if (includeLabels === void 0) includeLabels = true;
        var child = this._first, next;
        while(child){
            next = child._next;
            this.remove(child);
            child = next;
        }
        this._dp && (this._time = this._tTime = this._pTime = 0);
        includeLabels && (this.labels = {});
        return _uncache(this);
    };
    _proto2.totalDuration = function totalDuration(value) {
        var max = 0, self = this, child = self._last, prevStart = _bigNum, prev, start, parent;
        if (arguments.length) return self.timeScale((self._repeat < 0 ? self.duration() : self.totalDuration()) / (self.reversed() ? -value : value));
        if (self._dirty) {
            parent = self.parent;
            while(child){
                prev = child._prev; //record it here in case the tween changes position in the sequence...
                child._dirty && child.totalDuration(); //could change the tween._startTime, so make sure the animation's cache is clean before analyzing it.
                start = child._start;
                if (start > prevStart && self._sort && child._ts && !self._lock) {
                    //in case one of the tweens shifted out of order, it needs to be re-inserted into the correct position in the sequence
                    self._lock = 1; //prevent endless recursive calls - there are methods that get triggered that check duration/totalDuration when we add().
                    _addToTimeline(self, child, start - child._delay, 1)._lock = 0;
                } else prevStart = start;
                if (start < 0 && child._ts) {
                    //children aren't allowed to have negative startTimes unless smoothChildTiming is true, so adjust here if one is found.
                    max -= start;
                    if (!parent && !self._dp || parent && parent.smoothChildTiming) {
                        self._start += start / self._ts;
                        self._time -= start;
                        self._tTime -= start;
                    }
                    self.shiftChildren(-start, false, -Infinity);
                    prevStart = 0;
                }
                child._end > max && child._ts && (max = child._end);
                child = prev;
            }
            _setDuration(self, self === _globalTimeline && self._time > max ? self._time : max, 1, 1);
            self._dirty = 0;
        }
        return self._tDur;
    };
    Timeline.updateRoot = function updateRoot(time) {
        if (_globalTimeline._ts) {
            _lazySafeRender(_globalTimeline, _parentToChildTotalTime(time, _globalTimeline));
            _lastRenderedFrame = _ticker.frame;
        }
        if (_ticker.frame >= _nextGCFrame) {
            _nextGCFrame += _config.autoSleep || 120;
            var child = _globalTimeline._first;
            if (!child || !child._ts) {
                if (_config.autoSleep && _ticker._listeners.length < 2) {
                    while(child && !child._ts)child = child._next;
                    child || _ticker.sleep();
                }
            }
        }
    };
    return Timeline;
}(Animation);
_setDefaults(Timeline.prototype, {
    _lock: 0,
    _hasPause: 0,
    _forcing: 0
});
var _addComplexStringPropTween = function _addComplexStringPropTween(target, prop, start, end, setter, stringFilter, funcParam) {
    //note: we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    var pt = new PropTween(this._pt, target, prop, 0, 1, _renderComplexString, null, setter), index = 0, matchIndex = 0, result, startNums, color, endNum, chunk, startNum, hasRandom, a;
    pt.b = start;
    pt.e = end;
    start += ""; //ensure values are strings
    end += "";
    if (hasRandom = ~end.indexOf("random(")) end = _replaceRandom(end);
    if (stringFilter) {
        a = [
            start,
            end
        ];
        stringFilter(a, target, prop); //pass an array with the starting and ending values and let the filter do whatever it needs to the values.
        start = a[0];
        end = a[1];
    }
    startNums = start.match(_complexStringNumExp) || [];
    while(result = _complexStringNumExp.exec(end)){
        endNum = result[0];
        chunk = end.substring(index, result.index);
        if (color) color = (color + 1) % 5;
        else if (chunk.substr(-5) === "rgba(") color = 1;
        if (endNum !== startNums[matchIndex++]) {
            startNum = parseFloat(startNums[matchIndex - 1]) || 0; //these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
            pt._pt = {
                _next: pt._pt,
                p: chunk || matchIndex === 1 ? chunk : ",",
                //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
                s: startNum,
                c: endNum.charAt(1) === "=" ? _parseRelative(startNum, endNum) - startNum : parseFloat(endNum) - startNum,
                m: color && color < 4 ? Math.round : 0
            };
            index = _complexStringNumExp.lastIndex;
        }
    }
    pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    pt.fp = funcParam;
    if (_relExp.test(end) || hasRandom) pt.e = 0; //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    return pt;
}, _addPropTween = function _addPropTween(target, prop, start, end, index, targets, modifier, stringFilter, funcParam, optional) {
    _isFunction(end) && (end = end(index || 0, target, targets));
    var currentValue = target[prop], parsedStart = start !== "get" ? start : !_isFunction(currentValue) ? currentValue : funcParam ? target[prop.indexOf("set") || !_isFunction(target["get" + prop.substr(3)]) ? prop : "get" + prop.substr(3)](funcParam) : target[prop](), setter = !_isFunction(currentValue) ? _setterPlain : funcParam ? _setterFuncWithParam : _setterFunc, pt;
    if (_isString(end)) {
        if (~end.indexOf("random(")) end = _replaceRandom(end);
        if (end.charAt(1) === "=") {
            pt = _parseRelative(parsedStart, end) + (getUnit(parsedStart) || 0);
            if (pt || pt === 0) // to avoid isNaN, like if someone passes in a value like "!= whatever"
            end = pt;
        }
    }
    if (!optional || parsedStart !== end || _forceAllPropTweens) {
        if (!isNaN(parsedStart * end) && end !== "") {
            // fun fact: any number multiplied by "" is evaluated as the number 0!
            pt = new PropTween(this._pt, target, prop, +parsedStart || 0, end - (parsedStart || 0), typeof currentValue === "boolean" ? _renderBoolean : _renderPlain, 0, setter);
            funcParam && (pt.fp = funcParam);
            modifier && pt.modifier(modifier, this, target);
            return this._pt = pt;
        }
        !currentValue && !(prop in target) && _missingPlugin(prop, end);
        return _addComplexStringPropTween.call(this, target, prop, parsedStart, end, setter, stringFilter || _config.stringFilter, funcParam);
    }
}, //creates a copy of the vars object and processes any function-based values (putting the resulting values directly into the copy) as well as strings with "random()" in them. It does NOT process relative values.
_processVars = function _processVars(vars, index, target, targets, tween) {
    _isFunction(vars) && (vars = _parseFuncOrString(vars, tween, index, target, targets));
    if (!_isObject(vars) || vars.style && vars.nodeType || _isArray(vars) || _isTypedArray(vars)) return _isString(vars) ? _parseFuncOrString(vars, tween, index, target, targets) : vars;
    var copy = {}, p;
    for(p in vars)copy[p] = _parseFuncOrString(vars[p], tween, index, target, targets);
    return copy;
}, _checkPlugin = function _checkPlugin(property, vars, tween, index, target, targets) {
    var plugin, pt, ptLookup, i;
    if (_plugins[property] && (plugin = new _plugins[property]()).init(target, plugin.rawVars ? vars[property] : _processVars(vars[property], index, target, targets, tween), tween, index, targets) !== false) {
        tween._pt = pt = new PropTween(tween._pt, target, property, 0, 1, plugin.render, plugin, 0, plugin.priority);
        if (tween !== _quickTween) {
            ptLookup = tween._ptLookup[tween._targets.indexOf(target)]; //note: we can't use tween._ptLookup[index] because for staggered tweens, the index from the fullTargets array won't match what it is in each individual tween that spawns from the stagger.
            i = plugin._props.length;
            while(i--)ptLookup[plugin._props[i]] = pt;
        }
    }
    return plugin;
}, _overwritingTween, //store a reference temporarily so we can avoid overwriting itself.
_forceAllPropTweens, _initTween = function _initTween(tween, time, tTime) {
    var vars = tween.vars, ease = vars.ease, startAt = vars.startAt, immediateRender = vars.immediateRender, lazy = vars.lazy, onUpdate = vars.onUpdate, runBackwards = vars.runBackwards, yoyoEase = vars.yoyoEase, keyframes = vars.keyframes, autoRevert = vars.autoRevert, dur = tween._dur, prevStartAt = tween._startAt, targets = tween._targets, parent = tween.parent, fullTargets = parent && parent.data === "nested" ? parent.vars.targets : targets, autoOverwrite = tween._overwrite === "auto" && !_suppressOverwrites, tl = tween.timeline, cleanVars, i, p, pt, target, hasPriority, gsData, harness, plugin, ptLookup, index, harnessVars, overwritten;
    tl && (!keyframes || !ease) && (ease = "none");
    tween._ease = _parseEase(ease, _defaults.ease);
    tween._yEase = yoyoEase ? _invertEase(_parseEase(yoyoEase === true ? ease : yoyoEase, _defaults.ease)) : 0;
    if (yoyoEase && tween._yoyo && !tween._repeat) {
        //there must have been a parent timeline with yoyo:true that is currently in its yoyo phase, so flip the eases.
        yoyoEase = tween._yEase;
        tween._yEase = tween._ease;
        tween._ease = yoyoEase;
    }
    tween._from = !tl && !!vars.runBackwards; //nested timelines should never run backwards - the backwards-ness is in the child tweens.
    if (!tl || keyframes && !vars.stagger) {
        //if there's an internal timeline, skip all the parsing because we passed that task down the chain.
        harness = targets[0] ? _getCache(targets[0]).harness : 0;
        harnessVars = harness && vars[harness.prop]; //someone may need to specify CSS-specific values AND non-CSS values, like if the element has an "x" property plus it's a standard DOM element. We allow people to distinguish by wrapping plugin-specific stuff in a css:{} object for example.
        cleanVars = _copyExcluding(vars, _reservedProps);
        if (prevStartAt) {
            prevStartAt._zTime < 0 && prevStartAt.progress(1); // in case it's a lazy startAt that hasn't rendered yet.
            time < 0 && runBackwards && immediateRender && !autoRevert ? prevStartAt.render(-1, true) : prevStartAt.revert(runBackwards && dur ? _revertConfigNoKill : _startAtRevertConfig); // if it's a "startAt" (not "from()" or runBackwards: true), we only need to do a shallow revert (keep transforms cached in CSSPlugin)
            // don't just _removeFromParent(prevStartAt.render(-1, true)) because that'll leave inline styles. We're creating a new _startAt for "startAt" tweens that re-capture things to ensure that if the pre-tween values changed since the tween was created, they're recorded.
            prevStartAt._lazy = 0;
        }
        if (startAt) {
            _removeFromParent(tween._startAt = Tween.set(targets, _setDefaults({
                data: "isStart",
                overwrite: false,
                parent: parent,
                immediateRender: true,
                lazy: !prevStartAt && _isNotFalse(lazy),
                startAt: null,
                delay: 0,
                onUpdate: onUpdate && function() {
                    return _callback(tween, "onUpdate");
                },
                stagger: 0
            }, startAt))); //copy the properties/values into a new object to avoid collisions, like var to = {x:0}, from = {x:500}; timeline.fromTo(e, from, to).fromTo(e, to, from);
            tween._startAt._dp = 0; // don't allow it to get put back into root timeline! Like when revert() is called and totalTime() gets set.
            tween._startAt._sat = tween; // used in globalTime(). _sat stands for _startAtTween
            time < 0 && (_reverting || !immediateRender && !autoRevert) && tween._startAt.revert(_revertConfigNoKill); // rare edge case, like if a render is forced in the negative direction of a non-initted tween.
            if (immediateRender) {
                if (dur && time <= 0 && tTime <= 0) {
                    // check tTime here because in the case of a yoyo tween whose playhead gets pushed to the end like tween.progress(1), we should allow it through so that the onComplete gets fired properly.
                    time && (tween._zTime = time);
                    return; //we skip initialization here so that overwriting doesn't occur until the tween actually begins. Otherwise, if you create several immediateRender:true tweens of the same target/properties to drop into a Timeline, the last one created would overwrite the first ones because they didn't get placed into the timeline yet before the first render occurs and kicks in overwriting.
                }
            }
        } else if (runBackwards && dur) //from() tweens must be handled uniquely: their beginning values must be rendered but we don't want overwriting to occur yet (when time is still 0). Wait until the tween actually begins before doing all the routines like overwriting. At that time, we should render at the END of the tween to ensure that things initialize correctly (remember, from() tweens go backwards)
        {
            if (!prevStartAt) {
                time && (immediateRender = false); //in rare cases (like if a from() tween runs and then is invalidate()-ed), immediateRender could be true but the initial forced-render gets skipped, so there's no need to force the render in this context when the _time is greater than 0
                p = _setDefaults({
                    overwrite: false,
                    data: "isFromStart",
                    //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
                    lazy: immediateRender && !prevStartAt && _isNotFalse(lazy),
                    immediateRender: immediateRender,
                    //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
                    stagger: 0,
                    parent: parent //ensures that nested tweens that had a stagger are handled properly, like gsap.from(".class", {y: gsap.utils.wrap([-100,100]), stagger: 0.5})
                }, cleanVars);
                harnessVars && (p[harness.prop] = harnessVars); // in case someone does something like .from(..., {css:{}})
                _removeFromParent(tween._startAt = Tween.set(targets, p));
                tween._startAt._dp = 0; // don't allow it to get put back into root timeline!
                tween._startAt._sat = tween; // used in globalTime()
                time < 0 && (_reverting ? tween._startAt.revert(_revertConfigNoKill) : tween._startAt.render(-1, true));
                tween._zTime = time;
                if (!immediateRender) _initTween(tween._startAt, _tinyNum, _tinyNum); //ensures that the initial values are recorded
                else if (!time) return;
            }
        }
        tween._pt = tween._ptCache = 0;
        lazy = dur && _isNotFalse(lazy) || lazy && !dur;
        for(i = 0; i < targets.length; i++){
            target = targets[i];
            gsData = target._gsap || _harness(targets)[i]._gsap;
            tween._ptLookup[i] = ptLookup = {};
            _lazyLookup[gsData.id] && _lazyTweens.length && _lazyRender(); //if other tweens of the same target have recently initted but haven't rendered yet, we've got to force the render so that the starting values are correct (imagine populating a timeline with a bunch of sequential tweens and then jumping to the end)
            index = fullTargets === targets ? i : fullTargets.indexOf(target);
            if (harness && (plugin = new harness()).init(target, harnessVars || cleanVars, tween, index, fullTargets) !== false) {
                tween._pt = pt = new PropTween(tween._pt, target, plugin.name, 0, 1, plugin.render, plugin, 0, plugin.priority);
                plugin._props.forEach(function(name) {
                    ptLookup[name] = pt;
                });
                plugin.priority && (hasPriority = 1);
            }
            if (!harness || harnessVars) {
                for(p in cleanVars)if (_plugins[p] && (plugin = _checkPlugin(p, cleanVars, tween, index, target, fullTargets))) plugin.priority && (hasPriority = 1);
                else ptLookup[p] = pt = _addPropTween.call(tween, target, p, "get", cleanVars[p], index, fullTargets, 0, vars.stringFilter);
            }
            tween._op && tween._op[i] && tween.kill(target, tween._op[i]);
            if (autoOverwrite && tween._pt) {
                _overwritingTween = tween;
                _globalTimeline.killTweensOf(target, ptLookup, tween.globalTime(time)); // make sure the overwriting doesn't overwrite THIS tween!!!
                overwritten = !tween.parent;
                _overwritingTween = 0;
            }
            tween._pt && lazy && (_lazyLookup[gsData.id] = 1);
        }
        hasPriority && _sortPropTweensByPriority(tween);
        tween._onInit && tween._onInit(tween); //plugins like RoundProps must wait until ALL of the PropTweens are instantiated. In the plugin's init() function, it sets the _onInit on the tween instance. May not be pretty/intuitive, but it's fast and keeps file size down.
    }
    tween._onUpdate = onUpdate;
    tween._initted = (!tween._op || tween._pt) && !overwritten; // if overwrittenProps resulted in the entire tween being killed, do NOT flag it as initted or else it may render for one tick.
    keyframes && time <= 0 && tl.render(_bigNum, true, true); // if there's a 0% keyframe, it'll render in the "before" state for any staggered/delayed animations thus when the following tween initializes, it'll use the "before" state instead of the "after" state as the initial values.
}, _updatePropTweens = function _updatePropTweens(tween, property, value, start, startIsRelative, ratio, time, skipRecursion) {
    var ptCache = (tween._pt && tween._ptCache || (tween._ptCache = {}))[property], pt, rootPT, lookup, i;
    if (!ptCache) {
        ptCache = tween._ptCache[property] = [];
        lookup = tween._ptLookup;
        i = tween._targets.length;
        while(i--){
            pt = lookup[i][property];
            if (pt && pt.d && pt.d._pt) {
                // it's a plugin, so find the nested PropTween
                pt = pt.d._pt;
                while(pt && pt.p !== property && pt.fp !== property)// "fp" is functionParam for things like setting CSS variables which require .setProperty("--var-name", value)
                pt = pt._next;
            }
            if (!pt) {
                // there is no PropTween associated with that property, so we must FORCE one to be created and ditch out of this
                // if the tween has other properties that already rendered at new positions, we'd normally have to rewind to put them back like tween.render(0, true) before forcing an _initTween(), but that can create another edge case like tweening a timeline's progress would trigger onUpdates to fire which could move other things around. It's better to just inform users that .resetTo() should ONLY be used for tweens that already have that property. For example, you can't gsap.to(...{ y: 0 }) and then tween.restTo("x", 200) for example.
                _forceAllPropTweens = 1; // otherwise, when we _addPropTween() and it finds no change between the start and end values, it skips creating a PropTween (for efficiency...why tween when there's no difference?) but in this case we NEED that PropTween created so we can edit it.
                tween.vars[property] = "+=0";
                _initTween(tween, time);
                _forceAllPropTweens = 0;
                return skipRecursion ? _warn(property + " not eligible for reset") : 1; // if someone tries to do a quickTo() on a special property like borderRadius which must get split into 4 different properties, that's not eligible for .resetTo().
            }
            ptCache.push(pt);
        }
    }
    i = ptCache.length;
    while(i--){
        rootPT = ptCache[i];
        pt = rootPT._pt || rootPT; // complex values may have nested PropTweens. We only accommodate the FIRST value.
        pt.s = (start || start === 0) && !startIsRelative ? start : pt.s + (start || 0) + ratio * pt.c;
        pt.c = value - pt.s;
        rootPT.e && (rootPT.e = _round(value) + getUnit(rootPT.e)); // mainly for CSSPlugin (end value)
        rootPT.b && (rootPT.b = pt.s + getUnit(rootPT.b)); // (beginning value)
    }
}, _addAliasesToVars = function _addAliasesToVars(targets, vars) {
    var harness = targets[0] ? _getCache(targets[0]).harness : 0, propertyAliases = harness && harness.aliases, copy, p, i, aliases;
    if (!propertyAliases) return vars;
    copy = _merge({}, vars);
    for(p in propertyAliases)if (p in copy) {
        aliases = propertyAliases[p].split(",");
        i = aliases.length;
        while(i--)copy[aliases[i]] = copy[p];
    }
    return copy;
}, // parses multiple formats, like {"0%": {x: 100}, {"50%": {x: -20}} and { x: {"0%": 100, "50%": -20} }, and an "ease" can be set on any object. We populate an "allProps" object with an Array for each property, like {x: [{}, {}], y:[{}, {}]} with data for each property tween. The objects have a "t" (time), "v", (value), and "e" (ease) property. This allows us to piece together a timeline later.
_parseKeyframe = function _parseKeyframe(prop, obj, allProps, easeEach) {
    var ease = obj.ease || easeEach || "power1.inOut", p, a;
    if (_isArray(obj)) {
        a = allProps[prop] || (allProps[prop] = []); // t = time (out of 100), v = value, e = ease
        obj.forEach(function(value, i) {
            return a.push({
                t: i / (obj.length - 1) * 100,
                v: value,
                e: ease
            });
        });
    } else for(p in obj){
        a = allProps[p] || (allProps[p] = []);
        p === "ease" || a.push({
            t: parseFloat(prop),
            v: obj[p],
            e: ease
        });
    }
}, _parseFuncOrString = function _parseFuncOrString(value, tween, i, target, targets) {
    return _isFunction(value) ? value.call(tween, i, target, targets) : _isString(value) && ~value.indexOf("random(") ? _replaceRandom(value) : value;
}, _staggerTweenProps = _callbackNames + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert", _staggerPropsToSkip = {};
_forEachName(_staggerTweenProps + ",id,stagger,delay,duration,paused,scrollTrigger", function(name) {
    return _staggerPropsToSkip[name] = 1;
});
var Tween = /*#__PURE__*/ function(_Animation2) {
    _inheritsLoose(Tween, _Animation2);
    function Tween(targets, vars, position, skipInherit) {
        var _this3;
        if (typeof vars === "number") {
            position.duration = vars;
            vars = position;
            position = null;
        }
        _this3 = _Animation2.call(this, skipInherit ? vars : _inheritDefaults(vars)) || this;
        var _this3$vars = _this3.vars, duration = _this3$vars.duration, delay = _this3$vars.delay, immediateRender = _this3$vars.immediateRender, stagger = _this3$vars.stagger, overwrite = _this3$vars.overwrite, keyframes = _this3$vars.keyframes, defaults = _this3$vars.defaults, scrollTrigger = _this3$vars.scrollTrigger, yoyoEase = _this3$vars.yoyoEase, parent = vars.parent || _globalTimeline, parsedTargets = (_isArray(targets) || _isTypedArray(targets) ? _isNumber(targets[0]) : "length" in vars) ? [
            targets
        ] : toArray(targets), tl, i, copy, l, p, curTarget, staggerFunc, staggerVarsToMerge;
        _this3._targets = parsedTargets.length ? _harness(parsedTargets) : _warn("GSAP target " + targets + " not found. https://gsap.com", !_config.nullTargetWarn) || [];
        _this3._ptLookup = []; //PropTween lookup. An array containing an object for each target, having keys for each tweening property
        _this3._overwrite = overwrite;
        if (keyframes || stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
            vars = _this3.vars;
            tl = _this3.timeline = new Timeline({
                data: "nested",
                defaults: defaults || {},
                targets: parent && parent.data === "nested" ? parent.vars.targets : parsedTargets
            }); // we need to store the targets because for staggers and keyframes, we end up creating an individual tween for each but function-based values need to know the index and the whole Array of targets.
            tl.kill();
            tl.parent = tl._dp = _assertThisInitialized(_this3);
            tl._start = 0;
            if (stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
                l = parsedTargets.length;
                staggerFunc = stagger && distribute(stagger);
                if (_isObject(stagger)) {
                    //users can pass in callbacks like onStart/onComplete in the stagger object. These should fire with each individual tween.
                    for(p in stagger)if (~_staggerTweenProps.indexOf(p)) {
                        staggerVarsToMerge || (staggerVarsToMerge = {});
                        staggerVarsToMerge[p] = stagger[p];
                    }
                }
                for(i = 0; i < l; i++){
                    copy = _copyExcluding(vars, _staggerPropsToSkip);
                    copy.stagger = 0;
                    yoyoEase && (copy.yoyoEase = yoyoEase);
                    staggerVarsToMerge && _merge(copy, staggerVarsToMerge);
                    curTarget = parsedTargets[i]; //don't just copy duration or delay because if they're a string or function, we'd end up in an infinite loop because _isFuncOrString() would evaluate as true in the child tweens, entering this loop, etc. So we parse the value straight from vars and default to 0.
                    copy.duration = +_parseFuncOrString(duration, _assertThisInitialized(_this3), i, curTarget, parsedTargets);
                    copy.delay = (+_parseFuncOrString(delay, _assertThisInitialized(_this3), i, curTarget, parsedTargets) || 0) - _this3._delay;
                    if (!stagger && l === 1 && copy.delay) {
                        // if someone does delay:"random(1, 5)", repeat:-1, for example, the delay shouldn't be inside the repeat.
                        _this3._delay = delay = copy.delay;
                        _this3._start += delay;
                        copy.delay = 0;
                    }
                    tl.to(curTarget, copy, staggerFunc ? staggerFunc(i, curTarget, parsedTargets) : 0);
                    tl._ease = _easeMap.none;
                }
                tl.duration() ? duration = delay = 0 : _this3.timeline = 0; // if the timeline's duration is 0, we don't need a timeline internally!
            } else if (keyframes) {
                _inheritDefaults(_setDefaults(tl.vars.defaults, {
                    ease: "none"
                }));
                tl._ease = _parseEase(keyframes.ease || vars.ease || "none");
                var time = 0, a, kf, v;
                if (_isArray(keyframes)) {
                    keyframes.forEach(function(frame) {
                        return tl.to(parsedTargets, frame, ">");
                    });
                    tl.duration(); // to ensure tl._dur is cached because we tap into it for performance purposes in the render() method.
                } else {
                    copy = {};
                    for(p in keyframes)p === "ease" || p === "easeEach" || _parseKeyframe(p, keyframes[p], copy, keyframes.easeEach);
                    for(p in copy){
                        a = copy[p].sort(function(a, b) {
                            return a.t - b.t;
                        });
                        time = 0;
                        for(i = 0; i < a.length; i++){
                            kf = a[i];
                            v = {
                                ease: kf.e,
                                duration: (kf.t - (i ? a[i - 1].t : 0)) / 100 * duration
                            };
                            v[p] = kf.v;
                            tl.to(parsedTargets, v, time);
                            time += v.duration;
                        }
                    }
                    tl.duration() < duration && tl.to({}, {
                        duration: duration - tl.duration()
                    }); // in case keyframes didn't go to 100%
                }
            }
            duration || _this3.duration(duration = tl.duration());
        } else _this3.timeline = 0; //speed optimization, faster lookups (no going up the prototype chain)
        if (overwrite === true && !_suppressOverwrites) {
            _overwritingTween = _assertThisInitialized(_this3);
            _globalTimeline.killTweensOf(parsedTargets);
            _overwritingTween = 0;
        }
        _addToTimeline(parent, _assertThisInitialized(_this3), position);
        vars.reversed && _this3.reverse();
        vars.paused && _this3.paused(true);
        if (immediateRender || !duration && !keyframes && _this3._start === _roundPrecise(parent._time) && _isNotFalse(immediateRender) && _hasNoPausedAncestors(_assertThisInitialized(_this3)) && parent.data !== "nested") {
            _this3._tTime = -_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)
            _this3.render(Math.max(0, -delay) || 0); //in case delay is negative
        }
        scrollTrigger && _scrollTrigger(_assertThisInitialized(_this3), scrollTrigger);
        return _this3;
    }
    var _proto3 = Tween.prototype;
    _proto3.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._tDur, dur = this._dur, isNegative = totalTime < 0, tTime = totalTime > tDur - _tinyNum && !isNegative ? tDur : totalTime < _tinyNum ? 0 : totalTime, time, pt, iteration, cycleDuration, prevIteration, isYoyo, ratio, timeline, yoyoEase;
        if (!dur) _renderZeroDurationTween(this, totalTime, suppressEvents, force);
        else if (tTime !== this._tTime || !totalTime || force || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== isNegative) {
            //this senses if we're crossing over the start time, in which case we must record _zTime and force the render, but we do it in this lengthy conditional way for performance reasons (usually we can skip the calculations): this._initted && (this._zTime < 0) !== (totalTime < 0)
            time = tTime;
            timeline = this.timeline;
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && isNegative) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
                    iteration = this._repeat;
                    time = dur;
                } else {
                    iteration = ~~(tTime / cycleDuration);
                    if (iteration && iteration === _roundPrecise(tTime / cycleDuration)) {
                        time = dur;
                        iteration--;
                    }
                    time > dur && (time = dur);
                }
                isYoyo = this._yoyo && iteration & 1;
                if (isYoyo) {
                    yoyoEase = this._yEase;
                    time = dur - time;
                }
                prevIteration = _animationCycle(this._tTime, cycleDuration);
                if (time === prevTime && !force && this._initted && iteration === prevIteration) {
                    //could be during the repeatDelay part. No need to render and fire callbacks.
                    this._tTime = tTime;
                    return this;
                }
                if (iteration !== prevIteration) {
                    timeline && this._yEase && _propagateYoyoEase(timeline, isYoyo); //repeatRefresh functionality
                    if (this.vars.repeatRefresh && !isYoyo && !this._lock && this._time !== cycleDuration && this._initted) {
                        // this._time will === cycleDuration when we render at EXACTLY the end of an iteration. Without this condition, it'd often do the repeatRefresh render TWICE (again on the very next tick).
                        this._lock = force = 1; //force, otherwise if lazy is true, the _attemptInitTween() will return and we'll jump out and get caught bouncing on each tick.
                        this.render(_roundPrecise(cycleDuration * iteration), true).invalidate()._lock = 0;
                    }
                }
            }
            if (!this._initted) {
                if (_attemptInitTween(this, isNegative ? totalTime : time, force, suppressEvents, tTime)) {
                    this._tTime = 0; // in constructor if immediateRender is true, we set _tTime to -_tinyNum to have the playhead cross the starting point but we can't leave _tTime as a negative number.
                    return this;
                }
                if (prevTime !== this._time && !(force && this.vars.repeatRefresh && iteration !== prevIteration)) // rare edge case - during initialization, an onUpdate in the _startAt (.fromTo()) might force this tween to render at a different spot in which case we should ditch this render() call so that it doesn't revert the values. But we also don't want to dump if we're doing a repeatRefresh render!
                return this;
                if (dur !== this._dur) // while initting, a plugin like InertiaPlugin might alter the duration, so rerun from the start to ensure everything renders as it should.
                return this.render(totalTime, suppressEvents, force);
            }
            this._tTime = tTime;
            this._time = time;
            if (!this._act && this._ts) {
                this._act = 1; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
                this._lazy = 0;
            }
            this.ratio = ratio = (yoyoEase || this._ease)(time / dur);
            if (this._from) this.ratio = ratio = 1 - ratio;
            if (time && !prevTime && !suppressEvents && !iteration) {
                _callback(this, "onStart");
                if (this._tTime !== tTime) // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
                return this;
            }
            pt = this._pt;
            while(pt){
                pt.r(ratio, pt.d);
                pt = pt._next;
            }
            timeline && timeline.render(totalTime < 0 ? totalTime : timeline._dur * timeline._ease(time / this._dur), suppressEvents, force) || this._startAt && (this._zTime = totalTime);
            if (this._onUpdate && !suppressEvents) {
                isNegative && _rewindStartAt(this, totalTime, suppressEvents, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.
                _callback(this, "onUpdate");
            }
            this._repeat && iteration !== prevIteration && this.vars.onRepeat && !suppressEvents && this.parent && _callback(this, "onRepeat");
            if ((tTime === this._tDur || !tTime) && this._tTime === tTime) {
                isNegative && !this._onUpdate && _rewindStartAt(this, totalTime, true, true);
                (totalTime || !dur) && (tTime === this._tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if we're rendering at exactly a time of 0, as there could be autoRevert values that should get set on the next tick (if the playhead goes backward beyond the startTime, negative totalTime). Don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                if (!suppressEvents && !(isNegative && !prevTime) && (tTime || prevTime || isYoyo)) {
                    // if prevTime and tTime are zero, we shouldn't fire the onReverseComplete. This could happen if you gsap.to(... {paused:true}).play();
                    _callback(this, tTime === tDur ? "onComplete" : "onReverseComplete", true);
                    this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                }
            }
        }
        return this;
    };
    _proto3.targets = function targets() {
        return this._targets;
    };
    _proto3.invalidate = function invalidate(soft) {
        // "soft" gives us a way to clear out everything EXCEPT the recorded pre-"from" portion of from() tweens. Otherwise, for example, if you tween.progress(1).render(0, true true).invalidate(), the "from" values would persist and then on the next render, the from() tweens would initialize and the current value would match the "from" values, thus animate from the same value to the same value (no animation). We tap into this in ScrollTrigger's refresh() where we must push a tween to completion and then back again but honor its init state in case the tween is dependent on another tween further up on the page.
        (!soft || !this.vars.runBackwards) && (this._startAt = 0);
        this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0;
        this._ptLookup = [];
        this.timeline && this.timeline.invalidate(soft);
        return _Animation2.prototype.invalidate.call(this, soft);
    };
    _proto3.resetTo = function resetTo(property, value, start, startIsRelative, skipRecursion) {
        _tickerActive || _ticker.wake();
        this._ts || this.play();
        var time = Math.min(this._dur, (this._dp._time - this._start) * this._ts), ratio;
        this._initted || _initTween(this, time);
        ratio = this._ease(time / this._dur); // don't just get tween.ratio because it may not have rendered yet.
        // possible future addition to allow an object with multiple values to update, like tween.resetTo({x: 100, y: 200}); At this point, it doesn't seem worth the added kb given the fact that most users will likely opt for the convenient gsap.quickTo() way of interacting with this method.
        // if (_isObject(property)) { // performance optimization
        // 	for (p in property) {
        // 		if (_updatePropTweens(this, p, property[p], value ? value[p] : null, start, ratio, time)) {
        // 			return this.resetTo(property, value, start, startIsRelative); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
        // 		}
        // 	}
        // } else {
        if (_updatePropTweens(this, property, value, start, startIsRelative, ratio, time, skipRecursion)) return this.resetTo(property, value, start, startIsRelative, 1); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
         //}
        _alignPlayhead(this, 0);
        this.parent || _addLinkedListItem(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0);
        return this.render(0);
    };
    _proto3.kill = function kill(targets, vars) {
        if (vars === void 0) vars = "all";
        if (!targets && (!vars || vars === "all")) {
            this._lazy = this._pt = 0;
            return this.parent ? _interrupt(this) : this;
        }
        if (this.timeline) {
            var tDur = this.timeline.totalDuration();
            this.timeline.killTweensOf(targets, vars, _overwritingTween && _overwritingTween.vars.overwrite !== true)._first || _interrupt(this); // if nothing is left tweening, interrupt.
            this.parent && tDur !== this.timeline.totalDuration() && _setDuration(this, this._dur * this.timeline._tDur / tDur, 0, 1); // if a nested tween is killed that changes the duration, it should affect this tween's duration. We must use the ratio, though, because sometimes the internal timeline is stretched like for keyframes where they don't all add up to whatever the parent tween's duration was set to.
            return this;
        }
        var parsedTargets = this._targets, killingTargets = targets ? toArray(targets) : parsedTargets, propTweenLookup = this._ptLookup, firstPT = this._pt, overwrittenProps, curLookup, curOverwriteProps, props, p, pt, i;
        if ((!vars || vars === "all") && _arraysMatch(parsedTargets, killingTargets)) {
            vars === "all" && (this._pt = 0);
            return _interrupt(this);
        }
        overwrittenProps = this._op = this._op || [];
        if (vars !== "all") {
            //so people can pass in a comma-delimited list of property names
            if (_isString(vars)) {
                p = {};
                _forEachName(vars, function(name) {
                    return p[name] = 1;
                });
                vars = p;
            }
            vars = _addAliasesToVars(parsedTargets, vars);
        }
        i = parsedTargets.length;
        while(i--)if (~killingTargets.indexOf(parsedTargets[i])) {
            curLookup = propTweenLookup[i];
            if (vars === "all") {
                overwrittenProps[i] = vars;
                props = curLookup;
                curOverwriteProps = {};
            } else {
                curOverwriteProps = overwrittenProps[i] = overwrittenProps[i] || {};
                props = vars;
            }
            for(p in props){
                pt = curLookup && curLookup[p];
                if (pt) {
                    if (!("kill" in pt.d) || pt.d.kill(p) === true) _removeLinkedListItem(this, pt, "_pt");
                    delete curLookup[p];
                }
                if (curOverwriteProps !== "all") curOverwriteProps[p] = 1;
            }
        }
        this._initted && !this._pt && firstPT && _interrupt(this); //if all tweening properties are killed, kill the tween. Without this line, if there's a tween with multiple targets and then you killTweensOf() each target individually, the tween would technically still remain active and fire its onComplete even though there aren't any more properties tweening.
        return this;
    };
    Tween.to = function to(targets, vars) {
        return new Tween(targets, vars, arguments[2]);
    };
    Tween.from = function from(targets, vars) {
        return _createTweenType(1, arguments);
    };
    Tween.delayedCall = function delayedCall(delay, callback, params, scope) {
        return new Tween(callback, 0, {
            immediateRender: false,
            lazy: false,
            overwrite: false,
            delay: delay,
            onComplete: callback,
            onReverseComplete: callback,
            onCompleteParams: params,
            onReverseCompleteParams: params,
            callbackScope: scope
        }); // we must use onReverseComplete too for things like timeline.add(() => {...}) which should be triggered in BOTH directions (forward and reverse)
    };
    Tween.fromTo = function fromTo(targets, fromVars, toVars) {
        return _createTweenType(2, arguments);
    };
    Tween.set = function set(targets, vars) {
        vars.duration = 0;
        vars.repeatDelay || (vars.repeat = 0);
        return new Tween(targets, vars);
    };
    Tween.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        return _globalTimeline.killTweensOf(targets, props, onlyActive);
    };
    return Tween;
}(Animation);
_setDefaults(Tween.prototype, {
    _targets: [],
    _lazy: 0,
    _startAt: 0,
    _op: 0,
    _onInit: 0
}); //add the pertinent timeline methods to Tween instances so that users can chain conveniently and create a timeline automatically. (removed due to concerns that it'd ultimately add to more confusion especially for beginners)
// _forEachName("to,from,fromTo,set,call,add,addLabel,addPause", name => {
// 	Tween.prototype[name] = function() {
// 		let tl = new Timeline();
// 		return _addToTimeline(tl, this)[name].apply(tl, toArray(arguments));
// 	}
// });
//for backward compatibility. Leverage the timeline calls.
_forEachName("staggerTo,staggerFrom,staggerFromTo", function(name) {
    Tween[name] = function() {
        var tl = new Timeline(), params = _slice.call(arguments, 0);
        params.splice(name === "staggerFromTo" ? 5 : 4, 0, 0);
        return tl[name].apply(tl, params);
    };
});
/*
 * --------------------------------------------------------------------------------------
 * PROPTWEEN
 * --------------------------------------------------------------------------------------
 */ var _setterPlain = function _setterPlain(target, property, value) {
    return target[property] = value;
}, _setterFunc = function _setterFunc(target, property, value) {
    return target[property](value);
}, _setterFuncWithParam = function _setterFuncWithParam(target, property, value, data) {
    return target[property](data.fp, value);
}, _setterAttribute = function _setterAttribute(target, property, value) {
    return target.setAttribute(property, value);
}, _getSetter = function _getSetter(target, property) {
    return _isFunction(target[property]) ? _setterFunc : _isUndefined(target[property]) && target.setAttribute ? _setterAttribute : _setterPlain;
}, _renderPlain = function _renderPlain(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 1000000) / 1000000, data);
}, _renderBoolean = function _renderBoolean(ratio, data) {
    return data.set(data.t, data.p, !!(data.s + data.c * ratio), data);
}, _renderComplexString = function _renderComplexString(ratio, data) {
    var pt = data._pt, s = "";
    if (!ratio && data.b) //b = beginning string
    s = data.b;
    else if (ratio === 1 && data.e) //e = ending string
    s = data.e;
    else {
        while(pt){
            s = pt.p + (pt.m ? pt.m(pt.s + pt.c * ratio) : Math.round((pt.s + pt.c * ratio) * 10000) / 10000) + s; //we use the "p" property for the text inbetween (like a suffix). And in the context of a complex string, the modifier (m) is typically just Math.round(), like for RGB colors.
            pt = pt._next;
        }
        s += data.c; //we use the "c" of the PropTween to store the final chunk of non-numeric text.
    }
    data.set(data.t, data.p, s, data);
}, _renderPropTweens = function _renderPropTweens(ratio, data) {
    var pt = data._pt;
    while(pt){
        pt.r(ratio, pt.d);
        pt = pt._next;
    }
}, _addPluginModifier = function _addPluginModifier(modifier, tween, target, property) {
    var pt = this._pt, next;
    while(pt){
        next = pt._next;
        pt.p === property && pt.modifier(modifier, tween, target);
        pt = next;
    }
}, _killPropTweensOf = function _killPropTweensOf(property) {
    var pt = this._pt, hasNonDependentRemaining, next;
    while(pt){
        next = pt._next;
        if (pt.p === property && !pt.op || pt.op === property) _removeLinkedListItem(this, pt, "_pt");
        else if (!pt.dep) hasNonDependentRemaining = 1;
        pt = next;
    }
    return !hasNonDependentRemaining;
}, _setterWithModifier = function _setterWithModifier(target, property, value, data) {
    data.mSet(target, property, data.m.call(data.tween, value, data.mt), data);
}, _sortPropTweensByPriority = function _sortPropTweensByPriority(parent) {
    var pt = parent._pt, next, pt2, first, last; //sorts the PropTween linked list in order of priority because some plugins need to do their work after ALL of the PropTweens were created (like RoundPropsPlugin and ModifiersPlugin)
    while(pt){
        next = pt._next;
        pt2 = first;
        while(pt2 && pt2.pr > pt.pr)pt2 = pt2._next;
        if (pt._prev = pt2 ? pt2._prev : last) pt._prev._next = pt;
        else first = pt;
        if (pt._next = pt2) pt2._prev = pt;
        else last = pt;
        pt = next;
    }
    parent._pt = first;
}; //PropTween key: t = target, p = prop, r = renderer, d = data, s = start, c = change, op = overwriteProperty (ONLY populated when it's different than p), pr = priority, _next/_prev for the linked list siblings, set = setter, m = modifier, mSet = modifierSetter (the original setter, before a modifier was added)
var PropTween = /*#__PURE__*/ function() {
    function PropTween(next, target, prop, start, change, renderer, data, setter, priority) {
        this.t = target;
        this.s = start;
        this.c = change;
        this.p = prop;
        this.r = renderer || _renderPlain;
        this.d = data || this;
        this.set = setter || _setterPlain;
        this.pr = priority || 0;
        this._next = next;
        if (next) next._prev = this;
    }
    var _proto4 = PropTween.prototype;
    _proto4.modifier = function modifier(func, tween, target) {
        this.mSet = this.mSet || this.set; //in case it was already set (a PropTween can only have one modifier)
        this.set = _setterWithModifier;
        this.m = func;
        this.mt = target; //modifier target
        this.tween = tween;
    };
    return PropTween;
}(); //Initialization tasks
_forEachName(_callbackNames + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger", function(name) {
    return _reservedProps[name] = 1;
});
_globals.TweenMax = _globals.TweenLite = Tween;
_globals.TimelineLite = _globals.TimelineMax = Timeline;
_globalTimeline = new Timeline({
    sortChildren: false,
    defaults: _defaults,
    autoRemoveChildren: true,
    id: "root",
    smoothChildTiming: true
});
_config.stringFilter = _colorStringFilter;
var _media = [], _listeners = {}, _emptyArray = [], _lastMediaTime = 0, _contextID = 0, _dispatch = function _dispatch(type) {
    return (_listeners[type] || _emptyArray).map(function(f) {
        return f();
    });
}, _onMediaChange = function _onMediaChange() {
    var time = Date.now(), matches = [];
    if (time - _lastMediaTime > 2) {
        _dispatch("matchMediaInit");
        _media.forEach(function(c) {
            var queries = c.queries, conditions = c.conditions, match, p, anyMatch, toggled;
            for(p in queries){
                match = _win.matchMedia(queries[p]).matches; // Firefox doesn't update the "matches" property of the MediaQueryList object correctly - it only does so as it calls its change handler - so we must re-create a media query here to ensure it's accurate.
                match && (anyMatch = 1);
                if (match !== conditions[p]) {
                    conditions[p] = match;
                    toggled = 1;
                }
            }
            if (toggled) {
                c.revert();
                anyMatch && matches.push(c);
            }
        });
        _dispatch("matchMediaRevert");
        matches.forEach(function(c) {
            return c.onMatch(c, function(func) {
                return c.add(null, func);
            });
        });
        _lastMediaTime = time;
        _dispatch("matchMedia");
    }
};
var Context = /*#__PURE__*/ function() {
    function Context(func, scope) {
        this.selector = scope && selector(scope);
        this.data = [];
        this._r = []; // returned/cleanup functions
        this.isReverted = false;
        this.id = _contextID++; // to work around issues that frameworks like Vue cause by making things into Proxies which make it impossible to do something like _media.indexOf(this) because "this" would no longer refer to the Context instance itself - it'd refer to a Proxy! We needed a way to identify the context uniquely
        func && this.add(func);
    }
    var _proto5 = Context.prototype;
    _proto5.add = function add(name, func, scope) {
        // possible future addition if we need the ability to add() an animation to a context and for whatever reason cannot create that animation inside of a context.add(() => {...}) function.
        // if (name && _isFunction(name.revert)) {
        // 	this.data.push(name);
        // 	return (name._ctx = this);
        // }
        if (_isFunction(name)) {
            scope = func;
            func = name;
            name = _isFunction;
        }
        var self = this, f = function f() {
            var prev = _context, prevSelector = self.selector, result;
            prev && prev !== self && prev.data.push(self);
            scope && (self.selector = selector(scope));
            _context = self;
            result = func.apply(self, arguments);
            _isFunction(result) && self._r.push(result);
            _context = prev;
            self.selector = prevSelector;
            self.isReverted = false;
            return result;
        };
        self.last = f;
        return name === _isFunction ? f(self, function(func) {
            return self.add(null, func);
        }) : name ? self[name] = f : f;
    };
    _proto5.ignore = function ignore(func) {
        var prev = _context;
        _context = null;
        func(this);
        _context = prev;
    };
    _proto5.getTweens = function getTweens() {
        var a = [];
        this.data.forEach(function(e) {
            return e instanceof Context ? a.push.apply(a, e.getTweens()) : e instanceof Tween && !(e.parent && e.parent.data === "nested") && a.push(e);
        });
        return a;
    };
    _proto5.clear = function clear() {
        this._r.length = this.data.length = 0;
    };
    _proto5.kill = function kill(revert, matchMedia) {
        var _this4 = this;
        if (revert) (function() {
            var tweens = _this4.getTweens(), i = _this4.data.length, t;
            while(i--){
                // Flip plugin tweens are very different in that they should actually be pushed to their end. The plugin replaces the timeline's .revert() method to do exactly that. But we also need to remove any of those nested tweens inside the flip timeline so that they don't get individually reverted.
                t = _this4.data[i];
                if (t.data === "isFlip") {
                    t.revert();
                    t.getChildren(true, true, false).forEach(function(tween) {
                        return tweens.splice(tweens.indexOf(tween), 1);
                    });
                }
            } // save as an object so that we can cache the globalTime for each tween to optimize performance during the sort
            tweens.map(function(t) {
                return {
                    g: t._dur || t._delay || t._sat && !t._sat.vars.immediateRender ? t.globalTime(0) : -Infinity,
                    t: t
                };
            }).sort(function(a, b) {
                return b.g - a.g || -Infinity;
            }).forEach(function(o) {
                return o.t.revert(revert);
            }); // note: all of the _startAt tweens should be reverted in reverse order that they were created, and they'll all have the same globalTime (-1) so the " || -1" in the sort keeps the order properly.
            i = _this4.data.length;
            while(i--){
                // make sure we loop backwards so that, for example, SplitTexts that were created later on the same element get reverted first
                t = _this4.data[i];
                if (t instanceof Timeline) {
                    if (t.data !== "nested") {
                        t.scrollTrigger && t.scrollTrigger.revert();
                        t.kill(); // don't revert() the timeline because that's duplicating efforts since we already reverted all the tweens
                    }
                } else !(t instanceof Tween) && t.revert && t.revert(revert);
            }
            _this4._r.forEach(function(f) {
                return f(revert, _this4);
            });
            _this4.isReverted = true;
        })();
        else this.data.forEach(function(e) {
            return e.kill && e.kill();
        });
        this.clear();
        if (matchMedia) {
            var i = _media.length;
            while(i--)// previously, we checked _media.indexOf(this), but some frameworks like Vue enforce Proxy objects that make it impossible to get the proper result that way, so we must use a unique ID number instead.
            _media[i].id === this.id && _media.splice(i, 1);
        }
    };
    _proto5.revert = function revert(config) {
        this.kill(config || {});
    };
    return Context;
}();
var MatchMedia = /*#__PURE__*/ function() {
    function MatchMedia(scope) {
        this.contexts = [];
        this.scope = scope;
        _context && _context.data.push(this);
    }
    var _proto6 = MatchMedia.prototype;
    _proto6.add = function add(conditions, func, scope) {
        _isObject(conditions) || (conditions = {
            matches: conditions
        });
        var context = new Context(0, scope || this.scope), cond = context.conditions = {}, mq, p, active;
        _context && !context.selector && (context.selector = _context.selector); // in case a context is created inside a context. Like a gsap.matchMedia() that's inside a scoped gsap.context()
        this.contexts.push(context);
        func = context.add("onMatch", func);
        context.queries = conditions;
        for(p in conditions)if (p === "all") active = 1;
        else {
            mq = _win.matchMedia(conditions[p]);
            if (mq) {
                _media.indexOf(context) < 0 && _media.push(context);
                (cond[p] = mq.matches) && (active = 1);
                mq.addListener ? mq.addListener(_onMediaChange) : mq.addEventListener("change", _onMediaChange);
            }
        }
        active && func(context, function(f) {
            return context.add(null, f);
        });
        return this;
    } // refresh() {
    ;
    _proto6.revert = function revert(config) {
        this.kill(config || {});
    };
    _proto6.kill = function kill(revert) {
        this.contexts.forEach(function(c) {
            return c.kill(revert, true);
        });
    };
    return MatchMedia;
}();
/*
 * --------------------------------------------------------------------------------------
 * GSAP
 * --------------------------------------------------------------------------------------
 */ var _gsap = {
    registerPlugin: function registerPlugin() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        args.forEach(function(config) {
            return _createPlugin(config);
        });
    },
    timeline: function timeline(vars) {
        return new Timeline(vars);
    },
    getTweensOf: function getTweensOf(targets, onlyActive) {
        return _globalTimeline.getTweensOf(targets, onlyActive);
    },
    getProperty: function getProperty(target, property, unit, uncache) {
        _isString(target) && (target = toArray(target)[0]); //in case selector text or an array is passed in
        var getter = _getCache(target || {}).get, format = unit ? _passThrough : _numericIfPossible;
        unit === "native" && (unit = "");
        return !target ? target : !property ? function(property, unit, uncache) {
            return format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
        } : format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
    },
    quickSetter: function quickSetter(target, property, unit) {
        target = toArray(target);
        if (target.length > 1) {
            var setters = target.map(function(t) {
                return gsap.quickSetter(t, property, unit);
            }), l = setters.length;
            return function(value) {
                var i = l;
                while(i--)setters[i](value);
            };
        }
        target = target[0] || {};
        var Plugin = _plugins[property], cache = _getCache(target), p = cache.harness && (cache.harness.aliases || {})[property] || property, // in case it's an alias, like "rotate" for "rotation".
        setter = Plugin ? function(value) {
            var p = new Plugin();
            _quickTween._pt = 0;
            p.init(target, unit ? value + unit : value, _quickTween, 0, [
                target
            ]);
            p.render(1, p);
            _quickTween._pt && _renderPropTweens(1, _quickTween);
        } : cache.set(target, p);
        return Plugin ? setter : function(value) {
            return setter(target, p, unit ? value + unit : value, cache, 1);
        };
    },
    quickTo: function quickTo(target, property, vars) {
        var _merge2;
        var tween = gsap.to(target, _merge((_merge2 = {}, _merge2[property] = "+=0.1", _merge2.paused = true, _merge2), vars || {})), func = function func(value, start, startIsRelative) {
            return tween.resetTo(property, value, start, startIsRelative);
        };
        func.tween = tween;
        return func;
    },
    isTweening: function isTweening(targets) {
        return _globalTimeline.getTweensOf(targets, true).length > 0;
    },
    defaults: function defaults(value) {
        value && value.ease && (value.ease = _parseEase(value.ease, _defaults.ease));
        return _mergeDeep(_defaults, value || {});
    },
    config: function config(value) {
        return _mergeDeep(_config, value || {});
    },
    registerEffect: function registerEffect(_ref3) {
        var name = _ref3.name, effect = _ref3.effect, plugins = _ref3.plugins, defaults = _ref3.defaults, extendTimeline = _ref3.extendTimeline;
        (plugins || "").split(",").forEach(function(pluginName) {
            return pluginName && !_plugins[pluginName] && !_globals[pluginName] && _warn(name + " effect requires " + pluginName + " plugin.");
        });
        _effects[name] = function(targets, vars, tl) {
            return effect(toArray(targets), _setDefaults(vars || {}, defaults), tl);
        };
        if (extendTimeline) Timeline.prototype[name] = function(targets, vars, position) {
            return this.add(_effects[name](targets, _isObject(vars) ? vars : (position = vars) && {}, this), position);
        };
    },
    registerEase: function registerEase(name, ease) {
        _easeMap[name] = _parseEase(ease);
    },
    parseEase: function parseEase(ease, defaultEase) {
        return arguments.length ? _parseEase(ease, defaultEase) : _easeMap;
    },
    getById: function getById(id) {
        return _globalTimeline.getById(id);
    },
    exportRoot: function exportRoot(vars, includeDelayedCalls) {
        if (vars === void 0) vars = {};
        var tl = new Timeline(vars), child, next;
        tl.smoothChildTiming = _isNotFalse(vars.smoothChildTiming);
        _globalTimeline.remove(tl);
        tl._dp = 0; //otherwise it'll get re-activated when adding children and be re-introduced into _globalTimeline's linked list (then added to itself).
        tl._time = tl._tTime = _globalTimeline._time;
        child = _globalTimeline._first;
        while(child){
            next = child._next;
            if (includeDelayedCalls || !(!child._dur && child instanceof Tween && child.vars.onComplete === child._targets[0])) _addToTimeline(tl, child, child._start - child._delay);
            child = next;
        }
        _addToTimeline(_globalTimeline, tl, 0);
        return tl;
    },
    context: function context(func, scope) {
        return func ? new Context(func, scope) : _context;
    },
    matchMedia: function matchMedia(scope) {
        return new MatchMedia(scope);
    },
    matchMediaRefresh: function matchMediaRefresh() {
        return _media.forEach(function(c) {
            var cond = c.conditions, found, p;
            for(p in cond)if (cond[p]) {
                cond[p] = false;
                found = 1;
            }
            found && c.revert();
        }) || _onMediaChange();
    },
    addEventListener: function addEventListener(type, callback) {
        var a = _listeners[type] || (_listeners[type] = []);
        ~a.indexOf(callback) || a.push(callback);
    },
    removeEventListener: function removeEventListener(type, callback) {
        var a = _listeners[type], i = a && a.indexOf(callback);
        i >= 0 && a.splice(i, 1);
    },
    utils: {
        wrap: wrap,
        wrapYoyo: wrapYoyo,
        distribute: distribute,
        random: random,
        snap: snap,
        normalize: normalize,
        getUnit: getUnit,
        clamp: clamp,
        splitColor: splitColor,
        toArray: toArray,
        selector: selector,
        mapRange: mapRange,
        pipe: pipe,
        unitize: unitize,
        interpolate: interpolate,
        shuffle: shuffle
    },
    install: _install,
    effects: _effects,
    ticker: _ticker,
    updateRoot: Timeline.updateRoot,
    plugins: _plugins,
    globalTimeline: _globalTimeline,
    core: {
        PropTween: PropTween,
        globals: _addGlobal,
        Tween: Tween,
        Timeline: Timeline,
        Animation: Animation,
        getCache: _getCache,
        _removeLinkedListItem: _removeLinkedListItem,
        reverting: function reverting() {
            return _reverting;
        },
        context: function context(toAdd) {
            if (toAdd && _context) {
                _context.data.push(toAdd);
                toAdd._ctx = _context;
            }
            return _context;
        },
        suppressOverwrites: function suppressOverwrites(value) {
            return _suppressOverwrites = value;
        }
    }
};
_forEachName("to,from,fromTo,delayedCall,set,killTweensOf", function(name) {
    return _gsap[name] = Tween[name];
});
_ticker.add(Timeline.updateRoot);
_quickTween = _gsap.to({}, {
    duration: 0
}); // ---- EXTRA PLUGINS --------------------------------------------------------
var _getPluginPropTween = function _getPluginPropTween(plugin, prop) {
    var pt = plugin._pt;
    while(pt && pt.p !== prop && pt.op !== prop && pt.fp !== prop)pt = pt._next;
    return pt;
}, _addModifiers = function _addModifiers(tween, modifiers) {
    var targets = tween._targets, p, i, pt;
    for(p in modifiers){
        i = targets.length;
        while(i--){
            pt = tween._ptLookup[i][p];
            if (pt && (pt = pt.d)) {
                if (pt._pt) // is a plugin
                pt = _getPluginPropTween(pt, p);
                pt && pt.modifier && pt.modifier(modifiers[p], tween, targets[i], p);
            }
        }
    }
}, _buildModifierPlugin = function _buildModifierPlugin(name, modifier) {
    return {
        name: name,
        rawVars: 1,
        //don't pre-process function-based values or "random()" strings.
        init: function init(target, vars, tween) {
            tween._onInit = function(tween) {
                var temp, p;
                if (_isString(vars)) {
                    temp = {};
                    _forEachName(vars, function(name) {
                        return temp[name] = 1;
                    }); //if the user passes in a comma-delimited list of property names to roundProps, like "x,y", we round to whole numbers.
                    vars = temp;
                }
                if (modifier) {
                    temp = {};
                    for(p in vars)temp[p] = modifier(vars[p]);
                    vars = temp;
                }
                _addModifiers(tween, vars);
            };
        }
    };
}; //register core plugins
var gsap = _gsap.registerPlugin({
    name: "attr",
    init: function init(target, vars, tween, index, targets) {
        var p, pt, v;
        this.tween = tween;
        for(p in vars){
            v = target.getAttribute(p) || "";
            pt = this.add(target, "setAttribute", (v || 0) + "", vars[p], index, targets, 0, 0, p);
            pt.op = p;
            pt.b = v; // record the beginning value so we can revert()
            this._props.push(p);
        }
    },
    render: function render(ratio, data) {
        var pt = data._pt;
        while(pt){
            _reverting ? pt.set(pt.t, pt.p, pt.b, pt) : pt.r(ratio, pt.d); // if reverting, go back to the original (pt.b)
            pt = pt._next;
        }
    }
}, {
    name: "endArray",
    init: function init(target, value) {
        var i = value.length;
        while(i--)this.add(target, i, target[i] || 0, value[i], 0, 0, 0, 0, 0, 1);
    }
}, _buildModifierPlugin("roundProps", _roundModifier), _buildModifierPlugin("modifiers"), _buildModifierPlugin("snap", snap)) || _gsap; //to prevent the core plugins from being dropped via aggressive tree shaking, we must include them in the variable declaration in this way.
Tween.version = Timeline.version = gsap.version = "3.12.5";
_coreReady = 1;
_windowExists() && _wake();
var Power0 = _easeMap.Power0, Power1 = _easeMap.Power1, Power2 = _easeMap.Power2, Power3 = _easeMap.Power3, Power4 = _easeMap.Power4, Linear = _easeMap.Linear, Quad = _easeMap.Quad, Cubic = _easeMap.Cubic, Quart = _easeMap.Quart, Quint = _easeMap.Quint, Strong = _easeMap.Strong, Elastic = _easeMap.Elastic, Back = _easeMap.Back, SteppedEase = _easeMap.SteppedEase, Bounce = _easeMap.Bounce, Sine = _easeMap.Sine, Expo = _easeMap.Expo, Circ = _easeMap.Circ;

});


var $jk9Tw = parcelRequire("jk9Tw");

var $2Dfnu = parcelRequire("2Dfnu");

var $adylO = parcelRequire("adylO");

var $7HZRt = parcelRequire("7HZRt");
/*!
 * CSSPlugin 3.12.5
 * https://gsap.com
 *
 * Copyright 2008-2024, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ 
var $7HZRt = parcelRequire("7HZRt");
var $bb9415d43f60f2ec$var$_win, $bb9415d43f60f2ec$var$_doc, $bb9415d43f60f2ec$var$_docElement, $bb9415d43f60f2ec$var$_pluginInitted, $bb9415d43f60f2ec$var$_tempDiv, $bb9415d43f60f2ec$var$_tempDivStyler, $bb9415d43f60f2ec$var$_recentSetterPlugin, $bb9415d43f60f2ec$var$_reverting, $bb9415d43f60f2ec$var$_windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, $bb9415d43f60f2ec$var$_transformProps = {}, $bb9415d43f60f2ec$var$_RAD2DEG = 180 / Math.PI, $bb9415d43f60f2ec$var$_DEG2RAD = Math.PI / 180, $bb9415d43f60f2ec$var$_atan2 = Math.atan2, $bb9415d43f60f2ec$var$_bigNum = 1e8, $bb9415d43f60f2ec$var$_capsExp = /([A-Z])/g, $bb9415d43f60f2ec$var$_horizontalExp = /(left|right|width|margin|padding|x)/i, $bb9415d43f60f2ec$var$_complexExp = /[\s,\(]\S/, $bb9415d43f60f2ec$var$_propertyAliases = {
    autoAlpha: "opacity,visibility",
    scale: "scaleX,scaleY",
    alpha: "opacity"
}, $bb9415d43f60f2ec$var$_renderCSSProp = function _renderCSSProp(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
}, $bb9415d43f60f2ec$var$_renderPropWithEnd = function _renderPropWithEnd(ratio, data) {
    return data.set(data.t, data.p, ratio === 1 ? data.e : Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
}, $bb9415d43f60f2ec$var$_renderCSSPropWithBeginning = function _renderCSSPropWithBeginning(ratio, data) {
    return data.set(data.t, data.p, ratio ? Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u : data.b, data);
}, //if units change, we need a way to render the original unit/value when the tween goes all the way back to the beginning (ratio:0)
$bb9415d43f60f2ec$var$_renderRoundedCSSProp = function _renderRoundedCSSProp(ratio, data) {
    var value = data.s + data.c * ratio;
    data.set(data.t, data.p, ~~(value + (value < 0 ? -0.5 : .5)) + data.u, data);
}, $bb9415d43f60f2ec$var$_renderNonTweeningValue = function _renderNonTweeningValue(ratio, data) {
    return data.set(data.t, data.p, ratio ? data.e : data.b, data);
}, $bb9415d43f60f2ec$var$_renderNonTweeningValueOnlyAtEnd = function _renderNonTweeningValueOnlyAtEnd(ratio, data) {
    return data.set(data.t, data.p, ratio !== 1 ? data.b : data.e, data);
}, $bb9415d43f60f2ec$var$_setterCSSStyle = function _setterCSSStyle(target, property, value) {
    return target.style[property] = value;
}, $bb9415d43f60f2ec$var$_setterCSSProp = function _setterCSSProp(target, property, value) {
    return target.style.setProperty(property, value);
}, $bb9415d43f60f2ec$var$_setterTransform = function _setterTransform(target, property, value) {
    return target._gsap[property] = value;
}, $bb9415d43f60f2ec$var$_setterScale = function _setterScale(target, property, value) {
    return target._gsap.scaleX = target._gsap.scaleY = value;
}, $bb9415d43f60f2ec$var$_setterScaleWithRender = function _setterScaleWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache.scaleX = cache.scaleY = value;
    cache.renderTransform(ratio, cache);
}, $bb9415d43f60f2ec$var$_setterTransformWithRender = function _setterTransformWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache[property] = value;
    cache.renderTransform(ratio, cache);
}, $bb9415d43f60f2ec$var$_transformProp = "transform", $bb9415d43f60f2ec$var$_transformOriginProp = $bb9415d43f60f2ec$var$_transformProp + "Origin", $bb9415d43f60f2ec$var$_saveStyle = function _saveStyle(property, isNotCSS) {
    var _this = this;
    var target = this.target, style = target.style, cache = target._gsap;
    if (property in $bb9415d43f60f2ec$var$_transformProps && style) {
        this.tfm = this.tfm || {};
        if (property !== "transform") {
            property = $bb9415d43f60f2ec$var$_propertyAliases[property] || property;
            ~property.indexOf(",") ? property.split(",").forEach(function(a) {
                return _this.tfm[a] = $bb9415d43f60f2ec$var$_get(target, a);
            }) : this.tfm[property] = cache.x ? cache[property] : $bb9415d43f60f2ec$var$_get(target, property); // note: scale would map to "scaleX,scaleY", thus we loop and apply them both.
            property === $bb9415d43f60f2ec$var$_transformOriginProp && (this.tfm.zOrigin = cache.zOrigin);
        } else return $bb9415d43f60f2ec$var$_propertyAliases.transform.split(",").forEach(function(p) {
            return _saveStyle.call(_this, p, isNotCSS);
        });
        if (this.props.indexOf($bb9415d43f60f2ec$var$_transformProp) >= 0) return;
        if (cache.svg) {
            this.svgo = target.getAttribute("data-svg-origin");
            this.props.push($bb9415d43f60f2ec$var$_transformOriginProp, isNotCSS, "");
        }
        property = $bb9415d43f60f2ec$var$_transformProp;
    }
    (style || isNotCSS) && this.props.push(property, isNotCSS, style[property]);
}, $bb9415d43f60f2ec$var$_removeIndependentTransforms = function _removeIndependentTransforms(style) {
    if (style.translate) {
        style.removeProperty("translate");
        style.removeProperty("scale");
        style.removeProperty("rotate");
    }
}, $bb9415d43f60f2ec$var$_revertStyle = function _revertStyle() {
    var props = this.props, target = this.target, style = target.style, cache = target._gsap, i, p;
    for(i = 0; i < props.length; i += 3)// stored like this: property, isNotCSS, value
    props[i + 1] ? target[props[i]] = props[i + 2] : props[i + 2] ? style[props[i]] = props[i + 2] : style.removeProperty(props[i].substr(0, 2) === "--" ? props[i] : props[i].replace($bb9415d43f60f2ec$var$_capsExp, "-$1").toLowerCase());
    if (this.tfm) {
        for(p in this.tfm)cache[p] = this.tfm[p];
        if (cache.svg) {
            cache.renderTransform();
            target.setAttribute("data-svg-origin", this.svgo || "");
        }
        i = $bb9415d43f60f2ec$var$_reverting();
        if ((!i || !i.isStart) && !style[$bb9415d43f60f2ec$var$_transformProp]) {
            $bb9415d43f60f2ec$var$_removeIndependentTransforms(style);
            if (cache.zOrigin && style[$bb9415d43f60f2ec$var$_transformOriginProp]) {
                style[$bb9415d43f60f2ec$var$_transformOriginProp] += " " + cache.zOrigin + "px"; // since we're uncaching, we must put the zOrigin back into the transformOrigin so that we can pull it out accurately when we parse again. Otherwise, we'd lose the z portion of the origin since we extract it to protect from Safari bugs.
                cache.zOrigin = 0;
                cache.renderTransform();
            }
            cache.uncache = 1; // if it's a startAt that's being reverted in the _initTween() of the core, we don't need to uncache transforms. This is purely a performance optimization.
        }
    }
}, $bb9415d43f60f2ec$var$_getStyleSaver = function _getStyleSaver(target, properties) {
    var saver = {
        target: target,
        props: [],
        revert: $bb9415d43f60f2ec$var$_revertStyle,
        save: $bb9415d43f60f2ec$var$_saveStyle
    };
    target._gsap || (0, $7HZRt.gsap).core.getCache(target); // just make sure there's a _gsap cache defined because we read from it in _saveStyle() and it's more efficient to just check it here once.
    properties && properties.split(",").forEach(function(p) {
        return saver.save(p);
    });
    return saver;
}, $bb9415d43f60f2ec$var$_supports3D, $bb9415d43f60f2ec$export$a232bb0480ae674a = function _createElement(type, ns) {
    var e = $bb9415d43f60f2ec$var$_doc.createElementNS ? $bb9415d43f60f2ec$var$_doc.createElementNS((ns || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), type) : $bb9415d43f60f2ec$var$_doc.createElement(type); //some servers swap in https for http in the namespace which can break things, making "style" inaccessible.
    return e && e.style ? e : $bb9415d43f60f2ec$var$_doc.createElement(type); //some environments won't allow access to the element's style when created with a namespace in which case we default to the standard createElement() to work around the issue. Also note that when GSAP is embedded directly inside an SVG file, createElement() won't allow access to the style object in Firefox (see https://gsap.com/forums/topic/20215-problem-using-tweenmax-in-standalone-self-containing-svg-file-err-cannot-set-property-csstext-of-undefined/).
}, $bb9415d43f60f2ec$var$_getComputedProperty = function _getComputedProperty(target, property, skipPrefixFallback) {
    var cs = getComputedStyle(target);
    return cs[property] || cs.getPropertyValue(property.replace($bb9415d43f60f2ec$var$_capsExp, "-$1").toLowerCase()) || cs.getPropertyValue(property) || !skipPrefixFallback && _getComputedProperty(target, $bb9415d43f60f2ec$export$8cbef5dd49a09c8b(property) || property, 1) || ""; //css variables may not need caps swapped out for dashes and lowercase.
}, $bb9415d43f60f2ec$var$_prefixes = "O,Moz,ms,Ms,Webkit".split(","), $bb9415d43f60f2ec$export$8cbef5dd49a09c8b = function _checkPropPrefix(property, element, preferPrefix) {
    var e = element || $bb9415d43f60f2ec$var$_tempDiv, s = e.style, i = 5;
    if (property in s && !preferPrefix) return property;
    property = property.charAt(0).toUpperCase() + property.substr(1);
    while(i-- && !($bb9415d43f60f2ec$var$_prefixes[i] + property in s));
    return i < 0 ? null : (i === 3 ? "ms" : i >= 0 ? $bb9415d43f60f2ec$var$_prefixes[i] : "") + property;
}, $bb9415d43f60f2ec$var$_initCore = function _initCore() {
    if ($bb9415d43f60f2ec$var$_windowExists() && window.document) {
        $bb9415d43f60f2ec$var$_win = window;
        $bb9415d43f60f2ec$var$_doc = $bb9415d43f60f2ec$var$_win.document;
        $bb9415d43f60f2ec$var$_docElement = $bb9415d43f60f2ec$var$_doc.documentElement;
        $bb9415d43f60f2ec$var$_tempDiv = $bb9415d43f60f2ec$export$a232bb0480ae674a("div") || {
            style: {}
        };
        $bb9415d43f60f2ec$var$_tempDivStyler = $bb9415d43f60f2ec$export$a232bb0480ae674a("div");
        $bb9415d43f60f2ec$var$_transformProp = $bb9415d43f60f2ec$export$8cbef5dd49a09c8b($bb9415d43f60f2ec$var$_transformProp);
        $bb9415d43f60f2ec$var$_transformOriginProp = $bb9415d43f60f2ec$var$_transformProp + "Origin";
        $bb9415d43f60f2ec$var$_tempDiv.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0"; //make sure to override certain properties that may contaminate measurements, in case the user has overreaching style sheets.
        $bb9415d43f60f2ec$var$_supports3D = !!$bb9415d43f60f2ec$export$8cbef5dd49a09c8b("perspective");
        $bb9415d43f60f2ec$var$_reverting = (0, $7HZRt.gsap).core.reverting;
        $bb9415d43f60f2ec$var$_pluginInitted = 1;
    }
}, $bb9415d43f60f2ec$var$_getBBoxHack = function _getBBoxHack(swapIfPossible) {
    //works around issues in some browsers (like Firefox) that don't correctly report getBBox() on SVG elements inside a <defs> element and/or <mask>. We try creating an SVG, adding it to the documentElement and toss the element in there so that it's definitely part of the rendering tree, then grab the bbox and if it works, we actually swap out the original getBBox() method for our own that does these extra steps whenever getBBox is needed. This helps ensure that performance is optimal (only do all these extra steps when absolutely necessary...most elements don't need it).
    var svg = $bb9415d43f60f2ec$export$a232bb0480ae674a("svg", this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns") || "http://www.w3.org/2000/svg"), oldParent = this.parentNode, oldSibling = this.nextSibling, oldCSS = this.style.cssText, bbox;
    $bb9415d43f60f2ec$var$_docElement.appendChild(svg);
    svg.appendChild(this);
    this.style.display = "block";
    if (swapIfPossible) try {
        bbox = this.getBBox();
        this._gsapBBox = this.getBBox; //store the original
        this.getBBox = _getBBoxHack;
    } catch (e) {}
    else if (this._gsapBBox) bbox = this._gsapBBox();
    if (oldParent) {
        if (oldSibling) oldParent.insertBefore(this, oldSibling);
        else oldParent.appendChild(this);
    }
    $bb9415d43f60f2ec$var$_docElement.removeChild(svg);
    this.style.cssText = oldCSS;
    return bbox;
}, $bb9415d43f60f2ec$var$_getAttributeFallbacks = function _getAttributeFallbacks(target, attributesArray) {
    var i = attributesArray.length;
    while(i--){
        if (target.hasAttribute(attributesArray[i])) return target.getAttribute(attributesArray[i]);
    }
}, $bb9415d43f60f2ec$export$41bc7c2d1e04f11b = function _getBBox(target) {
    var bounds;
    try {
        bounds = target.getBBox(); //Firefox throws errors if you try calling getBBox() on an SVG element that's not rendered (like in a <symbol> or <defs>). https://bugzilla.mozilla.org/show_bug.cgi?id=612118
    } catch (error) {
        bounds = $bb9415d43f60f2ec$var$_getBBoxHack.call(target, true);
    }
    bounds && (bounds.width || bounds.height) || target.getBBox === $bb9415d43f60f2ec$var$_getBBoxHack || (bounds = $bb9415d43f60f2ec$var$_getBBoxHack.call(target, true)); //some browsers (like Firefox) misreport the bounds if the element has zero width and height (it just assumes it's at x:0, y:0), thus we need to manually grab the position in that case.
    return bounds && !bounds.width && !bounds.x && !bounds.y ? {
        x: +$bb9415d43f60f2ec$var$_getAttributeFallbacks(target, [
            "x",
            "cx",
            "x1"
        ]) || 0,
        y: +$bb9415d43f60f2ec$var$_getAttributeFallbacks(target, [
            "y",
            "cy",
            "y1"
        ]) || 0,
        width: 0,
        height: 0
    } : bounds;
}, $bb9415d43f60f2ec$var$_isSVG = function _isSVG(e) {
    return !!(e.getCTM && (!e.parentNode || e.ownerSVGElement) && $bb9415d43f60f2ec$export$41bc7c2d1e04f11b(e));
}, //reports if the element is an SVG on which getBBox() actually works
$bb9415d43f60f2ec$var$_removeProperty = function _removeProperty(target, property) {
    if (property) {
        var style = target.style, first2Chars;
        if (property in $bb9415d43f60f2ec$var$_transformProps && property !== $bb9415d43f60f2ec$var$_transformOriginProp) property = $bb9415d43f60f2ec$var$_transformProp;
        if (style.removeProperty) {
            first2Chars = property.substr(0, 2);
            if (first2Chars === "ms" || property.substr(0, 6) === "webkit") //Microsoft and some Webkit browsers don't conform to the standard of capitalizing the first prefix character, so we adjust so that when we prefix the caps with a dash, it's correct (otherwise it'd be "ms-transform" instead of "-ms-transform" for IE9, for example)
            property = "-" + property;
            style.removeProperty(first2Chars === "--" ? property : property.replace($bb9415d43f60f2ec$var$_capsExp, "-$1").toLowerCase());
        } else //note: old versions of IE use "removeAttribute()" instead of "removeProperty()"
        style.removeAttribute(property);
    }
}, $bb9415d43f60f2ec$var$_addNonTweeningPT = function _addNonTweeningPT(plugin, target, property, beginning, end, onlySetAtEnd) {
    var pt = new (0, $7HZRt.PropTween)(plugin._pt, target, property, 0, 1, onlySetAtEnd ? $bb9415d43f60f2ec$var$_renderNonTweeningValueOnlyAtEnd : $bb9415d43f60f2ec$var$_renderNonTweeningValue);
    plugin._pt = pt;
    pt.b = beginning;
    pt.e = end;
    plugin._props.push(property);
    return pt;
}, $bb9415d43f60f2ec$var$_nonConvertibleUnits = {
    deg: 1,
    rad: 1,
    turn: 1
}, $bb9415d43f60f2ec$var$_nonStandardLayouts = {
    grid: 1,
    flex: 1
}, //takes a single value like 20px and converts it to the unit specified, like "%", returning only the numeric amount.
$bb9415d43f60f2ec$var$_convertToUnit = function _convertToUnit(target, property, value, unit) {
    var curValue = parseFloat(value) || 0, curUnit = (value + "").trim().substr((curValue + "").length) || "px", // some browsers leave extra whitespace at the beginning of CSS variables, hence the need to trim()
    style = $bb9415d43f60f2ec$var$_tempDiv.style, horizontal = $bb9415d43f60f2ec$var$_horizontalExp.test(property), isRootSVG = target.tagName.toLowerCase() === "svg", measureProperty = (isRootSVG ? "client" : "offset") + (horizontal ? "Width" : "Height"), amount = 100, toPixels = unit === "px", toPercent = unit === "%", px, parent, cache, isSVG;
    if (unit === curUnit || !curValue || $bb9415d43f60f2ec$var$_nonConvertibleUnits[unit] || $bb9415d43f60f2ec$var$_nonConvertibleUnits[curUnit]) return curValue;
    curUnit !== "px" && !toPixels && (curValue = _convertToUnit(target, property, value, "px"));
    isSVG = target.getCTM && $bb9415d43f60f2ec$var$_isSVG(target);
    if ((toPercent || curUnit === "%") && ($bb9415d43f60f2ec$var$_transformProps[property] || ~property.indexOf("adius"))) {
        px = isSVG ? target.getBBox()[horizontal ? "width" : "height"] : target[measureProperty];
        return (0, $7HZRt._round)(toPercent ? curValue / px * amount : curValue / 100 * px);
    }
    style[horizontal ? "width" : "height"] = amount + (toPixels ? curUnit : unit);
    parent = ~property.indexOf("adius") || unit === "em" && target.appendChild && !isRootSVG ? target : target.parentNode;
    if (isSVG) parent = (target.ownerSVGElement || {}).parentNode;
    if (!parent || parent === $bb9415d43f60f2ec$var$_doc || !parent.appendChild) parent = $bb9415d43f60f2ec$var$_doc.body;
    cache = parent._gsap;
    if (cache && toPercent && cache.width && horizontal && cache.time === (0, $7HZRt._ticker).time && !cache.uncache) return (0, $7HZRt._round)(curValue / cache.width * amount);
    else {
        if (toPercent && (property === "height" || property === "width")) {
            // if we're dealing with width/height that's inside a container with padding and/or it's a flexbox/grid container, we must apply it to the target itself rather than the _tempDiv in order to ensure complete accuracy, factoring in the parent's padding.
            var v = target.style[property];
            target.style[property] = amount + unit;
            px = target[measureProperty];
            v ? target.style[property] = v : $bb9415d43f60f2ec$var$_removeProperty(target, property);
        } else {
            (toPercent || curUnit === "%") && !$bb9415d43f60f2ec$var$_nonStandardLayouts[$bb9415d43f60f2ec$var$_getComputedProperty(parent, "display")] && (style.position = $bb9415d43f60f2ec$var$_getComputedProperty(target, "position"));
            parent === target && (style.position = "static"); // like for borderRadius, if it's a % we must have it relative to the target itself but that may not have position: relative or position: absolute in which case it'd go up the chain until it finds its offsetParent (bad). position: static protects against that.
            parent.appendChild($bb9415d43f60f2ec$var$_tempDiv);
            px = $bb9415d43f60f2ec$var$_tempDiv[measureProperty];
            parent.removeChild($bb9415d43f60f2ec$var$_tempDiv);
            style.position = "absolute";
        }
        if (horizontal && toPercent) {
            cache = (0, $7HZRt._getCache)(parent);
            cache.time = (0, $7HZRt._ticker).time;
            cache.width = parent[measureProperty];
        }
    }
    return (0, $7HZRt._round)(toPixels ? px * curValue / amount : px && curValue ? amount / px * curValue : 0);
}, $bb9415d43f60f2ec$var$_get = function _get(target, property, unit, uncache) {
    var value;
    $bb9415d43f60f2ec$var$_pluginInitted || $bb9415d43f60f2ec$var$_initCore();
    if (property in $bb9415d43f60f2ec$var$_propertyAliases && property !== "transform") {
        property = $bb9415d43f60f2ec$var$_propertyAliases[property];
        if (~property.indexOf(",")) property = property.split(",")[0];
    }
    if ($bb9415d43f60f2ec$var$_transformProps[property] && property !== "transform") {
        value = $bb9415d43f60f2ec$var$_parseTransform(target, uncache);
        value = property !== "transformOrigin" ? value[property] : value.svg ? value.origin : $bb9415d43f60f2ec$var$_firstTwoOnly($bb9415d43f60f2ec$var$_getComputedProperty(target, $bb9415d43f60f2ec$var$_transformOriginProp)) + " " + value.zOrigin + "px";
    } else {
        value = target.style[property];
        if (!value || value === "auto" || uncache || ~(value + "").indexOf("calc(")) value = $bb9415d43f60f2ec$var$_specialProps[property] && $bb9415d43f60f2ec$var$_specialProps[property](target, property, unit) || $bb9415d43f60f2ec$var$_getComputedProperty(target, property) || (0, $7HZRt._getProperty)(target, property) || (property === "opacity" ? 1 : 0); // note: some browsers, like Firefox, don't report borderRadius correctly! Instead, it only reports every corner like  borderTopLeftRadius
    }
    return unit && !~(value + "").trim().indexOf(" ") ? $bb9415d43f60f2ec$var$_convertToUnit(target, property, value, unit) + unit : value;
}, $bb9415d43f60f2ec$var$_tweenComplexCSSString = function _tweenComplexCSSString(target, prop, start, end) {
    // note: we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    if (!start || start === "none") {
        // some browsers like Safari actually PREFER the prefixed property and mis-report the unprefixed value like clipPath (BUG). In other words, even though clipPath exists in the style ("clipPath" in target.style) and it's set in the CSS properly (along with -webkit-clip-path), Safari reports clipPath as "none" whereas WebkitClipPath reports accurately like "ellipse(100% 0% at 50% 0%)", so in this case we must SWITCH to using the prefixed property instead. See https://gsap.com/forums/topic/18310-clippath-doesnt-work-on-ios/
        var p = $bb9415d43f60f2ec$export$8cbef5dd49a09c8b(prop, target, 1), s = p && $bb9415d43f60f2ec$var$_getComputedProperty(target, p, 1);
        if (s && s !== start) {
            prop = p;
            start = s;
        } else if (prop === "borderColor") start = $bb9415d43f60f2ec$var$_getComputedProperty(target, "borderTopColor"); // Firefox bug: always reports "borderColor" as "", so we must fall back to borderTopColor. See https://gsap.com/forums/topic/24583-how-to-return-colors-that-i-had-after-reverse/
    }
    var pt = new (0, $7HZRt.PropTween)(this._pt, target.style, prop, 0, 1, (0, $7HZRt._renderComplexString)), index = 0, matchIndex = 0, a, result, startValues, startNum, color, startValue, endValue, endNum, chunk, endUnit, startUnit, endValues;
    pt.b = start;
    pt.e = end;
    start += ""; // ensure values are strings
    end += "";
    if (end === "auto") {
        startValue = target.style[prop];
        target.style[prop] = end;
        end = $bb9415d43f60f2ec$var$_getComputedProperty(target, prop) || end;
        startValue ? target.style[prop] = startValue : $bb9415d43f60f2ec$var$_removeProperty(target, prop);
    }
    a = [
        start,
        end
    ];
    (0, $7HZRt._colorStringFilter)(a); // pass an array with the starting and ending values and let the filter do whatever it needs to the values. If colors are found, it returns true and then we must match where the color shows up order-wise because for things like boxShadow, sometimes the browser provides the computed values with the color FIRST, but the user provides it with the color LAST, so flip them if necessary. Same for drop-shadow().
    start = a[0];
    end = a[1];
    startValues = start.match((0, $7HZRt._numWithUnitExp)) || [];
    endValues = end.match((0, $7HZRt._numWithUnitExp)) || [];
    if (endValues.length) {
        while(result = (0, $7HZRt._numWithUnitExp).exec(end)){
            endValue = result[0];
            chunk = end.substring(index, result.index);
            if (color) color = (color + 1) % 5;
            else if (chunk.substr(-5) === "rgba(" || chunk.substr(-5) === "hsla(") color = 1;
            if (endValue !== (startValue = startValues[matchIndex++] || "")) {
                startNum = parseFloat(startValue) || 0;
                startUnit = startValue.substr((startNum + "").length);
                endValue.charAt(1) === "=" && (endValue = (0, $7HZRt._parseRelative)(startNum, endValue) + startUnit);
                endNum = parseFloat(endValue);
                endUnit = endValue.substr((endNum + "").length);
                index = (0, $7HZRt._numWithUnitExp).lastIndex - endUnit.length;
                if (!endUnit) {
                    //if something like "perspective:300" is passed in and we must add a unit to the end
                    endUnit = endUnit || (0, $7HZRt._config).units[prop] || startUnit;
                    if (index === end.length) {
                        end += endUnit;
                        pt.e += endUnit;
                    }
                }
                if (startUnit !== endUnit) startNum = $bb9415d43f60f2ec$var$_convertToUnit(target, prop, startValue, endUnit) || 0;
                 // these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
                pt._pt = {
                    _next: pt._pt,
                    p: chunk || matchIndex === 1 ? chunk : ",",
                    //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
                    s: startNum,
                    c: endNum - startNum,
                    m: color && color < 4 || prop === "zIndex" ? Math.round : 0
                };
            }
        }
        pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    } else pt.r = prop === "display" && end === "none" ? $bb9415d43f60f2ec$var$_renderNonTweeningValueOnlyAtEnd : $bb9415d43f60f2ec$var$_renderNonTweeningValue;
    (0, $7HZRt._relExp).test(end) && (pt.e = 0); //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within another plugin too, thus "this" would refer to the plugin.
    return pt;
}, $bb9415d43f60f2ec$var$_keywordToPercent = {
    top: "0%",
    bottom: "100%",
    left: "0%",
    right: "100%",
    center: "50%"
}, $bb9415d43f60f2ec$var$_convertKeywordsToPercentages = function _convertKeywordsToPercentages(value) {
    var split = value.split(" "), x = split[0], y = split[1] || "50%";
    if (x === "top" || x === "bottom" || y === "left" || y === "right") {
        //the user provided them in the wrong order, so flip them
        value = x;
        x = y;
        y = value;
    }
    split[0] = $bb9415d43f60f2ec$var$_keywordToPercent[x] || x;
    split[1] = $bb9415d43f60f2ec$var$_keywordToPercent[y] || y;
    return split.join(" ");
}, $bb9415d43f60f2ec$var$_renderClearProps = function _renderClearProps(ratio, data) {
    if (data.tween && data.tween._time === data.tween._dur) {
        var target = data.t, style = target.style, props = data.u, cache = target._gsap, prop, clearTransforms, i;
        if (props === "all" || props === true) {
            style.cssText = "";
            clearTransforms = 1;
        } else {
            props = props.split(",");
            i = props.length;
            while(--i > -1){
                prop = props[i];
                if ($bb9415d43f60f2ec$var$_transformProps[prop]) {
                    clearTransforms = 1;
                    prop = prop === "transformOrigin" ? $bb9415d43f60f2ec$var$_transformOriginProp : $bb9415d43f60f2ec$var$_transformProp;
                }
                $bb9415d43f60f2ec$var$_removeProperty(target, prop);
            }
        }
        if (clearTransforms) {
            $bb9415d43f60f2ec$var$_removeProperty(target, $bb9415d43f60f2ec$var$_transformProp);
            if (cache) {
                cache.svg && target.removeAttribute("transform");
                $bb9415d43f60f2ec$var$_parseTransform(target, 1); // force all the cached values back to "normal"/identity, otherwise if there's another tween that's already set to render transforms on this element, it could display the wrong values.
                cache.uncache = 1;
                $bb9415d43f60f2ec$var$_removeIndependentTransforms(style);
            }
        }
    }
}, // note: specialProps should return 1 if (and only if) they have a non-zero priority. It indicates we need to sort the linked list.
$bb9415d43f60f2ec$var$_specialProps = {
    clearProps: function clearProps(plugin, target, property, endValue, tween) {
        if (tween.data !== "isFromStart") {
            var pt = plugin._pt = new (0, $7HZRt.PropTween)(plugin._pt, target, property, 0, 0, $bb9415d43f60f2ec$var$_renderClearProps);
            pt.u = endValue;
            pt.pr = -10;
            pt.tween = tween;
            plugin._props.push(property);
            return 1;
        }
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TRANSFORMS
 * --------------------------------------------------------------------------------------
 */ $bb9415d43f60f2ec$var$_identity2DMatrix = [
    1,
    0,
    0,
    1,
    0,
    0
], $bb9415d43f60f2ec$var$_rotationalProperties = {}, $bb9415d43f60f2ec$var$_isNullTransform = function _isNullTransform(value) {
    return value === "matrix(1, 0, 0, 1, 0, 0)" || value === "none" || !value;
}, $bb9415d43f60f2ec$var$_getComputedTransformMatrixAsArray = function _getComputedTransformMatrixAsArray(target) {
    var matrixString = $bb9415d43f60f2ec$var$_getComputedProperty(target, $bb9415d43f60f2ec$var$_transformProp);
    return $bb9415d43f60f2ec$var$_isNullTransform(matrixString) ? $bb9415d43f60f2ec$var$_identity2DMatrix : matrixString.substr(7).match((0, $7HZRt._numExp)).map((0, $7HZRt._round));
}, $bb9415d43f60f2ec$var$_getMatrix = function _getMatrix(target, force2D) {
    var cache = target._gsap || (0, $7HZRt._getCache)(target), style = target.style, matrix = $bb9415d43f60f2ec$var$_getComputedTransformMatrixAsArray(target), parent, nextSibling, temp, addedToDOM;
    if (cache.svg && target.getAttribute("transform")) {
        temp = target.transform.baseVal.consolidate().matrix; //ensures that even complex values like "translate(50,60) rotate(135,0,0)" are parsed because it mashes it into a matrix.
        matrix = [
            temp.a,
            temp.b,
            temp.c,
            temp.d,
            temp.e,
            temp.f
        ];
        return matrix.join(",") === "1,0,0,1,0,0" ? $bb9415d43f60f2ec$var$_identity2DMatrix : matrix;
    } else if (matrix === $bb9415d43f60f2ec$var$_identity2DMatrix && !target.offsetParent && target !== $bb9415d43f60f2ec$var$_docElement && !cache.svg) {
        //note: if offsetParent is null, that means the element isn't in the normal document flow, like if it has display:none or one of its ancestors has display:none). Firefox returns null for getComputedStyle() if the element is in an iframe that has display:none. https://bugzilla.mozilla.org/show_bug.cgi?id=548397
        //browsers don't report transforms accurately unless the element is in the DOM and has a display value that's not "none". Firefox and Microsoft browsers have a partial bug where they'll report transforms even if display:none BUT not any percentage-based values like translate(-50%, 8px) will be reported as if it's translate(0, 8px).
        temp = style.display;
        style.display = "block";
        parent = target.parentNode;
        if (!parent || !target.offsetParent) {
            // note: in 3.3.0 we switched target.offsetParent to _doc.body.contains(target) to avoid [sometimes unnecessary] MutationObserver calls but that wasn't adequate because there are edge cases where nested position: fixed elements need to get reparented to accurately sense transforms. See https://github.com/greensock/GSAP/issues/388 and https://github.com/greensock/GSAP/issues/375
            addedToDOM = 1; //flag
            nextSibling = target.nextElementSibling;
            $bb9415d43f60f2ec$var$_docElement.appendChild(target); //we must add it to the DOM in order to get values properly
        }
        matrix = $bb9415d43f60f2ec$var$_getComputedTransformMatrixAsArray(target);
        temp ? style.display = temp : $bb9415d43f60f2ec$var$_removeProperty(target, "display");
        if (addedToDOM) nextSibling ? parent.insertBefore(target, nextSibling) : parent ? parent.appendChild(target) : $bb9415d43f60f2ec$var$_docElement.removeChild(target);
    }
    return force2D && matrix.length > 6 ? [
        matrix[0],
        matrix[1],
        matrix[4],
        matrix[5],
        matrix[12],
        matrix[13]
    ] : matrix;
}, $bb9415d43f60f2ec$var$_applySVGOrigin = function _applySVGOrigin(target, origin, originIsAbsolute, smooth, matrixArray, pluginToAddPropTweensTo) {
    var cache = target._gsap, matrix = matrixArray || $bb9415d43f60f2ec$var$_getMatrix(target, true), xOriginOld = cache.xOrigin || 0, yOriginOld = cache.yOrigin || 0, xOffsetOld = cache.xOffset || 0, yOffsetOld = cache.yOffset || 0, a = matrix[0], b = matrix[1], c = matrix[2], d = matrix[3], tx = matrix[4], ty = matrix[5], originSplit = origin.split(" "), xOrigin = parseFloat(originSplit[0]) || 0, yOrigin = parseFloat(originSplit[1]) || 0, bounds, determinant, x, y;
    if (!originIsAbsolute) {
        bounds = $bb9415d43f60f2ec$export$41bc7c2d1e04f11b(target);
        xOrigin = bounds.x + (~originSplit[0].indexOf("%") ? xOrigin / 100 * bounds.width : xOrigin);
        yOrigin = bounds.y + (~(originSplit[1] || originSplit[0]).indexOf("%") ? yOrigin / 100 * bounds.height : yOrigin); // if (!("xOrigin" in cache) && (xOrigin || yOrigin)) { // added in 3.12.3, reverted in 3.12.4; requires more exploration
    // 	xOrigin -= bounds.x;
    // 	yOrigin -= bounds.y;
    // }
    } else if (matrix !== $bb9415d43f60f2ec$var$_identity2DMatrix && (determinant = a * d - b * c)) {
        //if it's zero (like if scaleX and scaleY are zero), skip it to avoid errors with dividing by zero.
        x = xOrigin * (d / determinant) + yOrigin * (-c / determinant) + (c * ty - d * tx) / determinant;
        y = xOrigin * (-b / determinant) + yOrigin * (a / determinant) - (a * ty - b * tx) / determinant;
        xOrigin = x;
        yOrigin = y; // theory: we only had to do this for smoothing and it assumes that the previous one was not originIsAbsolute.
    }
    if (smooth || smooth !== false && cache.smooth) {
        tx = xOrigin - xOriginOld;
        ty = yOrigin - yOriginOld;
        cache.xOffset = xOffsetOld + (tx * a + ty * c) - tx;
        cache.yOffset = yOffsetOld + (tx * b + ty * d) - ty;
    } else cache.xOffset = cache.yOffset = 0;
    cache.xOrigin = xOrigin;
    cache.yOrigin = yOrigin;
    cache.smooth = !!smooth;
    cache.origin = origin;
    cache.originIsAbsolute = !!originIsAbsolute;
    target.style[$bb9415d43f60f2ec$var$_transformOriginProp] = "0px 0px"; //otherwise, if someone sets  an origin via CSS, it will likely interfere with the SVG transform attribute ones (because remember, we're baking the origin into the matrix() value).
    if (pluginToAddPropTweensTo) {
        $bb9415d43f60f2ec$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOrigin", xOriginOld, xOrigin);
        $bb9415d43f60f2ec$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOrigin", yOriginOld, yOrigin);
        $bb9415d43f60f2ec$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOffset", xOffsetOld, cache.xOffset);
        $bb9415d43f60f2ec$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOffset", yOffsetOld, cache.yOffset);
    }
    target.setAttribute("data-svg-origin", xOrigin + " " + yOrigin);
}, $bb9415d43f60f2ec$var$_parseTransform = function _parseTransform(target, uncache) {
    var cache = target._gsap || new (0, $7HZRt.GSCache)(target);
    if ("x" in cache && !uncache && !cache.uncache) return cache;
    var style = target.style, invertedScaleX = cache.scaleX < 0, px = "px", deg = "deg", cs = getComputedStyle(target), origin = $bb9415d43f60f2ec$var$_getComputedProperty(target, $bb9415d43f60f2ec$var$_transformOriginProp) || "0", x, y, z, scaleX, scaleY, rotation, rotationX, rotationY, skewX, skewY, perspective, xOrigin, yOrigin, matrix, angle, cos, sin, a, b, c, d, a12, a22, t1, t2, t3, a13, a23, a33, a42, a43, a32;
    x = y = z = rotation = rotationX = rotationY = skewX = skewY = perspective = 0;
    scaleX = scaleY = 1;
    cache.svg = !!(target.getCTM && $bb9415d43f60f2ec$var$_isSVG(target));
    if (cs.translate) {
        // accommodate independent transforms by combining them into normal ones.
        if (cs.translate !== "none" || cs.scale !== "none" || cs.rotate !== "none") style[$bb9415d43f60f2ec$var$_transformProp] = (cs.translate !== "none" ? "translate3d(" + (cs.translate + " 0 0").split(" ").slice(0, 3).join(", ") + ") " : "") + (cs.rotate !== "none" ? "rotate(" + cs.rotate + ") " : "") + (cs.scale !== "none" ? "scale(" + cs.scale.split(" ").join(",") + ") " : "") + (cs[$bb9415d43f60f2ec$var$_transformProp] !== "none" ? cs[$bb9415d43f60f2ec$var$_transformProp] : "");
        style.scale = style.rotate = style.translate = "none";
    }
    matrix = $bb9415d43f60f2ec$var$_getMatrix(target, cache.svg);
    if (cache.svg) {
        if (cache.uncache) {
            // if cache.uncache is true (and maybe if origin is 0,0), we need to set element.style.transformOrigin = (cache.xOrigin - bbox.x) + "px " + (cache.yOrigin - bbox.y) + "px". Previously we let the data-svg-origin stay instead, but when introducing revert(), it complicated things.
            t2 = target.getBBox();
            origin = cache.xOrigin - t2.x + "px " + (cache.yOrigin - t2.y) + "px";
            t1 = "";
        } else t1 = !uncache && target.getAttribute("data-svg-origin"); //  Remember, to work around browser inconsistencies we always force SVG elements' transformOrigin to 0,0 and offset the translation accordingly.
        $bb9415d43f60f2ec$var$_applySVGOrigin(target, t1 || origin, !!t1 || cache.originIsAbsolute, cache.smooth !== false, matrix);
    }
    xOrigin = cache.xOrigin || 0;
    yOrigin = cache.yOrigin || 0;
    if (matrix !== $bb9415d43f60f2ec$var$_identity2DMatrix) {
        a = matrix[0]; //a11
        b = matrix[1]; //a21
        c = matrix[2]; //a31
        d = matrix[3]; //a41
        x = a12 = matrix[4];
        y = a22 = matrix[5]; //2D matrix
        if (matrix.length === 6) {
            scaleX = Math.sqrt(a * a + b * b);
            scaleY = Math.sqrt(d * d + c * c);
            rotation = a || b ? $bb9415d43f60f2ec$var$_atan2(b, a) * $bb9415d43f60f2ec$var$_RAD2DEG : 0; //note: if scaleX is 0, we cannot accurately measure rotation. Same for skewX with a scaleY of 0. Therefore, we default to the previously recorded value (or zero if that doesn't exist).
            skewX = c || d ? $bb9415d43f60f2ec$var$_atan2(c, d) * $bb9415d43f60f2ec$var$_RAD2DEG + rotation : 0;
            skewX && (scaleY *= Math.abs(Math.cos(skewX * $bb9415d43f60f2ec$var$_DEG2RAD)));
            if (cache.svg) {
                x -= xOrigin - (xOrigin * a + yOrigin * c);
                y -= yOrigin - (xOrigin * b + yOrigin * d);
            } //3D matrix
        } else {
            a32 = matrix[6];
            a42 = matrix[7];
            a13 = matrix[8];
            a23 = matrix[9];
            a33 = matrix[10];
            a43 = matrix[11];
            x = matrix[12];
            y = matrix[13];
            z = matrix[14];
            angle = $bb9415d43f60f2ec$var$_atan2(a32, a33);
            rotationX = angle * $bb9415d43f60f2ec$var$_RAD2DEG; //rotationX
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a12 * cos + a13 * sin;
                t2 = a22 * cos + a23 * sin;
                t3 = a32 * cos + a33 * sin;
                a13 = a12 * -sin + a13 * cos;
                a23 = a22 * -sin + a23 * cos;
                a33 = a32 * -sin + a33 * cos;
                a43 = a42 * -sin + a43 * cos;
                a12 = t1;
                a22 = t2;
                a32 = t3;
            } //rotationY
            angle = $bb9415d43f60f2ec$var$_atan2(-c, a33);
            rotationY = angle * $bb9415d43f60f2ec$var$_RAD2DEG;
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a * cos - a13 * sin;
                t2 = b * cos - a23 * sin;
                t3 = c * cos - a33 * sin;
                a43 = d * sin + a43 * cos;
                a = t1;
                b = t2;
                c = t3;
            } //rotationZ
            angle = $bb9415d43f60f2ec$var$_atan2(b, a);
            rotation = angle * $bb9415d43f60f2ec$var$_RAD2DEG;
            if (angle) {
                cos = Math.cos(angle);
                sin = Math.sin(angle);
                t1 = a * cos + b * sin;
                t2 = a12 * cos + a22 * sin;
                b = b * cos - a * sin;
                a22 = a22 * cos - a12 * sin;
                a = t1;
                a12 = t2;
            }
            if (rotationX && Math.abs(rotationX) + Math.abs(rotation) > 359.9) {
                //when rotationY is set, it will often be parsed as 180 degrees different than it should be, and rotationX and rotation both being 180 (it looks the same), so we adjust for that here.
                rotationX = rotation = 0;
                rotationY = 180 - rotationY;
            }
            scaleX = (0, $7HZRt._round)(Math.sqrt(a * a + b * b + c * c));
            scaleY = (0, $7HZRt._round)(Math.sqrt(a22 * a22 + a32 * a32));
            angle = $bb9415d43f60f2ec$var$_atan2(a12, a22);
            skewX = Math.abs(angle) > 0.0002 ? angle * $bb9415d43f60f2ec$var$_RAD2DEG : 0;
            perspective = a43 ? 1 / (a43 < 0 ? -a43 : a43) : 0;
        }
        if (cache.svg) {
            //sense if there are CSS transforms applied on an SVG element in which case we must overwrite them when rendering. The transform attribute is more reliable cross-browser, but we can't just remove the CSS ones because they may be applied in a CSS rule somewhere (not just inline).
            t1 = target.getAttribute("transform");
            cache.forceCSS = target.setAttribute("transform", "") || !$bb9415d43f60f2ec$var$_isNullTransform($bb9415d43f60f2ec$var$_getComputedProperty(target, $bb9415d43f60f2ec$var$_transformProp));
            t1 && target.setAttribute("transform", t1);
        }
    }
    if (Math.abs(skewX) > 90 && Math.abs(skewX) < 270) {
        if (invertedScaleX) {
            scaleX *= -1;
            skewX += rotation <= 0 ? 180 : -180;
            rotation += rotation <= 0 ? 180 : -180;
        } else {
            scaleY *= -1;
            skewX += skewX <= 0 ? 180 : -180;
        }
    }
    uncache = uncache || cache.uncache;
    cache.x = x - ((cache.xPercent = x && (!uncache && cache.xPercent || (Math.round(target.offsetWidth / 2) === Math.round(-x) ? -50 : 0))) ? target.offsetWidth * cache.xPercent / 100 : 0) + px;
    cache.y = y - ((cache.yPercent = y && (!uncache && cache.yPercent || (Math.round(target.offsetHeight / 2) === Math.round(-y) ? -50 : 0))) ? target.offsetHeight * cache.yPercent / 100 : 0) + px;
    cache.z = z + px;
    cache.scaleX = (0, $7HZRt._round)(scaleX);
    cache.scaleY = (0, $7HZRt._round)(scaleY);
    cache.rotation = (0, $7HZRt._round)(rotation) + deg;
    cache.rotationX = (0, $7HZRt._round)(rotationX) + deg;
    cache.rotationY = (0, $7HZRt._round)(rotationY) + deg;
    cache.skewX = skewX + deg;
    cache.skewY = skewY + deg;
    cache.transformPerspective = perspective + px;
    if (cache.zOrigin = parseFloat(origin.split(" ")[2]) || !uncache && cache.zOrigin || 0) style[$bb9415d43f60f2ec$var$_transformOriginProp] = $bb9415d43f60f2ec$var$_firstTwoOnly(origin);
    cache.xOffset = cache.yOffset = 0;
    cache.force3D = (0, $7HZRt._config).force3D;
    cache.renderTransform = cache.svg ? $bb9415d43f60f2ec$var$_renderSVGTransforms : $bb9415d43f60f2ec$var$_supports3D ? $bb9415d43f60f2ec$var$_renderCSSTransforms : $bb9415d43f60f2ec$var$_renderNon3DTransforms;
    cache.uncache = 0;
    return cache;
}, $bb9415d43f60f2ec$var$_firstTwoOnly = function _firstTwoOnly(value) {
    return (value = value.split(" "))[0] + " " + value[1];
}, //for handling transformOrigin values, stripping out the 3rd dimension
$bb9415d43f60f2ec$var$_addPxTranslate = function _addPxTranslate(target, start, value) {
    var unit = (0, $7HZRt.getUnit)(start);
    return (0, $7HZRt._round)(parseFloat(start) + parseFloat($bb9415d43f60f2ec$var$_convertToUnit(target, "x", value + "px", unit))) + unit;
}, $bb9415d43f60f2ec$var$_renderNon3DTransforms = function _renderNon3DTransforms(ratio, cache) {
    cache.z = "0px";
    cache.rotationY = cache.rotationX = "0deg";
    cache.force3D = 0;
    $bb9415d43f60f2ec$var$_renderCSSTransforms(ratio, cache);
}, $bb9415d43f60f2ec$var$_zeroDeg = "0deg", $bb9415d43f60f2ec$var$_zeroPx = "0px", $bb9415d43f60f2ec$var$_endParenthesis = ") ", $bb9415d43f60f2ec$var$_renderCSSTransforms = function _renderCSSTransforms(ratio, cache) {
    var _ref = cache || this, xPercent = _ref.xPercent, yPercent = _ref.yPercent, x = _ref.x, y = _ref.y, z = _ref.z, rotation = _ref.rotation, rotationY = _ref.rotationY, rotationX = _ref.rotationX, skewX = _ref.skewX, skewY = _ref.skewY, scaleX = _ref.scaleX, scaleY = _ref.scaleY, transformPerspective = _ref.transformPerspective, force3D = _ref.force3D, target = _ref.target, zOrigin = _ref.zOrigin, transforms = "", use3D = force3D === "auto" && ratio && ratio !== 1 || force3D === true; // Safari has a bug that causes it not to render 3D transform-origin values properly, so we force the z origin to 0, record it in the cache, and then do the math here to offset the translate values accordingly (basically do the 3D transform-origin part manually)
    if (zOrigin && (rotationX !== $bb9415d43f60f2ec$var$_zeroDeg || rotationY !== $bb9415d43f60f2ec$var$_zeroDeg)) {
        var angle = parseFloat(rotationY) * $bb9415d43f60f2ec$var$_DEG2RAD, a13 = Math.sin(angle), a33 = Math.cos(angle), cos;
        angle = parseFloat(rotationX) * $bb9415d43f60f2ec$var$_DEG2RAD;
        cos = Math.cos(angle);
        x = $bb9415d43f60f2ec$var$_addPxTranslate(target, x, a13 * cos * -zOrigin);
        y = $bb9415d43f60f2ec$var$_addPxTranslate(target, y, -Math.sin(angle) * -zOrigin);
        z = $bb9415d43f60f2ec$var$_addPxTranslate(target, z, a33 * cos * -zOrigin + zOrigin);
    }
    if (transformPerspective !== $bb9415d43f60f2ec$var$_zeroPx) transforms += "perspective(" + transformPerspective + $bb9415d43f60f2ec$var$_endParenthesis;
    if (xPercent || yPercent) transforms += "translate(" + xPercent + "%, " + yPercent + "%) ";
    if (use3D || x !== $bb9415d43f60f2ec$var$_zeroPx || y !== $bb9415d43f60f2ec$var$_zeroPx || z !== $bb9415d43f60f2ec$var$_zeroPx) transforms += z !== $bb9415d43f60f2ec$var$_zeroPx || use3D ? "translate3d(" + x + ", " + y + ", " + z + ") " : "translate(" + x + ", " + y + $bb9415d43f60f2ec$var$_endParenthesis;
    if (rotation !== $bb9415d43f60f2ec$var$_zeroDeg) transforms += "rotate(" + rotation + $bb9415d43f60f2ec$var$_endParenthesis;
    if (rotationY !== $bb9415d43f60f2ec$var$_zeroDeg) transforms += "rotateY(" + rotationY + $bb9415d43f60f2ec$var$_endParenthesis;
    if (rotationX !== $bb9415d43f60f2ec$var$_zeroDeg) transforms += "rotateX(" + rotationX + $bb9415d43f60f2ec$var$_endParenthesis;
    if (skewX !== $bb9415d43f60f2ec$var$_zeroDeg || skewY !== $bb9415d43f60f2ec$var$_zeroDeg) transforms += "skew(" + skewX + ", " + skewY + $bb9415d43f60f2ec$var$_endParenthesis;
    if (scaleX !== 1 || scaleY !== 1) transforms += "scale(" + scaleX + ", " + scaleY + $bb9415d43f60f2ec$var$_endParenthesis;
    target.style[$bb9415d43f60f2ec$var$_transformProp] = transforms || "translate(0, 0)";
}, $bb9415d43f60f2ec$var$_renderSVGTransforms = function _renderSVGTransforms(ratio, cache) {
    var _ref2 = cache || this, xPercent = _ref2.xPercent, yPercent = _ref2.yPercent, x = _ref2.x, y = _ref2.y, rotation = _ref2.rotation, skewX = _ref2.skewX, skewY = _ref2.skewY, scaleX = _ref2.scaleX, scaleY = _ref2.scaleY, target = _ref2.target, xOrigin = _ref2.xOrigin, yOrigin = _ref2.yOrigin, xOffset = _ref2.xOffset, yOffset = _ref2.yOffset, forceCSS = _ref2.forceCSS, tx = parseFloat(x), ty = parseFloat(y), a11, a21, a12, a22, temp;
    rotation = parseFloat(rotation);
    skewX = parseFloat(skewX);
    skewY = parseFloat(skewY);
    if (skewY) {
        //for performance reasons, we combine all skewing into the skewX and rotation values. Remember, a skewY of 10 degrees looks the same as a rotation of 10 degrees plus a skewX of 10 degrees.
        skewY = parseFloat(skewY);
        skewX += skewY;
        rotation += skewY;
    }
    if (rotation || skewX) {
        rotation *= $bb9415d43f60f2ec$var$_DEG2RAD;
        skewX *= $bb9415d43f60f2ec$var$_DEG2RAD;
        a11 = Math.cos(rotation) * scaleX;
        a21 = Math.sin(rotation) * scaleX;
        a12 = Math.sin(rotation - skewX) * -scaleY;
        a22 = Math.cos(rotation - skewX) * scaleY;
        if (skewX) {
            skewY *= $bb9415d43f60f2ec$var$_DEG2RAD;
            temp = Math.tan(skewX - skewY);
            temp = Math.sqrt(1 + temp * temp);
            a12 *= temp;
            a22 *= temp;
            if (skewY) {
                temp = Math.tan(skewY);
                temp = Math.sqrt(1 + temp * temp);
                a11 *= temp;
                a21 *= temp;
            }
        }
        a11 = (0, $7HZRt._round)(a11);
        a21 = (0, $7HZRt._round)(a21);
        a12 = (0, $7HZRt._round)(a12);
        a22 = (0, $7HZRt._round)(a22);
    } else {
        a11 = scaleX;
        a22 = scaleY;
        a21 = a12 = 0;
    }
    if (tx && !~(x + "").indexOf("px") || ty && !~(y + "").indexOf("px")) {
        tx = $bb9415d43f60f2ec$var$_convertToUnit(target, "x", x, "px");
        ty = $bb9415d43f60f2ec$var$_convertToUnit(target, "y", y, "px");
    }
    if (xOrigin || yOrigin || xOffset || yOffset) {
        tx = (0, $7HZRt._round)(tx + xOrigin - (xOrigin * a11 + yOrigin * a12) + xOffset);
        ty = (0, $7HZRt._round)(ty + yOrigin - (xOrigin * a21 + yOrigin * a22) + yOffset);
    }
    if (xPercent || yPercent) {
        //The SVG spec doesn't support percentage-based translation in the "transform" attribute, so we merge it into the translation to simulate it.
        temp = target.getBBox();
        tx = (0, $7HZRt._round)(tx + xPercent / 100 * temp.width);
        ty = (0, $7HZRt._round)(ty + yPercent / 100 * temp.height);
    }
    temp = "matrix(" + a11 + "," + a21 + "," + a12 + "," + a22 + "," + tx + "," + ty + ")";
    target.setAttribute("transform", temp);
    forceCSS && (target.style[$bb9415d43f60f2ec$var$_transformProp] = temp); //some browsers prioritize CSS transforms over the transform attribute. When we sense that the user has CSS transforms applied, we must overwrite them this way (otherwise some browser simply won't render the transform attribute changes!)
}, $bb9415d43f60f2ec$var$_addRotationalPropTween = function _addRotationalPropTween(plugin, target, property, startNum, endValue) {
    var cap = 360, isString = (0, $7HZRt._isString)(endValue), endNum = parseFloat(endValue) * (isString && ~endValue.indexOf("rad") ? $bb9415d43f60f2ec$var$_RAD2DEG : 1), change = endNum - startNum, finalValue = startNum + change + "deg", direction, pt;
    if (isString) {
        direction = endValue.split("_")[1];
        if (direction === "short") {
            change %= cap;
            if (change !== change % (cap / 2)) change += change < 0 ? cap : -cap;
        }
        if (direction === "cw" && change < 0) change = (change + cap * $bb9415d43f60f2ec$var$_bigNum) % cap - ~~(change / cap) * cap;
        else if (direction === "ccw" && change > 0) change = (change - cap * $bb9415d43f60f2ec$var$_bigNum) % cap - ~~(change / cap) * cap;
    }
    plugin._pt = pt = new (0, $7HZRt.PropTween)(plugin._pt, target, property, startNum, change, $bb9415d43f60f2ec$var$_renderPropWithEnd);
    pt.e = finalValue;
    pt.u = "deg";
    plugin._props.push(property);
    return pt;
}, $bb9415d43f60f2ec$var$_assign = function _assign(target, source) {
    // Internet Explorer doesn't have Object.assign(), so we recreate it here.
    for(var p in source)target[p] = source[p];
    return target;
}, $bb9415d43f60f2ec$var$_addRawTransformPTs = function _addRawTransformPTs(plugin, transforms, target) {
    //for handling cases where someone passes in a whole transform string, like transform: "scale(2, 3) rotate(20deg) translateY(30em)"
    var startCache = $bb9415d43f60f2ec$var$_assign({}, target._gsap), exclude = "perspective,force3D,transformOrigin,svgOrigin", style = target.style, endCache, p, startValue, endValue, startNum, endNum, startUnit, endUnit;
    if (startCache.svg) {
        startValue = target.getAttribute("transform");
        target.setAttribute("transform", "");
        style[$bb9415d43f60f2ec$var$_transformProp] = transforms;
        endCache = $bb9415d43f60f2ec$var$_parseTransform(target, 1);
        $bb9415d43f60f2ec$var$_removeProperty(target, $bb9415d43f60f2ec$var$_transformProp);
        target.setAttribute("transform", startValue);
    } else {
        startValue = getComputedStyle(target)[$bb9415d43f60f2ec$var$_transformProp];
        style[$bb9415d43f60f2ec$var$_transformProp] = transforms;
        endCache = $bb9415d43f60f2ec$var$_parseTransform(target, 1);
        style[$bb9415d43f60f2ec$var$_transformProp] = startValue;
    }
    for(p in $bb9415d43f60f2ec$var$_transformProps){
        startValue = startCache[p];
        endValue = endCache[p];
        if (startValue !== endValue && exclude.indexOf(p) < 0) {
            //tweening to no perspective gives very unintuitive results - just keep the same perspective in that case.
            startUnit = (0, $7HZRt.getUnit)(startValue);
            endUnit = (0, $7HZRt.getUnit)(endValue);
            startNum = startUnit !== endUnit ? $bb9415d43f60f2ec$var$_convertToUnit(target, p, startValue, endUnit) : parseFloat(startValue);
            endNum = parseFloat(endValue);
            plugin._pt = new (0, $7HZRt.PropTween)(plugin._pt, endCache, p, startNum, endNum - startNum, $bb9415d43f60f2ec$var$_renderCSSProp);
            plugin._pt.u = endUnit || 0;
            plugin._props.push(p);
        }
    }
    $bb9415d43f60f2ec$var$_assign(endCache, startCache);
}; // handle splitting apart padding, margin, borderWidth, and borderRadius into their 4 components. Firefox, for example, won't report borderRadius correctly - it will only do borderTopLeftRadius and the other corners. We also want to handle paddingTop, marginLeft, borderRightWidth, etc.
(0, $7HZRt._forEachName)("padding,margin,Width,Radius", function(name, index) {
    var t = "Top", r = "Right", b = "Bottom", l = "Left", props = (index < 3 ? [
        t,
        r,
        b,
        l
    ] : [
        t + l,
        t + r,
        b + r,
        b + l
    ]).map(function(side) {
        return index < 2 ? name + side : "border" + side + name;
    });
    $bb9415d43f60f2ec$var$_specialProps[index > 1 ? "border" + name : name] = function(plugin, target, property, endValue, tween) {
        var a, vars;
        if (arguments.length < 4) {
            // getter, passed target, property, and unit (from _get())
            a = props.map(function(prop) {
                return $bb9415d43f60f2ec$var$_get(plugin, prop, property);
            });
            vars = a.join(" ");
            return vars.split(a[0]).length === 5 ? a[0] : vars;
        }
        a = (endValue + "").split(" ");
        vars = {};
        props.forEach(function(prop, i) {
            return vars[prop] = a[i] = a[i] || a[(i - 1) / 2 | 0];
        });
        plugin.init(target, vars, tween);
    };
});
var $bb9415d43f60f2ec$export$855822f522f18eef = {
    name: "css",
    register: $bb9415d43f60f2ec$var$_initCore,
    targetTest: function targetTest(target) {
        return target.style && target.nodeType;
    },
    init: function init(target, vars, tween, index, targets) {
        var props = this._props, style = target.style, startAt = tween.vars.startAt, startValue, endValue, endNum, startNum, type, specialProp, p, startUnit, endUnit, relative, isTransformRelated, transformPropTween, cache, smooth, hasPriority, inlineProps;
        $bb9415d43f60f2ec$var$_pluginInitted || $bb9415d43f60f2ec$var$_initCore(); // we may call init() multiple times on the same plugin instance, like when adding special properties, so make sure we don't overwrite the revert data or inlineProps
        this.styles = this.styles || $bb9415d43f60f2ec$var$_getStyleSaver(target);
        inlineProps = this.styles.props;
        this.tween = tween;
        for(p in vars){
            if (p === "autoRound") continue;
            endValue = vars[p];
            if ((0, $7HZRt._plugins)[p] && (0, $7HZRt._checkPlugin)(p, vars, tween, index, target, targets)) continue;
            type = typeof endValue;
            specialProp = $bb9415d43f60f2ec$var$_specialProps[p];
            if (type === "function") {
                endValue = endValue.call(tween, index, target, targets);
                type = typeof endValue;
            }
            if (type === "string" && ~endValue.indexOf("random(")) endValue = (0, $7HZRt._replaceRandom)(endValue);
            if (specialProp) specialProp(this, target, p, endValue, tween) && (hasPriority = 1);
            else if (p.substr(0, 2) === "--") {
                //CSS variable
                startValue = (getComputedStyle(target).getPropertyValue(p) + "").trim();
                endValue += "";
                (0, $7HZRt._colorExp).lastIndex = 0;
                if (!(0, $7HZRt._colorExp).test(startValue)) {
                    // colors don't have units
                    startUnit = (0, $7HZRt.getUnit)(startValue);
                    endUnit = (0, $7HZRt.getUnit)(endValue);
                }
                endUnit ? startUnit !== endUnit && (startValue = $bb9415d43f60f2ec$var$_convertToUnit(target, p, startValue, endUnit) + endUnit) : startUnit && (endValue += startUnit);
                this.add(style, "setProperty", startValue, endValue, index, targets, 0, 0, p);
                props.push(p);
                inlineProps.push(p, 0, style[p]);
            } else if (type !== "undefined") {
                if (startAt && p in startAt) {
                    // in case someone hard-codes a complex value as the start, like top: "calc(2vh / 2)". Without this, it'd use the computed value (always in px)
                    startValue = typeof startAt[p] === "function" ? startAt[p].call(tween, index, target, targets) : startAt[p];
                    (0, $7HZRt._isString)(startValue) && ~startValue.indexOf("random(") && (startValue = (0, $7HZRt._replaceRandom)(startValue));
                    (0, $7HZRt.getUnit)(startValue + "") || startValue === "auto" || (startValue += (0, $7HZRt._config).units[p] || (0, $7HZRt.getUnit)($bb9415d43f60f2ec$var$_get(target, p)) || ""); // for cases when someone passes in a unitless value like {x: 100}; if we try setting translate(100, 0px) it won't work.
                    (startValue + "").charAt(1) === "=" && (startValue = $bb9415d43f60f2ec$var$_get(target, p)); // can't work with relative values
                } else startValue = $bb9415d43f60f2ec$var$_get(target, p);
                startNum = parseFloat(startValue);
                relative = type === "string" && endValue.charAt(1) === "=" && endValue.substr(0, 2);
                relative && (endValue = endValue.substr(2));
                endNum = parseFloat(endValue);
                if (p in $bb9415d43f60f2ec$var$_propertyAliases) {
                    if (p === "autoAlpha") {
                        //special case where we control the visibility along with opacity. We still allow the opacity value to pass through and get tweened.
                        if (startNum === 1 && $bb9415d43f60f2ec$var$_get(target, "visibility") === "hidden" && endNum) //if visibility is initially set to "hidden", we should interpret that as intent to make opacity 0 (a convenience)
                        startNum = 0;
                        inlineProps.push("visibility", 0, style.visibility);
                        $bb9415d43f60f2ec$var$_addNonTweeningPT(this, style, "visibility", startNum ? "inherit" : "hidden", endNum ? "inherit" : "hidden", !endNum);
                    }
                    if (p !== "scale" && p !== "transform") {
                        p = $bb9415d43f60f2ec$var$_propertyAliases[p];
                        ~p.indexOf(",") && (p = p.split(",")[0]);
                    }
                }
                isTransformRelated = p in $bb9415d43f60f2ec$var$_transformProps; //--- TRANSFORM-RELATED ---
                if (isTransformRelated) {
                    this.styles.save(p);
                    if (!transformPropTween) {
                        cache = target._gsap;
                        cache.renderTransform && !vars.parseTransform || $bb9415d43f60f2ec$var$_parseTransform(target, vars.parseTransform); // if, for example, gsap.set(... {transform:"translateX(50vw)"}), the _get() call doesn't parse the transform, thus cache.renderTransform won't be set yet so force the parsing of the transform here.
                        smooth = vars.smoothOrigin !== false && cache.smooth;
                        transformPropTween = this._pt = new (0, $7HZRt.PropTween)(this._pt, style, $bb9415d43f60f2ec$var$_transformProp, 0, 1, cache.renderTransform, cache, 0, -1); //the first time through, create the rendering PropTween so that it runs LAST (in the linked list, we keep adding to the beginning)
                        transformPropTween.dep = 1; //flag it as dependent so that if things get killed/overwritten and this is the only PropTween left, we can safely kill the whole tween.
                    }
                    if (p === "scale") {
                        this._pt = new (0, $7HZRt.PropTween)(this._pt, cache, "scaleY", cache.scaleY, (relative ? (0, $7HZRt._parseRelative)(cache.scaleY, relative + endNum) : endNum) - cache.scaleY || 0, $bb9415d43f60f2ec$var$_renderCSSProp);
                        this._pt.u = 0;
                        props.push("scaleY", p);
                        p += "X";
                    } else if (p === "transformOrigin") {
                        inlineProps.push($bb9415d43f60f2ec$var$_transformOriginProp, 0, style[$bb9415d43f60f2ec$var$_transformOriginProp]);
                        endValue = $bb9415d43f60f2ec$var$_convertKeywordsToPercentages(endValue); //in case something like "left top" or "bottom right" is passed in. Convert to percentages.
                        if (cache.svg) $bb9415d43f60f2ec$var$_applySVGOrigin(target, endValue, 0, smooth, 0, this);
                        else {
                            endUnit = parseFloat(endValue.split(" ")[2]) || 0; //handle the zOrigin separately!
                            endUnit !== cache.zOrigin && $bb9415d43f60f2ec$var$_addNonTweeningPT(this, cache, "zOrigin", cache.zOrigin, endUnit);
                            $bb9415d43f60f2ec$var$_addNonTweeningPT(this, style, p, $bb9415d43f60f2ec$var$_firstTwoOnly(startValue), $bb9415d43f60f2ec$var$_firstTwoOnly(endValue));
                        }
                        continue;
                    } else if (p === "svgOrigin") {
                        $bb9415d43f60f2ec$var$_applySVGOrigin(target, endValue, 1, smooth, 0, this);
                        continue;
                    } else if (p in $bb9415d43f60f2ec$var$_rotationalProperties) {
                        $bb9415d43f60f2ec$var$_addRotationalPropTween(this, cache, p, startNum, relative ? (0, $7HZRt._parseRelative)(startNum, relative + endValue) : endValue);
                        continue;
                    } else if (p === "smoothOrigin") {
                        $bb9415d43f60f2ec$var$_addNonTweeningPT(this, cache, "smooth", cache.smooth, endValue);
                        continue;
                    } else if (p === "force3D") {
                        cache[p] = endValue;
                        continue;
                    } else if (p === "transform") {
                        $bb9415d43f60f2ec$var$_addRawTransformPTs(this, endValue, target);
                        continue;
                    }
                } else if (!(p in style)) p = $bb9415d43f60f2ec$export$8cbef5dd49a09c8b(p) || p;
                if (isTransformRelated || (endNum || endNum === 0) && (startNum || startNum === 0) && !$bb9415d43f60f2ec$var$_complexExp.test(endValue) && p in style) {
                    startUnit = (startValue + "").substr((startNum + "").length);
                    endNum || (endNum = 0); // protect against NaN
                    endUnit = (0, $7HZRt.getUnit)(endValue) || (p in (0, $7HZRt._config).units ? (0, $7HZRt._config).units[p] : startUnit);
                    startUnit !== endUnit && (startNum = $bb9415d43f60f2ec$var$_convertToUnit(target, p, startValue, endUnit));
                    this._pt = new (0, $7HZRt.PropTween)(this._pt, isTransformRelated ? cache : style, p, startNum, (relative ? (0, $7HZRt._parseRelative)(startNum, relative + endNum) : endNum) - startNum, !isTransformRelated && (endUnit === "px" || p === "zIndex") && vars.autoRound !== false ? $bb9415d43f60f2ec$var$_renderRoundedCSSProp : $bb9415d43f60f2ec$var$_renderCSSProp);
                    this._pt.u = endUnit || 0;
                    if (startUnit !== endUnit && endUnit !== "%") {
                        //when the tween goes all the way back to the beginning, we need to revert it to the OLD/ORIGINAL value (with those units). We record that as a "b" (beginning) property and point to a render method that handles that. (performance optimization)
                        this._pt.b = startValue;
                        this._pt.r = $bb9415d43f60f2ec$var$_renderCSSPropWithBeginning;
                    }
                } else if (!(p in style)) {
                    if (p in target) //maybe it's not a style - it could be a property added directly to an element in which case we'll try to animate that.
                    this.add(target, p, startValue || target[p], relative ? relative + endValue : endValue, index, targets);
                    else if (p !== "parseTransform") {
                        (0, $7HZRt._missingPlugin)(p, endValue);
                        continue;
                    }
                } else $bb9415d43f60f2ec$var$_tweenComplexCSSString.call(this, target, p, startValue, relative ? relative + endValue : endValue);
                isTransformRelated || (p in style ? inlineProps.push(p, 0, style[p]) : inlineProps.push(p, 1, startValue || target[p]));
                props.push(p);
            }
        }
        hasPriority && (0, $7HZRt._sortPropTweensByPriority)(this);
    },
    render: function render(ratio, data) {
        if (data.tween._time || !$bb9415d43f60f2ec$var$_reverting()) {
            var pt = data._pt;
            while(pt){
                pt.r(ratio, pt.d);
                pt = pt._next;
            }
        } else data.styles.revert();
    },
    get: $bb9415d43f60f2ec$var$_get,
    aliases: $bb9415d43f60f2ec$var$_propertyAliases,
    getSetter: function getSetter(target, property, plugin) {
        //returns a setter function that accepts target, property, value and applies it accordingly. Remember, properties like "x" aren't as simple as target.style.property = value because they've got to be applied to a proxy object and then merged into a transform string in a renderer.
        var p = $bb9415d43f60f2ec$var$_propertyAliases[property];
        p && p.indexOf(",") < 0 && (property = p);
        return property in $bb9415d43f60f2ec$var$_transformProps && property !== $bb9415d43f60f2ec$var$_transformOriginProp && (target._gsap.x || $bb9415d43f60f2ec$var$_get(target, "x")) ? plugin && $bb9415d43f60f2ec$var$_recentSetterPlugin === plugin ? property === "scale" ? $bb9415d43f60f2ec$var$_setterScale : $bb9415d43f60f2ec$var$_setterTransform : ($bb9415d43f60f2ec$var$_recentSetterPlugin = plugin || {}, property === "scale" ? $bb9415d43f60f2ec$var$_setterScaleWithRender : $bb9415d43f60f2ec$var$_setterTransformWithRender) : target.style && !(0, $7HZRt._isUndefined)(target.style[property]) ? $bb9415d43f60f2ec$var$_setterCSSStyle : ~property.indexOf("-") ? $bb9415d43f60f2ec$var$_setterCSSProp : (0, $7HZRt._getSetter)(target, property);
    },
    core: {
        _removeProperty: $bb9415d43f60f2ec$var$_removeProperty,
        _getMatrix: $bb9415d43f60f2ec$var$_getMatrix
    }
};
(0, $7HZRt.gsap).utils.checkPrefix = $bb9415d43f60f2ec$export$8cbef5dd49a09c8b;
(0, $7HZRt.gsap).core.getStyleSaver = $bb9415d43f60f2ec$var$_getStyleSaver;
(function(positionAndScale, rotation, others, aliases) {
    var all = (0, $7HZRt._forEachName)(positionAndScale + "," + rotation + "," + others, function(name) {
        $bb9415d43f60f2ec$var$_transformProps[name] = 1;
    });
    (0, $7HZRt._forEachName)(rotation, function(name) {
        (0, $7HZRt._config).units[name] = "deg";
        $bb9415d43f60f2ec$var$_rotationalProperties[name] = 1;
    });
    $bb9415d43f60f2ec$var$_propertyAliases[all[13]] = positionAndScale + "," + rotation;
    (0, $7HZRt._forEachName)(aliases, function(name) {
        var split = name.split(":");
        $bb9415d43f60f2ec$var$_propertyAliases[split[1]] = all[split[0]];
    });
})("x,y,z,scale,scaleX,scaleY,xPercent,yPercent", "rotation,rotationX,rotationY,skewX,skewY", "transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY");
(0, $7HZRt._forEachName)("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function(name) {
    (0, $7HZRt._config).units[name] = "px";
});
(0, $7HZRt.gsap).registerPlugin($bb9415d43f60f2ec$export$855822f522f18eef);


var $54598d203dd72198$export$99ee26438460406a = (0, $7HZRt.gsap).registerPlugin((0, $bb9415d43f60f2ec$export$855822f522f18eef)) || (0, $7HZRt.gsap), // to protect from tree shaking
$54598d203dd72198$export$7b23975ad686bf91 = $54598d203dd72198$export$99ee26438460406a.core.Tween;


/*!
 * ScrollToPlugin 3.12.5
 * https://gsap.com
 *
 * @license Copyright 2008-2024, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var $d2b48baa8290cfe7$var$gsap, $d2b48baa8290cfe7$var$_coreInitted, $d2b48baa8290cfe7$var$_window, $d2b48baa8290cfe7$var$_docEl, $d2b48baa8290cfe7$var$_body, $d2b48baa8290cfe7$var$_toArray, $d2b48baa8290cfe7$var$_config, $d2b48baa8290cfe7$var$ScrollTrigger, $d2b48baa8290cfe7$var$_windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, $d2b48baa8290cfe7$var$_getGSAP = function _getGSAP() {
    return $d2b48baa8290cfe7$var$gsap || $d2b48baa8290cfe7$var$_windowExists() && ($d2b48baa8290cfe7$var$gsap = window.gsap) && $d2b48baa8290cfe7$var$gsap.registerPlugin && $d2b48baa8290cfe7$var$gsap;
}, $d2b48baa8290cfe7$var$_isString = function _isString(value) {
    return typeof value === "string";
}, $d2b48baa8290cfe7$var$_isFunction = function _isFunction(value) {
    return typeof value === "function";
}, $d2b48baa8290cfe7$var$_max = function _max(element, axis) {
    var dim = axis === "x" ? "Width" : "Height", scroll = "scroll" + dim, client = "client" + dim;
    return element === $d2b48baa8290cfe7$var$_window || element === $d2b48baa8290cfe7$var$_docEl || element === $d2b48baa8290cfe7$var$_body ? Math.max($d2b48baa8290cfe7$var$_docEl[scroll], $d2b48baa8290cfe7$var$_body[scroll]) - ($d2b48baa8290cfe7$var$_window["inner" + dim] || $d2b48baa8290cfe7$var$_docEl[client] || $d2b48baa8290cfe7$var$_body[client]) : element[scroll] - element["offset" + dim];
}, $d2b48baa8290cfe7$var$_buildGetter = function _buildGetter(e, axis) {
    //pass in an element and an axis ("x" or "y") and it'll return a getter function for the scroll position of that element (like scrollTop or scrollLeft, although if the element is the window, it'll use the pageXOffset/pageYOffset or the documentElement's scrollTop/scrollLeft or document.body's. Basically this streamlines things and makes a very fast getter across browsers.
    var p = "scroll" + (axis === "x" ? "Left" : "Top");
    if (e === $d2b48baa8290cfe7$var$_window) {
        if (e.pageXOffset != null) p = "page" + axis.toUpperCase() + "Offset";
        else e = $d2b48baa8290cfe7$var$_docEl[p] != null ? $d2b48baa8290cfe7$var$_docEl : $d2b48baa8290cfe7$var$_body;
    }
    return function() {
        return e[p];
    };
}, $d2b48baa8290cfe7$var$_clean = function _clean(value, index, target, targets) {
    $d2b48baa8290cfe7$var$_isFunction(value) && (value = value(index, target, targets));
    if (typeof value !== "object") return $d2b48baa8290cfe7$var$_isString(value) && value !== "max" && value.charAt(1) !== "=" ? {
        x: value,
        y: value
    } : {
        y: value
    }; //if we don't receive an object as the parameter, assume the user intends "y".
    else if (value.nodeType) return {
        y: value,
        x: value
    };
    else {
        var result = {}, p;
        for(p in value)result[p] = p !== "onAutoKill" && $d2b48baa8290cfe7$var$_isFunction(value[p]) ? value[p](index, target, targets) : value[p];
        return result;
    }
}, $d2b48baa8290cfe7$var$_getOffset = function _getOffset(element, container) {
    element = $d2b48baa8290cfe7$var$_toArray(element)[0];
    if (!element || !element.getBoundingClientRect) return console.warn("scrollTo target doesn't exist. Using 0") || {
        x: 0,
        y: 0
    };
    var rect = element.getBoundingClientRect(), isRoot = !container || container === $d2b48baa8290cfe7$var$_window || container === $d2b48baa8290cfe7$var$_body, cRect = isRoot ? {
        top: $d2b48baa8290cfe7$var$_docEl.clientTop - ($d2b48baa8290cfe7$var$_window.pageYOffset || $d2b48baa8290cfe7$var$_docEl.scrollTop || $d2b48baa8290cfe7$var$_body.scrollTop || 0),
        left: $d2b48baa8290cfe7$var$_docEl.clientLeft - ($d2b48baa8290cfe7$var$_window.pageXOffset || $d2b48baa8290cfe7$var$_docEl.scrollLeft || $d2b48baa8290cfe7$var$_body.scrollLeft || 0)
    } : container.getBoundingClientRect(), offsets = {
        x: rect.left - cRect.left,
        y: rect.top - cRect.top
    };
    if (!isRoot && container) {
        //only add the current scroll position if it's not the window/body.
        offsets.x += $d2b48baa8290cfe7$var$_buildGetter(container, "x")();
        offsets.y += $d2b48baa8290cfe7$var$_buildGetter(container, "y")();
    }
    return offsets;
}, $d2b48baa8290cfe7$var$_parseVal = function _parseVal(value, target, axis, currentVal, offset) {
    return !isNaN(value) && typeof value !== "object" ? parseFloat(value) - offset : $d2b48baa8290cfe7$var$_isString(value) && value.charAt(1) === "=" ? parseFloat(value.substr(2)) * (value.charAt(0) === "-" ? -1 : 1) + currentVal - offset : value === "max" ? $d2b48baa8290cfe7$var$_max(target, axis) - offset : Math.min($d2b48baa8290cfe7$var$_max(target, axis), $d2b48baa8290cfe7$var$_getOffset(value, target)[axis] - offset);
}, $d2b48baa8290cfe7$var$_initCore = function _initCore() {
    $d2b48baa8290cfe7$var$gsap = $d2b48baa8290cfe7$var$_getGSAP();
    if ($d2b48baa8290cfe7$var$_windowExists() && $d2b48baa8290cfe7$var$gsap && typeof document !== "undefined" && document.body) {
        $d2b48baa8290cfe7$var$_window = window;
        $d2b48baa8290cfe7$var$_body = document.body;
        $d2b48baa8290cfe7$var$_docEl = document.documentElement;
        $d2b48baa8290cfe7$var$_toArray = $d2b48baa8290cfe7$var$gsap.utils.toArray;
        $d2b48baa8290cfe7$var$gsap.config({
            autoKillThreshold: 7
        });
        $d2b48baa8290cfe7$var$_config = $d2b48baa8290cfe7$var$gsap.config();
        $d2b48baa8290cfe7$var$_coreInitted = 1;
    }
};
var $d2b48baa8290cfe7$export$6953cc323644330b = {
    version: "3.12.5",
    name: "scrollTo",
    rawVars: 1,
    register: function register(core) {
        $d2b48baa8290cfe7$var$gsap = core;
        $d2b48baa8290cfe7$var$_initCore();
    },
    init: function init(target, value, tween, index, targets) {
        $d2b48baa8290cfe7$var$_coreInitted || $d2b48baa8290cfe7$var$_initCore();
        var data = this, snapType = $d2b48baa8290cfe7$var$gsap.getProperty(target, "scrollSnapType");
        data.isWin = target === $d2b48baa8290cfe7$var$_window;
        data.target = target;
        data.tween = tween;
        value = $d2b48baa8290cfe7$var$_clean(value, index, target, targets);
        data.vars = value;
        data.autoKill = !!value.autoKill;
        data.getX = $d2b48baa8290cfe7$var$_buildGetter(target, "x");
        data.getY = $d2b48baa8290cfe7$var$_buildGetter(target, "y");
        data.x = data.xPrev = data.getX();
        data.y = data.yPrev = data.getY();
        $d2b48baa8290cfe7$var$ScrollTrigger || ($d2b48baa8290cfe7$var$ScrollTrigger = $d2b48baa8290cfe7$var$gsap.core.globals().ScrollTrigger);
        $d2b48baa8290cfe7$var$gsap.getProperty(target, "scrollBehavior") === "smooth" && $d2b48baa8290cfe7$var$gsap.set(target, {
            scrollBehavior: "auto"
        });
        if (snapType && snapType !== "none") {
            // disable scroll snapping to avoid strange behavior
            data.snap = 1;
            data.snapInline = target.style.scrollSnapType;
            target.style.scrollSnapType = "none";
        }
        if (value.x != null) {
            data.add(data, "x", data.x, $d2b48baa8290cfe7$var$_parseVal(value.x, target, "x", data.x, value.offsetX || 0), index, targets);
            data._props.push("scrollTo_x");
        } else data.skipX = 1;
        if (value.y != null) {
            data.add(data, "y", data.y, $d2b48baa8290cfe7$var$_parseVal(value.y, target, "y", data.y, value.offsetY || 0), index, targets);
            data._props.push("scrollTo_y");
        } else data.skipY = 1;
    },
    render: function render(ratio, data) {
        var pt = data._pt, target = data.target, tween = data.tween, autoKill = data.autoKill, xPrev = data.xPrev, yPrev = data.yPrev, isWin = data.isWin, snap = data.snap, snapInline = data.snapInline, x, y, yDif, xDif, threshold;
        while(pt){
            pt.r(ratio, pt.d);
            pt = pt._next;
        }
        x = isWin || !data.skipX ? data.getX() : xPrev;
        y = isWin || !data.skipY ? data.getY() : yPrev;
        yDif = y - yPrev;
        xDif = x - xPrev;
        threshold = $d2b48baa8290cfe7$var$_config.autoKillThreshold;
        if (data.x < 0) //can't scroll to a position less than 0! Might happen if someone uses a Back.easeOut or Elastic.easeOut when scrolling back to the top of the page (for example)
        data.x = 0;
        if (data.y < 0) data.y = 0;
        if (autoKill) {
            //note: iOS has a bug that throws off the scroll by several pixels, so we need to check if it's within 7 pixels of the previous one that we set instead of just looking for an exact match.
            if (!data.skipX && (xDif > threshold || xDif < -threshold) && x < $d2b48baa8290cfe7$var$_max(target, "x")) data.skipX = 1; //if the user scrolls separately, we should stop tweening!
            if (!data.skipY && (yDif > threshold || yDif < -threshold) && y < $d2b48baa8290cfe7$var$_max(target, "y")) data.skipY = 1; //if the user scrolls separately, we should stop tweening!
            if (data.skipX && data.skipY) {
                tween.kill();
                data.vars.onAutoKill && data.vars.onAutoKill.apply(tween, data.vars.onAutoKillParams || []);
            }
        }
        if (isWin) $d2b48baa8290cfe7$var$_window.scrollTo(!data.skipX ? data.x : x, !data.skipY ? data.y : y);
        else {
            data.skipY || (target.scrollTop = data.y);
            data.skipX || (target.scrollLeft = data.x);
        }
        if (snap && (ratio === 1 || ratio === 0)) {
            y = target.scrollTop;
            x = target.scrollLeft;
            snapInline ? target.style.scrollSnapType = snapInline : target.style.removeProperty("scroll-snap-type");
            target.scrollTop = y + 1; // bug in Safari causes the element to totally reset its scroll position when scroll-snap-type changes, so we need to set it to a slightly different value and then back again to work around this bug.
            target.scrollLeft = x + 1;
            target.scrollTop = y;
            target.scrollLeft = x;
        }
        data.xPrev = data.x;
        data.yPrev = data.y;
        $d2b48baa8290cfe7$var$ScrollTrigger && $d2b48baa8290cfe7$var$ScrollTrigger.update();
    },
    kill: function kill(property) {
        var both = property === "scrollTo", i = this._props.indexOf(property);
        if (both || property === "scrollTo_x") this.skipX = 1;
        if (both || property === "scrollTo_y") this.skipY = 1;
        i > -1 && this._props.splice(i, 1);
        return !this._props.length;
    }
};
$d2b48baa8290cfe7$export$6953cc323644330b.max = $d2b48baa8290cfe7$var$_max;
$d2b48baa8290cfe7$export$6953cc323644330b.getOffset = $d2b48baa8290cfe7$var$_getOffset;
$d2b48baa8290cfe7$export$6953cc323644330b.buildGetter = $d2b48baa8290cfe7$var$_buildGetter;
$d2b48baa8290cfe7$var$_getGSAP() && $d2b48baa8290cfe7$var$gsap.registerPlugin($d2b48baa8290cfe7$export$6953cc323644330b);



var $fLHXI = parcelRequire("fLHXI");


var $5MibD = parcelRequire("5MibD");

const $58535dd16cea4d69$var$e = (t, ...s)=>{
    const n = s.length;
    for(let i = 0; i < n; i++){
        const n = s[i] || {};
        Object.entries(n).forEach(([s, n])=>{
            const i = Array.isArray(n) ? [] : {};
            var o;
            t[s] || Object.assign(t, {
                [s]: i
            }), "object" == typeof (o = n) && null !== o && o.constructor === Object && "[object Object]" === Object.prototype.toString.call(o) ? Object.assign(t[s], $58535dd16cea4d69$var$e(i, n)) : Array.isArray(n) ? Object.assign(t, {
                [s]: [
                    ...n
                ]
            }) : Object.assign(t, {
                [s]: n
            });
        });
    }
    return t;
}, $58535dd16cea4d69$var$t = function(e, t) {
    return e.split(".").reduce((e, t)=>"object" == typeof e ? e[t] : void 0, t);
};
class $58535dd16cea4d69$var$s {
    constructor(e = {}){
        Object.defineProperty(this, "options", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: e
        }), Object.defineProperty(this, "events", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: new Map
        }), this.setOptions(e);
        for (const e of Object.getOwnPropertyNames(Object.getPrototypeOf(this)))e.startsWith("on") && "function" == typeof this[e] && (this[e] = this[e].bind(this));
    }
    setOptions(t) {
        this.options = t ? $58535dd16cea4d69$var$e({}, this.constructor.defaults, t) : {};
        for (const [e, t] of Object.entries(this.option("on") || {}))this.on(e, t);
    }
    option(e, ...s) {
        let n = $58535dd16cea4d69$var$t(e, this.options);
        return n && "function" == typeof n && (n = n.call(this, this, ...s)), n;
    }
    optionFor(e, s, n, ...i) {
        let o = $58535dd16cea4d69$var$t(s, e);
        var r;
        "string" != typeof (r = o) || isNaN(r) || isNaN(parseFloat(r)) || (o = parseFloat(o)), "true" === o && (o = !0), "false" === o && (o = !1), o && "function" == typeof o && (o = o.call(this, this, e, ...i));
        let a = $58535dd16cea4d69$var$t(s, this.options);
        return a && "function" == typeof a ? o = a.call(this, this, e, ...i, o) : void 0 === o && (o = a), void 0 === o ? n : o;
    }
    cn(e) {
        const t = this.options.classes;
        return t && t[e] || "";
    }
    localize(e, t = []) {
        e = String(e).replace(/\{\{(\w+).?(\w+)?\}\}/g, (e, t, s)=>{
            let n = "";
            return s ? n = this.option(`${t[0] + t.toLowerCase().substring(1)}.l10n.${s}`) : t && (n = this.option(`l10n.${t}`)), n || (n = e), n;
        });
        for(let s = 0; s < t.length; s++)e = e.split(t[s][0]).join(t[s][1]);
        return e = e.replace(/\{\{(.*?)\}\}/g, (e, t)=>t);
    }
    on(e, t) {
        let s = [];
        "string" == typeof e ? s = e.split(" ") : Array.isArray(e) && (s = e), this.events || (this.events = new Map), s.forEach((e)=>{
            let s = this.events.get(e);
            s || (this.events.set(e, []), s = []), s.includes(t) || s.push(t), this.events.set(e, s);
        });
    }
    off(e, t) {
        let s = [];
        "string" == typeof e ? s = e.split(" ") : Array.isArray(e) && (s = e), s.forEach((e)=>{
            const s = this.events.get(e);
            if (Array.isArray(s)) {
                const e = s.indexOf(t);
                e > -1 && s.splice(e, 1);
            }
        });
    }
    emit(e, ...t) {
        [
            ...this.events.get(e) || []
        ].forEach((e)=>e(this, ...t)), "*" !== e && this.emit("*", e, ...t);
    }
}
Object.defineProperty($58535dd16cea4d69$var$s, "version", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: "5.0.36"
}), Object.defineProperty($58535dd16cea4d69$var$s, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {}
});
class $58535dd16cea4d69$var$n extends $58535dd16cea4d69$var$s {
    constructor(e, t){
        super(t), Object.defineProperty(this, "instance", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: e
        });
    }
    attach() {}
    detach() {}
}
const $58535dd16cea4d69$var$i = (e)=>`${e || ""}`.split(" ").filter((e)=>!!e), $58535dd16cea4d69$var$o = (e, t)=>{
    e && $58535dd16cea4d69$var$i(t).forEach((t)=>{
        e.classList.add(t);
    });
}, $58535dd16cea4d69$var$r = "play", $58535dd16cea4d69$var$a = "pause", $58535dd16cea4d69$var$l = "ready";
class $58535dd16cea4d69$export$6c96167f46662e38 extends $58535dd16cea4d69$var$n {
    constructor(){
        super(...arguments), Object.defineProperty(this, "state", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $58535dd16cea4d69$var$l
        }), Object.defineProperty(this, "inHover", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "timer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "progressBar", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        });
    }
    get isActive() {
        return this.state !== $58535dd16cea4d69$var$l;
    }
    onReady(e) {
        this.option("autoStart") && (e.isInfinite || e.page < e.pages.length - 1) && this.start();
    }
    onChange() {
        this.removeProgressBar(), this.pause();
    }
    onSettle() {
        this.resume();
    }
    onVisibilityChange() {
        "visible" === document.visibilityState ? this.resume() : this.pause();
    }
    onMouseEnter() {
        this.inHover = !0, this.pause();
    }
    onMouseLeave() {
        var e;
        this.inHover = !1, (null === (e = this.instance.panzoom) || void 0 === e ? void 0 : e.isResting) && this.resume();
    }
    onTimerEnd() {
        const e = this.instance;
        "play" === this.state && (e.isInfinite || e.page !== e.pages.length - 1 ? e.slideNext() : e.slideTo(0));
    }
    removeProgressBar() {
        this.progressBar && (this.progressBar.remove(), this.progressBar = null);
    }
    createProgressBar() {
        var e;
        if (!this.option("showProgress")) return null;
        this.removeProgressBar();
        const t = this.instance, s = (null === (e = t.pages[t.page]) || void 0 === e ? void 0 : e.slides) || [];
        let n = this.option("progressParentEl");
        if (n || (n = (1 === s.length ? s[0].el : null) || t.viewport), !n) return null;
        const i = document.createElement("div");
        return $58535dd16cea4d69$var$o(i, "f-progress"), n.prepend(i), this.progressBar = i, i.offsetHeight, i;
    }
    set() {
        const e = this, t = e.instance;
        if (t.pages.length < 2) return;
        if (e.timer) return;
        const s = e.option("timeout");
        e.state = $58535dd16cea4d69$var$r, $58535dd16cea4d69$var$o(t.container, "has-autoplay");
        let n = e.createProgressBar();
        n && (n.style.transitionDuration = `${s}ms`, n.style.transform = "scaleX(1)"), e.timer = setTimeout(()=>{
            e.timer = null, e.inHover || e.onTimerEnd();
        }, s), e.emit("set");
    }
    clear() {
        const e = this;
        e.timer && (clearTimeout(e.timer), e.timer = null), e.removeProgressBar();
    }
    start() {
        const e = this;
        if (e.set(), e.state !== $58535dd16cea4d69$var$l) {
            if (e.option("pauseOnHover")) {
                const t = e.instance.container;
                t.addEventListener("mouseenter", e.onMouseEnter, !1), t.addEventListener("mouseleave", e.onMouseLeave, !1);
            }
            document.addEventListener("visibilitychange", e.onVisibilityChange, !1), e.emit("start");
        }
    }
    stop() {
        const e = this, t = e.state, s = e.instance.container;
        var n, o;
        e.clear(), e.state = $58535dd16cea4d69$var$l, s.removeEventListener("mouseenter", e.onMouseEnter, !1), s.removeEventListener("mouseleave", e.onMouseLeave, !1), document.removeEventListener("visibilitychange", e.onVisibilityChange, !1), o = "has-autoplay", (n = s) && $58535dd16cea4d69$var$i(o).forEach((e)=>{
            n.classList.remove(e);
        }), t !== $58535dd16cea4d69$var$l && e.emit("stop");
    }
    pause() {
        const e = this;
        e.state === $58535dd16cea4d69$var$r && (e.state = $58535dd16cea4d69$var$a, e.clear(), e.emit($58535dd16cea4d69$var$a));
    }
    resume() {
        const e = this, t = e.instance;
        if (t.isInfinite || t.page !== t.pages.length - 1) {
            if (e.state !== $58535dd16cea4d69$var$r) {
                if (e.state === $58535dd16cea4d69$var$a && !e.inHover) {
                    const t = new Event("resume", {
                        bubbles: !0,
                        cancelable: !0
                    });
                    e.emit("resume", t), t.defaultPrevented || e.set();
                }
            } else e.set();
        } else e.stop();
    }
    toggle() {
        this.state === $58535dd16cea4d69$var$r || this.state === $58535dd16cea4d69$var$a ? this.stop() : this.start();
    }
    attach() {
        const e = this, t = e.instance;
        t.on("ready", e.onReady), t.on("Panzoom.startAnimation", e.onChange), t.on("Panzoom.endAnimation", e.onSettle), t.on("Panzoom.touchMove", e.onChange);
    }
    detach() {
        const e = this, t = e.instance;
        t.off("ready", e.onReady), t.off("Panzoom.startAnimation", e.onChange), t.off("Panzoom.endAnimation", e.onSettle), t.off("Panzoom.touchMove", e.onChange), e.stop();
    }
}
Object.defineProperty($58535dd16cea4d69$export$6c96167f46662e38, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {
        autoStart: !0,
        pauseOnHover: !0,
        progressParentEl: null,
        showProgress: !0,
        timeout: 3e3
    }
});



"use strict";
function $63689eb8761ae423$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


var $851085fe3b0750dc$exports = {};
// shim for using process in browser
var $851085fe3b0750dc$var$process = $851085fe3b0750dc$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $851085fe3b0750dc$var$cachedSetTimeout;
var $851085fe3b0750dc$var$cachedClearTimeout;
function $851085fe3b0750dc$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $851085fe3b0750dc$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $851085fe3b0750dc$var$cachedSetTimeout = setTimeout;
        else $851085fe3b0750dc$var$cachedSetTimeout = $851085fe3b0750dc$var$defaultSetTimout;
    } catch (e) {
        $851085fe3b0750dc$var$cachedSetTimeout = $851085fe3b0750dc$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $851085fe3b0750dc$var$cachedClearTimeout = clearTimeout;
        else $851085fe3b0750dc$var$cachedClearTimeout = $851085fe3b0750dc$var$defaultClearTimeout;
    } catch (e) {
        $851085fe3b0750dc$var$cachedClearTimeout = $851085fe3b0750dc$var$defaultClearTimeout;
    }
})();
function $851085fe3b0750dc$var$runTimeout(fun) {
    if ($851085fe3b0750dc$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($851085fe3b0750dc$var$cachedSetTimeout === $851085fe3b0750dc$var$defaultSetTimout || !$851085fe3b0750dc$var$cachedSetTimeout) && setTimeout) {
        $851085fe3b0750dc$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $851085fe3b0750dc$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $851085fe3b0750dc$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $851085fe3b0750dc$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $851085fe3b0750dc$var$runClearTimeout(marker) {
    if ($851085fe3b0750dc$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($851085fe3b0750dc$var$cachedClearTimeout === $851085fe3b0750dc$var$defaultClearTimeout || !$851085fe3b0750dc$var$cachedClearTimeout) && clearTimeout) {
        $851085fe3b0750dc$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $851085fe3b0750dc$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $851085fe3b0750dc$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $851085fe3b0750dc$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $851085fe3b0750dc$var$queue = [];
var $851085fe3b0750dc$var$draining = false;
var $851085fe3b0750dc$var$currentQueue;
var $851085fe3b0750dc$var$queueIndex = -1;
function $851085fe3b0750dc$var$cleanUpNextTick() {
    if (!$851085fe3b0750dc$var$draining || !$851085fe3b0750dc$var$currentQueue) return;
    $851085fe3b0750dc$var$draining = false;
    if ($851085fe3b0750dc$var$currentQueue.length) $851085fe3b0750dc$var$queue = $851085fe3b0750dc$var$currentQueue.concat($851085fe3b0750dc$var$queue);
    else $851085fe3b0750dc$var$queueIndex = -1;
    if ($851085fe3b0750dc$var$queue.length) $851085fe3b0750dc$var$drainQueue();
}
function $851085fe3b0750dc$var$drainQueue() {
    if ($851085fe3b0750dc$var$draining) return;
    var timeout = $851085fe3b0750dc$var$runTimeout($851085fe3b0750dc$var$cleanUpNextTick);
    $851085fe3b0750dc$var$draining = true;
    var len = $851085fe3b0750dc$var$queue.length;
    while(len){
        $851085fe3b0750dc$var$currentQueue = $851085fe3b0750dc$var$queue;
        $851085fe3b0750dc$var$queue = [];
        while(++$851085fe3b0750dc$var$queueIndex < len)if ($851085fe3b0750dc$var$currentQueue) $851085fe3b0750dc$var$currentQueue[$851085fe3b0750dc$var$queueIndex].run();
        $851085fe3b0750dc$var$queueIndex = -1;
        len = $851085fe3b0750dc$var$queue.length;
    }
    $851085fe3b0750dc$var$currentQueue = null;
    $851085fe3b0750dc$var$draining = false;
    $851085fe3b0750dc$var$runClearTimeout(timeout);
}
$851085fe3b0750dc$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $851085fe3b0750dc$var$queue.push(new $851085fe3b0750dc$var$Item(fun, args));
    if ($851085fe3b0750dc$var$queue.length === 1 && !$851085fe3b0750dc$var$draining) $851085fe3b0750dc$var$runTimeout($851085fe3b0750dc$var$drainQueue);
};
// v8 likes predictible objects
function $851085fe3b0750dc$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$851085fe3b0750dc$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$851085fe3b0750dc$var$process.title = "browser";
$851085fe3b0750dc$var$process.browser = true;
$851085fe3b0750dc$var$process.env = {};
$851085fe3b0750dc$var$process.argv = [];
$851085fe3b0750dc$var$process.version = ""; // empty string to avoid regexp issues
$851085fe3b0750dc$var$process.versions = {};
function $851085fe3b0750dc$var$noop() {}
$851085fe3b0750dc$var$process.on = $851085fe3b0750dc$var$noop;
$851085fe3b0750dc$var$process.addListener = $851085fe3b0750dc$var$noop;
$851085fe3b0750dc$var$process.once = $851085fe3b0750dc$var$noop;
$851085fe3b0750dc$var$process.off = $851085fe3b0750dc$var$noop;
$851085fe3b0750dc$var$process.removeListener = $851085fe3b0750dc$var$noop;
$851085fe3b0750dc$var$process.removeAllListeners = $851085fe3b0750dc$var$noop;
$851085fe3b0750dc$var$process.emit = $851085fe3b0750dc$var$noop;
$851085fe3b0750dc$var$process.prependListener = $851085fe3b0750dc$var$noop;
$851085fe3b0750dc$var$process.prependOnceListener = $851085fe3b0750dc$var$noop;
$851085fe3b0750dc$var$process.listeners = function(name) {
    return [];
};
$851085fe3b0750dc$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$851085fe3b0750dc$var$process.cwd = function() {
    return "/";
};
$851085fe3b0750dc$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$851085fe3b0750dc$var$process.umask = function() {
    return 0;
};


"use strict";
// utils is a library of generic helper functions non-specific to axios
const { toString: $4b81136b670d1f22$var$toString } = Object.prototype;
const { getPrototypeOf: $4b81136b670d1f22$var$getPrototypeOf } = Object;
const $4b81136b670d1f22$var$kindOf = ((cache)=>(thing)=>{
        const str = $4b81136b670d1f22$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $4b81136b670d1f22$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$4b81136b670d1f22$var$kindOf(thing) === type;
};
const $4b81136b670d1f22$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $4b81136b670d1f22$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $4b81136b670d1f22$var$isUndefined = $4b81136b670d1f22$var$typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $4b81136b670d1f22$var$isBuffer(val) {
    return val !== null && !$4b81136b670d1f22$var$isUndefined(val) && val.constructor !== null && !$4b81136b670d1f22$var$isUndefined(val.constructor) && $4b81136b670d1f22$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $4b81136b670d1f22$var$isArrayBuffer = $4b81136b670d1f22$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $4b81136b670d1f22$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $4b81136b670d1f22$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $4b81136b670d1f22$var$isString = $4b81136b670d1f22$var$typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $4b81136b670d1f22$var$isFunction = $4b81136b670d1f22$var$typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $4b81136b670d1f22$var$isNumber = $4b81136b670d1f22$var$typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $4b81136b670d1f22$var$isObject = (thing)=>thing !== null && typeof thing === "object";
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $4b81136b670d1f22$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $4b81136b670d1f22$var$isPlainObject = (val)=>{
    if ($4b81136b670d1f22$var$kindOf(val) !== "object") return false;
    const prototype = $4b81136b670d1f22$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $4b81136b670d1f22$var$isDate = $4b81136b670d1f22$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $4b81136b670d1f22$var$isFile = $4b81136b670d1f22$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $4b81136b670d1f22$var$isBlob = $4b81136b670d1f22$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $4b81136b670d1f22$var$isFileList = $4b81136b670d1f22$var$kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $4b81136b670d1f22$var$isStream = (val)=>$4b81136b670d1f22$var$isObject(val) && $4b81136b670d1f22$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $4b81136b670d1f22$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === "function" && thing instanceof FormData || $4b81136b670d1f22$var$isFunction(thing.append) && ((kind = $4b81136b670d1f22$var$kindOf(thing)) === "formdata" || // detect form-data instance
    kind === "object" && $4b81136b670d1f22$var$isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $4b81136b670d1f22$var$isURLSearchParams = $4b81136b670d1f22$var$kindOfTest("URLSearchParams");
const [$4b81136b670d1f22$var$isReadableStream, $4b81136b670d1f22$var$isRequest, $4b81136b670d1f22$var$isResponse, $4b81136b670d1f22$var$isHeaders] = [
    "ReadableStream",
    "Request",
    "Response",
    "Headers"
].map($4b81136b670d1f22$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $4b81136b670d1f22$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $4b81136b670d1f22$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($4b81136b670d1f22$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $4b81136b670d1f22$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $4b81136b670d1f22$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
})();
const $4b81136b670d1f22$var$isContextDefined = (context)=>!$4b81136b670d1f22$var$isUndefined(context) && context !== $4b81136b670d1f22$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $4b81136b670d1f22$var$merge() {
    const { caseless: caseless } = $4b81136b670d1f22$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $4b81136b670d1f22$var$findKey(result, key) || key;
        if ($4b81136b670d1f22$var$isPlainObject(result[targetKey]) && $4b81136b670d1f22$var$isPlainObject(val)) result[targetKey] = $4b81136b670d1f22$var$merge(result[targetKey], val);
        else if ($4b81136b670d1f22$var$isPlainObject(val)) result[targetKey] = $4b81136b670d1f22$var$merge({}, val);
        else if ($4b81136b670d1f22$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $4b81136b670d1f22$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $4b81136b670d1f22$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $4b81136b670d1f22$var$forEach(b, (val, key)=>{
        if (thisArg && $4b81136b670d1f22$var$isFunction(val)) a[key] = (0, $63689eb8761ae423$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $4b81136b670d1f22$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $4b81136b670d1f22$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, "super", {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $4b81136b670d1f22$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $4b81136b670d1f22$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $4b81136b670d1f22$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $4b81136b670d1f22$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($4b81136b670d1f22$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$4b81136b670d1f22$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $4b81136b670d1f22$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== "undefined" && $4b81136b670d1f22$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $4b81136b670d1f22$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $4b81136b670d1f22$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $4b81136b670d1f22$var$isHTMLForm = $4b81136b670d1f22$var$kindOfTest("HTMLFormElement");
const $4b81136b670d1f22$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $4b81136b670d1f22$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $4b81136b670d1f22$var$isRegExp = $4b81136b670d1f22$var$kindOfTest("RegExp");
const $4b81136b670d1f22$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $4b81136b670d1f22$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $4b81136b670d1f22$var$freezeMethods = (obj)=>{
    $4b81136b670d1f22$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($4b81136b670d1f22$var$isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$4b81136b670d1f22$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
const $4b81136b670d1f22$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $4b81136b670d1f22$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $4b81136b670d1f22$var$noop = ()=>{};
const $4b81136b670d1f22$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
const $4b81136b670d1f22$var$ALPHA = "abcdefghijklmnopqrstuvwxyz";
const $4b81136b670d1f22$var$DIGIT = "0123456789";
const $4b81136b670d1f22$var$ALPHABET = {
    DIGIT: $4b81136b670d1f22$var$DIGIT,
    ALPHA: $4b81136b670d1f22$var$ALPHA,
    ALPHA_DIGIT: $4b81136b670d1f22$var$ALPHA + $4b81136b670d1f22$var$ALPHA.toUpperCase() + $4b81136b670d1f22$var$DIGIT
};
const $4b81136b670d1f22$var$generateString = (size = 16, alphabet = $4b81136b670d1f22$var$ALPHABET.ALPHA_DIGIT)=>{
    let str = "";
    const { length: length } = alphabet;
    while(size--)str += alphabet[Math.random() * length | 0];
    return str;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $4b81136b670d1f22$var$isSpecCompliantForm(thing) {
    return !!(thing && $4b81136b670d1f22$var$isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
const $4b81136b670d1f22$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($4b81136b670d1f22$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!("toJSON" in source)) {
                stack[i] = source;
                const target = $4b81136b670d1f22$var$isArray(source) ? [] : {};
                $4b81136b670d1f22$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$4b81136b670d1f22$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $4b81136b670d1f22$var$isAsyncFn = $4b81136b670d1f22$var$kindOfTest("AsyncFunction");
const $4b81136b670d1f22$var$isThenable = (thing)=>thing && ($4b81136b670d1f22$var$isObject(thing) || $4b81136b670d1f22$var$isFunction(thing)) && $4b81136b670d1f22$var$isFunction(thing.then) && $4b81136b670d1f22$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
const $4b81136b670d1f22$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $4b81136b670d1f22$var$_global.addEventListener("message", ({ source: source, data: data })=>{
            if (source === $4b81136b670d1f22$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $4b81136b670d1f22$var$_global.postMessage(token, "*");
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === "function", $4b81136b670d1f22$var$isFunction($4b81136b670d1f22$var$_global.postMessage));
const $4b81136b670d1f22$var$asap = typeof queueMicrotask !== "undefined" ? queueMicrotask.bind($4b81136b670d1f22$var$_global) : typeof $851085fe3b0750dc$exports !== "undefined" && $851085fe3b0750dc$exports.nextTick || $4b81136b670d1f22$var$_setImmediate;
var // *********************
$4b81136b670d1f22$export$2e2bcd8739ae039 = {
    isArray: $4b81136b670d1f22$var$isArray,
    isArrayBuffer: $4b81136b670d1f22$var$isArrayBuffer,
    isBuffer: $4b81136b670d1f22$var$isBuffer,
    isFormData: $4b81136b670d1f22$var$isFormData,
    isArrayBufferView: $4b81136b670d1f22$var$isArrayBufferView,
    isString: $4b81136b670d1f22$var$isString,
    isNumber: $4b81136b670d1f22$var$isNumber,
    isBoolean: $4b81136b670d1f22$var$isBoolean,
    isObject: $4b81136b670d1f22$var$isObject,
    isPlainObject: $4b81136b670d1f22$var$isPlainObject,
    isReadableStream: $4b81136b670d1f22$var$isReadableStream,
    isRequest: $4b81136b670d1f22$var$isRequest,
    isResponse: $4b81136b670d1f22$var$isResponse,
    isHeaders: $4b81136b670d1f22$var$isHeaders,
    isUndefined: $4b81136b670d1f22$var$isUndefined,
    isDate: $4b81136b670d1f22$var$isDate,
    isFile: $4b81136b670d1f22$var$isFile,
    isBlob: $4b81136b670d1f22$var$isBlob,
    isRegExp: $4b81136b670d1f22$var$isRegExp,
    isFunction: $4b81136b670d1f22$var$isFunction,
    isStream: $4b81136b670d1f22$var$isStream,
    isURLSearchParams: $4b81136b670d1f22$var$isURLSearchParams,
    isTypedArray: $4b81136b670d1f22$var$isTypedArray,
    isFileList: $4b81136b670d1f22$var$isFileList,
    forEach: $4b81136b670d1f22$var$forEach,
    merge: $4b81136b670d1f22$var$merge,
    extend: $4b81136b670d1f22$var$extend,
    trim: $4b81136b670d1f22$var$trim,
    stripBOM: $4b81136b670d1f22$var$stripBOM,
    inherits: $4b81136b670d1f22$var$inherits,
    toFlatObject: $4b81136b670d1f22$var$toFlatObject,
    kindOf: $4b81136b670d1f22$var$kindOf,
    kindOfTest: $4b81136b670d1f22$var$kindOfTest,
    endsWith: $4b81136b670d1f22$var$endsWith,
    toArray: $4b81136b670d1f22$var$toArray,
    forEachEntry: $4b81136b670d1f22$var$forEachEntry,
    matchAll: $4b81136b670d1f22$var$matchAll,
    isHTMLForm: $4b81136b670d1f22$var$isHTMLForm,
    hasOwnProperty: $4b81136b670d1f22$var$hasOwnProperty,
    hasOwnProp: $4b81136b670d1f22$var$hasOwnProperty,
    reduceDescriptors: $4b81136b670d1f22$var$reduceDescriptors,
    freezeMethods: $4b81136b670d1f22$var$freezeMethods,
    toObjectSet: $4b81136b670d1f22$var$toObjectSet,
    toCamelCase: $4b81136b670d1f22$var$toCamelCase,
    noop: $4b81136b670d1f22$var$noop,
    toFiniteNumber: $4b81136b670d1f22$var$toFiniteNumber,
    findKey: $4b81136b670d1f22$var$findKey,
    global: $4b81136b670d1f22$var$_global,
    isContextDefined: $4b81136b670d1f22$var$isContextDefined,
    ALPHABET: $4b81136b670d1f22$var$ALPHABET,
    generateString: $4b81136b670d1f22$var$generateString,
    isSpecCompliantForm: $4b81136b670d1f22$var$isSpecCompliantForm,
    toJSONObject: $4b81136b670d1f22$var$toJSONObject,
    isAsyncFn: $4b81136b670d1f22$var$isAsyncFn,
    isThenable: $4b81136b670d1f22$var$isThenable,
    setImmediate: $4b81136b670d1f22$var$_setImmediate,
    asap: $4b81136b670d1f22$var$asap
};







"use strict";
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $439e2ddfe035ad5c$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    if (response) {
        this.response = response;
        this.status = response.status ? response.status : null;
    }
}
(0, $4b81136b670d1f22$export$2e2bcd8739ae039).inherits($439e2ddfe035ad5c$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $4b81136b670d1f22$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
});
const $439e2ddfe035ad5c$var$prototype = $439e2ddfe035ad5c$var$AxiosError.prototype;
const $439e2ddfe035ad5c$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
].forEach((code)=>{
    $439e2ddfe035ad5c$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($439e2ddfe035ad5c$var$AxiosError, $439e2ddfe035ad5c$var$descriptors);
Object.defineProperty($439e2ddfe035ad5c$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$439e2ddfe035ad5c$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($439e2ddfe035ad5c$var$prototype);
    (0, $4b81136b670d1f22$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== "isAxiosError";
    });
    $439e2ddfe035ad5c$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $439e2ddfe035ad5c$export$2e2bcd8739ae039 = $439e2ddfe035ad5c$var$AxiosError;


// eslint-disable-next-line strict
var $9c5da67d6da66cc2$export$2e2bcd8739ae039 = null;


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $861eb1c5376c8fcd$export$a143d493d941bafc;
var $861eb1c5376c8fcd$export$e4cf37d7f6fb9e0a;
var $861eb1c5376c8fcd$export$f99ded8fe4b79145;
var $861eb1c5376c8fcd$export$599f31c3813fae4d;
"use strict";
var $03e89b175801d31d$export$a48f0734ac7c2329;
var $03e89b175801d31d$export$d622b2ad8d90c771;
var $03e89b175801d31d$export$6100ba28696e12de;
"use strict";
$03e89b175801d31d$export$a48f0734ac7c2329 = $03e89b175801d31d$var$byteLength;
$03e89b175801d31d$export$d622b2ad8d90c771 = $03e89b175801d31d$var$toByteArray;
$03e89b175801d31d$export$6100ba28696e12de = $03e89b175801d31d$var$fromByteArray;
var $03e89b175801d31d$var$lookup = [];
var $03e89b175801d31d$var$revLookup = [];
var $03e89b175801d31d$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $03e89b175801d31d$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $03e89b175801d31d$var$i = 0, $03e89b175801d31d$var$len = $03e89b175801d31d$var$code.length; $03e89b175801d31d$var$i < $03e89b175801d31d$var$len; ++$03e89b175801d31d$var$i){
    $03e89b175801d31d$var$lookup[$03e89b175801d31d$var$i] = $03e89b175801d31d$var$code[$03e89b175801d31d$var$i];
    $03e89b175801d31d$var$revLookup[$03e89b175801d31d$var$code.charCodeAt($03e89b175801d31d$var$i)] = $03e89b175801d31d$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$03e89b175801d31d$var$revLookup["-".charCodeAt(0)] = 62;
$03e89b175801d31d$var$revLookup["_".charCodeAt(0)] = 63;
function $03e89b175801d31d$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $03e89b175801d31d$var$byteLength(b64) {
    var lens = $03e89b175801d31d$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $03e89b175801d31d$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $03e89b175801d31d$var$toByteArray(b64) {
    var tmp;
    var lens = $03e89b175801d31d$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $03e89b175801d31d$var$Arr($03e89b175801d31d$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $03e89b175801d31d$var$revLookup[b64.charCodeAt(i)] << 18 | $03e89b175801d31d$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $03e89b175801d31d$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $03e89b175801d31d$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $03e89b175801d31d$var$revLookup[b64.charCodeAt(i)] << 2 | $03e89b175801d31d$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $03e89b175801d31d$var$revLookup[b64.charCodeAt(i)] << 10 | $03e89b175801d31d$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $03e89b175801d31d$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $03e89b175801d31d$var$tripletToBase64(num) {
    return $03e89b175801d31d$var$lookup[num >> 18 & 0x3F] + $03e89b175801d31d$var$lookup[num >> 12 & 0x3F] + $03e89b175801d31d$var$lookup[num >> 6 & 0x3F] + $03e89b175801d31d$var$lookup[num & 0x3F];
}
function $03e89b175801d31d$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($03e89b175801d31d$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $03e89b175801d31d$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($03e89b175801d31d$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($03e89b175801d31d$var$lookup[tmp >> 2] + $03e89b175801d31d$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($03e89b175801d31d$var$lookup[tmp >> 10] + $03e89b175801d31d$var$lookup[tmp >> 4 & 0x3F] + $03e89b175801d31d$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $c00c67ab4c033e18$export$aafa59e2e03f2942;
var $c00c67ab4c033e18$export$68d8715fc104d294;
$c00c67ab4c033e18$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$c00c67ab4c033e18$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $861eb1c5376c8fcd$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$861eb1c5376c8fcd$export$a143d493d941bafc = $861eb1c5376c8fcd$var$Buffer;
$861eb1c5376c8fcd$export$e4cf37d7f6fb9e0a = $861eb1c5376c8fcd$var$SlowBuffer;
$861eb1c5376c8fcd$export$f99ded8fe4b79145 = 50;
const $861eb1c5376c8fcd$var$K_MAX_LENGTH = 0x7fffffff;
$861eb1c5376c8fcd$export$599f31c3813fae4d = $861eb1c5376c8fcd$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $861eb1c5376c8fcd$var$Buffer.TYPED_ARRAY_SUPPORT = $861eb1c5376c8fcd$var$typedArraySupport();
if (!$861eb1c5376c8fcd$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $861eb1c5376c8fcd$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($861eb1c5376c8fcd$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$861eb1c5376c8fcd$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($861eb1c5376c8fcd$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$861eb1c5376c8fcd$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $861eb1c5376c8fcd$var$createBuffer(length) {
    if (length > $861eb1c5376c8fcd$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $861eb1c5376c8fcd$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $861eb1c5376c8fcd$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $861eb1c5376c8fcd$var$allocUnsafe(arg);
    }
    return $861eb1c5376c8fcd$var$from(arg, encodingOrOffset, length);
}
$861eb1c5376c8fcd$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $861eb1c5376c8fcd$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $861eb1c5376c8fcd$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $861eb1c5376c8fcd$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($861eb1c5376c8fcd$var$isInstance(value, ArrayBuffer) || value && $861eb1c5376c8fcd$var$isInstance(value.buffer, ArrayBuffer)) return $861eb1c5376c8fcd$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($861eb1c5376c8fcd$var$isInstance(value, SharedArrayBuffer) || value && $861eb1c5376c8fcd$var$isInstance(value.buffer, SharedArrayBuffer))) return $861eb1c5376c8fcd$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $861eb1c5376c8fcd$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $861eb1c5376c8fcd$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $861eb1c5376c8fcd$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $861eb1c5376c8fcd$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $861eb1c5376c8fcd$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($861eb1c5376c8fcd$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($861eb1c5376c8fcd$var$Buffer, Uint8Array);
function $861eb1c5376c8fcd$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $861eb1c5376c8fcd$var$alloc(size, fill, encoding) {
    $861eb1c5376c8fcd$var$assertSize(size);
    if (size <= 0) return $861eb1c5376c8fcd$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $861eb1c5376c8fcd$var$createBuffer(size).fill(fill, encoding) : $861eb1c5376c8fcd$var$createBuffer(size).fill(fill);
    return $861eb1c5376c8fcd$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $861eb1c5376c8fcd$var$Buffer.alloc = function(size, fill, encoding) {
    return $861eb1c5376c8fcd$var$alloc(size, fill, encoding);
};
function $861eb1c5376c8fcd$var$allocUnsafe(size) {
    $861eb1c5376c8fcd$var$assertSize(size);
    return $861eb1c5376c8fcd$var$createBuffer(size < 0 ? 0 : $861eb1c5376c8fcd$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $861eb1c5376c8fcd$var$Buffer.allocUnsafe = function(size) {
    return $861eb1c5376c8fcd$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $861eb1c5376c8fcd$var$Buffer.allocUnsafeSlow = function(size) {
    return $861eb1c5376c8fcd$var$allocUnsafe(size);
};
function $861eb1c5376c8fcd$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$861eb1c5376c8fcd$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $861eb1c5376c8fcd$var$byteLength(string, encoding) | 0;
    let buf = $861eb1c5376c8fcd$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $861eb1c5376c8fcd$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $861eb1c5376c8fcd$var$checked(array.length) | 0;
    const buf = $861eb1c5376c8fcd$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $861eb1c5376c8fcd$var$fromArrayView(arrayView) {
    if ($861eb1c5376c8fcd$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $861eb1c5376c8fcd$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $861eb1c5376c8fcd$var$fromArrayLike(arrayView);
}
function $861eb1c5376c8fcd$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $861eb1c5376c8fcd$var$Buffer.prototype);
    return buf;
}
function $861eb1c5376c8fcd$var$fromObject(obj) {
    if ($861eb1c5376c8fcd$var$Buffer.isBuffer(obj)) {
        const len = $861eb1c5376c8fcd$var$checked(obj.length) | 0;
        const buf = $861eb1c5376c8fcd$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $861eb1c5376c8fcd$var$numberIsNaN(obj.length)) return $861eb1c5376c8fcd$var$createBuffer(0);
        return $861eb1c5376c8fcd$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $861eb1c5376c8fcd$var$fromArrayLike(obj.data);
}
function $861eb1c5376c8fcd$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $861eb1c5376c8fcd$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $861eb1c5376c8fcd$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $861eb1c5376c8fcd$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $861eb1c5376c8fcd$var$Buffer.alloc(+length);
}
$861eb1c5376c8fcd$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $861eb1c5376c8fcd$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$861eb1c5376c8fcd$var$Buffer.compare = function compare(a, b) {
    if ($861eb1c5376c8fcd$var$isInstance(a, Uint8Array)) a = $861eb1c5376c8fcd$var$Buffer.from(a, a.offset, a.byteLength);
    if ($861eb1c5376c8fcd$var$isInstance(b, Uint8Array)) b = $861eb1c5376c8fcd$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$861eb1c5376c8fcd$var$Buffer.isBuffer(a) || !$861eb1c5376c8fcd$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$861eb1c5376c8fcd$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$861eb1c5376c8fcd$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $861eb1c5376c8fcd$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $861eb1c5376c8fcd$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($861eb1c5376c8fcd$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$861eb1c5376c8fcd$var$Buffer.isBuffer(buf)) buf = $861eb1c5376c8fcd$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$861eb1c5376c8fcd$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $861eb1c5376c8fcd$var$byteLength(string, encoding) {
    if ($861eb1c5376c8fcd$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $861eb1c5376c8fcd$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $861eb1c5376c8fcd$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $861eb1c5376c8fcd$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $861eb1c5376c8fcd$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$861eb1c5376c8fcd$var$Buffer.byteLength = $861eb1c5376c8fcd$var$byteLength;
function $861eb1c5376c8fcd$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $861eb1c5376c8fcd$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $861eb1c5376c8fcd$var$utf8Slice(this, start, end);
        case "ascii":
            return $861eb1c5376c8fcd$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $861eb1c5376c8fcd$var$latin1Slice(this, start, end);
        case "base64":
            return $861eb1c5376c8fcd$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $861eb1c5376c8fcd$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$861eb1c5376c8fcd$var$Buffer.prototype._isBuffer = true;
function $861eb1c5376c8fcd$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$861eb1c5376c8fcd$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$861eb1c5376c8fcd$var$swap(this, i, i + 1);
    return this;
};
$861eb1c5376c8fcd$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $861eb1c5376c8fcd$var$swap(this, i, i + 3);
        $861eb1c5376c8fcd$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$861eb1c5376c8fcd$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $861eb1c5376c8fcd$var$swap(this, i, i + 7);
        $861eb1c5376c8fcd$var$swap(this, i + 1, i + 6);
        $861eb1c5376c8fcd$var$swap(this, i + 2, i + 5);
        $861eb1c5376c8fcd$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$861eb1c5376c8fcd$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $861eb1c5376c8fcd$var$utf8Slice(this, 0, length);
    return $861eb1c5376c8fcd$var$slowToString.apply(this, arguments);
};
$861eb1c5376c8fcd$var$Buffer.prototype.toLocaleString = $861eb1c5376c8fcd$var$Buffer.prototype.toString;
$861eb1c5376c8fcd$var$Buffer.prototype.equals = function equals(b) {
    if (!$861eb1c5376c8fcd$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $861eb1c5376c8fcd$var$Buffer.compare(this, b) === 0;
};
$861eb1c5376c8fcd$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $861eb1c5376c8fcd$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($861eb1c5376c8fcd$var$customInspectSymbol) $861eb1c5376c8fcd$var$Buffer.prototype[$861eb1c5376c8fcd$var$customInspectSymbol] = $861eb1c5376c8fcd$var$Buffer.prototype.inspect;
$861eb1c5376c8fcd$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($861eb1c5376c8fcd$var$isInstance(target, Uint8Array)) target = $861eb1c5376c8fcd$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$861eb1c5376c8fcd$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $861eb1c5376c8fcd$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($861eb1c5376c8fcd$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $861eb1c5376c8fcd$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($861eb1c5376c8fcd$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $861eb1c5376c8fcd$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $861eb1c5376c8fcd$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $861eb1c5376c8fcd$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$861eb1c5376c8fcd$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$861eb1c5376c8fcd$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $861eb1c5376c8fcd$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$861eb1c5376c8fcd$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $861eb1c5376c8fcd$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $861eb1c5376c8fcd$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($861eb1c5376c8fcd$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $861eb1c5376c8fcd$var$utf8Write(buf, string, offset, length) {
    return $861eb1c5376c8fcd$var$blitBuffer($861eb1c5376c8fcd$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $861eb1c5376c8fcd$var$asciiWrite(buf, string, offset, length) {
    return $861eb1c5376c8fcd$var$blitBuffer($861eb1c5376c8fcd$var$asciiToBytes(string), buf, offset, length);
}
function $861eb1c5376c8fcd$var$base64Write(buf, string, offset, length) {
    return $861eb1c5376c8fcd$var$blitBuffer($861eb1c5376c8fcd$var$base64ToBytes(string), buf, offset, length);
}
function $861eb1c5376c8fcd$var$ucs2Write(buf, string, offset, length) {
    return $861eb1c5376c8fcd$var$blitBuffer($861eb1c5376c8fcd$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$861eb1c5376c8fcd$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $861eb1c5376c8fcd$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $861eb1c5376c8fcd$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $861eb1c5376c8fcd$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $861eb1c5376c8fcd$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $861eb1c5376c8fcd$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$861eb1c5376c8fcd$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $861eb1c5376c8fcd$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $03e89b175801d31d$export$6100ba28696e12de(buf);
    else return $03e89b175801d31d$export$6100ba28696e12de(buf.slice(start, end));
}
function $861eb1c5376c8fcd$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $861eb1c5376c8fcd$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $861eb1c5376c8fcd$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $861eb1c5376c8fcd$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $861eb1c5376c8fcd$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $861eb1c5376c8fcd$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $861eb1c5376c8fcd$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $861eb1c5376c8fcd$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $861eb1c5376c8fcd$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $861eb1c5376c8fcd$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $861eb1c5376c8fcd$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$861eb1c5376c8fcd$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $861eb1c5376c8fcd$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $861eb1c5376c8fcd$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$861eb1c5376c8fcd$var$Buffer.prototype.readUintLE = $861eb1c5376c8fcd$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $861eb1c5376c8fcd$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$861eb1c5376c8fcd$var$Buffer.prototype.readUintBE = $861eb1c5376c8fcd$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $861eb1c5376c8fcd$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$861eb1c5376c8fcd$var$Buffer.prototype.readUint8 = $861eb1c5376c8fcd$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $861eb1c5376c8fcd$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$861eb1c5376c8fcd$var$Buffer.prototype.readUint16LE = $861eb1c5376c8fcd$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $861eb1c5376c8fcd$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$861eb1c5376c8fcd$var$Buffer.prototype.readUint16BE = $861eb1c5376c8fcd$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $861eb1c5376c8fcd$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$861eb1c5376c8fcd$var$Buffer.prototype.readUint32LE = $861eb1c5376c8fcd$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $861eb1c5376c8fcd$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$861eb1c5376c8fcd$var$Buffer.prototype.readUint32BE = $861eb1c5376c8fcd$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $861eb1c5376c8fcd$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$861eb1c5376c8fcd$var$Buffer.prototype.readBigUInt64LE = $861eb1c5376c8fcd$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $861eb1c5376c8fcd$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $861eb1c5376c8fcd$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$861eb1c5376c8fcd$var$Buffer.prototype.readBigUInt64BE = $861eb1c5376c8fcd$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $861eb1c5376c8fcd$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $861eb1c5376c8fcd$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$861eb1c5376c8fcd$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $861eb1c5376c8fcd$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$861eb1c5376c8fcd$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $861eb1c5376c8fcd$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$861eb1c5376c8fcd$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $861eb1c5376c8fcd$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$861eb1c5376c8fcd$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $861eb1c5376c8fcd$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$861eb1c5376c8fcd$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $861eb1c5376c8fcd$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$861eb1c5376c8fcd$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $861eb1c5376c8fcd$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$861eb1c5376c8fcd$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $861eb1c5376c8fcd$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$861eb1c5376c8fcd$var$Buffer.prototype.readBigInt64LE = $861eb1c5376c8fcd$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $861eb1c5376c8fcd$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $861eb1c5376c8fcd$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$861eb1c5376c8fcd$var$Buffer.prototype.readBigInt64BE = $861eb1c5376c8fcd$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $861eb1c5376c8fcd$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $861eb1c5376c8fcd$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$861eb1c5376c8fcd$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $861eb1c5376c8fcd$var$checkOffset(offset, 4, this.length);
    return $c00c67ab4c033e18$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$861eb1c5376c8fcd$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $861eb1c5376c8fcd$var$checkOffset(offset, 4, this.length);
    return $c00c67ab4c033e18$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$861eb1c5376c8fcd$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $861eb1c5376c8fcd$var$checkOffset(offset, 8, this.length);
    return $c00c67ab4c033e18$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$861eb1c5376c8fcd$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $861eb1c5376c8fcd$var$checkOffset(offset, 8, this.length);
    return $c00c67ab4c033e18$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $861eb1c5376c8fcd$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$861eb1c5376c8fcd$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$861eb1c5376c8fcd$var$Buffer.prototype.writeUintLE = $861eb1c5376c8fcd$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $861eb1c5376c8fcd$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$861eb1c5376c8fcd$var$Buffer.prototype.writeUintBE = $861eb1c5376c8fcd$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $861eb1c5376c8fcd$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$861eb1c5376c8fcd$var$Buffer.prototype.writeUint8 = $861eb1c5376c8fcd$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $861eb1c5376c8fcd$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$861eb1c5376c8fcd$var$Buffer.prototype.writeUint16LE = $861eb1c5376c8fcd$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $861eb1c5376c8fcd$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$861eb1c5376c8fcd$var$Buffer.prototype.writeUint16BE = $861eb1c5376c8fcd$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $861eb1c5376c8fcd$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$861eb1c5376c8fcd$var$Buffer.prototype.writeUint32LE = $861eb1c5376c8fcd$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $861eb1c5376c8fcd$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$861eb1c5376c8fcd$var$Buffer.prototype.writeUint32BE = $861eb1c5376c8fcd$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $861eb1c5376c8fcd$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $861eb1c5376c8fcd$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $861eb1c5376c8fcd$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $861eb1c5376c8fcd$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $861eb1c5376c8fcd$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$861eb1c5376c8fcd$var$Buffer.prototype.writeBigUInt64LE = $861eb1c5376c8fcd$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $861eb1c5376c8fcd$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$861eb1c5376c8fcd$var$Buffer.prototype.writeBigUInt64BE = $861eb1c5376c8fcd$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $861eb1c5376c8fcd$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$861eb1c5376c8fcd$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $861eb1c5376c8fcd$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$861eb1c5376c8fcd$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $861eb1c5376c8fcd$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$861eb1c5376c8fcd$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $861eb1c5376c8fcd$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$861eb1c5376c8fcd$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $861eb1c5376c8fcd$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$861eb1c5376c8fcd$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $861eb1c5376c8fcd$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$861eb1c5376c8fcd$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $861eb1c5376c8fcd$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$861eb1c5376c8fcd$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $861eb1c5376c8fcd$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$861eb1c5376c8fcd$var$Buffer.prototype.writeBigInt64LE = $861eb1c5376c8fcd$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $861eb1c5376c8fcd$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$861eb1c5376c8fcd$var$Buffer.prototype.writeBigInt64BE = $861eb1c5376c8fcd$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $861eb1c5376c8fcd$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $861eb1c5376c8fcd$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $861eb1c5376c8fcd$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $861eb1c5376c8fcd$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $c00c67ab4c033e18$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$861eb1c5376c8fcd$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $861eb1c5376c8fcd$var$writeFloat(this, value, offset, true, noAssert);
};
$861eb1c5376c8fcd$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $861eb1c5376c8fcd$var$writeFloat(this, value, offset, false, noAssert);
};
function $861eb1c5376c8fcd$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $861eb1c5376c8fcd$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $c00c67ab4c033e18$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$861eb1c5376c8fcd$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $861eb1c5376c8fcd$var$writeDouble(this, value, offset, true, noAssert);
};
$861eb1c5376c8fcd$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $861eb1c5376c8fcd$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$861eb1c5376c8fcd$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$861eb1c5376c8fcd$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$861eb1c5376c8fcd$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$861eb1c5376c8fcd$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $861eb1c5376c8fcd$var$Buffer.isBuffer(val) ? val : $861eb1c5376c8fcd$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $861eb1c5376c8fcd$var$errors = {};
function $861eb1c5376c8fcd$var$E(sym, getMessage, Base) {
    $861eb1c5376c8fcd$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$861eb1c5376c8fcd$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$861eb1c5376c8fcd$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$861eb1c5376c8fcd$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $861eb1c5376c8fcd$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $861eb1c5376c8fcd$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $861eb1c5376c8fcd$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $861eb1c5376c8fcd$var$checkBounds(buf, offset, byteLength) {
    $861eb1c5376c8fcd$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $861eb1c5376c8fcd$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $861eb1c5376c8fcd$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $861eb1c5376c8fcd$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $861eb1c5376c8fcd$var$checkBounds(buf, offset, byteLength);
}
function $861eb1c5376c8fcd$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $861eb1c5376c8fcd$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $861eb1c5376c8fcd$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $861eb1c5376c8fcd$var$validateNumber(value, type);
        throw new $861eb1c5376c8fcd$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $861eb1c5376c8fcd$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $861eb1c5376c8fcd$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $861eb1c5376c8fcd$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $861eb1c5376c8fcd$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($861eb1c5376c8fcd$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $861eb1c5376c8fcd$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $861eb1c5376c8fcd$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $861eb1c5376c8fcd$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $861eb1c5376c8fcd$var$base64ToBytes(str) {
    return $03e89b175801d31d$export$d622b2ad8d90c771($861eb1c5376c8fcd$var$base64clean(str));
}
function $861eb1c5376c8fcd$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $861eb1c5376c8fcd$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $861eb1c5376c8fcd$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $861eb1c5376c8fcd$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $861eb1c5376c8fcd$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $861eb1c5376c8fcd$var$BufferBigIntNotDefined : fn;
}
function $861eb1c5376c8fcd$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}


var $6ec8b142642fb121$require$Buffer = $861eb1c5376c8fcd$export$a143d493d941bafc;
"use strict";
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $6ec8b142642fb121$var$isVisitable(thing) {
    return (0, $4b81136b670d1f22$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $4b81136b670d1f22$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $6ec8b142642fb121$var$removeBrackets(key) {
    return (0, $4b81136b670d1f22$export$2e2bcd8739ae039).endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $6ec8b142642fb121$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $6ec8b142642fb121$var$removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $6ec8b142642fb121$var$isFlatArray(arr) {
    return (0, $4b81136b670d1f22$export$2e2bcd8739ae039).isArray(arr) && !arr.some($6ec8b142642fb121$var$isVisitable);
}
const $6ec8b142642fb121$var$predicates = (0, $4b81136b670d1f22$export$2e2bcd8739ae039).toFlatObject((0, $4b81136b670d1f22$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $6ec8b142642fb121$var$toFormData(obj, formData, options) {
    if (!(0, $4b81136b670d1f22$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $9c5da67d6da66cc2$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $4b81136b670d1f22$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $4b81136b670d1f22$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    const useBlob = _Blob && (0, $4b81136b670d1f22$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $4b81136b670d1f22$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError("visitor must be a function");
    function convertValue(value) {
        if (value === null) return "";
        if ((0, $4b81136b670d1f22$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $4b81136b670d1f22$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $439e2ddfe035ad5c$export$2e2bcd8739ae039)("Blob is not supported. Use a Buffer instead.");
        if ((0, $4b81136b670d1f22$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $4b81136b670d1f22$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === "function" ? new Blob([
            value
        ]) : $6ec8b142642fb121$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === "object") {
            if ((0, $4b81136b670d1f22$export$2e2bcd8739ae039).endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $4b81136b670d1f22$export$2e2bcd8739ae039).isArray(value) && $6ec8b142642fb121$var$isFlatArray(value) || ((0, $4b81136b670d1f22$export$2e2bcd8739ae039).isFileList(value) || (0, $4b81136b670d1f22$export$2e2bcd8739ae039).endsWith(key, "[]")) && (arr = (0, $4b81136b670d1f22$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $6ec8b142642fb121$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $4b81136b670d1f22$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $6ec8b142642fb121$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if ($6ec8b142642fb121$var$isVisitable(value)) return true;
        formData.append($6ec8b142642fb121$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($6ec8b142642fb121$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $6ec8b142642fb121$var$isVisitable
    });
    function build(value, path) {
        if ((0, $4b81136b670d1f22$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        (0, $4b81136b670d1f22$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $4b81136b670d1f22$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $4b81136b670d1f22$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $4b81136b670d1f22$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
var $6ec8b142642fb121$export$2e2bcd8739ae039 = $6ec8b142642fb121$var$toFormData;


"use strict";
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $0fdb77046f904ee1$var$encode(str) {
    const charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\0"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $0fdb77046f904ee1$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $6ec8b142642fb121$export$2e2bcd8739ae039)(params, this, options);
}
const $0fdb77046f904ee1$var$prototype = $0fdb77046f904ee1$var$AxiosURLSearchParams.prototype;
$0fdb77046f904ee1$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$0fdb77046f904ee1$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $0fdb77046f904ee1$var$encode);
    } : $0fdb77046f904ee1$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
var $0fdb77046f904ee1$export$2e2bcd8739ae039 = $0fdb77046f904ee1$var$AxiosURLSearchParams;


"use strict";
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $65eed306c989299a$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function $65eed306c989299a$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $65eed306c989299a$var$encode;
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $4b81136b670d1f22$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $0fdb77046f904ee1$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}



"use strict";
class $fd47e109001cc96d$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $4b81136b670d1f22$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $fd47e109001cc96d$export$2e2bcd8739ae039 = $fd47e109001cc96d$var$InterceptorManager;





"use strict";
var $950d2d5976293741$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};






"use strict";
var $b17b3b19cb4dce04$export$2e2bcd8739ae039 = typeof URLSearchParams !== "undefined" ? URLSearchParams : (0, $0fdb77046f904ee1$export$2e2bcd8739ae039);


"use strict";
var $2bbb652a7b2351af$export$2e2bcd8739ae039 = typeof FormData !== "undefined" ? FormData : null;


"use strict";
var $4c432de7c4146fcb$export$2e2bcd8739ae039 = typeof Blob !== "undefined" ? Blob : null;


var $8b81468cfca75141$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $b17b3b19cb4dce04$export$2e2bcd8739ae039,
        FormData: $2bbb652a7b2351af$export$2e2bcd8739ae039,
        Blob: $4c432de7c4146fcb$export$2e2bcd8739ae039
    },
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};


var $c2d775689a6ffacb$exports = {};

$parcel$export($c2d775689a6ffacb$exports, "hasBrowserEnv", function () { return $c2d775689a6ffacb$export$c4996c4b7b93b0bf; });
$parcel$export($c2d775689a6ffacb$exports, "navigator", function () { return $c2d775689a6ffacb$export$ec7c8efa7f5790ae; });
$parcel$export($c2d775689a6ffacb$exports, "hasStandardBrowserEnv", function () { return $c2d775689a6ffacb$export$c0bcc9250309d66; });
$parcel$export($c2d775689a6ffacb$exports, "hasStandardBrowserWebWorkerEnv", function () { return $c2d775689a6ffacb$export$c81692cf5af97dac; });
$parcel$export($c2d775689a6ffacb$exports, "origin", function () { return $c2d775689a6ffacb$export$f710a83a91838a36; });
const $c2d775689a6ffacb$export$c4996c4b7b93b0bf = typeof window !== "undefined" && typeof document !== "undefined";
const $c2d775689a6ffacb$export$ec7c8efa7f5790ae = typeof navigator === "object" && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $c2d775689a6ffacb$export$c0bcc9250309d66 = $c2d775689a6ffacb$export$c4996c4b7b93b0bf && (!$c2d775689a6ffacb$export$ec7c8efa7f5790ae || [
    "ReactNative",
    "NativeScript",
    "NS"
].indexOf($c2d775689a6ffacb$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $c2d775689a6ffacb$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();
const $c2d775689a6ffacb$export$f710a83a91838a36 = $c2d775689a6ffacb$export$c4996c4b7b93b0bf && window.location.href || "http://localhost";


var $e98764cb71e557f7$export$2e2bcd8739ae039 = {
    ...$c2d775689a6ffacb$exports,
    ...(0, $8b81468cfca75141$export$2e2bcd8739ae039)
};


"use strict";
function $82b9b12db06eec6e$export$2e2bcd8739ae039(data, options) {
    return (0, $6ec8b142642fb121$export$2e2bcd8739ae039)(data, new (0, $e98764cb71e557f7$export$2e2bcd8739ae039).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $e98764cb71e557f7$export$2e2bcd8739ae039).isNode && (0, $4b81136b670d1f22$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}




"use strict";
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $86d954b481fb5336$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $4b81136b670d1f22$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === "[]" ? "" : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $86d954b481fb5336$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $86d954b481fb5336$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === "__proto__") return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $4b81136b670d1f22$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $4b81136b670d1f22$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $4b81136b670d1f22$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $4b81136b670d1f22$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $86d954b481fb5336$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $4b81136b670d1f22$export$2e2bcd8739ae039).isFormData(formData) && (0, $4b81136b670d1f22$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $4b81136b670d1f22$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($86d954b481fb5336$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $86d954b481fb5336$export$2e2bcd8739ae039 = $86d954b481fb5336$var$formDataToJSON;


"use strict";
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $85354d4486dd80fc$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $4b81136b670d1f22$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $4b81136b670d1f22$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $85354d4486dd80fc$var$defaults = {
    transitional: (0, $950d2d5976293741$export$2e2bcd8739ae039),
    adapter: [
        "xhr",
        "http",
        "fetch"
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || "";
            const hasJSONContentType = contentType.indexOf("application/json") > -1;
            const isObjectPayload = (0, $4b81136b670d1f22$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $4b81136b670d1f22$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $4b81136b670d1f22$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $86d954b481fb5336$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $4b81136b670d1f22$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $4b81136b670d1f22$export$2e2bcd8739ae039).isBuffer(data) || (0, $4b81136b670d1f22$export$2e2bcd8739ae039).isStream(data) || (0, $4b81136b670d1f22$export$2e2bcd8739ae039).isFile(data) || (0, $4b81136b670d1f22$export$2e2bcd8739ae039).isBlob(data) || (0, $4b81136b670d1f22$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $4b81136b670d1f22$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $4b81136b670d1f22$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return (0, $82b9b12db06eec6e$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $4b81136b670d1f22$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $6ec8b142642fb121$export$2e2bcd8739ae039)(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return $85354d4486dd80fc$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $85354d4486dd80fc$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === "json";
            if ((0, $4b81136b670d1f22$export$2e2bcd8739ae039).isResponse(data) || (0, $4b81136b670d1f22$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $4b81136b670d1f22$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw (0, $439e2ddfe035ad5c$export$2e2bcd8739ae039).from(e, (0, $439e2ddfe035ad5c$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $e98764cb71e557f7$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $e98764cb71e557f7$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*",
            "Content-Type": undefined
        }
    }
};
(0, $4b81136b670d1f22$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "post",
    "put",
    "patch"
], (method)=>{
    $85354d4486dd80fc$var$defaults.headers[method] = {};
});
var $85354d4486dd80fc$export$2e2bcd8739ae039 = $85354d4486dd80fc$var$defaults;




"use strict";
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $cc44cfbd59db1c85$var$ignoreDuplicateOf = (0, $4b81136b670d1f22$export$2e2bcd8739ae039).toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $cc44cfbd59db1c85$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $cc44cfbd59db1c85$var$ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};


"use strict";
const $32359ce6cad7a51b$var$$internals = Symbol("internals");
function $32359ce6cad7a51b$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $32359ce6cad7a51b$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $4b81136b670d1f22$export$2e2bcd8739ae039).isArray(value) ? value.map($32359ce6cad7a51b$var$normalizeValue) : String(value);
}
function $32359ce6cad7a51b$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $32359ce6cad7a51b$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $32359ce6cad7a51b$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $4b81136b670d1f22$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $4b81136b670d1f22$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $4b81136b670d1f22$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $4b81136b670d1f22$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $32359ce6cad7a51b$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $32359ce6cad7a51b$var$buildAccessors(obj, header) {
    const accessorName = (0, $4b81136b670d1f22$export$2e2bcd8739ae039).toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $32359ce6cad7a51b$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $32359ce6cad7a51b$var$normalizeHeader(_header);
            if (!lHeader) throw new Error("header name must be a non-empty string");
            const key = (0, $4b81136b670d1f22$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $32359ce6cad7a51b$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $4b81136b670d1f22$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $4b81136b670d1f22$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $4b81136b670d1f22$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$32359ce6cad7a51b$var$isValidHeaderName(header)) setHeaders((0, $cc44cfbd59db1c85$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $4b81136b670d1f22$export$2e2bcd8739ae039).isHeaders(header)) for (const [key, value] of header.entries())setHeader(value, key, rewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $32359ce6cad7a51b$var$normalizeHeader(header);
        if (header) {
            const key = (0, $4b81136b670d1f22$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $32359ce6cad7a51b$var$parseTokens(value);
                if ((0, $4b81136b670d1f22$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $4b81136b670d1f22$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError("parser must be boolean|regexp|function");
            }
        }
    }
    has(header, matcher) {
        header = $32359ce6cad7a51b$var$normalizeHeader(header);
        if (header) {
            const key = (0, $4b81136b670d1f22$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $32359ce6cad7a51b$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $32359ce6cad7a51b$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $4b81136b670d1f22$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $32359ce6cad7a51b$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $4b81136b670d1f22$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $32359ce6cad7a51b$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $4b81136b670d1f22$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $4b81136b670d1f22$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $32359ce6cad7a51b$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $32359ce6cad7a51b$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $32359ce6cad7a51b$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $4b81136b670d1f22$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $4b81136b670d1f22$export$2e2bcd8739ae039).isArray(value) ? value.join(", ") : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ": " + value).join("\n");
    }
    get [Symbol.toStringTag]() {
        return "AxiosHeaders";
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$32359ce6cad7a51b$var$$internals] = this[$32359ce6cad7a51b$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $32359ce6cad7a51b$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $32359ce6cad7a51b$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $4b81136b670d1f22$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$32359ce6cad7a51b$var$AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
// reserved names hotfix
(0, $4b81136b670d1f22$export$2e2bcd8739ae039).reduceDescriptors($32359ce6cad7a51b$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $4b81136b670d1f22$export$2e2bcd8739ae039).freezeMethods($32359ce6cad7a51b$var$AxiosHeaders);
var $32359ce6cad7a51b$export$2e2bcd8739ae039 = $32359ce6cad7a51b$var$AxiosHeaders;


"use strict";
function $e073394a86cc8c44$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $85354d4486dd80fc$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $32359ce6cad7a51b$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $4b81136b670d1f22$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


"use strict";
function $25327c15c91d77ad$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





"use strict";
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $7f07a02cbde468a5$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $439e2ddfe035ad5c$export$2e2bcd8739ae039).call(this, message == null ? "canceled" : message, (0, $439e2ddfe035ad5c$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = "CanceledError";
}
(0, $4b81136b670d1f22$export$2e2bcd8739ae039).inherits($7f07a02cbde468a5$var$CanceledError, (0, $439e2ddfe035ad5c$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $7f07a02cbde468a5$export$2e2bcd8739ae039 = $7f07a02cbde468a5$var$CanceledError;







"use strict";
function $e308fecd708a2782$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $439e2ddfe035ad5c$export$2e2bcd8739ae039)("Request failed with status code " + response.status, [
        (0, $439e2ddfe035ad5c$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $439e2ddfe035ad5c$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}





"use strict";
function $74e231a7a331f820$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
}




"use strict";
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $8383bb11a0d04e7d$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $8383bb11a0d04e7d$export$2e2bcd8739ae039 = $8383bb11a0d04e7d$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $c72572a8d506cbbf$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn.apply(null, args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $c72572a8d506cbbf$export$2e2bcd8739ae039 = $c72572a8d506cbbf$var$throttle;



const $22db17d8a0d8e211$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $8383bb11a0d04e7d$export$2e2bcd8739ae039)(50, 250);
    return (0, $c72572a8d506cbbf$export$2e2bcd8739ae039)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? "download" : "upload"]: true
        };
        listener(data);
    }, freq);
};
const $22db17d8a0d8e211$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $22db17d8a0d8e211$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $4b81136b670d1f22$export$2e2bcd8739ae039).asap(()=>fn(...args));






"use strict";
var $a4c26800752038cd$export$2e2bcd8739ae039 = (0, $e98764cb71e557f7$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    const msie = (0, $e98764cb71e557f7$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $e98764cb71e557f7$export$2e2bcd8739ae039).navigator.userAgent);
    const urlParsingNode = document.createElement("a");
    let originURL;
    /**
    * Parse a URL to discover its components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        let href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        const parsed = (0, $4b81136b670d1f22$export$2e2bcd8739ae039).isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();




var $0d1210bce8663e01$export$2e2bcd8739ae039 = (0, $e98764cb71e557f7$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + "=" + encodeURIComponent(value)
        ];
        (0, $4b81136b670d1f22$export$2e2bcd8739ae039).isNumber(expires) && cookie.push("expires=" + new Date(expires).toGMTString());
        (0, $4b81136b670d1f22$export$2e2bcd8739ae039).isString(path) && cookie.push("path=" + path);
        (0, $4b81136b670d1f22$export$2e2bcd8739ae039).isString(domain) && cookie.push("domain=" + domain);
        secure === true && cookie.push("secure");
        document.cookie = cookie.join("; ");
    },
    read (name) {
        const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, "", Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};


"use strict";
function $9b8e0e83616b6d0c$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


"use strict";
function $ed8aace1929d1bd6$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}


"use strict";
function $0ea5bac3c9c6121b$export$2e2bcd8739ae039(baseURL, requestedURL) {
    if (baseURL && !(0, $9b8e0e83616b6d0c$export$2e2bcd8739ae039)(requestedURL)) return (0, $ed8aace1929d1bd6$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




"use strict";
const $58f83f555bb7b6d6$var$headersToObject = (thing)=>thing instanceof (0, $32359ce6cad7a51b$export$2e2bcd8739ae039) ? {
        ...thing
    } : thing;
function $58f83f555bb7b6d6$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, caseless) {
        if ((0, $4b81136b670d1f22$export$2e2bcd8739ae039).isPlainObject(target) && (0, $4b81136b670d1f22$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $4b81136b670d1f22$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $4b81136b670d1f22$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $4b81136b670d1f22$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $4b81136b670d1f22$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, caseless) {
        if (!(0, $4b81136b670d1f22$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, caseless);
        else if (!(0, $4b81136b670d1f22$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $4b81136b670d1f22$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $4b81136b670d1f22$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $4b81136b670d1f22$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b)=>mergeDeepProperties($58f83f555bb7b6d6$var$headersToObject(a), $58f83f555bb7b6d6$var$headersToObject(b), true)
    };
    (0, $4b81136b670d1f22$export$2e2bcd8739ae039).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $4b81136b670d1f22$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}




var $a599d38c09dd7270$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $58f83f555bb7b6d6$export$2e2bcd8739ae039)({}, config);
    let { data: data, withXSRFToken: withXSRFToken, xsrfHeaderName: xsrfHeaderName, xsrfCookieName: xsrfCookieName, headers: headers, auth: auth } = newConfig;
    newConfig.headers = headers = (0, $32359ce6cad7a51b$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $65eed306c989299a$export$2e2bcd8739ae039)((0, $0ea5bac3c9c6121b$export$2e2bcd8739ae039)(newConfig.baseURL, newConfig.url), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set("Authorization", "Basic " + btoa((auth.username || "") + ":" + (auth.password ? unescape(encodeURIComponent(auth.password)) : "")));
    let contentType;
    if ((0, $4b81136b670d1f22$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $e98764cb71e557f7$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $e98764cb71e557f7$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // Let the browser set it
        else if ((contentType = headers.getContentType()) !== false) {
            // fix semicolon duplication issue for ReactNative FormData implementation
            const [type, ...tokens] = contentType ? contentType.split(";").map((token)=>token.trim()).filter(Boolean) : [];
            headers.setContentType([
                type || "multipart/form-data",
                ...tokens
            ].join("; "));
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $e98764cb71e557f7$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        withXSRFToken && (0, $4b81136b670d1f22$export$2e2bcd8739ae039).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $a4c26800752038cd$export$2e2bcd8739ae039)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $0d1210bce8663e01$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};


const $02852e65e74e19c0$var$isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
var $02852e65e74e19c0$export$2e2bcd8739ae039 = $02852e65e74e19c0$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $a599d38c09dd7270$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $32359ce6cad7a51b$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener("abort", onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $32359ce6cad7a51b$export$2e2bcd8739ae039).from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $e308fecd708a2782$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $439e2ddfe035ad5c$export$2e2bcd8739ae039)("Request aborted", (0, $439e2ddfe035ad5c$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $439e2ddfe035ad5c$export$2e2bcd8739ae039)("Network Error", (0, $439e2ddfe035ad5c$export$2e2bcd8739ae039).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? "timeout of " + _config.timeout + "ms exceeded" : "timeout exceeded";
            const transitional = _config.transitional || (0, $950d2d5976293741$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $439e2ddfe035ad5c$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $439e2ddfe035ad5c$export$2e2bcd8739ae039).ETIMEDOUT : (0, $439e2ddfe035ad5c$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) (0, $4b81136b670d1f22$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $4b81136b670d1f22$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $22db17d8a0d8e211$export$c1b28109d46c3592)(onDownloadProgress, true);
            request.addEventListener("progress", downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $22db17d8a0d8e211$export$c1b28109d46c3592)(onUploadProgress);
            request.upload.addEventListener("progress", uploadThrottled);
            request.upload.addEventListener("loadend", flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $7f07a02cbde468a5$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener("abort", onCanceled);
        }
        const protocol = (0, $74e231a7a331f820$export$2e2bcd8739ae039)(_config.url);
        if (protocol && (0, $e98764cb71e557f7$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $439e2ddfe035ad5c$export$2e2bcd8739ae039)("Unsupported protocol " + protocol + ":", (0, $439e2ddfe035ad5c$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};








const $30a80c5385b192e7$var$composeSignals = (signals, timeout)=>{
    const { length: length } = signals = signals ? signals.filter(Boolean) : [];
    if (timeout || length) {
        let controller = new AbortController();
        let aborted;
        const onabort = function(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                const err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, $439e2ddfe035ad5c$export$2e2bcd8739ae039) ? err : new (0, $7f07a02cbde468a5$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
            }
        };
        let timer = timeout && setTimeout(()=>{
            timer = null;
            onabort(new (0, $439e2ddfe035ad5c$export$2e2bcd8739ae039)(`timeout ${timeout} of ms exceeded`, (0, $439e2ddfe035ad5c$export$2e2bcd8739ae039).ETIMEDOUT));
        }, timeout);
        const unsubscribe = ()=>{
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach((signal)=>{
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener("abort", onabort);
                });
                signals = null;
            }
        };
        signals.forEach((signal)=>signal.addEventListener("abort", onabort));
        const { signal: signal } = controller;
        signal.unsubscribe = ()=>(0, $4b81136b670d1f22$export$2e2bcd8739ae039).asap(unsubscribe);
        return signal;
    }
};
var $30a80c5385b192e7$export$2e2bcd8739ae039 = $30a80c5385b192e7$var$composeSignals;


const $3ec3de3359c4db76$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $3ec3de3359c4db76$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $3ec3de3359c4db76$var$readStream(iterable))yield* $3ec3de3359c4db76$export$71b051935044bd5d(chunk, chunkSize);
};
const $3ec3de3359c4db76$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $3ec3de3359c4db76$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $3ec3de3359c4db76$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






const $9e86019bb4297b31$var$isFetchSupported = typeof fetch === "function" && typeof Request === "function" && typeof Response === "function";
const $9e86019bb4297b31$var$isReadableStreamSupported = $9e86019bb4297b31$var$isFetchSupported && typeof ReadableStream === "function";
// used only inside the fetch adapter
const $9e86019bb4297b31$var$encodeText = $9e86019bb4297b31$var$isFetchSupported && (typeof TextEncoder === "function" ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Response(str).arrayBuffer()));
const $9e86019bb4297b31$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $9e86019bb4297b31$var$supportsRequestStream = $9e86019bb4297b31$var$isReadableStreamSupported && $9e86019bb4297b31$var$test(()=>{
    let duplexAccessed = false;
    const hasContentType = new Request((0, $e98764cb71e557f7$export$2e2bcd8739ae039).origin, {
        body: new ReadableStream(),
        method: "POST",
        get duplex () {
            duplexAccessed = true;
            return "half";
        }
    }).headers.has("Content-Type");
    return duplexAccessed && !hasContentType;
});
const $9e86019bb4297b31$var$DEFAULT_CHUNK_SIZE = 65536;
const $9e86019bb4297b31$var$supportsResponseStream = $9e86019bb4297b31$var$isReadableStreamSupported && $9e86019bb4297b31$var$test(()=>(0, $4b81136b670d1f22$export$2e2bcd8739ae039).isReadableStream(new Response("").body));
const $9e86019bb4297b31$var$resolvers = {
    stream: $9e86019bb4297b31$var$supportsResponseStream && ((res)=>res.body)
};
$9e86019bb4297b31$var$isFetchSupported && ((res)=>{
    [
        "text",
        "arrayBuffer",
        "blob",
        "formData",
        "stream"
    ].forEach((type)=>{
        !$9e86019bb4297b31$var$resolvers[type] && ($9e86019bb4297b31$var$resolvers[type] = (0, $4b81136b670d1f22$export$2e2bcd8739ae039).isFunction(res[type]) ? (res)=>res[type]() : (_, config)=>{
            throw new (0, $439e2ddfe035ad5c$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $439e2ddfe035ad5c$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
        });
    });
})(new Response);
const $9e86019bb4297b31$var$getBodyLength = async (body)=>{
    if (body == null) return 0;
    if ((0, $4b81136b670d1f22$export$2e2bcd8739ae039).isBlob(body)) return body.size;
    if ((0, $4b81136b670d1f22$export$2e2bcd8739ae039).isSpecCompliantForm(body)) {
        const _request = new Request((0, $e98764cb71e557f7$export$2e2bcd8739ae039).origin, {
            method: "POST",
            body: body
        });
        return (await _request.arrayBuffer()).byteLength;
    }
    if ((0, $4b81136b670d1f22$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $4b81136b670d1f22$export$2e2bcd8739ae039).isArrayBuffer(body)) return body.byteLength;
    if ((0, $4b81136b670d1f22$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + "";
    if ((0, $4b81136b670d1f22$export$2e2bcd8739ae039).isString(body)) return (await $9e86019bb4297b31$var$encodeText(body)).byteLength;
};
const $9e86019bb4297b31$var$resolveBodyLength = async (headers, body)=>{
    const length = (0, $4b81136b670d1f22$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
    return length == null ? $9e86019bb4297b31$var$getBodyLength(body) : length;
};
var $9e86019bb4297b31$export$2e2bcd8739ae039 = $9e86019bb4297b31$var$isFetchSupported && (async (config)=>{
    let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = "same-origin", fetchOptions: fetchOptions } = (0, $a599d38c09dd7270$export$2e2bcd8739ae039)(config);
    responseType = responseType ? (responseType + "").toLowerCase() : "text";
    let composedSignal = (0, $30a80c5385b192e7$export$2e2bcd8739ae039)([
        signal,
        cancelToken && cancelToken.toAbortSignal()
    ], timeout);
    let request;
    const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
        composedSignal.unsubscribe();
    });
    let requestContentLength;
    try {
        if (onUploadProgress && $9e86019bb4297b31$var$supportsRequestStream && method !== "get" && method !== "head" && (requestContentLength = await $9e86019bb4297b31$var$resolveBodyLength(headers, data)) !== 0) {
            let _request = new Request(url, {
                method: "POST",
                body: data,
                duplex: "half"
            });
            let contentTypeHeader;
            if ((0, $4b81136b670d1f22$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get("content-type"))) headers.setContentType(contentTypeHeader);
            if (_request.body) {
                const [onProgress, flush] = (0, $22db17d8a0d8e211$export$d9fadd12586c18d6)(requestContentLength, (0, $22db17d8a0d8e211$export$c1b28109d46c3592)((0, $22db17d8a0d8e211$export$5d35863c355a22a9)(onUploadProgress)));
                data = (0, $3ec3de3359c4db76$export$b0119225647bd83)(_request.body, $9e86019bb4297b31$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
            }
        }
        if (!(0, $4b81136b670d1f22$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? "include" : "omit";
        // Cloudflare Workers throws when credentials are defined
        // see https://github.com/cloudflare/workerd/issues/902
        const isCredentialsSupported = "credentials" in Request.prototype;
        request = new Request(url, {
            ...fetchOptions,
            signal: composedSignal,
            method: method.toUpperCase(),
            headers: headers.normalize().toJSON(),
            body: data,
            duplex: "half",
            credentials: isCredentialsSupported ? withCredentials : undefined
        });
        let response = await fetch(request);
        const isStreamResponse = $9e86019bb4297b31$var$supportsResponseStream && (responseType === "stream" || responseType === "response");
        if ($9e86019bb4297b31$var$supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
            const options = {};
            [
                "status",
                "statusText",
                "headers"
            ].forEach((prop)=>{
                options[prop] = response[prop];
            });
            const responseContentLength = (0, $4b81136b670d1f22$export$2e2bcd8739ae039).toFiniteNumber(response.headers.get("content-length"));
            const [onProgress, flush] = onDownloadProgress && (0, $22db17d8a0d8e211$export$d9fadd12586c18d6)(responseContentLength, (0, $22db17d8a0d8e211$export$c1b28109d46c3592)((0, $22db17d8a0d8e211$export$5d35863c355a22a9)(onDownloadProgress), true)) || [];
            response = new Response((0, $3ec3de3359c4db76$export$b0119225647bd83)(response.body, $9e86019bb4297b31$var$DEFAULT_CHUNK_SIZE, onProgress, ()=>{
                flush && flush();
                unsubscribe && unsubscribe();
            }), options);
        }
        responseType = responseType || "text";
        let responseData = await $9e86019bb4297b31$var$resolvers[(0, $4b81136b670d1f22$export$2e2bcd8739ae039).findKey($9e86019bb4297b31$var$resolvers, responseType) || "text"](response, config);
        !isStreamResponse && unsubscribe && unsubscribe();
        return await new Promise((resolve, reject)=>{
            (0, $e308fecd708a2782$export$2e2bcd8739ae039)(resolve, reject, {
                data: responseData,
                headers: (0, $32359ce6cad7a51b$export$2e2bcd8739ae039).from(response.headers),
                status: response.status,
                statusText: response.statusText,
                config: config,
                request: request
            });
        });
    } catch (err) {
        unsubscribe && unsubscribe();
        if (err && err.name === "TypeError" && /fetch/i.test(err.message)) throw Object.assign(new (0, $439e2ddfe035ad5c$export$2e2bcd8739ae039)("Network Error", (0, $439e2ddfe035ad5c$export$2e2bcd8739ae039).ERR_NETWORK, config, request), {
            cause: err.cause || err
        });
        throw (0, $439e2ddfe035ad5c$export$2e2bcd8739ae039).from(err, err && err.code, config, request);
    }
});



const $63ae40bdd928d80c$var$knownAdapters = {
    http: (0, $9c5da67d6da66cc2$export$2e2bcd8739ae039),
    xhr: (0, $02852e65e74e19c0$export$2e2bcd8739ae039),
    fetch: (0, $9e86019bb4297b31$export$2e2bcd8739ae039)
};
(0, $4b81136b670d1f22$export$2e2bcd8739ae039).forEach($63ae40bdd928d80c$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, "name", {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            value: value
        });
    }
});
const $63ae40bdd928d80c$var$renderReason = (reason)=>`- ${reason}`;
const $63ae40bdd928d80c$var$isResolvedHandle = (adapter)=>(0, $4b81136b670d1f22$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
var $63ae40bdd928d80c$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $4b81136b670d1f22$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$63ae40bdd928d80c$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $63ae40bdd928d80c$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $439e2ddfe035ad5c$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || "#" + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? "is not supported by the environment" : "is not available in the build"));
            let s = length ? reasons.length > 1 ? "since :\n" + reasons.map($63ae40bdd928d80c$var$renderReason).join("\n") : " " + $63ae40bdd928d80c$var$renderReason(reasons[0]) : "as no adapter specified";
            throw new (0, $439e2ddfe035ad5c$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, "ERR_NOT_SUPPORT");
        }
        return adapter;
    },
    adapters: $63ae40bdd928d80c$var$knownAdapters
};


"use strict";
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $14dac953f98c316c$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $7f07a02cbde468a5$export$2e2bcd8739ae039)(null, config);
}
function $14dac953f98c316c$export$2e2bcd8739ae039(config) {
    $14dac953f98c316c$var$throwIfCancellationRequested(config);
    config.headers = (0, $32359ce6cad7a51b$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $e073394a86cc8c44$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    const adapter = (0, $63ae40bdd928d80c$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $85354d4486dd80fc$export$2e2bcd8739ae039).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $14dac953f98c316c$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $e073394a86cc8c44$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $32359ce6cad7a51b$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $25327c15c91d77ad$export$2e2bcd8739ae039)(reason)) {
            $14dac953f98c316c$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $e073394a86cc8c44$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $32359ce6cad7a51b$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




const $494b236ff1467a15$export$a4ad2735b021c132 = "1.7.7";



"use strict";
const $9fb23192706a5761$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach((type, i)=>{
    $9fb23192706a5761$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
const $9fb23192706a5761$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $9fb23192706a5761$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + (0, $494b236ff1467a15$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $439e2ddfe035ad5c$export$2e2bcd8739ae039)(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), (0, $439e2ddfe035ad5c$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$9fb23192706a5761$var$deprecatedWarnings[opt]) {
            $9fb23192706a5761$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $9fb23192706a5761$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new (0, $439e2ddfe035ad5c$export$2e2bcd8739ae039)("options must be an object", (0, $439e2ddfe035ad5c$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $439e2ddfe035ad5c$export$2e2bcd8739ae039)("option " + opt + " must be " + result, (0, $439e2ddfe035ad5c$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $439e2ddfe035ad5c$export$2e2bcd8739ae039)("Unknown option " + opt, (0, $439e2ddfe035ad5c$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $9fb23192706a5761$export$2e2bcd8739ae039 = {
    assertOptions: $9fb23192706a5761$var$assertOptions,
    validators: $9fb23192706a5761$var$validators
};



"use strict";
const $1286c12e2102dde7$var$validators = (0, $9fb23192706a5761$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $1286c12e2102dde7$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $fd47e109001cc96d$export$2e2bcd8739ae039)(),
            response: new (0, $fd47e109001cc96d$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy;
                Error.captureStackTrace ? Error.captureStackTrace(dummy = {}) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, "") : "";
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ""))) err.stack += "\n" + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === "string") {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $58f83f555bb7b6d6$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $9fb23192706a5761$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $1286c12e2102dde7$var$validators.transitional($1286c12e2102dde7$var$validators.boolean),
            forcedJSONParsing: $1286c12e2102dde7$var$validators.transitional($1286c12e2102dde7$var$validators.boolean),
            clarifyTimeoutError: $1286c12e2102dde7$var$validators.transitional($1286c12e2102dde7$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $4b81136b670d1f22$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $9fb23192706a5761$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $1286c12e2102dde7$var$validators.function,
                serialize: $1286c12e2102dde7$var$validators.function
            }, true);
        }
        // Set config.method
        config.method = (config.method || this.defaults.method || "get").toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $4b81136b670d1f22$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $4b81136b670d1f22$export$2e2bcd8739ae039).forEach([
            "delete",
            "get",
            "head",
            "post",
            "put",
            "patch",
            "common"
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $32359ce6cad7a51b$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $14dac953f98c316c$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $14dac953f98c316c$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $58f83f555bb7b6d6$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $0ea5bac3c9c6121b$export$2e2bcd8739ae039)(config.baseURL, config.url);
        return (0, $65eed306c989299a$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $4b81136b670d1f22$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $1286c12e2102dde7$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $58f83f555bb7b6d6$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $4b81136b670d1f22$export$2e2bcd8739ae039).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $58f83f555bb7b6d6$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $1286c12e2102dde7$var$Axios.prototype[method] = generateHTTPMethod();
    $1286c12e2102dde7$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
var $1286c12e2102dde7$export$2e2bcd8739ae039 = $1286c12e2102dde7$var$Axios;







"use strict";
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $8576b355a2f009bd$var$CancelToken {
    constructor(executor){
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $7f07a02cbde468a5$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $8576b355a2f009bd$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $8576b355a2f009bd$export$2e2bcd8739ae039 = $8576b355a2f009bd$var$CancelToken;






"use strict";
function $5545d8cd13b6942c$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



"use strict";
function $e7a9c94f0e01c782$export$2e2bcd8739ae039(payload) {
    return (0, $4b81136b670d1f22$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $ebaccd0a85cc7b26$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($ebaccd0a85cc7b26$var$HttpStatusCode).forEach(([key, value])=>{
    $ebaccd0a85cc7b26$var$HttpStatusCode[value] = key;
});
var $ebaccd0a85cc7b26$export$2e2bcd8739ae039 = $ebaccd0a85cc7b26$var$HttpStatusCode;


"use strict";
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $5d947360ab0ea9ad$var$createInstance(defaultConfig) {
    const context = new (0, $1286c12e2102dde7$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $63689eb8761ae423$export$2e2bcd8739ae039)((0, $1286c12e2102dde7$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $4b81136b670d1f22$export$2e2bcd8739ae039).extend(instance, (0, $1286c12e2102dde7$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $4b81136b670d1f22$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $5d947360ab0ea9ad$var$createInstance((0, $58f83f555bb7b6d6$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $5d947360ab0ea9ad$var$axios = $5d947360ab0ea9ad$var$createInstance((0, $85354d4486dd80fc$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$5d947360ab0ea9ad$var$axios.Axios = (0, $1286c12e2102dde7$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$5d947360ab0ea9ad$var$axios.CanceledError = (0, $7f07a02cbde468a5$export$2e2bcd8739ae039);
$5d947360ab0ea9ad$var$axios.CancelToken = (0, $8576b355a2f009bd$export$2e2bcd8739ae039);
$5d947360ab0ea9ad$var$axios.isCancel = (0, $25327c15c91d77ad$export$2e2bcd8739ae039);
$5d947360ab0ea9ad$var$axios.VERSION = (0, $494b236ff1467a15$export$a4ad2735b021c132);
$5d947360ab0ea9ad$var$axios.toFormData = (0, $6ec8b142642fb121$export$2e2bcd8739ae039);
// Expose AxiosError class
$5d947360ab0ea9ad$var$axios.AxiosError = (0, $439e2ddfe035ad5c$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$5d947360ab0ea9ad$var$axios.Cancel = $5d947360ab0ea9ad$var$axios.CanceledError;
// Expose all/spread
$5d947360ab0ea9ad$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$5d947360ab0ea9ad$var$axios.spread = (0, $5545d8cd13b6942c$export$2e2bcd8739ae039);
// Expose isAxiosError
$5d947360ab0ea9ad$var$axios.isAxiosError = (0, $e7a9c94f0e01c782$export$2e2bcd8739ae039);
// Expose mergeConfig
$5d947360ab0ea9ad$var$axios.mergeConfig = (0, $58f83f555bb7b6d6$export$2e2bcd8739ae039);
$5d947360ab0ea9ad$var$axios.AxiosHeaders = (0, $32359ce6cad7a51b$export$2e2bcd8739ae039);
$5d947360ab0ea9ad$var$axios.formToJSON = (thing)=>(0, $86d954b481fb5336$export$2e2bcd8739ae039)((0, $4b81136b670d1f22$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$5d947360ab0ea9ad$var$axios.getAdapter = (0, $63ae40bdd928d80c$export$2e2bcd8739ae039).getAdapter;
$5d947360ab0ea9ad$var$axios.HttpStatusCode = (0, $ebaccd0a85cc7b26$export$2e2bcd8739ae039);
$5d947360ab0ea9ad$var$axios.default = $5d947360ab0ea9ad$var$axios;
var // this module should only have a default export
$5d947360ab0ea9ad$export$2e2bcd8739ae039 = $5d947360ab0ea9ad$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $bf84b3a7f94194c2$export$1c00760e9e5a4e95, AxiosError: $bf84b3a7f94194c2$export$c1fbed17c2f6a328, CanceledError: $bf84b3a7f94194c2$export$1ab0c6b20d94fa14, isCancel: $bf84b3a7f94194c2$export$3b22524397b493c6, CancelToken: $bf84b3a7f94194c2$export$fd08e3cb425f0d61, VERSION: $bf84b3a7f94194c2$export$a4ad2735b021c132, all: $bf84b3a7f94194c2$export$84bf76cd7afc7469, Cancel: $bf84b3a7f94194c2$export$848c9b7ead0df967, isAxiosError: $bf84b3a7f94194c2$export$fbafdbe06a5b5a9a, spread: $bf84b3a7f94194c2$export$3ae0fd4797ed47c8, toFormData: $bf84b3a7f94194c2$export$10ae0d317ea97f8b, AxiosHeaders: $bf84b3a7f94194c2$export$4e7d6ff0f3e6520, HttpStatusCode: $bf84b3a7f94194c2$export$a972f69c851492b3, formToJSON: $bf84b3a7f94194c2$export$86d7c59254d6a2c9, getAdapter: $bf84b3a7f94194c2$export$17ddc20a97d669e2, mergeConfig: $bf84b3a7f94194c2$export$7ec1ebcfa9d8bd6a } = (0, $5d947360ab0ea9ad$export$2e2bcd8739ae039);


var $b7881d378c67312d$exports = {};
!function(e, n) {
    $b7881d378c67312d$exports = n(e);
}(typeof window === "object" && window, function(r, e) {
    if (!r) {
        console.warn("can't use weixin-js-sdk in server side");
        return;
    }
    var a, c, n, i, t, o, s, d, l, u, p, f, m, g, h, S, y, I, v, _, w, T;
    if (!r.jWeixin) return a = {
        config: "preVerifyJSAPI",
        onMenuShareTimeline: "menu:share:timeline",
        onMenuShareAppMessage: "menu:share:appmessage",
        onMenuShareQQ: "menu:share:qq",
        onMenuShareWeibo: "menu:share:weiboApp",
        onMenuShareQZone: "menu:share:QZone",
        previewImage: "imagePreview",
        getLocation: "geoLocation",
        openProductSpecificView: "openProductViewWithPid",
        addCard: "batchAddCard",
        openCard: "batchViewCard",
        chooseWXPay: "getBrandWCPayRequest",
        openEnterpriseRedPacket: "getRecevieBizHongBaoRequest",
        startSearchBeacons: "startMonitoringBeacons",
        stopSearchBeacons: "stopMonitoringBeacons",
        onSearchBeacons: "onBeaconsInRange",
        consumeAndShareCard: "consumedShareCard",
        openAddress: "editAddress"
    }, c = function() {
        var e, n = {};
        for(e in a)n[a[e]] = e;
        return n;
    }(), n = r.document, i = n.title, t = navigator.userAgent.toLowerCase(), f = navigator.platform.toLowerCase(), o = !(!f.match("mac") && !f.match("win")), s = -1 != t.indexOf("wxdebugger"), d = -1 != t.indexOf("micromessenger"), l = -1 != t.indexOf("android"), u = -1 != t.indexOf("iphone") || -1 != t.indexOf("ipad"), p = (f = t.match(/micromessenger\/(\d+\.\d+\.\d+)/) || t.match(/micromessenger\/(\d+\.\d+)/)) ? f[1] : "", m = {
        initStartTime: L(),
        initEndTime: 0,
        preVerifyStartTime: 0,
        preVerifyEndTime: 0
    }, g = {
        version: 1,
        appId: "",
        initTime: 0,
        preVerifyTime: 0,
        networkType: "",
        isPreVerifyOk: 1,
        systemType: u ? 1 : l ? 2 : -1,
        clientVersion: p,
        url: encodeURIComponent(location.href)
    }, h = {}, S = {
        _completes: []
    }, y = {
        state: 0,
        data: {}
    }, O(function() {
        m.initEndTime = L();
    }), I = !1, v = [], _ = {
        config: function(e) {
            C("config", h = e);
            var o = !1 !== h.check;
            O(function() {
                if (o) k(a.config, {
                    verifyJsApiList: A(h.jsApiList),
                    verifyOpenTagList: A(h.openTagList)
                }, (S._complete = function(e) {
                    m.preVerifyEndTime = L(), y.state = 1, y.data = e;
                }, S.success = function(e) {
                    g.isPreVerifyOk = 0;
                }, S.fail = function(e) {
                    S._fail ? S._fail(e) : y.state = -1;
                }, (t = S._completes).push(function() {
                    B();
                }), S.complete = function(e) {
                    for(var n = 0, i = t.length; n < i; ++n)t[n]();
                    S._completes = [];
                }, S)), m.preVerifyStartTime = L();
                else {
                    y.state = 1;
                    for(var e = S._completes, n = 0, i = e.length; n < i; ++n)e[n]();
                    S._completes = [];
                }
                var t;
            }), _.invoke || (_.invoke = function(e, n, i) {
                r.WeixinJSBridge && WeixinJSBridge.invoke(e, P(n), i);
            }, _.on = function(e, n) {
                r.WeixinJSBridge && WeixinJSBridge.on(e, n);
            });
        },
        ready: function(e) {
            (0 != y.state || (S._completes.push(e), !d && h.debug)) && e();
        },
        error: function(e) {
            p < "6.0.2" || (-1 == y.state ? e(y.data) : S._fail = e);
        },
        checkJsApi: function(e) {
            k("checkJsApi", {
                jsApiList: A(e.jsApiList)
            }, (e._complete = function(e) {
                l && (i = e.checkResult) && (e.checkResult = JSON.parse(i));
                var n, i = e, t = i.checkResult;
                for(n in t){
                    var o = c[n];
                    o && (t[o] = t[n], delete t[n]);
                }
            }, e));
        },
        onMenuShareTimeline: function(e) {
            M(a.onMenuShareTimeline, {
                complete: function() {
                    k("shareTimeline", {
                        title: e.title || i,
                        desc: e.title || i,
                        img_url: e.imgUrl || "",
                        link: e.link || location.href,
                        type: e.type || "link",
                        data_url: e.dataUrl || ""
                    }, e);
                }
            }, e);
        },
        onMenuShareAppMessage: function(n) {
            M(a.onMenuShareAppMessage, {
                complete: function(e) {
                    "favorite" === e.scene ? k("sendAppMessage", {
                        title: n.title || i,
                        desc: n.desc || "",
                        link: n.link || location.href,
                        img_url: n.imgUrl || "",
                        type: n.type || "link",
                        data_url: n.dataUrl || ""
                    }) : k("sendAppMessage", {
                        title: n.title || i,
                        desc: n.desc || "",
                        link: n.link || location.href,
                        img_url: n.imgUrl || "",
                        type: n.type || "link",
                        data_url: n.dataUrl || ""
                    }, n);
                }
            }, n);
        },
        onMenuShareQQ: function(e) {
            M(a.onMenuShareQQ, {
                complete: function() {
                    k("shareQQ", {
                        title: e.title || i,
                        desc: e.desc || "",
                        img_url: e.imgUrl || "",
                        link: e.link || location.href
                    }, e);
                }
            }, e);
        },
        onMenuShareWeibo: function(e) {
            M(a.onMenuShareWeibo, {
                complete: function() {
                    k("shareWeiboApp", {
                        title: e.title || i,
                        desc: e.desc || "",
                        img_url: e.imgUrl || "",
                        link: e.link || location.href
                    }, e);
                }
            }, e);
        },
        onMenuShareQZone: function(e) {
            M(a.onMenuShareQZone, {
                complete: function() {
                    k("shareQZone", {
                        title: e.title || i,
                        desc: e.desc || "",
                        img_url: e.imgUrl || "",
                        link: e.link || location.href
                    }, e);
                }
            }, e);
        },
        updateTimelineShareData: function(e) {
            k("updateTimelineShareData", {
                title: e.title,
                link: e.link,
                imgUrl: e.imgUrl
            }, e);
        },
        updateAppMessageShareData: function(e) {
            k("updateAppMessageShareData", {
                title: e.title,
                desc: e.desc,
                link: e.link,
                imgUrl: e.imgUrl
            }, e);
        },
        startRecord: function(e) {
            k("startRecord", {}, e);
        },
        stopRecord: function(e) {
            k("stopRecord", {}, e);
        },
        onVoiceRecordEnd: function(e) {
            M("onVoiceRecordEnd", e);
        },
        playVoice: function(e) {
            k("playVoice", {
                localId: e.localId
            }, e);
        },
        pauseVoice: function(e) {
            k("pauseVoice", {
                localId: e.localId
            }, e);
        },
        stopVoice: function(e) {
            k("stopVoice", {
                localId: e.localId
            }, e);
        },
        onVoicePlayEnd: function(e) {
            M("onVoicePlayEnd", e);
        },
        uploadVoice: function(e) {
            k("uploadVoice", {
                localId: e.localId,
                isShowProgressTips: 0 == e.isShowProgressTips ? 0 : 1
            }, e);
        },
        downloadVoice: function(e) {
            k("downloadVoice", {
                serverId: e.serverId,
                isShowProgressTips: 0 == e.isShowProgressTips ? 0 : 1
            }, e);
        },
        translateVoice: function(e) {
            k("translateVoice", {
                localId: e.localId,
                isShowProgressTips: 0 == e.isShowProgressTips ? 0 : 1
            }, e);
        },
        chooseImage: function(e) {
            k("chooseImage", {
                scene: "1|2",
                count: e.count || 9,
                sizeType: e.sizeType || [
                    "original",
                    "compressed"
                ],
                sourceType: e.sourceType || [
                    "album",
                    "camera"
                ]
            }, (e._complete = function(e) {
                if (l) {
                    var n = e.localIds;
                    try {
                        n && (e.localIds = JSON.parse(n));
                    } catch (e) {}
                }
            }, e));
        },
        getLocation: function(e) {
            e = e || {}, k(a.getLocation, {
                type: e.type || "wgs84"
            }, (e._complete = function(e) {
                delete e.type;
            }, e));
        },
        previewImage: function(e) {
            k(a.previewImage, {
                current: e.current,
                urls: e.urls
            }, e);
        },
        uploadImage: function(e) {
            k("uploadImage", {
                localId: e.localId,
                isShowProgressTips: 0 == e.isShowProgressTips ? 0 : 1
            }, e);
        },
        downloadImage: function(e) {
            k("downloadImage", {
                serverId: e.serverId,
                isShowProgressTips: 0 == e.isShowProgressTips ? 0 : 1
            }, e);
        },
        getLocalImgData: function(e) {
            !1 === I ? (I = !0, k("getLocalImgData", {
                localId: e.localId
            }, (e._complete = function(e) {
                var n;
                I = !1, 0 < v.length && (n = v.shift(), wx.getLocalImgData(n));
            }, e))) : v.push(e);
        },
        getNetworkType: function(e) {
            k("getNetworkType", {}, (e._complete = function(e) {
                var n = e, e = n.errMsg, i = (n.errMsg = "getNetworkType:ok", n.subtype);
                if (delete n.subtype, i) n.networkType = i;
                else {
                    var i = e.indexOf(":"), t = e.substring(i + 1);
                    switch(t){
                        case "wifi":
                        case "edge":
                        case "wwan":
                            n.networkType = t;
                            break;
                        default:
                            n.errMsg = "getNetworkType:fail";
                    }
                }
            }, e));
        },
        openLocation: function(e) {
            k("openLocation", {
                latitude: e.latitude,
                longitude: e.longitude,
                name: e.name || "",
                address: e.address || "",
                scale: e.scale || 28,
                infoUrl: e.infoUrl || ""
            }, e);
        },
        hideOptionMenu: function(e) {
            k("hideOptionMenu", {}, e);
        },
        showOptionMenu: function(e) {
            k("showOptionMenu", {}, e);
        },
        closeWindow: function(e) {
            k("closeWindow", {}, e = e || {});
        },
        hideMenuItems: function(e) {
            k("hideMenuItems", {
                menuList: e.menuList
            }, e);
        },
        showMenuItems: function(e) {
            k("showMenuItems", {
                menuList: e.menuList
            }, e);
        },
        hideAllNonBaseMenuItem: function(e) {
            k("hideAllNonBaseMenuItem", {}, e);
        },
        showAllNonBaseMenuItem: function(e) {
            k("showAllNonBaseMenuItem", {}, e);
        },
        scanQRCode: function(e) {
            k("scanQRCode", {
                needResult: (e = e || {}).needResult || 0,
                scanType: e.scanType || [
                    "qrCode",
                    "barCode"
                ]
            }, (e._complete = function(e) {
                var n;
                u && (n = e.resultStr) && (n = JSON.parse(n), e.resultStr = n && n.scan_code && n.scan_code.scan_result);
            }, e));
        },
        openAddress: function(e) {
            k(a.openAddress, {}, (e._complete = function(e) {
                e.postalCode = e.addressPostalCode, delete e.addressPostalCode, e.provinceName = e.proviceFirstStageName, delete e.proviceFirstStageName, e.cityName = e.addressCitySecondStageName, delete e.addressCitySecondStageName, e.countryName = e.addressCountiesThirdStageName, delete e.addressCountiesThirdStageName, e.detailInfo = e.addressDetailInfo, delete e.addressDetailInfo;
            }, e));
        },
        openProductSpecificView: function(e) {
            k(a.openProductSpecificView, {
                pid: e.productId,
                view_type: e.viewType || 0,
                ext_info: e.extInfo
            }, e);
        },
        addCard: function(e) {
            for(var n = e.cardList, i = [], t = 0, o = n.length; t < o; ++t){
                var r = n[t], r = {
                    card_id: r.cardId,
                    card_ext: r.cardExt
                };
                i.push(r);
            }
            k(a.addCard, {
                card_list: i
            }, (e._complete = function(e) {
                if (n = e.card_list) {
                    for(var n, i = 0, t = (n = JSON.parse(n)).length; i < t; ++i){
                        var o = n[i];
                        o.cardId = o.card_id, o.cardExt = o.card_ext, o.isSuccess = !!o.is_succ, delete o.card_id, delete o.card_ext, delete o.is_succ;
                    }
                    e.cardList = n, delete e.card_list;
                }
            }, e));
        },
        chooseCard: function(e) {
            k("chooseCard", {
                app_id: h.appId,
                location_id: e.shopId || "",
                sign_type: e.signType || "SHA1",
                card_id: e.cardId || "",
                card_type: e.cardType || "",
                card_sign: e.cardSign,
                time_stamp: e.timestamp + "",
                nonce_str: e.nonceStr
            }, (e._complete = function(e) {
                e.cardList = e.choose_card_info, delete e.choose_card_info;
            }, e));
        },
        openCard: function(e) {
            for(var n = e.cardList, i = [], t = 0, o = n.length; t < o; ++t){
                var r = n[t], r = {
                    card_id: r.cardId,
                    code: r.code
                };
                i.push(r);
            }
            k(a.openCard, {
                card_list: i
            }, e);
        },
        consumeAndShareCard: function(e) {
            k(a.consumeAndShareCard, {
                consumedCardId: e.cardId,
                consumedCode: e.code
            }, e);
        },
        chooseWXPay: function(e) {
            k(a.chooseWXPay, x(e), e), B({
                jsApiName: "chooseWXPay"
            });
        },
        openEnterpriseRedPacket: function(e) {
            k(a.openEnterpriseRedPacket, x(e), e);
        },
        startSearchBeacons: function(e) {
            k(a.startSearchBeacons, {
                ticket: e.ticket
            }, e);
        },
        stopSearchBeacons: function(e) {
            k(a.stopSearchBeacons, {}, e);
        },
        onSearchBeacons: function(e) {
            M(a.onSearchBeacons, e);
        },
        openEnterpriseChat: function(e) {
            k("openEnterpriseChat", {
                useridlist: e.userIds,
                chatname: e.groupName
            }, e);
        },
        launchMiniProgram: function(e) {
            k("launchMiniProgram", {
                targetAppId: e.targetAppId,
                path: function(e) {
                    var n;
                    if ("string" == typeof e && 0 < e.length) return n = e.split("?")[0], n += ".html", void 0 !== (e = e.split("?")[1]) ? n + "?" + e : n;
                }(e.path),
                envVersion: e.envVersion
            }, e);
        },
        openBusinessView: function(e) {
            k("openBusinessView", {
                businessType: e.businessType,
                queryString: e.queryString || "",
                envVersion: e.envVersion
            }, (e._complete = function(n) {
                if (l) {
                    var e = n.extraData;
                    if (e) try {
                        n.extraData = JSON.parse(e);
                    } catch (e) {
                        n.extraData = {};
                    }
                }
            }, e));
        },
        miniProgram: {
            navigateBack: function(e) {
                e = e || {}, O(function() {
                    k("invokeMiniProgramAPI", {
                        name: "navigateBack",
                        arg: {
                            delta: e.delta || 1
                        }
                    }, e);
                });
            },
            navigateTo: function(e) {
                O(function() {
                    k("invokeMiniProgramAPI", {
                        name: "navigateTo",
                        arg: {
                            url: e.url
                        }
                    }, e);
                });
            },
            redirectTo: function(e) {
                O(function() {
                    k("invokeMiniProgramAPI", {
                        name: "redirectTo",
                        arg: {
                            url: e.url
                        }
                    }, e);
                });
            },
            switchTab: function(e) {
                O(function() {
                    k("invokeMiniProgramAPI", {
                        name: "switchTab",
                        arg: {
                            url: e.url
                        }
                    }, e);
                });
            },
            reLaunch: function(e) {
                O(function() {
                    k("invokeMiniProgramAPI", {
                        name: "reLaunch",
                        arg: {
                            url: e.url
                        }
                    }, e);
                });
            },
            postMessage: function(e) {
                O(function() {
                    k("invokeMiniProgramAPI", {
                        name: "postMessage",
                        arg: e.data || {}
                    }, e);
                });
            },
            getEnv: function(e) {
                O(function() {
                    e({
                        miniprogram: "miniprogram" === r.__wxjs_environment
                    });
                });
            }
        }
    }, w = 1, T = {}, n.addEventListener("error", function(e) {
        var n, i, t;
        l || (t = (n = e.target).tagName, i = n.src, "IMG" != t && "VIDEO" != t && "AUDIO" != t && "SOURCE" != t) || -1 != i.indexOf("wxlocalresource://") && (e.preventDefault(), e.stopPropagation(), (t = n["wx-id"]) || (t = w++, n["wx-id"] = t), T[t] || (T[t] = !0, wx.ready(function() {
            wx.getLocalImgData({
                localId: i,
                success: function(e) {
                    n.src = e.localData;
                }
            });
        })));
    }, !0), n.addEventListener("load", function(e) {
        var n;
        l || (n = (e = e.target).tagName, e.src, "IMG" != n && "VIDEO" != n && "AUDIO" != n && "SOURCE" != n) || (n = e["wx-id"]) && (T[n] = !1);
    }, !0), e && (r.wx = r.jWeixin = _), _;
    else return r.jWeixin;
    function k(n, e, i) {
        r.WeixinJSBridge ? WeixinJSBridge.invoke(n, P(e), function(e) {
            V(n, e, i);
        }) : C(n, i);
    }
    function M(n, i, t) {
        r.WeixinJSBridge ? WeixinJSBridge.on(n, function(e) {
            t && t.trigger && t.trigger(e), V(n, e, i);
        }) : C(n, t || i);
    }
    function P(e) {
        return (e = e || {}).appId = h.appId, e.verifyAppId = h.appId, e.verifySignType = "sha1", e.verifyTimestamp = h.timestamp + "", e.verifyNonceStr = h.nonceStr, e.verifySignature = h.signature, e;
    }
    function x(e) {
        return {
            timeStamp: e.timestamp + "",
            nonceStr: e.nonceStr,
            package: e.package,
            paySign: e.paySign,
            signType: e.signType || "SHA1"
        };
    }
    function V(e, n, i) {
        "openEnterpriseChat" != e && "openBusinessView" !== e || (n.errCode = n.err_code), delete n.err_code, delete n.err_desc, delete n.err_detail;
        var t = n.errMsg, e = (t || (t = n.err_msg, delete n.err_msg, t = function(e, n) {
            var i = c[e];
            i && (e = i);
            i = "ok";
            var t;
            n && (t = n.indexOf(":"), "access denied" != (i = (i = (i = -1 != (i = -1 != (i = "failed" == (i = "confirm" == (i = n.substring(t + 1)) ? "ok" : i) ? "fail" : i).indexOf("failed_") ? i.substring(7) : i).indexOf("fail_") ? i.substring(5) : i).replace(/_/g, " ")).toLowerCase()) && "no permission to execute" != i || (i = "permission denied"), "" == (i = "config" == e && "function not exist" == i ? "ok" : i)) && (i = "fail");
            return n = e + ":" + i;
        }(e, t), n.errMsg = t), (i = i || {})._complete && (i._complete(n), delete i._complete), t = n.errMsg || "", h.debug && !i.isInnerInvoke && alert(JSON.stringify(n)), t.indexOf(":"));
        switch(t.substring(e + 1)){
            case "ok":
                i.success && i.success(n);
                break;
            case "cancel":
                i.cancel && i.cancel(n);
                break;
            default:
                i.fail && i.fail(n);
        }
        i.complete && i.complete(n);
    }
    function A(e) {
        if (e) {
            for(var n = 0, i = e.length; n < i; ++n){
                var t = e[n], t = a[t];
                t && (e[n] = t);
            }
            return e;
        }
    }
    function C(e, n) {
        var i;
        !h.debug || n && n.isInnerInvoke || ((i = c[e]) && (e = i), n && n._complete && delete n._complete, console.log('"' + e + '",', n || ""));
    }
    function B(n) {
        var i;
        o || s || h.debug || p < "6.0.2" || g.systemType < 0 || (i = new Image(), g.appId = h.appId, g.initTime = m.initEndTime - m.initStartTime, g.preVerifyTime = m.preVerifyEndTime - m.preVerifyStartTime, _.getNetworkType({
            isInnerInvoke: !0,
            success: function(e) {
                g.networkType = e.networkType;
                e = "https://open.weixin.qq.com/sdk/report?v=" + g.version + "&o=" + g.isPreVerifyOk + "&s=" + g.systemType + "&c=" + g.clientVersion + "&a=" + g.appId + "&n=" + g.networkType + "&i=" + g.initTime + "&p=" + g.preVerifyTime + "&u=" + g.url + "&jsapi_name=" + (n ? n.jsApiName : "");
                i.src = e;
            }
        }));
    }
    function L() {
        return new Date().getTime();
    }
    function O(e) {
        d && (r.WeixinJSBridge ? e() : n.addEventListener && n.addEventListener("WeixinJSBridgeReady", e, !1));
    }
});


function $b3211a456c41491f$export$2e2bcd8739ae039(link, title, desc, imgUrl) {
    (0, $5d947360ab0ea9ad$export$2e2bcd8739ae039).post("https://www.shanghaimuseum.net/mu/frontend/pg/get-weixin-js-api-signature", {
        url: link
    }).then(function(response) {
        if (response.data.code == 0) {
            const result = response.data.data;
            (0, (/*@__PURE__*/$parcel$interopDefault($b7881d378c67312d$exports))).config({
                debug: false,
                appId: result.appid,
                timestamp: result.timestamp,
                nonceStr: result.noncestr,
                signature: result.signature,
                jsApiList: [
                    "updateAppMessageShareData",
                    "updateTimelineShareData"
                ]
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($b7881d378c67312d$exports))).ready(function() {
                (0, (/*@__PURE__*/$parcel$interopDefault($b7881d378c67312d$exports))).updateAppMessageShareData({
                    link: link,
                    title: title,
                    desc: desc,
                    imgUrl: imgUrl
                });
                (0, (/*@__PURE__*/$parcel$interopDefault($b7881d378c67312d$exports))).updateTimelineShareData({
                    link: link,
                    title: title,
                    imgUrl: imgUrl
                });
            });
        }
    });
}



var $6Mm5x = parcelRequire("6Mm5x");

var $02fc47684f44c282$exports = {};

$02fc47684f44c282$exports = (parcelRequire("5uhT4")).getBundleURL("jJOHl") + "share.16ec90e5.jpg";


var $bf1a0ed6c4f03446$exports = {};
$bf1a0ed6c4f03446$exports = "<svg viewBox=\"0 0 191.485 200.908\" xmlns=\"http://www.w3.org/2000/svg\" class=\"shbwg-logo\"><path d=\"M131.291 0v17.774H60.195V0H42.42v106.644h17.774V71.096h26.661v35.548h17.774V71.096h26.661v35.548h17.774V0h-17.773zm0 53.322H60.195V35.548h71.096v17.774z\" fill=\"#BD1932\" class=\"upper\"/><g fill=\"#48474F\" class=\"lower\"><g class=\"ch\"><path d=\"M164.347 143.331c.075-.051.072-.144.111-.215.085-.055.063-.165.122-.234a.096.096 0 0 1 .033-.1.233.233 0 0 1 .086-.098l.006-.006a.597.597 0 0 1 .103-.11l.002-.003a.335.335 0 0 0 .096-.151c-.013-.029-.007-.054.018-.074.064-.065.041-.167.099-.236-.013-.109-.025-.217.026-.321.045-.072.03-.166.085-.234l.044-.096c.046-.057.127-.059.175-.113a.56.56 0 0 0 .116-.117c.073-.067.06-.17.102-.25-.013-.03-.006-.057.019-.078.064-.065.042-.167.1-.236a.098.098 0 0 1 .025-.098c.021-.042.057-.073.076-.115.082-.055.063-.163.121-.23a.1.1 0 0 1 .026-.099c.029-.047.067-.089.08-.146-.013-.029-.007-.054.018-.074.093-.094.005-.244.102-.336l-.001.002c.083-.081.172-.042.26-.011l.042-.004.035.023c.063.062.163.04.226.102l-.003-.001c.04.049.085.089.149.103l.04-.004.032.023c.086.096.24-.005.32.11l.008.006a.481.481 0 0 1 .11.101l.003.002c.133.112.319-.009.452.103l-.005-.002a.242.242 0 0 0 .149.105c.032-.008.056.002.074.03.046.032.089.07.146.083l.04-.005.034.023c.043.042.089.08.15.092a.067.067 0 0 1 .075.038.45.45 0 0 1 .109.085h-.001c.038.04.075.081.128.101.045.07.149.056.194.127l.006.006a.385.385 0 0 1 .105.104l.006.006a.565.565 0 0 1 .11.103l.003.002c.038.032.073.068.117.092a.22.22 0 0 0 .147.113c.034-.005.058.007.073.038a.15.15 0 0 1 .08.082l.04.185a.227.227 0 0 0 .117.151c.036.072.031.162.094.223v-.001c.102.088.002.254.126.333.024.043.06.077.091.115l.002.003a.918.918 0 0 1 .108.108l.003.002c.041.034.076.073.124.097.056.075.16.06.226.116h.304c.069-.059.18-.036.237-.119l-.014.014a.388.388 0 0 0 .115-.12c.113-.082.021-.242.119-.329l-.001.003c.073-.061.052-.167.109-.235a.108.108 0 0 1 .016-.098c.058-.07.042-.169.092-.244-.01-.143-.029-.286.029-.424.061-.115.015-.253.077-.368l.004-.043c-.116-.133.056-.356-.144-.463-.033.006-.057-.006-.072-.036a.255.255 0 0 1-.098-.089l-.006-.006a.378.378 0 0 1-.102-.105l-.007-.008a1.47 1.47 0 0 0-.216-.216l-.008-.007c-.047-.024-.08-.067-.124-.097l.006.004a.352.352 0 0 0-.11-.097.223.223 0 0 0-.15-.119c-.034.005-.059-.008-.074-.038a.321.321 0 0 1-.103-.087l-.003-.002c-.045-.041-.09-.082-.151-.096-.034.006-.06-.006-.076-.037a.79.79 0 0 1-.116-.083l.007.004c-.06-.077-.167-.055-.235-.113a.098.098 0 0 1-.099-.026c-.047-.029-.089-.067-.146-.079l-.188-.032c-.142-.081-.318.018-.456-.085-.146.012-.292.033-.433-.025-.079-.043-.172-.04-.252-.079a.07.07 0 0 1-.081-.029c-.07-.049-.166-.032-.233-.088a.107.107 0 0 1-.098-.016c-.109-.08-.253-.018-.365-.088-.031.013-.057.006-.079-.019-.073-.063-.174-.05-.254-.092-.031.013-.057.006-.079-.019-.055-.063-.161-.03-.207-.111l-.008-.008c-.089-.066-.057-.139-.011-.213a.41.41 0 0 0 .213-.222c.08-.047.056-.158.129-.209l.003-.005c.06-.068.042-.169.099-.239a.101.101 0 0 1 .026-.099c.029-.047.067-.089.079-.146-.006-.035.006-.061.037-.077a.74.74 0 0 1 .083-.116l-.004.006c.071-.058.063-.153.103-.225a.278.278 0 0 0 .111-.112.368.368 0 0 0 .126-.119l-.014.013c.081-.054.059-.162.122-.226l-.001.003a.26.26 0 0 0 .103-.149c-.007-.032.002-.056.03-.073a.762.762 0 0 1 .093-.11h-.001a.5.5 0 0 0 .107-.131.098.098 0 0 1 .016-.092.628.628 0 0 1 .32-.312l.115-.01c.215.115.466-.029.679.095.366-.014.732-.037 1.098.016.328.125.685-.04 1.012.095l.053-.001.046.027c.042.021.073.058.116.076.027.05.066.089.118.113.016.05.057.082.087.122l.022.183a.223.223 0 0 0 .107.14c.085.114.247.024.34.117l.169-.006c.057-.012.099-.05.146-.08l.046-.026.053.001c.214-.119.46.009.677-.085l.106-.023c.093-.1.25-.002.34-.112l-.003.001c.062-.063.163-.041.225-.102l.034-.023.041.005c.057-.012.099-.05.146-.079l.046-.026h.053c.1-.089.246-.01.346-.095l.186-.022c.056-.012.099-.05.146-.079l.046-.026h.053c.097-.095.262.005.348-.122.074-.04.179-.031.211-.136-.008-.031.001-.055.029-.072.049-.071.032-.166.088-.234l-.006-.174c-.072-.112-.005-.26-.095-.368l-.002-.003c-.042-.037-.083-.074-.133-.101a.092.092 0 0 1-.093-.026c-.047-.029-.09-.068-.147-.079-.032.009-.057-.001-.075-.029-.046-.033-.089-.07-.146-.083-.032.009-.057-.001-.075-.029-.046-.032-.089-.07-.146-.083-.032.009-.058 0-.076-.028l-.114-.083c-.028-.047-.068-.084-.107-.122l.001.001c-.183-.094-.367-.075-.553-.012-.433.057-.867.022-1.3.022-.148.086-.327-.001-.476.083-1.032.248-2.079.059-3.118.105-.267.012-.291-.116-.236-.348.057-.247.12-.494.167-.744.112-.603-.148-1.155-.157-1.735-.012-.058-.05-.101-.083-.146-.027-.018-.037-.043-.028-.075a.334.334 0 0 0-.097-.151l-.002-.003a.332.332 0 0 1-.087-.103c-.031-.016-.043-.041-.038-.075a.263.263 0 0 0-.103-.15l.001.003c-.062-.063-.042-.167-.113-.225l.001.003c-.059-.06-.046-.161-.118-.214-.024-.049-.064-.084-.098-.125l-.002-.003a.534.534 0 0 1-.101-.111l-.007-.008c-.079-.047-.047-.153-.11-.209-.025-.021-.031-.047-.019-.077-.042-.082-.028-.184-.095-.256-.023-.02-.028-.042-.015-.07-.026-.106-.152-.083-.204-.156l-.004-.003c-.046-.039-.091-.08-.152-.094-.032.009-.057 0-.075-.028-.046-.032-.089-.07-.146-.083-.029.013-.053.007-.074-.018-.065-.064-.168-.041-.235-.099a.105.105 0 0 1-.1-.026c-.072-.045-.166-.03-.233-.085a.106.106 0 0 1-.082 0c-.071.06-.188.035-.238.133l.029-.019c-.122.084-.168.223-.245.34l.008.178c.112.202-.331.246-.135.472v.225c-.084.101-.006.247-.095.347a.096.096 0 0 1-.033.1 1.632 1.632 0 0 1-.077.126c.089.221.008.434-.026.65-.095.218.034.463-.085.678l-.016.431c-.084.101-.006.247-.095.347a.108.108 0 0 1-.016.098c-.059.067-.038.167-.095.235l-.026.21c-.042.079-.04.172-.079.252a.513.513 0 0 1-.033.302c-.044.072-.03.166-.085.234a.107.107 0 0 1-.016.098c-.058.075-.048.173-.089.254l-.032.191c-.042.08-.04.172-.079.253.009.034-.001.06-.03.08-.047.078-.042.172-.082.253l-.032.191c-.042.079-.04.172-.079.252.013.031.006.057-.019.079-.092.099-.009.248-.099.347.01.038.001.07-.026.099-.029.047-.067.09-.079.146.013.029.007.054-.018.074-.095.088.002.241-.108.325l-.003.004c-.039.046-.08.09-.094.152.009.032 0 .057-.028.075-.047.078-.042.173-.082.253.021.104.035.207-.029.302-.048.067-.031.161-.091.224l.001-.003c-.109.088-.013.245-.112.336l.001-.003c-.074.061-.052.167-.11.235a.1.1 0 0 1-.025.099 1.19 1.19 0 0 1-.085.113.363.363 0 0 0-.112.125c-.063.051-.051.149-.119.197l-.003.004c-.055.065-.05.139-.034.215.061.071.057.15.03.232-.104.122.02.299-.101.417l-.115.138a1.048 1.048 0 0 0-.104.117l.007-.006a.59.59 0 0 0-.117.117c-.073.067-.06.169-.102.249l-.139.191c-.084.148.003.327-.083.475.006.036-.007.061-.04.077-.177.102-.109.301-.177.446a.229.229 0 0 0-.116.15c.008.032-.002.056-.029.074-.044.068-.041.154-.079.225a.342.342 0 0 0-.124.118l.01-.016a.279.279 0 0 0-.113.154c.013.028.008.052-.017.072-.03.035-.063.068-.083.111a.226.226 0 0 0-.121.15c.008.032-.002.056-.029.074-.049.067-.031.161-.091.224l.001-.003c-.073.062-.052.167-.11.236a.105.105 0 0 1-.016.098c-.058.06-.03.161-.104.214l-.003.004c-.058.066-.041.165-.102.229l.001-.002a.357.357 0 0 0-.098.117c-.083.053-.066.162-.123.229-.002.096-.071.151-.132.209-.026.041-.064.073-.083.119-.076.052-.061.156-.121.217l.001-.003c-.071.058-.051.163-.112.225l.001-.003a.26.26 0 0 0-.103.15c.005.034-.007.059-.038.075a.321.321 0 0 1-.087.103l-.002.003c-.062.06-.038.163-.111.216l-.003.005c-.039.046-.08.09-.094.152.013.029.007.053-.018.073-.062.063-.04.163-.102.226l.001-.003c-.105.102-.027.255-.103.366.006.036-.006.063-.038.081a.321.321 0 0 1-.087.103l-.002.003c-.064.074-.053.175-.095.257.009.034 0 .06-.029.08-.033.046-.07.089-.083.147.006.034-.007.058-.039.072-.043.073-.158.05-.189.14l.02-.032c-.098.064-.08.182-.124.271l.1.078c.009 0 .018.011.027.034.009.022.001.046-.024.069l.001-.002a.862.862 0 0 0-.113.113l.002-.001c-.083.079-.171.043-.259.01l-.163-.005c-.143.071-.032.244-.134.331l.002-.003a1.09 1.09 0 0 0-.115.11.3.3 0 0 0-.101.149l-.002.034c.016.06.057.104.092.152l.007.006c.045.028.079.07.123.1l-.006-.005a.648.648 0 0 0 .112.116l-.001-.004a.456.456 0 0 0 .234.222h.053l.046.026c.072.045.166.03.234.085l.173-.007c.104-.085.287.028.357-.142.006-.052.034-.081.087-.08.124-.025.194-.113.253-.215l-.001.003c.069-.059.057-.155.105-.223.078-.052.053-.161.122-.218v-.001c.035-.038.073-.074.111-.108l.003-.002c.034-.039.069-.075.108-.108l.002-.003c.032-.038.068-.073.092-.117a.224.224 0 0 0 .114-.146c-.008-.032.002-.056.029-.073.022-.039.057-.07.077-.111a.228.228 0 0 0 .116-.148c-.006-.034.007-.059.038-.075a.351.351 0 0 1 .086-.105v-.001c.057-.069.181-.046.209-.153-.01-.031 0-.054.028-.07.046-.065.147-.054.188-.126.058-.033.071-.091.077-.154.009-.066.016-.133.042-.195.047-.102.105-.197.173-.286.052-.071.096-.148.168-.202.043-.043.072-.097.109-.145a.591.591 0 0 1 .082-.076l.042-.032a.214.214 0 0 1 .098-.032c.052-.008.102-.026.152-.039a.17.17 0 0 0 .06-.085c-.007-.032.002-.056.03-.073.028-.039.057-.076.087-.112a.264.264 0 0 0 .107-.147c-.009-.032 0-.056.028-.074.023-.041.061-.072.08-.116a.257.257 0 0 0 .111-.115.246.246 0 0 0 .122-.126l-.024.017c.088-.065.152-.158.249-.214l-.001.001a.5.5 0 0 0 .099-.116.224.224 0 0 0 .112-.146c-.008-.031.002-.056.03-.073.037-.102.121-.161.204-.221.067-.061.048-.163.109-.226l-.001.003a.313.313 0 0 0 .107-.12z\"/><path d=\"M191.469 138.013a.093.093 0 0 1-.021-.093c-.025-.049-.064-.089-.095-.134l-.007-.006a.48.48 0 0 1-.107-.104l-.005-.004a.596.596 0 0 1-.106-.107l-.003-.005c-.066-.045-.058-.141-.117-.191-.05-.093-.165-.07-.234-.13a.102.102 0 0 1-.1-.025c-.064-.046-.16-.022-.212-.094l-.004-.003c-.109-.086-.256-.021-.369-.093l-.191-.032c-.047-.029-.09-.067-.146-.079-.03.013-.054.006-.075-.018-.403-.134-.832.038-1.235-.099a15.04 15.04 0 0 1-.21-.026c-.142-.081-.317.018-.456-.085l-1.395.006c-.112.07-.256.009-.366.088l-.19.022c-.11.076-.264-.002-.366.104l.003-.001c-.063.062-.163.04-.226.102-.021.025-.047.031-.078.019-.081.038-.174.036-.253.078a.103.103 0 0 1-.1.026c-.068.059-.17.036-.235.099-.022.025-.048.031-.079.019-.123.042-.245.085-.363-.014l-.001-.003c-.092-.112-.071-.227-.008-.343-.015-.182-.031-.363.016-.542.088-.091-.005-.24.104-.325l.003-.004c.088-.105.015-.252.096-.359a.08.08 0 0 1 .024-.089c.032-.043.067-.083.088-.133a.094.094 0 0 1 .018-.088c.084-.101.006-.247.095-.346a.098.098 0 0 1 .026-.099c.042-.08.04-.172.079-.253-.013-.031-.007-.057.019-.079.062-.058.034-.162.107-.214l.003-.005c.093-.091-.001-.243.108-.329l.003-.004c.125-.214-.027-.469.099-.683l-.006-.396c-.068-.112-.014-.251-.082-.364a.062.062 0 0 1-.029-.073.178.178 0 0 0-.141-.141c-.034.006-.058-.006-.073-.037a.168.168 0 0 1-.082-.082c-.03-.016-.043-.041-.038-.074a.242.242 0 0 0-.105-.149l.006.007a.569.569 0 0 0-.12-.12l.007.006a.362.362 0 0 0-.122-.108c-.019-.045-.057-.077-.081-.118-.027-.018-.037-.042-.029-.073a.25.25 0 0 0-.105-.149l.006.007a.605.605 0 0 0-.118-.119c-.056-.066-.157-.047-.213-.114h-.001c-.039-.037-.075-.077-.126-.099-.046-.07-.151-.054-.195-.127l-.008-.007c-.047-.025-.08-.068-.124-.097l.007.004c-.056-.074-.162-.053-.224-.115l.002.001a.266.266 0 0 0-.149-.103c-.029.012-.053.005-.072-.019-.073-.063-.174-.05-.255-.092-.031.013-.057.006-.078-.019-.175-.119-.394.021-.568-.099a.094.094 0 0 1-.077 0c-.049.026-.089.065-.134.096l-.006.006a.26.26 0 0 1-.097.089c-.018.032-.045.044-.081.038-.081.045-.196.024-.249.125a.094.094 0 0 1-.017.087c-.085.101-.007.247-.096.346v.303c.095.096-.003.261.122.346.024.043.06.078.091.115l.002.003a.597.597 0 0 1 .103.11l.006.006a.365.365 0 0 1 .102.105l.007.008c.079.048.05.17.145.207l-.019-.024c.063.087.156.149.206.248.024.019.03.043.019.072.013.064.054.11.103.15l-.001-.003c.113.131-.004.313.098.447.021.03.027.063.016.098.09.1.007.248.099.347.025.022.031.048.019.079.041.081.031.179.089.254.044.26.044.52 0 .78-.058.075-.048.173-.089.254v.154c.038.091.064.182-.007.271l-.013.542c-.108.121.018.299-.103.417l-.115.138c-.096.097-.01.248-.102.347a.105.105 0 0 1-.016.098c-.118.21.032.46-.098.669l.001-.003c-.074.062-.052.167-.11.236.012.109.029.22-.033.322a.584.584 0 0 1-.08.116l.004-.006a.297.297 0 0 0-.105.125c-.049.018-.084.055-.123.088-.019.024-.042.031-.071.019a.259.259 0 0 0-.15.103l.003-.001c-.063.06-.155.044-.224.088a.1.1 0 0 1-.099.025c-.068.058-.174.037-.235.11l.003-.001c-.063.062-.167.042-.225.112l.003-.001c-.063.063-.168.041-.224.116l.007-.004a.74.74 0 0 1-.116.083c-.016.031-.041.043-.075.039a.246.246 0 0 0-.149.105l.007-.004a.79.79 0 0 1-.116.083c-.017.031-.042.043-.077.037-.057.012-.099.05-.146.079a.101.101 0 0 1-.099.026c-.068.058-.174.036-.235.109l.003-.001c-.061.061-.166.045-.217.122-.045.019-.077.057-.118.081-.017.028-.042.037-.073.029a.3.3 0 0 0-.151.098h-.001c-.057.067-.153.045-.218.095a.062.062 0 0 1-.073.029.248.248 0 0 0-.149.106l.007-.004a.614.614 0 0 1-.116.08.1.1 0 0 1-.101.034c-.068.058-.178.039-.23.125-.045.019-.081.054-.117.086-.02.024-.044.03-.072.017-.062.014-.107.055-.153.094l-.005.003c-.148.102-.3.075-.452.009a.104.104 0 0 1-.098-.016c-.109-.08-.253-.018-.365-.089l-.19-.023c-.075-.057-.173-.047-.254-.088l-.189-.022c-.101-.085-.247-.006-.347-.095a.101.101 0 0 1-.099-.026c-.063-.046-.159-.019-.208-.096l-.008-.007a.365.365 0 0 1-.105-.102l-.006-.006a.44.44 0 0 0-.174-.097l-.056.107c-.113.087-.228.07-.343.005h-.188c-.049.025-.088.065-.135.093l-.008.007c-.049.078-.154.051-.211.112l-.003.002a.597.597 0 0 1-.11.103l-.006.007a.411.411 0 0 1-.104.104l-.007.006c-.031.045-.07.085-.095.134v1.742c.055.068.041.162.085.234l.025.21c.058.068.036.17.1.236.024.02.03.044.017.073.014.062.055.106.095.151l.002.004c.059.085.132.157.212.222l.007.008c.077.046.054.173.158.197a.062.062 0 0 1 .073.029c.078.047.172.042.253.082h.483c.057-.012.099-.05.146-.079l.046-.026h.053c.068-.055.162-.041.233-.085a.499.499 0 0 1 .298-.031c.057-.013.101-.05.146-.083a.062.062 0 0 1 .073-.029c.104-.024.081-.151.158-.198l.007-.008a.378.378 0 0 1 .102-.105l.006-.006a.365.365 0 0 1 .105-.102l.008-.007c.044-.072.146-.059.192-.127a.256.256 0 0 0 .125-.118l-.013.006c.101-.083.255.005.347-.107l-.007.005c.043-.029.077-.072.124-.097l.008-.007c.047-.078.157-.049.208-.12l-.003.001c.061-.061.167-.045.218-.123.044-.018.075-.056.117-.077a.094.094 0 0 1 .094-.026c.041-.027.083-.054.125-.079a.067.067 0 0 1 .075-.038.228.228 0 0 0 .149-.118.248.248 0 0 0 .104-.104c.046-.023.082-.062.123-.093l.004-.003c.053-.073.16-.047.214-.118l-.003.001c.063-.062.171-.042.222-.124.073-.039.163-.034.228-.091l.003-.002a.321.321 0 0 1 .103-.087c.016-.031.04-.043.074-.038a.224.224 0 0 0 .148-.117.25.25 0 0 0 .104-.107.264.264 0 0 0 .117-.112c.069-.039.161-.036.213-.108a.251.251 0 0 0 .117-.113c.043-.018.075-.055.116-.076a.521.521 0 0 1 .302-.032c.081-.044.19-.029.252-.116.042-.02.073-.055.113-.078a.062.062 0 0 1 .072-.03.244.244 0 0 0 .15-.105l-.007.004a.614.614 0 0 1 .116-.08l.108-.031c.062-.063.159-.042.226-.091.018-.027.043-.037.075-.028a.343.343 0 0 0 .151-.097l.003-.002a.503.503 0 0 1 .11-.101l.008-.007c.045-.075.154-.055.199-.129.046-.017.077-.057.12-.078l.046-.026h.053c.068-.056.163-.039.233-.088.019-.028.044-.037.076-.028.057-.012.099-.05.146-.08l.043-.026h.051c.042-.027.083-.054.126-.079a.073.073 0 0 1 .082-.038c.081-.04.175-.035.253-.082.018-.028.043-.037.076-.029.057-.012.099-.05.146-.079l.046-.026h.053c.068-.057.167-.037.235-.094l.033-.025.042.002c.056-.012.099-.05.146-.08l.046-.026.054.001c.067-.056.161-.041.233-.085l.046-.026h.053c.067-.056.163-.039.233-.088.02-.028.046-.038.08-.029.081-.041.179-.031.254-.088.064-.029.101-.002.123.058.07.169.253.056.356.142.057.003.087.032.089.09a.183.183 0 0 1 0 .177.069.069 0 0 1-.03.081c-.049.071-.032.166-.088.234a.1.1 0 0 1-.025.099c-.046.064-.022.16-.094.212l-.003.004c-.032.042-.072.078-.095.127-.07.049-.054.153-.124.202l-.003.004c-.031.042-.071.078-.094.126-.073.052-.059.154-.119.214l.001-.003a.268.268 0 0 0-.103.15c.007.032-.002.056-.03.073-.023.041-.061.073-.08.116a.252.252 0 0 0-.111.115.248.248 0 0 0-.112.112.248.248 0 0 0-.111.111.248.248 0 0 0-.111.111.248.248 0 0 0-.111.111.247.247 0 0 0-.113.115c-.07.052-.06.152-.119.21l.001-.003a.336.336 0 0 0-.102.125c-.072.045-.057.151-.129.195l-.007.008a.365.365 0 0 1-.102.105l-.006.006a.432.432 0 0 1-.104.105l-.007.006a.396.396 0 0 1-.104.104l-.006.006c-.028.045-.07.08-.1.124l.005-.007a.34.34 0 0 0-.097.11.224.224 0 0 0-.12.15c.005.034-.007.059-.038.075a4.351 4.351 0 0 1-.079.126.093.093 0 0 1-.034.095.614.614 0 0 1-.08.116l.004-.006a.246.246 0 0 0-.105.149c.005.034-.009.057-.04.071-.039.065-.131.058-.173.118a.244.244 0 0 0-.124.123c-.067.051-.06.148-.116.206a.427.427 0 0 0-.101.115.222.222 0 0 0-.112.145c.005.034-.007.059-.038.075a.255.255 0 0 1-.089.098l-.006.006a.411.411 0 0 1-.104.104l-.006.006a.4.4 0 0 1-.105.104l-.006.006a.536.536 0 0 1-.103.11l-.002.003a.335.335 0 0 0-.096.151c.006.035-.006.06-.037.077a.79.79 0 0 1-.083.116l.004-.007a.242.242 0 0 0-.105.149c.012.028.005.052-.019.072-.063.053-.028.161-.113.202l-.009.014a.338.338 0 0 1-.097.109l-.004.005a1.61 1.61 0 0 1-.104.115v-.001a.3.3 0 0 0-.102.15c.003.038-.013.064-.048.079a.163.163 0 0 1-.078.093l-.005.009c-.056.063-.033.164-.105.218l-.003.005c-.03.039-.066.074-.09.117a.225.225 0 0 0-.114.147c.005.034-.007.059-.038.074a.321.321 0 0 1-.087.103l-.002.003c-.035.041-.076.077-.099.127-.069.049-.053.152-.123.201l-.003.005c-.039.046-.08.09-.094.152.006.034-.006.06-.037.076a.32.32 0 0 1-.087.103l-.002.003c-.064.074-.053.176-.095.257l-.022.19c-.086.098-.002.245-.098.339a4.013 4.013 0 0 0-.023.106c-.044.072-.03.166-.085.234a.108.108 0 0 1-.016.098c-.08.109-.018.253-.088.365l-.032.191c-.045.072-.03.166-.085.234l-.026.21c-.042.079-.04.172-.079.252l-.022.19c-.08.109-.018.253-.088.365.012.031.006.057-.019.079-.063.065-.041.167-.099.235a.108.108 0 0 1-.016.098c-.084.101-.006.247-.095.347a.098.098 0 0 1-.026.099c-.067.105 0 .244-.085.345l-.016.208c-.058.075-.048.173-.089.254.008.139.025.279-.032.414-.081.142.018.318-.085.456l-.026.21c-.081.142.018.318-.085.456.012.146.033.291-.026.432-.029.047-.067.09-.08.146.009.032 0 .057-.028.075a.752.752 0 0 1-.093.11h.001a.437.437 0 0 1-.108.084c-.016.031-.041.043-.075.039-.061.011-.105.049-.15.087a.108.108 0 0 1-.098.016c-.068.058-.172.037-.235.107-.067.06-.048.162-.109.226l.001-.003a.372.372 0 0 0-.099.117.29.29 0 0 0-.121.117c-.072.064-.063.165-.105.242.007.036-.005.063-.037.081a.255.255 0 0 1-.089.098l-.006.006a.255.255 0 0 1-.098.089c-.016.03-.041.043-.074.038a.224.224 0 0 0-.148.117.26.26 0 0 0-.103.105.248.248 0 0 0-.111.111.244.244 0 0 0-.111.111.24.24 0 0 0-.114.115.355.355 0 0 0-.119.099l.003-.001c-.062.062-.171.045-.22.129-.063.045-.052.146-.125.183l-.014.01c-.137.106-.276.091-.416.005l-.005-.003c-.074-.061-.174-.049-.254-.095l-.045.003c-.089.03-.178.069-.263-.011l.003.001c-.08-.086-.182-.054-.278-.052-.166.029-.326.104-.5.051-.059-.07-.162-.05-.224-.112l.003.001c-.059-.071-.162-.051-.225-.112l.003.001c-.058-.071-.162-.051-.225-.113l.003.001c-.058-.071-.162-.05-.225-.112l.003.001c-.059-.071-.163-.05-.226-.112l.003.001c-.054-.071-.162-.045-.214-.118l-.004-.003c-.043-.032-.079-.074-.129-.097-.063-.104-.01-.234-.078-.337-.029-.02-.039-.047-.029-.081-.039-.121-.091-.242.017-.355l.007-.008c.028-.047.068-.086.093-.135v-.188c-.044-.05-.032-.102-.005-.154-.015-.139-.035-.279.108-.372-.059-.118-.018-.257-.077-.375v-.117c.04-.113.068-.226-.025-.329l.002.002a.1.1 0 0 1-.009-.125c.08-.061.072-.133.022-.21l-.021-.296c-.012-.057-.05-.099-.08-.146l-.032-.191c-.094-.186.004-.398-.079-.586a.276.276 0 0 1-.012-.227.3.3 0 0 0-.001-.331c-.024-.02-.03-.045-.018-.074-.013-.058-.05-.101-.083-.146-.029-.02-.039-.047-.029-.081-.038-.091-.064-.182.006-.27a9.5 9.5 0 0 0-.007-.172.921.921 0 0 1 0-.598c.077-.052.06-.158.121-.22l-.001.003a.26.26 0 0 0 .103-.15.067.067 0 0 1 .038-.075.79.79 0 0 1 .083-.116l-.004.007c.075-.056.053-.162.115-.225l-.001.003a.344.344 0 0 0 .102-.125c.071-.045.057-.151.129-.195l.007-.008c.025-.047.068-.08.097-.124l-.005.007a.242.242 0 0 0 .105-.149c-.012-.028-.005-.053.019-.072.063-.058.034-.162.108-.214l.003-.004c.031-.042.071-.077.094-.125.073-.052.059-.154.119-.214l-.001.003c.075-.069.06-.173.104-.255-.007-.036.005-.063.037-.082a.781.781 0 0 1 .083-.115l-.004.006a.246.246 0 0 0 .105-.149c-.008-.032.002-.056.029-.074.032-.046.07-.089.083-.146-.009-.032 0-.057.029-.075.032-.046.07-.089.082-.147-.009-.032.001-.057.029-.076.05-.061.021-.159.099-.207l.007-.008a.245.245 0 0 1 .095-.091l.219-.191c-.007-.063-.05-.108-.078-.162l-.061-.105c.028-.079-.027-.166.025-.242l-.001.014c.112-.509.161-1.01-.207-1.451l-.002-.002c-.071-.054-.046-.17-.138-.211a.092.092 0 0 1-.089-.027c-.079-.042-.172-.04-.253-.079-.03.013-.057.006-.078-.019a.302.302 0 0 0-.15-.092h-.149c-.052.024-.104.028-.155 0-.065-.076-.127-.083-.183-.008a.237.237 0 0 0-.129.122.334.334 0 0 0-.119.102l.006-.004a.64.64 0 0 1-.115.08l-.117.018a.322.322 0 0 0-.149-.087h-.253a.235.235 0 0 0-.148.109c-.043.026-.076.065-.117.094l-.005.004a.437.437 0 0 1-.108.102l-.008.007c-.082.111-.224.023-.318.096-.131.058-.269.039-.406.032a.205.205 0 0 0-.105.096c-.141.103-.323.118-.464.219a.524.524 0 0 1-.204.061l-.14.013c-.244-.009-.465.134-.711.109-.168.039-.336.083-.508.102-.099.011-.194.042-.292.063a3.303 3.303 0 0 1-.295.05 6.6 6.6 0 0 0-.372.072c-.217.078-.427.172-.642.253-.246.065-.483.176-.749.137-.151-.011-.31-.08-.446.051l.018-.007c-.073.047-.17.033-.237.094a.139.139 0 0 1-.099.039c-.034.006-.058-.007-.071-.039l-.012-.042a.23.23 0 0 0-.063-.058l.024.015c-.116-.097-.227-.132-.324.023.008.031-.001.054-.028.071a.375.375 0 0 0-.003.327.092.092 0 0 1 .027.092c.025.051.063.093.1.135l.003.003c.042.037.083.074.132.101.095.008.152.074.207.141.042.026.084.053.125.081a.094.094 0 0 1 .094.026c.047.029.09.067.146.079l.041-.005.034.023c.103.089.25.015.355.096l.271-.002c.057-.012.099-.05.146-.08l.205-.026a.577.577 0 0 0 .132-.104v-.001c.036-.034.073-.039.112-.012a.313.313 0 0 0 .133.114l.037-.007.036.009c.087-.069.176-.048.265-.005l.042-.002a.235.235 0 0 0 .149-.108l-.008.003c.131-.116.338.033.456-.13.075-.025.16-.025.218-.092a.096.096 0 0 1 .12-.002c.045.055.11.08.17.113.143.085.278.189.459.172.121-.011.247.028.361-.04l.318-.022c.09-.07.184-.042.277-.008l.256.003c.124-.083.218-.269.407-.113l.043.001c.592-.032.223.366.26.582a.098.098 0 0 1-.026.099c-.044.069-.029.161-.088.224l.001-.003c-.071.058-.051.162-.113.225l.001-.003c-.071.059-.051.163-.112.225l.001-.003a.265.265 0 0 0-.103.15.067.067 0 0 1-.038.075.309.309 0 0 1-.087.103l-.002.003a.335.335 0 0 0-.096.151c.009.032 0 .057-.028.075-.032.046-.07.089-.083.146.011.031.003.056-.023.075-.055.076-.047.173-.087.254.007.036-.007.061-.04.077-.033.038-.07.042-.111.011a.236.236 0 0 1-.199-.039 1.37 1.37 0 0 1-.126-.077h-.411c-.163.085-.327.061-.492.006l-.301-.022c-.075-.057-.173-.047-.254-.088-.034.009-.06-.001-.08-.029-.104-.073-.245-.002-.345-.088a.098.098 0 0 1-.099-.026c-.072-.045-.166-.029-.233-.085l-.209-.016c-.11-.08-.253-.018-.365-.088l-.412-.022c-.064-.057-.162-.037-.225-.098l.003.001c-.069-.075-.173-.06-.255-.103-.033.009-.06 0-.079-.029-.219.017-.065-.374-.332-.305l.008-.009a.35.35 0 0 0-.103.12.25.25 0 0 0-.118.114c-.044.019-.076.056-.116.08-.018.028-.043.037-.075.028-.062.014-.106.055-.151.096l-.003.002c-.037.042-.074.083-.101.132a.09.09 0 0 1-.034.095.614.614 0 0 1-.08.116l.004-.007c-.074.057-.053.162-.115.225l.001-.003a.266.266 0 0 0-.103.149v.148c.07.112.008.256.088.365.021.03.027.063.016.098.058.068.036.168.095.235l.022.301c.071.112.009.256.089.365.041.335.056.67-.01 1.004a.964.964 0 0 0 0 .548l.031.188c.012.057.05.099.08.146.062.223.05.446.01.67-.096.146 0 .329-.089.477.009.034-.001.06-.029.08a.618.618 0 0 0-.003.438.592.592 0 0 1-.008.451.282.282 0 0 1-.085.103l-.002.003a1.311 1.311 0 0 0-.002.777c.024.02.031.044.019.073.012.06.049.105.088.149.021.03.027.063.016.098a.201.201 0 0 1 0 .251c.007.33.048.66-.026.988-.075.15.005.326-.079.475a.516.516 0 0 1-.032.303c-.075.15.005.326-.079.475.013.03.008.056-.016.078-.127.217.02.473-.098.691.006.178.034.358-.03.532-.063.113-.012.251-.079.364l-.032.191c-.042.079-.04.172-.079.253l-.032.191c-.044.069-.029.161-.088.224l.002-.003c-.075.068-.061.173-.104.255l-.032.191c-.075.15.005.326-.079.475l-.007.395c.124.253-.013.534.085.789l.026.21c.056.068.039.164.088.234.028.017.038.042.03.073a.248.248 0 0 0 .106.149l-.006-.007a.569.569 0 0 0 .12.12l-.007-.006a.298.298 0 0 0 .136.112l-.018-.021c.068.088.156.158.226.245l-.016-.008c.04.053.087.096.154.113.034-.007.059.005.075.036a.781.781 0 0 1 .115.083l-.006-.004c.034.041.066.083.118.098v-.023c.002.01.006.018.009.025.007.002.012.005.02.005h-.019c.039.075.148.059.191.128l.007.006c.054.039.104.085.174.096.018-.073.058-.118.139-.116.087-.049.174-.063.26.003l.168-.007a.302.302 0 0 0 .15-.092l.033-.023.041.005c.057-.012.101-.05.146-.083l.037-.029.047.001c.127-.055.296-.048.35-.216a.224.224 0 0 0 .111-.147c.005-.052.033-.08.085-.084.064-.031.129-.023.195-.002l.002.016a.24.24 0 0 0 .169-.132.092.092 0 0 1 .016-.091l.095-.113a.402.402 0 0 0 .111-.128.098.098 0 0 1 .016-.092c.058-.075.047-.173.089-.254l.032-.191c.03-.047.068-.09.08-.146-.013-.029-.007-.054.018-.074.063-.065.041-.167.099-.236a.103.103 0 0 1 .016-.097c.03-.041.073-.073.088-.125.072-.047.058-.152.127-.201l.003-.004c.058-.065.041-.165.102-.229l-.001.003c.075-.068.06-.173.103-.255a.067.067 0 0 1 .029-.079c.023-.041.061-.073.08-.116a.252.252 0 0 0 .121-.13l-.018.011c.237-.123.155-.502.459-.57l-.017.035c.135-.092.043-.26.123-.371-.013-.031-.006-.057.019-.079.094-.091 0-.242.105-.33v-.002a.485.485 0 0 0 .102-.136.092.092 0 0 1 .028-.09c.067-.105 0-.244.085-.345a.1.1 0 0 1 .026-.099c.044-.069.029-.161.088-.224l-.001.003c.07-.059.053-.16.109-.226.05-.036.11-.05.162-.082a.258.258 0 0 0 .112-.14.345.345 0 0 1 .068-.101l.003-.002c.042-.085.175-.02.207-.122.043-.025.077-.062.117-.09l.114-.005c.039.033.075.067.111.103l-.001-.001c.116.087.155-.034.222-.082.016-.033.042-.046.077-.04.148-.089.33.007.477-.088.185-.041.371-.043.557-.009.096.101.249.012.347.104l.21.025a.207.207 0 0 0 .217 0l.116-.004c.04.028.076.06.11.094l-.001-.001c.082.066.156.075.216-.026.044-.031.086-.034.121.025l-.005-.006c.084.116.246.016.335.119v-.001a.297.297 0 0 0 .149.102l.295.021c.223.11.476-.018.699.089l.042-.005.036.023c.369.082.738.075 1.107.004l.116.01c.255.099.536-.038.789.085l.21.026c.068.044.161.029.223.088l-.002-.001a.847.847 0 0 0 .112.112c.092.567.075 1.135.009 1.702l-.002.047c.121.296-.029.62.091.917l.016.32c.118.175-.015.392.095.569a.464.464 0 0 1-.01.338c-.111.773.051 1.558-.088 2.331-.072.062-.051.166-.108.234a.1.1 0 0 1-.026.099c-.041.074-.043.147.01.218.021.03.027.062.016.097.057.068.036.168.095.236l.016.207c.055.066.039.172.118.226.021.048.061.084.092.125l.003.005a.69.69 0 0 0 .23.213l-.003-.001c.06.068.153.06.225.1.029.05.067.089.12.113a.28.28 0 0 0 .1.113.38.38 0 0 0 .123.116.256.256 0 0 0 .111.105c.052.073.146.069.215.109.044.079.157.053.201.131l.008.008c.08.046.051.153.118.207.07.066.144.065.22.012h.114a.722.722 0 0 0 .555-.007l.003-.002a.597.597 0 0 1 .11-.103l.006-.006a.432.432 0 0 1 .104-.105l.006-.006a.428.428 0 0 1 .104-.104l.007-.006a.411.411 0 0 1 .104-.104l.006-.007a.365.365 0 0 1 .105-.102l.008-.007c.08-.114.234-.014.32-.11l.036-.023.042.005c.081-.041.18-.031.255-.088l.296-.022c.057-.012.099-.05.146-.079l.19-.032c.083-.041.182-.034.259-.088l.01-.005c.047-.08.155-.05.208-.119v.001c.038-.036.074-.073.113-.109h.001c.038-.039.078-.039.119-.008l-.008-.004c.093.127.263 0 .361.11l.03-.008.029.012c.191-.106.378-.229.611-.116a.069.069 0 0 1 .08.029c.075.044.148.047.218-.011l.036-.023.042.005c.223-.107.476.021.698-.089a.89.89 0 0 1 .447-.002c.256.082.515.06.773.012a.242.242 0 0 1 .228 0c.047.03.09.068.147.079.032-.009.057.001.075.029.07.049.166.032.233.089l.32.016a.516.516 0 0 0 .441 0l.3-.022c.334-.125.699.048 1.031-.103.101-.058.186-.129.215-.249l-.002-.047c-.038-.091-.064-.182.006-.27l-.006-.278a.224.224 0 0 0-.117-.148.248.248 0 0 0-.105-.103.245.245 0 0 0-.113-.112.271.271 0 0 0-.112-.118c-.041-.072-.033-.169-.111-.223-.039-.069-.036-.161-.106-.214-.023-.048-.063-.083-.094-.125l-.003-.004c-.073-.051-.049-.177-.156-.204-.033.005-.058-.007-.073-.037a.158.158 0 0 1-.082-.083c-.03-.015-.042-.039-.037-.072-.062-.167-.244-.051-.338-.143l.016.007c-.077-.129-.246-.022-.331-.129l-.001-.001a.496.496 0 0 0-.135-.102.095.095 0 0 1-.09-.028 3.009 3.009 0 0 0-.993 0 .102.102 0 0 1-.1.026c-.05.045-.102.032-.153.005a.072.072 0 0 1-.086-.027c-.071-.049-.166-.033-.234-.088a.1.1 0 0 1-.1-.026c-.113-.063-.251-.012-.364-.079l-.191-.032c-.118-.095-.489.077-.329-.311v-.001c.036-.038.072-.074.111-.108l.003-.002a.338.338 0 0 1 .103-.089l.142-.135a.856.856 0 0 0 .193-.227l-.001.003a.265.265 0 0 0 .103-.15.067.067 0 0 1 .038-.075.731.731 0 0 1 .083-.115l-.004.006a.352.352 0 0 0 .097-.11.223.223 0 0 0 .119-.15c-.005-.034.009-.057.04-.07.042-.074.146-.048.192-.118l-.007.004c.044-.03.078-.072.124-.099l.006-.006a.262.262 0 0 1 .097-.09l.139-.139a.338.338 0 0 1 .089-.103l.002-.003c.034-.039.07-.076.108-.111h.001c.057-.069.181-.046.209-.153.003-.051.03-.077.081-.081.119-.04.095-.163.141-.245-.007-.036.005-.063.038-.081a.227.227 0 0 1 .089-.095l.008-.007c.047-.078.158-.049.208-.123l-.006.004a.67.67 0 0 1 .116-.081c.062-.013.125-.025.187-.039a.315.315 0 0 0 .151-.099h.001c.036-.039.075-.075.104-.121a.278.278 0 0 0 .102-.113.248.248 0 0 0 .118-.119c.066-.048.055-.149.123-.197l.003-.004c.031-.042.072-.078.095-.127.07-.049.054-.152.124-.202l.003-.004c.099-.291.012-.605.118-.894l-.007-.009c-.071-.043-.06-.143-.124-.19a.253.253 0 0 0-.116-.119.248.248 0 0 0-.111-.111.256.256 0 0 0-.11-.111.242.242 0 0 0-.121-.115c-.047-.067-.147-.056-.195-.123l-.003-.002c-.042-.033-.078-.074-.127-.098-.048-.068-.152-.051-.196-.125l-.008-.007c-.047-.024-.08-.068-.124-.097l.007.005c-.067-.079-.173-.063-.254-.106-.033.009-.06 0-.08-.029-.046-.032-.089-.07-.146-.082a.063.063 0 0 1-.076-.029c-.046-.032-.089-.07-.146-.083-.029.013-.054.007-.074-.018-.063-.062-.163-.04-.226-.102l.003.001c-.068-.075-.173-.06-.254-.103-.031.012-.057.006-.079-.019a.499.499 0 0 0-.441-.004l-.431.016a.518.518 0 0 1-.465.003l-.087-.117c-.028-.02-.038-.046-.029-.08a.65.65 0 0 1-.002-.483c.076-.054.07-.149.11-.221.082-.054.065-.161.12-.229l-.004.009c.081-.058.058-.167.116-.235l.016-.319a.316.316 0 0 0 .088-.149c-.011-.029-.005-.053.02-.073.092-.099.009-.247.099-.347a.1.1 0 0 1 .025-.099c.02-.04.054-.07.073-.11.127-.079.027-.246.126-.335l-.001.003c.124-.14.009-.331.104-.477-.007-.036.005-.063.037-.082a.718.718 0 0 1 .08-.11c.085-.187.114-.373-.014-.555l.015.025c-.015-.053-.062-.085-.088-.131-.027-.017-.037-.041-.029-.072a.177.177 0 0 0-.141-.141c-.034.005-.058-.007-.074-.037a.252.252 0 0 1-.097-.089l-.007-.007c-.045-.03-.085-.07-.134-.095a.092.092 0 0 1-.093-.026c-.047-.03-.09-.067-.147-.079-.035.006-.061-.006-.077-.037a.781.781 0 0 1-.115-.083l.006.004a.31.31 0 0 0-.128-.107c-.025-.077-.063-.155.023-.223l.005-.006c.028-.045.07-.079.1-.124l-.005.007c.075-.056.054-.162.116-.225l-.001.003c.061-.093.149-.161.217-.248l-.016.028a.228.228 0 0 0 .124-.153c-.005-.034.007-.059.038-.075a.672.672 0 0 1 .083-.115l-.004.006a.317.317 0 0 0 .102-.119.245.245 0 0 0 .114-.113.245.245 0 0 0 .114-.115c.069-.052.06-.151.118-.21l-.001.003c.06-.097.157-.162.213-.261a.063.063 0 0 1 .03-.073c.05-.06.02-.16.1-.205l.008-.008c.041-.071.141-.061.188-.124a.246.246 0 0 0 .128-.13l-.024.016c.195-.228.485-.339.684-.562l-.008.014a.26.26 0 0 0 .117-.124c.07-.047.057-.151.126-.199l.003-.005c.031-.042.071-.077.095-.125.047-.023.083-.062.121-.097h.001c.035-.04.069-.037.101.003l.006.002c.04.032.077.029.112-.007.038-.036.075-.071.106-.113l.005-.006-.005.006c.08-.138.246-.177.339-.299a.088.088 0 0 1 .096-.036c.068-.06.193-.033.226-.148-.006-.033.007-.058.037-.073a.78.78 0 0 1 .08-.111c.101-.143.073-.29.016-.438l-.016-.315a3.338 3.338 0 0 1-.08-.126c-.031-.016-.043-.041-.039-.075a1.166 1.166 0 0 0-.237-.254l.025.02c-.04-.095-.161-.067-.213-.142l-.004-.003c-.045-.034-.082-.079-.135-.101l.016.017c-.08-.079-.155-.163-.243-.233l.028.018c-.049-.098-.167-.073-.237-.133a.105.105 0 0 1-.098-.016c-.067-.059-.167-.038-.235-.095a.102.102 0 0 1-.1-.025c-.079-.042-.172-.04-.253-.079-.03.013-.057.007-.078-.018-.064-.059-.155-.05-.227-.09-.045-.08-.159-.054-.205-.131l-.008-.007c-.047-.025-.08-.068-.124-.097l.007.005c-.067-.079-.173-.063-.254-.106h-.265c-.081.043-.186.028-.254.103l.003-.001c-.063.062-.171.042-.223.124-.071.039-.159.032-.225.085l-.208.016a3.044 3.044 0 0 1-1.225-.005l.006-.114c.025-.041.062-.073.081-.118.076-.051.061-.156.122-.217l-.001.003a.805.805 0 0 0 .113-.113l-.002.001a.532.532 0 0 0 .224-.224l-.001.003a.384.384 0 0 0 .094-.111.222.222 0 0 0 .12-.15c-.005-.034.007-.059.038-.074a.151.151 0 0 1 .083-.08.087.087 0 0 1 .089-.035c.096-.047.072-.162.131-.23-.013-.109-.025-.217.026-.321.042-.079.04-.172.079-.252-.013-.031-.006-.057.019-.078l.103-.114-.003.001c.063-.062.168-.041.225-.115l-.007.005c.045-.03.08-.071.122-.104l.003-.003c.034-.039.07-.076.107-.111v-.001c.037-.04.078-.076.102-.126.069-.053.058-.153.116-.212l-.001.003c.112-.077.002-.24.123-.313l.009-.014a.282.282 0 0 1 .099-.104l.008-.007c.042-.068.136-.06.185-.117.095-.05.072-.166.13-.236a.106.106 0 0 1 .016-.097c.03-.041.072-.073.087-.124a.322.322 0 0 0 .122-.104l-.007.005c.044-.029.078-.072.123-.099l.007-.007a.27.27 0 0 1 .097-.09l.14-.14a.95.95 0 0 1 .084-.116l-.004.007c.074-.056.053-.162.115-.225l-.001.003c.071-.051.042-.161.122-.207l.008-.008c.088-.1.215-.143.318-.222l.032-.023.04.004a.262.262 0 0 0 .15-.102l-.003.001c.062-.062.161-.041.225-.098l.184-.022c.06-.012.104-.05.149-.087l.033-.025.042.002c.057-.012.099-.05.146-.08l.046-.026h.053c.067-.056.163-.039.233-.088.018-.027.042-.038.074-.03a.227.227 0 0 0 .149-.116c.041-.019.071-.053.111-.073l.21-.026c.068-.058.174-.036.235-.109l-.003.001c.063-.06.156-.042.224-.091.02-.028.046-.038.08-.029.081-.043.186-.028.254-.103l-.003.001c.063-.063.171-.042.223-.124.071-.039.159-.032.224-.085l.209-.016c.061-.051.154-.044.211-.103l.003-.003c.008-.009.017-.015.023-.026v.003c.063-.063.059-.158.098-.232.01-.062.048-.087.108-.083.061-.052.154-.044.211-.103l.003-.003c.008-.009.018-.014.023-.026v.003c.063-.063.059-.158.099-.232-.009-.033 0-.06.029-.08.024-.042.063-.073.081-.119.076-.049.058-.155.125-.21v-.001c.035-.025.039-.061.013-.102zm-22.56 18.864a1.774 1.774 0 0 0-.221.503l-.015.067c-.075.188-.104.42-.235.551-.155.155-.118.646-.581.389-.081-.045-.189.147-.252.256-.145.253-.31.292-.591.171-.708-.304-.703-.286-.664-1.07a.72.72 0 0 1 .235-.525.348.348 0 0 0 .082-.225 1.665 1.665 0 0 1-.008-.122c.006-.04.015-.08.025-.119.007-.04.016-.079.025-.118a.571.571 0 0 1 .058-.106c.053-.06.118-.117.039-.202-.107-.394.053-.678.482-.746a5.275 5.275 0 0 1 1.044-.038c.278.012.676.555.648.845-.013.165-.046.327-.071.489zm-.204-3.201c-.406-.008-.805.052-1.206.11-.346.05-.405-.031-.344-.35.096-.503.219-1.004.278-1.512.038-.327.191-.385.473-.378.328.008.604.149.88.29.184.093.21.302.229.477.033.309-.009.625.069.931-.013.243-.084.438-.379.432zm12.064 1.333c.118-.339.235-.427.57-.322.296.093.588.219.857.374.187.108.47-.034.58.239.118.292.216.587.147.905 0 .042.002.079 0 .115-.058.987-.563 1.246-1.521.917-.485-.167-.643-.363-.658-.869-.014-.456-.133-.906.025-1.359zm2.544 6.759c-.334.685-.878 1.205-1.361 1.774-.165.195-.33.391-.507.575-.17.177-.307.097-.364-.102a10.981 10.981 0 0 1-.26-1.067c-.118-.647-.369-1.28-.222-1.96-.004-.328-.027-.656.042-.986.041-.193.018-.404-.004-.604-.042-.376.009-.444.38-.45.71-.012 1.42-.025 2.13-.042.361-.008.527.165.624.56.209.846-.102 1.574-.458 2.302zm.091-13.495c.188-.119.393-.07.576.049.187.122.092.282.072.445-.081.659-.283 1.207-.9 1.599-.395.251-.746.594-1.137.87-.116.082-.219.234-.383.149-.19-.099-.167-.266-.066-.451-.082-.332-.068-.671.112-.992.105-.189.147-.428.41-.484.079-.017.105-.082.136-.154.229-.529.734-.749 1.18-1.031zM111.96 132.6l.001.003c-.059-.063-.043-.154-.088-.223a.417.417 0 0 1 0-.339c.032-.074.043-.143-.024-.194a.25.25 0 0 0-.134-.133l.017.024c-.067-.088-.158-.154-.22-.247l.004.006a.781.781 0 0 1-.083-.115c-.031-.016-.043-.041-.038-.075a.224.224 0 0 0-.117-.148.251.251 0 0 0-.109-.105c-.052-.069-.152-.06-.21-.118l.003.001a.343.343 0 0 0-.119-.099.244.244 0 0 0-.118-.117c-.052-.07-.151-.06-.21-.118l.002.001a.405.405 0 0 0-.119-.103c-.024-.048-.063-.083-.097-.124l-.002-.003c-.042-.034-.077-.075-.122-.105l.007.006c-.056-.075-.162-.054-.225-.116l.003.001c-.054-.071-.162-.045-.214-.118l-.004-.003c-.04-.03-.074-.066-.118-.089a.223.223 0 0 0-.147-.114c-.031.008-.056-.002-.073-.03-.038-.021-.068-.053-.106-.074-.094-.13-.259-.039-.369-.119-.034.009-.06 0-.081-.029-.076-.047-.171-.04-.248-.083l-.048.002c-.137.055-.321.041-.355.245-.003.211.045.423-.018.633-.063.073-.05.174-.093.255l-.022.189c-.095.147 0 .329-.088.477l.099.208c.063.052.054.136.091.199a.513.513 0 0 1 .032.302c.067.113.017.25.079.364l.032.188c.012.057.05.099.079.146l.023.106c.01 0 .02.013.028.038.008.024-.004.046-.037.067l-.005.01c-.042.08-.063.156.028.205.008.055.053.089.083.131v.113a.332.332 0 0 0-.005.33l.022.317c.063.119.077.238-.004.355l.001-.002a.266.266 0 0 0-.103.149.072.072 0 0 1-.011.071c-.043.036-.05.077-.021.125.157.073.233.18.143.353l-.007.174c.021.03.036.063.045.097a.595.595 0 0 0 .055.091l.009.052.008.185c.027.126.115.199.225.251.073-.011.144-.013.207.035.06.051.056.14.116.19l-.001-.003c.054.1.128.177.234.221a.096.096 0 0 1 .1.033c.043.024.085.049.126.077l.049-.003.044.02c.152.051.305.099.445-.03l-.022.019a.301.301 0 0 0 .121-.124.248.248 0 0 0 .102-.101.222.222 0 0 0 .117-.148c-.012-.028-.005-.052.019-.071.033-.038.069-.073.088-.12.079-.05.064-.156.125-.216l-.001.003a.343.343 0 0 0 .101-.123c.051-.015.083-.058.124-.088l.043-.02.048.004a.29.29 0 0 0 .126-.126l.016-.203c.085-.101.006-.247.095-.347a.103.103 0 0 1 .026-.099c.044-.068.029-.161.088-.224l-.001.003c.111-.083.009-.243.118-.328l.002-.002c.054-.071.179-.047.206-.154l.032-.184c.044-.069.029-.161.088-.224l-.001.003c.066-.059.061-.149.098-.221.129-.085.027-.251.123-.348v-.192c-.057-.069-.035-.175-.108-.236zM107.733 153.173c-.071-.112-.009-.256-.089-.366a.096.096 0 0 1-.016-.092c-.025-.049-.065-.088-.094-.135l-.006-.007c-.072-.044-.056-.147-.125-.194-.021-.052-.063-.088-.098-.13l-.002-.003c-.042-.033-.077-.075-.122-.105l.007.005c-.066-.079-.173-.063-.254-.106-.03.013-.057.006-.078-.019-.066-.063-.168-.041-.236-.099a.1.1 0 0 1-.099-.025c-.066-.045-.16-.025-.218-.092h-.001c-.065-.067-.168-.046-.237-.104l-.396.007a.185.185 0 0 1-.177 0c-.176.004-.354.031-.526-.033-.258-.048-.516-.066-.772.01l-.431.016c-.252.129-.538-.025-.791.095a.108.108 0 0 1-.098.016c-.068.056-.164.039-.234.088a.069.069 0 0 1-.08.029c-.081.041-.179.031-.254.088l-.189.022c-.374.121-.77-.034-1.143.089l-.411.022c-.113.067-.25.017-.365.079l-.21.025c-.229.079-.458.08-.688 0-.103-.134 0-.309-.087-.446-.028-.018-.037-.042-.028-.074a.282.282 0 0 0-.113-.154l.01.015a.3.3 0 0 0-.12-.109.253.253 0 0 0-.118-.117c-.05-.067-.15-.057-.203-.121h-.001a.487.487 0 0 1-.091-.107l-.023-.106c-.098-.094-.008-.244-.102-.339-.025-.02-.031-.045-.018-.074-.012-.058-.05-.101-.083-.146a.069.069 0 0 1-.029-.08c-.07-.112-.008-.256-.088-.366l-.016-.208c-.117-.175.015-.392-.095-.568l-.023-.189c-.039-.081-.035-.175-.082-.253-.028-.019-.037-.044-.028-.076-.012-.057-.05-.099-.08-.146a.098.098 0 0 1-.026-.099c-.046-.077-.078-.154.011-.225l.007-.008c.032-.05.074-.094.089-.153l-.005-.035c-.041-.127-.077-.254.009-.378l-.002.005c.114-.09.019-.249.113-.346a.103.103 0 0 1 .016-.097c.029-.04.07-.072.086-.12.08-.054.064-.16.12-.227a.096.096 0 0 1 .033-.1c.024-.043.049-.085.077-.126l.025-.202c.072-.088.147-.075.225-.009.146.019.322-.092.427.101.027.041.055.083.08.125l.214.104c.051-.023.102-.029.152-.001.022.048.062.084.097.123.024.019.031.042.019.071.056.099.154.165.213.261l-.001-.003c.063.063.042.172.122.226l-.016-.013c.055.08.164.06.229.123l-.002-.001c.034.037.067.075.099.114l-.01.115c-.047.148-.06.294.01.439.021.03.027.063.016.098.089.1.01.246.095.347l.016.319c.057.07.04.17.097.24l.005.009c.042.03.081.063.117.099h-.001c.056.068.162.042.215.116l.004.003c.223.071.445.09.665-.013a.85.85 0 0 1 .11-.079.067.067 0 0 1 .075-.038.25.25 0 0 0 .149-.105l-.007.006a.589.589 0 0 0 .12-.119l-.006.007a.545.545 0 0 0 .115-.115l-.006.004a.614.614 0 0 1 .116-.08.098.098 0 0 1 .1-.034c.125-.111.314.011.438-.104l-.007-.001c.095-.049.08-.158.126-.233.075-.074.142-.157.232-.215l-.002.001c.084-.104.271.014.326-.151l.021-.292c.03-.039.067-.074.084-.123a.336.336 0 0 0 .125-.102l-.003.001c.131-.115.317.01.448-.104.183-.196.023-.464.14-.674a.219.219 0 0 1 .087-.096l.008-.007c.073-.071.161-.129.195-.232a.268.268 0 0 0 .116-.124c.068-.046.055-.149.127-.193l.007-.008a.503.503 0 0 1 .1-.111l.002-.003c.051-.057.047-.145.107-.197l.127-.14c.034-.045.071-.089.084-.147-.006-.035.006-.061.037-.077.025-.042.052-.085.079-.126l.026-.205c.029-.109.136-.158.191-.247l-.017.028c.098-.049.073-.167.133-.238a.103.103 0 0 1 .016-.097c.027-.038.065-.068.083-.111.124-.093.038-.257.117-.366v-.155a.185.185 0 0 1 0-.177c-.009-.034 0-.061.029-.082.049-.11.058-.22-.007-.328l.01-.116a1.34 1.34 0 0 0 0-.66.1.1 0 0 1-.026-.1c-.056-.068-.039-.164-.088-.234-.029-.02-.039-.047-.029-.081-.039-.08-.037-.173-.079-.252a.521.521 0 0 1-.032-.302c-.039-.081-.036-.174-.079-.253a.099.099 0 0 1-.026-.099c-.058-.068-.035-.176-.113-.235l.005.007c-.029-.044-.072-.078-.1-.124l-.006-.006a.222.222 0 0 1-.086-.098.09.09 0 0 1-.033-.094.395.395 0 0 0-.11-.127.365.365 0 0 0-.117-.104c-.024-.048-.063-.083-.097-.124l-.002-.003a.597.597 0 0 1-.103-.11l-.006-.007a.262.262 0 0 1-.09-.097l-.139-.139a.274.274 0 0 1-.098-.09l-.006-.007c-.045-.027-.079-.07-.123-.099l.007.005a.242.242 0 0 0-.149-.105.062.062 0 0 1-.073-.029c-.039-.023-.07-.057-.111-.077a.228.228 0 0 0-.148-.116c-.032.008-.056-.002-.073-.029-.046-.033-.09-.07-.147-.083-.032.009-.057-.001-.075-.029-.046-.032-.089-.07-.146-.083-.029.013-.054.007-.074-.018-.073-.063-.174-.051-.255-.093-.033.009-.06 0-.079-.029-.046-.032-.089-.07-.146-.083-.029.013-.054.007-.074-.018-.073-.063-.174-.05-.255-.092-.03.012-.057.006-.078-.019-.065-.064-.167-.041-.236-.099a.098.098 0 0 1-.099-.026c-.079-.042-.172-.04-.253-.079l-.191-.033c-.105-.067-.244.001-.344-.085l-.21-.026c-.063-.046-.159-.019-.208-.096l-.008-.007a.227.227 0 0 1-.089-.095c-.031-.016-.043-.042-.037-.076a.335.335 0 0 0-.096-.151l-.002-.003a.597.597 0 0 1-.103-.11l-.007-.006a.25.25 0 0 1-.088-.097c-.031-.016-.043-.041-.038-.075a.223.223 0 0 0-.117-.147.252.252 0 0 0-.104-.103.243.243 0 0 0-.116-.112c-.016-.049-.055-.083-.087-.122l.012-.115c.044-.186.073-.371-.019-.552-.024-.024-.028-.051-.012-.082-.121-.296.029-.62-.09-.917a1.251 1.251 0 0 1 0-.558.521.521 0 0 1 .099-.1l.047-.02.05.004c.136-.109.321.009.458-.1l.036-.023.042.005c.112-.07.256-.009.366-.088a.73.73 0 0 1 .448.01c.072.044.166.03.234.085l.05-.004.047.018c.222.115.476-.017.699.091h.487c.186-.095.398.004.586-.079a.524.524 0 0 1 .303-.032c.081-.039.175-.035.253-.082.018-.028.042-.038.074-.03a.29.29 0 0 0 .15-.094l.127-.118c.024-.038.058-.069.078-.11.125-.086.033-.247.118-.348l-.007.015c.113-.103.083-.216.024-.331-.025-.02-.03-.044-.017-.073a.337.337 0 0 0-.097-.152l-.002-.003a.597.597 0 0 1-.103-.11l-.006-.006a.597.597 0 0 1-.11-.103l-.003-.002c-.04-.033-.075-.071-.121-.095-.062-.081-.168-.069-.248-.112-.03.013-.057.007-.078-.018a.299.299 0 0 0-.149-.092c-.034.004-.058-.009-.071-.041-.074-.042-.048-.147-.118-.192l.007.007a.416.416 0 0 0-.132-.115c-.056.004-.09-.02-.102-.075a.177.177 0 0 0-.141-.141.062.062 0 0 1-.073-.029.926.926 0 0 0-.549-.003.102.102 0 0 1-.1.025c-.068.058-.168.037-.235.096h-.113c-.041-.032-.076-.071-.122-.096-.071-.072-.141-.07-.211.011l.014-.012a.46.46 0 0 0-.122.115l.006-.004a.614.614 0 0 1-.116.08c-.095.06-.199.05-.303.041-.112.067-.25.016-.364.079l-.187.032c-.057.012-.1.05-.146.079a.101.101 0 0 1-.099.026c-.11.059-.22.088-.328-.005l-.032-.188c-.041-.081-.031-.179-.088-.254l.01-.115c.04-.077.045-.151-.021-.218a.295.295 0 0 0-.149-.101c-.029.013-.053.007-.073-.018-.037-.032-.071-.066-.117-.085-.052-.085-.162-.067-.23-.125a.098.098 0 0 1-.099-.026c-.069-.044-.161-.028-.224-.088l.003.001c-.068-.075-.173-.06-.254-.103-.034.009-.06-.001-.08-.029-.046-.032-.089-.07-.146-.083l-.186-.022c-.213-.116-.464.031-.676-.096l-.641.001c-.068.056-.163.04-.234.089-.017.027-.042.037-.074.03a.256.256 0 0 0-.149.102l.003-.001c-.061.059-.16.048-.217.113-.079.065-.065.171-.108.252l-.006.396c.113.176-.005.387.086.566.028.024.037.055.028.09.061.093.046.186.003.279.007.036-.005.063-.037.082a.262.262 0 0 1-.089.098l-.006.006a.364.364 0 0 1-.105.102l-.008.007c-.048.078-.157.049-.209.12l.003-.001c-.063.062-.163.04-.226.102-.022.025-.048.031-.078.019-.081.042-.182.029-.255.092-.022.025-.048.031-.079.019-.112.071-.256.009-.365.088a.108.108 0 0 1-.098.016c-.068.055-.162.041-.233.085a.1.1 0 0 1-.099.025c-.068.056-.162.041-.234.085l-.19.032c-.186.099-.403-.015-.588.088a.108.108 0 0 1-.098.016c-.068.055-.162.041-.234.085l-.191.032c-.081.043-.186.028-.254.103l.003-.001c-.063.06-.155.044-.224.088a.101.101 0 0 1-.099.026c-.068.059-.17.036-.236.099-.021.025-.047.031-.078.019-.081.042-.182.029-.255.093-.02.024-.045.03-.074.018-.056.012-.099.05-.146.08a.102.102 0 0 1-.1.025c-.188.068-.376.095-.563-.009l-.005-.003c-.109-.085-.256-.021-.369-.092-.034.009-.061-.001-.08-.03-.078-.043-.151-.048-.218.021l.003-.001c-.064.061-.163.044-.229.102l-.005.003c-.04.042-.084.046-.132.014a.069.069 0 0 1-.084-.017c-.058-.063-.162-.034-.214-.108l-.004-.003c-.046-.039-.091-.08-.152-.094-.029.013-.053.007-.073-.017a.302.302 0 0 0-.15-.092c-.032.008-.057-.002-.074-.03-.07-.049-.166-.032-.233-.088-.109.012-.218.025-.322-.026-.188-.083-.4.015-.587-.079a56.572 56.572 0 0 1-.411-.023.824.824 0 0 0-.55-.006.065.065 0 0 1-.074.03.227.227 0 0 0-.149.116c-.041.019-.072.053-.111.074l-.113.016c-.062-.07-.075-.14.005-.206l.007-.008a.365.365 0 0 1 .102-.105l.006-.006a.597.597 0 0 1 .103-.11l.002-.003c.033-.04.072-.075.096-.122a.252.252 0 0 0 .11-.116.284.284 0 0 0 .112-.097.507.507 0 0 0 .119-.121.233.233 0 0 0 .102-.141c-.006-.034.007-.059.038-.074a.146.146 0 0 1 .082-.08.09.09 0 0 1 .092-.035.35.35 0 0 0 .135-.118l-.015.011a.323.323 0 0 0 .102-.106c.133-.087.037-.256.125-.359a.081.081 0 0 1 .017-.088c.062-.066.04-.167.097-.235l.026-.21c.044-.068.029-.161.088-.224l-.001.003c.075-.068.06-.173.103-.254-.012-.031-.006-.057.019-.079.063-.058.034-.162.108-.214l.003-.004c.062-.113.08-.223-.011-.33-.029-.042-.07-.076-.097-.12l-.006-.006a.396.396 0 0 1-.103-.105l-.007-.008c-.078-.049-.051-.154-.112-.211l-.002-.003c-.042-.037-.083-.074-.133-.101a.095.095 0 0 1-.094-.026c-.105-.067-.244 0-.344-.085a.107.107 0 0 1-.098-.016c-.075-.057-.174-.047-.254-.088-.031.013-.057.006-.079-.019-.109-.069-.22-.064-.331-.004a.267.267 0 0 1-.226-.01c-.079-.042-.173-.04-.253-.079l-.038-.002a.259.259 0 0 0-.154.119l.024-.014a.276.276 0 0 0-.126.122c-.072.04-.165.03-.227.094l-.111-.026c-.082-.042-.156-.036-.22.036l-.023.106c-.046.064-.022.16-.094.213l-.002.004c-.039.046-.08.091-.094.152.009.032 0 .057-.028.075-.022.039-.057.07-.077.111a.227.227 0 0 0-.116.149c.008.031-.002.055-.029.072-.024.041-.061.072-.08.116-.081.055-.063.162-.12.229a.1.1 0 0 1-.025.099c-.03.047-.067.09-.08.146.013.029.007.054-.018.074a.297.297 0 0 0-.092.15c.011.029.005.053-.02.072-.062.063-.04.163-.102.226l.001-.003a.265.265 0 0 0-.103.15c.005.034-.007.059-.038.075a2.06 2.06 0 0 1-.08.126.094.094 0 0 1-.026.094c-.03.047-.067.09-.08.146.008.138.026.276-.032.409-.044.068-.029.161-.088.224l.001-.003c-.109.093-.017.249-.11.347.013.109.026.218-.026.321-.067.105 0 .244-.085.345l-.026.21c-.063.113-.012.251-.079.364l-.02.189c-.084.108-.02.254-.091.366.009.034 0 .06-.029.08-.037.103-.123.161-.204.224l.003-.001c-.061.061-.167.045-.218.123-.044.018-.075.056-.117.077a.094.094 0 0 1-.094.026 1.632 1.632 0 0 1-.126.077.1.1 0 0 1-.101.034c-.068.058-.174.036-.236.109l.003-.001c-.063.062-.167.042-.225.113l.003-.001c-.063.062-.167.042-.225.113l.003-.001c-.063.062-.171.042-.223.124-.072.039-.165.032-.225.1l.003-.001c-.063.059-.155.043-.224.088a.1.1 0 0 1-.099.025c-.068.056-.162.041-.234.085a.102.102 0 0 1-.1.026c-.067.056-.163.039-.233.088-.02.028-.046.038-.08.029-.082.042-.187.028-.255.103l.003-.001c-.063.06-.155.044-.223.088l-.191.033c-.081.038-.174.036-.253.079a.1.1 0 0 1-.099.025c-.2.087-.402.065-.604.007-.031.013-.057.006-.079-.019a.7.7 0 0 0-.555.002l-.002.003a.327.327 0 0 0-.096.151c.013.028.007.053-.018.073-.052.075-.06.144.012.203.022.052.066.088.099.132l.003.005c.069.049.054.151.123.201.023.049.064.086.099.127l.002.003a.597.597 0 0 1 .103.11l.006.007a.365.365 0 0 1 .102.105l.007.008c.099.123.197.247.343.319l-.003-.001c.04.049.085.089.15.103l.04-.004.032.023c.066.063.168.041.236.099l.053-.001.046.026c.047.03.089.067.146.08.035-.006.061.006.077.037a.79.79 0 0 1 .116.083l-.007-.004c.05.074.161.045.208.124l.008.007c.047.025.08.068.124.097l-.006-.005a.33.33 0 0 0 .11.097c.079.13.249.028.338.129l.218.023c.258.048.516.066.773-.01l.208-.016c.069-.058.174-.036.236-.109l-.003.001c.063-.06.155-.044.223-.088l.113.01c.095.104.063.21.006.317a.11.11 0 0 1-.014.098c-.089.1-.008.247-.098.347l-.026.21c-.081.142.018.318-.085.456l-.016.32c-.085.101-.007.247-.096.347l-.025.21c-.063.114-.012.251-.079.364.009.034 0 .061-.029.081-.067.112-.014.251-.082.364.008.139.025.279-.032.414-.063.113-.012.251-.079.364.008.139.026.279-.032.413-.067.105 0 .244-.085.345l-.016.32c-.11.176.022.393-.095.568l-.016.32c-.096.146 0 .329-.089.476.005.176.032.353-.032.525-.102.293.042.609-.085.9l-.013.319c-.109.184.01.403-.091.588.008.139.026.279-.032.413-.075.15.005.326-.079.475.002.212.036.426-.032.635-.106.636.042 1.283-.079 1.918l-.022.301c-.084.101-.006.247-.095.346.028.146.045.292-.026.433-.065.109-.005.247-.082.354a.065.065 0 0 1-.003.073c.047.048.037.097.002.146.002.734.053 1.469-.028 2.203-.067.105 0 .244-.085.345.011.182.039.365-.026.543-.097.3.032.62-.079.919l-.006 1.062c.107.137-.006.319.095.458l.016.208c.089.386.07.772.006 1.159.013.03.007.057-.018.078a.472.472 0 0 0 .002.444l.002.003a.631.631 0 0 1 .103.11l.006.006a.365.365 0 0 1 .102.105l.007.008c.115.079.008.248.13.324l-.014-.016c.057.083.167.06.236.119a.096.096 0 0 1 .1.033.29.29 0 0 1 .103.084l.003.002c.037.031.071.065.113.09.092.126.256.035.362.118l.041-.002a.229.229 0 0 0 .15-.116c.072-.037.161-.033.225-.09l.003-.002c.033-.042.075-.077.105-.122l-.005.007a.35.35 0 0 0 .107-.122c.046-.019.077-.057.119-.081.017-.027.041-.037.072-.029.106-.026.083-.152.156-.204l.003-.004c.06-.069.042-.169.099-.239l.026-.209c.029-.111.143-.162.189-.26l.023-.405a.324.324 0 0 0 .088-.149c-.012-.029-.005-.053.019-.072.063-.073.05-.174.093-.255l.022-.301c.031-.04.07-.074.092-.121.279-.101.104-.392.226-.559a.108.108 0 0 1 .016-.098c.053-.071.052-.144.007-.218-.029-.02-.038-.047-.029-.081a.302.302 0 0 1 0-.289c-.013-.031-.007-.057.019-.079.091-.099.009-.248.099-.347l.016-.32a.19.19 0 0 0 .041-.13c-.023-.073-.058-.126-.146-.076l-.022-.017c-.03.043-.071.077-.094.125-.074.052-.06.155-.119.215l.001-.003a.4.4 0 0 0-.094.111.224.224 0 0 0-.12.15c.002.035-.013.059-.047.07-.107.102-.221.047-.334.014-.036.006-.062-.007-.079-.038a.166.166 0 0 1-.082-.083c-.032-.018-.044-.044-.037-.081-.072-.111-.006-.258-.093-.366-.025-.021-.031-.045-.018-.074-.012-.057-.05-.099-.08-.146a.1.1 0 0 1-.025-.099.336.336 0 0 1 0-.363.106.106 0 0 1 0-.082c-.089-.1-.01-.246-.095-.346-.052-.247-.027-.496-.022-.745-.041-.081-.031-.18-.088-.255a1.712 1.712 0 0 1 0-.669.316.316 0 0 0 0-.33l-.023-.299c-.053-.166-.079-.331.007-.494a.098.098 0 0 1 .026-.099c.045-.072.03-.166.085-.234a.107.107 0 0 1 .016-.098c.126-.404-.04-.831.095-1.234l.025-.21c.045-.072.03-.166.085-.234l.016-.431c.085-.101.006-.247.095-.346-.014-.218-.033-.437.016-.653.08-.11.018-.254.089-.366 0-.286-.039-.574.032-.857.044-.069.029-.161.088-.224l-.001.003c.075-.069.061-.173.103-.255-.009-.034.001-.061.03-.08.115-.442-.047-.903.088-1.344-.014-.218-.033-.436.016-.653.122-.248-.036-.531.097-.777.127-.13-.003-.323.109-.457l.016-.209c.122-.206-.041-.456.104-.658l.003-.005c.061-.075.051-.176.093-.258-.009-.034 0-.061.029-.081.067-.112.014-.251.082-.363l.032-.191c.067-.105 0-.244.085-.345-.014-.218-.033-.436.016-.653.089-.091-.005-.24.104-.325l.003-.004c.039-.046.08-.091.094-.153-.013-.029-.007-.053.018-.073.092-.099.009-.248.099-.347a.1.1 0 0 1 .026-.1c.075-.15-.005-.326.079-.475-.013-.03-.007-.056.018-.078.076-.112.145-.229.21-.347a.103.103 0 0 1 .016-.097c.059-.068.038-.167.095-.236-.014-.218-.033-.436.016-.652.03-.04.068-.073.088-.12.048-.023.084-.063.126-.095l.004-.003c.052-.073.161-.047.213-.121l-.007.004a.79.79 0 0 1 .116-.083c.018-.032.045-.044.082-.038.08-.039.173-.036.252-.079a.096.096 0 0 1 .095-.026 1.37 1.37 0 0 1 .126-.077.1.1 0 0 1 .101-.034c.068-.056.164-.039.234-.088a.07.07 0 0 1 .081-.029c.08-.039.173-.036.253-.079.026-.026.058-.035.095-.026.041-.028.083-.054.125-.08.017-.031.042-.043.078-.037.057-.013.1-.05.146-.083.02-.028.046-.038.08-.029.081-.042.182-.029.255-.093l.036-.023.042.005c.081-.042.182-.029.255-.092l.036-.023.042.005c.081-.044.188-.028.254-.106l-.007.004a.781.781 0 0 1 .115-.083c.017-.031.042-.043.077-.037.058-.013.101-.05.146-.083.018-.028.043-.037.075-.028a.346.346 0 0 0 .151-.097l.003-.002a.498.498 0 0 1 .11-.1l.008-.007c.044-.072.149-.058.194-.128a.312.312 0 0 0 .125-.106l-.007.006a.569.569 0 0 0 .12-.12l-.006.007a.34.34 0 0 0 .106-.12c.047-.023.083-.063.125-.094l.004-.003c.053-.074.16-.047.214-.118l-.002.001c.063-.06.155-.044.223-.088a.096.096 0 0 1 .095-.026c.041-.027.083-.054.125-.079.018-.032.045-.044.082-.038.227-.061.453-.083.677.012.03.015.041.038.033.07a.213.213 0 0 0 .126.145.092.092 0 0 1 .089.027c.111.044.221.056.329-.01h.114c.064.057.162.037.225.098l-.003-.001c.107.103.26.033.377.102h.02c.154-.077.333-.003.487-.08.02-.029.047-.039.08-.029.224-.102.472.01.697-.079l.185-.033a.226.226 0 0 0 .15-.116c.071-.037.159-.03.222-.087l.034-.023.041.005c.057-.012.099-.05.146-.08l.187-.032c.057-.012.099-.05.146-.079a.094.094 0 0 1 .094-.026c.041-.027.083-.054.125-.079a.073.073 0 0 1 .082-.038c.081-.042.182-.029.255-.093l.033-.023.04.005c.058-.012.101-.05.147-.083.02-.028.046-.038.08-.029.081-.043.186-.029.255-.103l-.003.001c.063-.059.154-.044.223-.088l.046-.026h.053c.069-.059.18-.037.234-.122.071-.037.158-.031.223-.084l.047-.02.051.004c.068-.055.162-.041.234-.085l.046-.026h.054c.1-.089.245-.01.346-.095.074-.029.148-.04.224-.006a.584.584 0 0 1 .095.104l.027.19c.069.112.013.253.084.365l.021.32c.113.176-.004.387.085.567l.032.191c.067.112.016.25.079.364a.239.239 0 0 1 0 .229c-.044.111-.056.221.01.329.041.667.061 1.335-.01 2.003-.095.218.034.463-.085.678l-.016.208c-.11.176.022.394-.095.568.013.109.025.218-.026.321-.062.114-.012.251-.079.364l-.032.19c-.046.063-.02.16-.095.209l-.005.006c-.05.076-.152.046-.211.104-.365.052-.731.03-1.097.016-.2.086-.402.065-.604.006l-.634-.022c-.064-.057-.162-.036-.225-.098l.003.001c-.051-.071-.161-.041-.207-.121l-.008-.008c-.009 0-.02-.011-.031-.032-.012-.022-.006-.047.018-.074l-.004.008c.09-.113.102-.224-.008-.332-.02-.039-.053-.07-.072-.109v-.116c.042-.113.061-.225-.016-.332l-.002-.003a.918.918 0 0 1-.108-.108l-.003-.002c-.042-.035-.078-.077-.129-.1-.042-.062-.137-.05-.175-.118a.09.09 0 0 1-.036-.096c-.057-.069-.039-.171-.102-.238l-.002-.003c-.042-.037-.083-.074-.132-.101l-.272.006c-.106.026-.083.152-.156.204l-.003.005c-.055.066-.05.156-.09.229-.08.047-.056.159-.129.21l-.003.005c-.07.11-.064.222-.004.333a.27.27 0 0 1-.01.227c-.044.069-.029.161-.088.224l.001-.003a.266.266 0 0 0-.103.149c.008.032-.002.056-.03.074-.022.04-.058.071-.077.113-.086.062-.072.17-.115.251.008.139.025.279-.032.413-.03.047-.067.089-.08.146a.063.063 0 0 1-.029.076c-.032.046-.07.089-.083.146.009.032 0 .057-.028.076-.049.067-.031.161-.091.224l.001-.003a.266.266 0 0 0-.103.149c.008.032-.002.056-.03.074-.049.067-.031.161-.091.224l.001-.003c-.071.058-.051.162-.112.225l.001-.003c-.075.068-.06.173-.103.254a.069.069 0 0 1-.029.08c-.032.046-.07.089-.083.146.013.029.007.054-.018.074-.063.073-.05.174-.092.255l-.032.191c-.045.072-.03.166-.085.234a.1.1 0 0 1-.025.099c-.043.079-.04.172-.079.252l-.032.191c-.045.072-.03.166-.085.234a.107.107 0 0 1-.016.098c-.057.075-.047.173-.089.254.014.03.008.056-.016.078-.067.072-.052.174-.095.256l-.023.189c-.057.075-.047.174-.088.254.013.03.006.057-.019.079-.063.073-.05.174-.093.254l-.032.191c-.083.139.022.315-.088.449l-.023.106c-.045.072-.03.166-.085.234a.108.108 0 0 1-.016.098c-.08.109-.018.253-.089.365a.52.52 0 0 1-.032.302c-.042.079-.04.172-.079.253l-.022.19c-.101.138.012.321-.095.458l-.016.32c-.125.329.04.685-.095 1.013l-.026.21c-.042.079-.041.172-.079.253l-.022.189c-.08.109-.018.253-.089.365l-.032.191c-.045.072-.03.166-.085.234l.007.618c.038.117.088.234-.012.347a.09.09 0 0 1-.096.025c-.068.055-.162.041-.234.085a.101.101 0 0 1-.099.026c-.098.093-.254.001-.347.109l.003-.001c-.062.062-.163.04-.225.102-.021.025-.048.031-.078.019-.081.042-.182.029-.255.093-.021.025-.047.031-.078.019-.081.041-.179.031-.255.088a.467.467 0 0 1-.337-.01c-.113-.063-.251-.012-.364-.079l-.301-.022c-.081-.052-.156-.059-.22.026l.013-.015c-.08.051-.056.162-.125.219v.001a.596.596 0 0 1-.107.094c-.018.028-.042.037-.074.028a.343.343 0 0 0-.151.097l-.003.002a1.001 1.001 0 0 1-.108.108l-.002.003c-.041.045-.082.09-.096.152l-.001.042c.025.11.107.18.185.252.031.013.044.036.039.069a.177.177 0 0 0 .141.141c.031-.008.055.001.072.029.063.05.16.024.213.097l.004.003c.039.029.072.064.115.088.084.126.25.027.346.123l.21.026c.047.029.09.067.146.079a.063.063 0 0 1 .076.029c.078.047.172.042.253.082l.042-.005.036.023c.136.108.321-.01.458.099l.051-.004.047.021c.107.065.217.054.328.01l.046-.026h.053c.069-.059.181-.036.235-.123.171-.097.385.035.55-.097.042-.029.075-.071.122-.095l.008-.007c.105-.101.216-.066.328-.019a.359.359 0 0 0 .107.119.398.398 0 0 0 .127.111c.107-.012.214-.025.316.026.114.038.226.069.328-.027l-.007.007a.406.406 0 0 0 .115-.132.083.083 0 0 1 .028-.09c.044-.076.146-.044.198-.105l.031-.022.038.005c.222-.13-.002-.39.158-.538l.002-.004c.059-.059.031-.163.111-.21l.008-.008c.045-.081.151-.048.207-.111l.036-.023.042.005c.147-.089.33.007.476-.088l.32-.016c.138-.103.314-.004.456-.085l.191-.033c.081-.042.182-.029.255-.092l.035-.023.042.005c.083-.044.192-.029.254-.116.041-.019.071-.054.111-.074a.53.53 0 0 1 .302-.032c.081-.041.179-.031.254-.088l.209-.016c.068-.055.162-.041.234-.085l.191-.032c.186-.096.399.007.586-.082a.07.07 0 0 1 .081-.029c.082-.042.184-.031.256-.098h.001c.072-.066.144-.07.216.001l.002.002c.107.086.012.238.106.328.025.02.031.045.018.074.012.057.05.101.083.146a.065.065 0 0 1 .03.074c.013.064.053.11.102.149l-.001-.002c.062.063.041.167.112.225l-.001-.003c.113.131-.004.313.098.447.052.247.026.496.022.745.095.186-.004.398.079.586.063.171.037.349.032.524.107.223-.021.476.089.698.04.225.052.448-.01.671-.067.105.001.244-.085.345.013.109.025.217-.026.321-.063.113-.012.251-.079.364a.52.52 0 0 1-.032.302c-.082.142.018.318-.085.456a.103.103 0 0 1-.016.097.551.551 0 0 1-.099.1l-.314.016c-.049.026-.088.065-.135.093l-.008.007c-.047.079-.153.047-.209.11-.021.025-.048.031-.078.019-.128.048-.256.074-.382-.006a.104.104 0 0 1-.081 0c-.175.117-.392-.015-.568.095l-.19.022c-.112.068-.251.015-.364.082-.019.028-.043.037-.075.028-.062.014-.106.055-.152.094l-.004.003c-.053.072-.148.048-.212.094a.1.1 0 0 1-.099.025c-.066.056-.17.042-.225.118a.245.245 0 0 0-.114.115.355.355 0 0 0-.119.099l.003-.001c-.131.115-.318-.009-.45.104l-.003.002a.321.321 0 0 1-.103.087c-.018.032-.044.044-.08.037-.083.046-.205.022-.246.142.008.031-.001.055-.029.072-.05.063-.024.16-.097.212l-.003.005c-.091.096-.005.245-.102.339l.001-.003c-.071.058-.051.162-.112.225l.001-.003c-.108.093-.017.249-.11.347l-.026.21c-.04.075-.043.148.01.218l.022.189c.042.082.031.184.098.256v.001c.067.057.045.153.094.217.029.02.039.046.03.08.043.082.028.186.103.255l-.001-.003c.06.06.046.162.119.215.023.048.063.083.094.125l.003.005c.131.114-.011.314.125.427a.218.218 0 0 0 .141.108l.042.002a.153.153 0 0 1 .167 0l.048-.002.038.029c.041.024.073.061.116.08a.252.252 0 0 0 .115.111.251.251 0 0 0 .115.115c.022.049.06.085.102.119l-.004-.006a.781.781 0 0 1 .083.115c.03.016.043.041.038.074a.177.177 0 0 0 .141.141c.031-.008.055.002.072.029.046.033.09.07.147.083.034-.006.059.007.072.039.061.051.054.138.105.193.024.02.03.045.018.074.013.057.05.101.083.146a.062.062 0 0 1 .029.073.177.177 0 0 0 .141.141c.033-.005.058.007.073.037a.74.74 0 0 1 .116.083l-.006-.004c.033.042.07.08.115.109.027.045.068.08.098.122l.004.004c.037.027.067.06.088.1.032.018.044.045.038.081.046.082.022.205.142.245.033-.006.058.006.073.037a.79.79 0 0 1 .116.083l-.007-.004c.066.079.172.063.254.106l.042-.005.036.023c.063.057.151.05.222.087.062.089.173.072.255.116l.042-.005.036.023c.185.074.37.078.555-.002l.003-.002a.503.503 0 0 1 .111-.1l.008-.007c.048-.079.151-.048.208-.106l.183-.021a.27.27 0 0 0 .154-.113l-.016.01a.303.303 0 0 0 .113-.125c.069-.045.055-.15.128-.193l.005-.01c.103-.131-.022-.315.104-.441l.002-.004c.032-.044.077-.079.103-.128l-.011.015a.247.247 0 0 0 .113-.151c-.008-.032.001-.057.029-.075.087-.141-.016-.318.088-.456a.1.1 0 0 1 .025-.099c.03-.047.067-.09.08-.146l-.001-.039c.019-.235-.104-.471.005-.706a.765.765 0 0 0 .118-.102l.122-.228c.058-.075.048-.174.089-.254-.013-.03-.007-.057.019-.078.033-.038.068-.073.087-.12.079-.05.065-.156.125-.216l-.001.002a.655.655 0 0 0 .107-.11.411.411 0 0 0 .114-.131.095.095 0 0 1 .016-.092c.053-.07.051-.143.01-.218l-.004-.116a.759.759 0 0 1 .094-.11v.001c.068-.058.045-.163.113-.22v-.001c.033-.035.066-.069.088-.112a.227.227 0 0 0 .121-.151l.009-.174c-.01 0-.02-.012-.028-.037-.008-.023.004-.045.038-.065l.006-.012c.024-.049.07-.082.095-.13l-.011.016c.15-.111-.011-.316.131-.43l.008-.01a.417.417 0 0 1 .098-.111l.002-.003c.06-.072.061-.146.006-.222v-.114c.12-.252-.033-.539.095-.791l-.006-.284c-.084-.149-.004-.325-.079-.475-.068-.215-.036-.436-.025-.654-.105-.137.001-.316-.09-.457-.051-.145-.036-.292-.018-.439-.01 0-.019-.014-.029-.042s0-.056.029-.083l-.009-.403c-.089-.148.007-.33-.089-.477l-.022-.189c-.059-.202-.08-.403.006-.604a.098.098 0 0 1 .026-.099c.082-.139-.02-.313.086-.447l-.004.004c.075-.065.069-.14.023-.218l-.021-.32c-.113-.176.004-.387-.085-.567l-.031-.197c-.027-.052-.04-.104.005-.154a.105.105 0 0 1 .016-.098c.047-.058.04-.144.101-.194.083-.098.092-.219.105-.339a.405.405 0 0 0-.111-.129.377.377 0 0 0-.12-.108c-.039-.071-.032-.161-.085-.227-.033-.115-.043-.228.018-.338a.367.367 0 0 1 .083-.109l-.001.001a.593.593 0 0 1 .11-.09c.246-.07.497-.032.746-.032.112-.067.25-.016.364-.079.215-.066.434-.037.652-.027.047-.037.093-.045.139.002.169-.042.34-.023.51-.008.224-.102.472.01.697-.079a3.371 3.371 0 0 1 1.116 0c.047.029.09.067.146.079.035-.006.06.006.077.037.041.024.08.051.116.083l-.007-.004c.066.079.172.063.254.106l.19.022c.214.116.466-.029.679.095l.209.022c.04.026.074.059.103.096l.003.005c.073.052.047.149.097.212.027.017.037.041.029.072a.177.177 0 0 0 .141.141l.167.006c.101-.086.239-.018.344-.085l.046-.026h.053a.334.334 0 0 1 .362 0l.277-.006c.107-.027.083-.152.155-.206l.002-.002c.209-.09.122-.317.212-.461l-.005-.179c-.027-.052-.04-.104.005-.154a1.914 1.914 0 0 0-.001-.169zm-8.414-10.327c.098-.581.301-1.136.368-1.728.032-.287.399-.366.628-.483.637-.325.671-.304 1.423-.126.054.013.107.051.158.046.55-.049.821.338 1.145.684.349.372.458.783.391 1.181.008.549-.048 1.006-.189 1.449-.166.52-.481.708-1.015.589a1.669 1.669 0 0 0-.693.004c-.455.08-.963.125-1.317-.282a5.308 5.308 0 0 0-.635-.612c-.246-.202-.316-.416-.264-.722zm-2.571 2.02c-.068.268-.159.533-.196.806-.116.858-.652 1.364-1.392 1.702-.401.183-.481.354-.35.76.105.327.372.547.517.846.217.446.458.88.67 1.328.223.471.364.958.254 1.492a2.084 2.084 0 0 0-.043.658c.031.266-.074.371-.315.403-1.246.167-2.433.586-3.651.868-.107.025-.218.039-.325.065-.276.067-.382-.012-.413-.321-.073-.731-.296-1.447-.191-2.177-.097-.567.074-1.104.074-1.652 0-.138.034-.282.125-.416.347-.505.576-1.067.74-1.655.125-.447.335-.852.608-1.223a.791.791 0 0 0 .145-.346c.051-.271.132-.539.309-.761.11-.138.111-.307.152-.467.063-.25.122-.506.229-.738.28-.605.481-.735 1.124-.43.534.253 1.078.454 1.628.656.413.152.411.168.301.602zm-.252 18.247c-.082.135-.006.367-.217.456-.037.016-.123-.007-.142-.039-.112-.188.046-.345.081-.517.014-.068.095-.107.179-.083s.111.083.099.183zM44.275 136.286l.139.139a.178.178 0 0 0 .083.082c.016.03.041.042.074.038.071.017.12.06.153.123l-.026-.026a.233.233 0 0 1 .124.153c-.005.034.009.057.04.071.043.071.161.054.182.152l.022.293c.032.044.081.077.092.136l-.015-.031c.161.122.011.331.129.464v.192c-.071.088-.044.179-.006.27l-.001.371a.302.302 0 0 1-.092.15c-.025.021-.031.048-.018.078-.043.082-.029.186-.104.254l.001-.003c-.063.064-.042.18-.136.226l.024-.026a.248.248 0 0 1-.134.134l.025-.024c-.046.094-.162.072-.226.136l.003-.001a.394.394 0 0 1-.13.11l.018-.017c-.025.054-.069.092-.11.132l.001-.001c-.104.1-.255.027-.366.101h-.147a.177.177 0 0 1-.141-.141c.005-.034-.007-.058-.037-.073a.157.157 0 0 0-.082-.082c-.016-.031-.041-.043-.074-.038a.263.263 0 0 1-.15-.103l.003.001c-.064-.064-.18-.042-.226-.136l.026.025a.253.253 0 0 1-.135-.134l.024.022a.258.258 0 0 1-.135-.127l.019.017c-.054-.023-.09-.068-.134-.104l-.003-.002c-.033-.042-.075-.077-.105-.122l.005.007c-.077-.06-.054-.167-.112-.235a.1.1 0 0 0-.026-.099c-.044-.066-.025-.16-.091-.218-.037-.041-.08-.077-.108-.125l.012.013c-.08-.051-.056-.162-.125-.219v-.001a.306.306 0 0 1-.098-.151c.008-.032-.001-.057-.029-.075-.046-.078-.042-.172-.082-.252.013-.031.006-.057-.019-.079-.063-.055-.03-.161-.11-.207l-.008-.008c-.044-.081-.175-.05-.2-.156l-.002.03.03.001c-.07-.016-.111-.065-.145-.124l.02.014c-.052-.014-.083-.062-.13-.084l-.206-.026a2.375 2.375 0 0 0-.125-.079.067.067 0 0 0-.075-.038c-.122-.049-.102-.126-.04-.21l-.001.001a.816.816 0 0 0 .094-.11l-.011-.117a.614.614 0 0 0-.08-.116l.004.006c-.074-.052-.048-.161-.121-.213l-.003-.004c-.034-.045-.079-.082-.101-.135l.017.016c-.08-.083-.169-.157-.23-.256l-.148-.187a.869.869 0 0 0-.084-.115l.004.006a.242.242 0 0 1-.105-.149.067.067 0 0 0-.038-.075.328.328 0 0 0-.087-.102l-.002-.003c-.036-.044-.081-.081-.104-.135l.018.021c-.089-.049-.067-.162-.13-.225l.001.003c-.044-.039-.09-.077-.108-.136l.021.021c-.06-.019-.098-.065-.136-.112l.007.005c-.044-.029-.077-.072-.124-.097l-.008-.007c-.048-.079-.173-.051-.206-.149l-.002.029.029.001c-.102-.042-.078-.161-.138-.229l.003.007c-.08-.066-.064-.173-.107-.255.007-.033-.005-.058-.036-.072-.104-.071-.208.082-.311 0l-.003-.002c-.037-.042-.074-.083-.101-.133a.096.096 0 0 0-.016-.092c-.048-.19-.11-.38.034-.559l-.021.031a.253.253 0 0 1 .134-.135l-.029.023c.077-.14.251-.032.343-.135l.181.01a.717.717 0 0 0 .512 0l.261-.001c.057.012.099.05.146.08l.21.026c.097.093.255 0 .346.112l-.007-.005c.044.029.077.072.124.098l.006.006c.048.078.173.049.207.147l-.025-.022c.06.012.097.058.14.095.019.024.043.03.072.019a.23.23 0 0 1 .151.119l-.022-.017c.054.022.09.067.135.101l.004.003c.052.074.169.047.213.136l-.02-.018c.054.022.09.067.135.101l.005.003c.052.075.173.048.213.142l-.022-.029a.233.233 0 0 1 .124.153c-.005.034.007.059.038.075a.245.245 0 0 0 .089.097l.006.006c.03.041.064.078.103.11l.002.003c.037.043.081.081.104.134l-.017-.017a.343.343 0 0 1 .129.113l-.007-.006a.569.569 0 0 1 .12.12l-.006-.007a.545.545 0 0 1 .115.115l-.007-.006a.644.644 0 0 1 .12.119l-.006-.006c.047.037.092.075.112.135l-.021-.021c.06.02.098.065.135.112l-.006-.005c.044.03.078.072.124.1l.006.006a.396.396 0 0 0 .104.104l.006.006a.538.538 0 0 0 .103.11l.002.003c.062.058.035.162.113.211l.007.008a.844.844 0 0 0 .098.117v-.001a.298.298 0 0 1 .101.15c-.006.034.006.06.037.076.021.04.051.073.089.097l.006.006a.411.411 0 0 0 .104.104l.006.006a.262.262 0 0 0 .099.094z\"/><path d=\"M67.028 153.315c-.014-.053-.058-.085-.089-.127l-.019-.199c-.053-.076-.027-.199-.144-.235-.033.005-.056-.008-.069-.039-.074-.043-.05-.159-.14-.19l.03.02a.229.229 0 0 0-.153-.123c-.034.005-.058-.007-.074-.038a.321.321 0 0 1-.103-.087l-.003-.002a.332.332 0 0 0-.152-.097c-.032.009-.056 0-.074-.028-.041-.024-.073-.062-.118-.081-.052-.077-.157-.061-.217-.122l.003.001a.4.4 0 0 0-.111-.094.224.224 0 0 0-.15-.12c-.032.007-.056-.002-.073-.03-.046-.033-.089-.07-.147-.083l-.187-.031c-.072-.045-.166-.03-.234-.085a.1.1 0 0 1-.099-.026c-.072-.045-.166-.03-.233-.085a.108.108 0 0 1-.098-.016c-.075-.057-.173-.047-.254-.088l-.191-.033c-.072-.044-.166-.03-.233-.085l-.21-.026c-.045-.022-.076-.067-.126-.08a.463.463 0 0 1 .006-.377.069.069 0 0 1 .029-.08c.033-.046.07-.089.083-.146v-.479c-.013-.058-.05-.101-.083-.146a.07.07 0 0 1-.029-.081.305.305 0 0 1 0-.289c-.013-.031-.006-.057.019-.079.063-.059.034-.162.108-.214l.003-.004c.031-.042.071-.078.094-.125a.396.396 0 0 0 .12-.103l-.003.001c.101-.06.189-.13.214-.253-.009-.034.001-.06.029-.08.032-.046.07-.089.083-.146-.009-.032.001-.057.029-.076.023-.041.06-.072.08-.116a.255.255 0 0 0 .105-.106.225.225 0 0 0 .118-.149c.011-.061.021-.123.033-.184.029-.047.067-.09.079-.146-.013-.029-.007-.054.018-.074.063-.066.041-.167.099-.236l-.006-.284c-.042-.083-.033-.183-.093-.258l-.003-.005c-.14-.162.018-.384-.11-.549l-.002-.003a.597.597 0 0 1-.103-.11l-.006-.006a.254.254 0 0 1-.09-.097l-.135-.141c-.073-.044-.049-.16-.139-.191l.029.02a.227.227 0 0 0-.153-.123c-.031.007-.056-.002-.073-.03-.042-.024-.073-.063-.119-.081a.348.348 0 0 0-.108-.121l.005.006c-.029-.044-.072-.078-.099-.124l-.007-.006a.411.411 0 0 1-.104-.104l-.006-.006c-.045-.028-.08-.07-.124-.1l.007.005a.545.545 0 0 0-.115-.115l.005.007c-.03-.044-.072-.078-.1-.124l-.006-.006a.597.597 0 0 1-.11-.103l-.003-.002a.335.335 0 0 0-.151-.096c-.032.009-.058 0-.076-.028-.337-.105-.694.033-1.031-.082l-.189-.022a.516.516 0 0 0-.441 0 .848.848 0 0 1-.447 0c-.223-.11-.476.018-.698-.089l-.191-.032c-.113-.062-.251-.012-.364-.079l-.301-.022c-.101-.084-.247-.006-.346-.095a.108.108 0 0 1-.098-.016c-.075-.057-.174-.047-.255-.089l-.189-.022c-.083-.088-.228.007-.304-.101-.033-.016-.046-.042-.04-.078-.034-.088-.069-.176.01-.259l-.001.003a.265.265 0 0 0 .103-.15c-.005-.034.007-.059.038-.075a.321.321 0 0 1 .087-.103l.002-.003c.033-.039.071-.075.095-.12.081-.063.068-.168.111-.248l.032-.191c.044-.068.029-.161.088-.224l-.001.003c.071-.058.051-.163.113-.225l-.001.003c.071-.058.051-.162.112-.225l-.001.003c.071-.054.045-.161.119-.214l.003-.004c.039-.046.08-.091.094-.152-.009-.032 0-.057.028-.075.024-.042.063-.074.082-.12.074-.048.056-.155.126-.205l.003-.004c.039-.046.08-.091.094-.152-.006-.035.006-.06.037-.077a.79.79 0 0 1 .083-.116l-.004.006c.047-.037.092-.075.112-.135l-.022.018c.115-.072.15-.211.25-.296.014-.031.037-.044.071-.04a.262.262 0 0 0 .15-.102l-.003.001c.063-.063.184-.042.215-.15-.012-.028-.006-.052.018-.07.033-.038.069-.073.088-.121a.257.257 0 0 0 .123-.116c.073-.039.163-.034.228-.092l.003-.002a.764.764 0 0 0 .101-.133.09.09 0 0 1 .033-.095.208.208 0 0 1 .088-.095l.008-.007c.045-.076.149-.053.201-.118a.564.564 0 0 0 .117-.117c.068-.057.051-.158.111-.219l-.001.002a.266.266 0 0 0 .103-.149c-.012-.029-.005-.053.019-.072a1.566 1.566 0 0 0-.008-.887.297.297 0 0 0-.149-.101c-.034.007-.059-.005-.076-.036a.252.252 0 0 1-.097-.089l-.007-.006a.631.631 0 0 1-.11-.103l-.003-.002c-.039-.033-.075-.07-.121-.095-.062-.081-.168-.068-.248-.111-.034.009-.06-.001-.08-.029-.046-.032-.089-.07-.146-.083-.035.006-.06-.006-.077-.037a.731.731 0 0 1-.115-.083l.006.004c-.056-.075-.162-.053-.224-.116l.003.001c-.058-.071-.162-.05-.225-.112l.003.001a.266.266 0 0 0-.149-.103h-.592c-.148.089-.33-.006-.477.088a.108.108 0 0 1-.098.016c-.068.058-.17.036-.235.099-.021.025-.047.031-.078.019-.112.067-.251.014-.364.082-.02.029-.046.039-.08.029-.081.038-.174.037-.253.079a.103.103 0 0 1-.1.026c-.099.09-.248.007-.347.099-.021.025-.047.031-.078.019-.081.042-.182.03-.255.093a.063.063 0 0 1-.078.018c-.081.042-.182.03-.255.093-.021.025-.048.031-.078.019-.081.039-.174.036-.253.079a.101.101 0 0 1-.099.026c-.068.055-.162.041-.234.085l-.191.032c-.081.041-.179.031-.255.088a.264.264 0 0 1-.223-.009c-.101-.112-.05-.23-.012-.347-.013-.031-.007-.057.018-.079.063-.073.051-.174.093-.254-.013-.031-.006-.057.019-.079.063-.066.041-.168.099-.236l-.006-.28c-.012-.057-.05-.101-.082-.146-.029-.02-.039-.046-.03-.08a.717.717 0 0 1 0-.512l.007-.284c-.059-.069-.036-.182-.124-.236l.007.015c-.08-.104-.002-.251-.099-.349v-.001c-.068-.057-.044-.157-.102-.219a.108.108 0 0 1-.016-.098c-.085-.101-.018-.24-.085-.345a15.04 15.04 0 0 0-.026-.21c-.057-.07-.039-.171-.102-.238l-.002-.003c-.042-.037-.083-.074-.133-.101a13.865 13.865 0 0 0-.203-.016c-.058-.046-.143-.04-.193-.101-.031-.013-.044-.036-.04-.069a.177.177 0 0 0-.141-.141c-.034.005-.058-.007-.074-.038a.447.447 0 0 1-.109-.084h.001c-.075-.072-.181-.059-.267-.101l-.094.436a.281.281 0 0 1-.084.103l-.002.003c-.063.067-.044.168-.102.238l-.016.32a.333.333 0 0 0-.088.149l-.023.406c-.059.067-.038.167-.095.235a.1.1 0 0 1-.026.099c-.044.069-.029.161-.088.224l.001-.003c-.075.069-.061.173-.104.255.013.03.007.057-.018.078-.062.063-.041.163-.102.226l.001-.003a.266.266 0 0 0-.103.149c.011.029.005.053-.019.072-.063.053-.028.161-.113.202l-.009.014a.397.397 0 0 1-.096.112l-.002.003c-.041.045-.082.089-.096.151.006.034-.005.06-.036.076a.321.321 0 0 1-.087.103l-.002.003c-.034.041-.074.077-.098.125-.071.053-.059.154-.118.214l.001-.003a.266.266 0 0 0-.103.149c.005.034-.008.06-.038.075a.79.79 0 0 1-.083.116l.004-.006a.317.317 0 0 0-.102.119.25.25 0 0 0-.109.104.227.227 0 0 0-.117.148c.005.034-.007.059-.038.074a.74.74 0 0 1-.083.116l.004-.006a.246.246 0 0 0-.105.149.067.067 0 0 1-.038.075.262.262 0 0 1-.089.098l-.006.006a.396.396 0 0 1-.105.103l-.008.007c-.048.079-.17.05-.207.145l.021-.029a.229.229 0 0 0-.124.152c.008.032-.002.056-.03.074-.044.074-.046.147.007.218a.267.267 0 0 1-.01.226c-.044.072-.03.166-.085.234a.098.098 0 0 1-.026.099c-.044.072-.03.166-.085.234l-.025.21a1.79 1.79 0 0 0 0 .771l.01.115c-.086.097-.002.243-.098.336l.001-.003c-.075.068-.06.173-.103.255.009.033 0 .06-.029.08-.032.046-.07.089-.083.146.013.029.007.054-.018.074a.299.299 0 0 0-.092.149c.007.032-.003.057-.03.074-.049.071-.032.166-.088.234a.1.1 0 0 1-.026.099c-.029.047-.067.089-.08.146.013.029.007.054-.018.074-.063.073-.051.174-.093.255.009.034-.001.061-.029.08-.05.068-.029.164-.091.227l-.023.106c-.03.047-.067.09-.08.146.009.032-.001.057-.029.076-.05.063-.024.16-.097.212l-.003.005c-.039.046-.08.09-.094.152.009.032 0 .057-.028.075-.033.046-.07.089-.083.146.009.032-.001.057-.029.076-.032.046-.07.089-.083.146.009.032 0 .057-.028.076-.033.046-.07.089-.083.146a.063.063 0 0 1-.029.076c-.032.046-.07.089-.082.146.013.029.007.054-.018.074-.062.063-.04.163-.102.226l.001-.003c-.073.062-.052.167-.109.236a.1.1 0 0 1-.026.099c-.029.047-.067.09-.079.146.013.029.007.054-.018.074-.064.069-.045.17-.096.245a.082.082 0 0 1-.028.089c-.031.047-.068.089-.081.146a.063.063 0 0 1-.029.076c-.032.046-.07.089-.083.146.009.032 0 .057-.028.076-.033.046-.07.089-.083.146.009.032-.001.057-.029.076-.032.046-.07.089-.083.146.009.032 0 .058-.028.076-.051.06-.021.159-.1.206l-.004.009c-.034.049-.076.093-.089.153.007.035-.005.06-.037.077a.79.79 0 0 1-.083.116l.004-.007c-.074.052-.047.161-.121.213l-.003.004c-.03.04-.065.074-.089.117a.225.225 0 0 0-.114.147c.005.034-.007.059-.038.075a.332.332 0 0 1-.087.103l-.002.003a.357.357 0 0 0-.097.151c.007.034-.005.06-.036.076a.321.321 0 0 1-.087.103l-.002.002c-.035.042-.075.078-.099.127-.068.049-.053.152-.123.2l-.003.005c-.031.042-.071.078-.095.125-.047.021-.082.059-.12.092-.019.024-.042.03-.07.018-.108.031-.087.151-.149.214a.932.932 0 0 1-.111.088l-.13.133c-.024.039-.059.07-.079.112a.224.224 0 0 0-.115.148c.008.032-.002.056-.029.073-.024.041-.061.072-.08.116a.26.26 0 0 0-.115.121c-.069.048-.056.15-.125.198l-.003.004c-.031.041-.069.076-.093.123a.255.255 0 0 0-.114.12c-.067.046-.054.149-.126.192l-.007.008c-.024.047-.068.08-.097.124l.005-.006a.33.33 0 0 0-.097.11.223.223 0 0 0-.119.149.067.067 0 0 1-.038.075.332.332 0 0 1-.087.103l-.002.003c-.033.04-.072.075-.096.122a.264.264 0 0 0-.103.104.223.223 0 0 0-.118.148.062.062 0 0 1-.029.073c-.024.041-.061.073-.08.117a.255.255 0 0 0-.115.121c-.067.046-.055.149-.126.192l-.007.008a.481.481 0 0 1-.101.11l-.002.003c-.033.04-.071.075-.096.122a.264.264 0 0 0-.103.104.225.225 0 0 0-.118.148c.005.034-.007.059-.038.075a.255.255 0 0 1-.089.098l-.006.006a.415.415 0 0 1-.105.104l-.006.006a.565.565 0 0 1-.103.11l-.002.003c-.033.04-.072.074-.102.116a.359.359 0 0 0-.107.119.256.256 0 0 0-.106.11.246.246 0 0 0-.117.119c-.064.046-.053.146-.127.185l-.009.013a.302.302 0 0 1-.098.106l-.006.006a.597.597 0 0 1-.103.11l-.002.003c-.033.04-.072.075-.096.122a.254.254 0 0 0-.108.112.244.244 0 0 0-.107.104.225.225 0 0 0-.117.147.062.062 0 0 1-.029.073c-.024.041-.061.073-.08.117a.252.252 0 0 0-.111.115.239.239 0 0 0-.112.112.25.25 0 0 0-.121.125l.024-.017c-.088.07-.163.154-.243.233l.015-.017c-.054.022-.091.067-.134.104l-.002.002c-.073.075-.148.06-.224.006l.004.003c-.045-.07-.15-.043-.193-.118a.378.378 0 0 1-.006-.336c.075-.15-.005-.326.079-.475v-.488c-.048-.128-.074-.256.006-.381l-.006-.507a.988.988 0 0 1 0-.622c-.013-.031-.007-.057.018-.079.119-.175-.02-.395.099-.569a.103.103 0 0 1 .026-.1c.042-.079.04-.172.079-.252-.013-.031-.006-.057.019-.079.062-.063.04-.163.102-.225l-.001.003c.074-.062.052-.167.11-.236a.096.096 0 0 1 .033-.1.234.234 0 0 1 .086-.098l.007-.006c.03-.046.07-.085.095-.134a.097.097 0 0 1 .016-.093c.108-.172-.016-.383.09-.556.074-.056.066-.15.105-.223.085-.055.063-.166.121-.234a.113.113 0 0 1 0-.081c-.067-.118-.076-.236.003-.353l-.001.003a.352.352 0 0 0 .101-.122.262.262 0 0 0 .121-.114c.075-.042.179-.031.227-.124l-.024.029a.229.229 0 0 0 .123-.153l.021-.405c.061-.075.05-.174.091-.255-.006-.036.006-.063.038-.081a.68.68 0 0 1 .083-.116l-.004.006a.242.242 0 0 0 .105-.149c-.012-.029-.005-.053.019-.072.062-.063.04-.163.102-.226l-.001.003a.909.909 0 0 1 .221-.225c.146-.156-.027-.384.122-.539l.007-.008c.028-.047.067-.086.093-.135a.095.095 0 0 1 .026-.094c.02-.04.054-.07.073-.111a.224.224 0 0 0 .116-.149l.033-.185c.042-.079.04-.172.079-.253-.013-.03-.006-.057.019-.078.063-.132-.055-.161-.124-.218l.004.001a.812.812 0 0 0-.113-.114l.001.002c-.062-.063-.042-.167-.113-.225l.002.003c-.061-.064-.045-.163-.1-.229l-.005-.009a.287.287 0 0 1-.098-.104l-.013-.01c-.048-.022-.081-.066-.125-.094l.007.005a.242.242 0 0 0-.149-.105c-.029.012-.053.005-.072-.019-.056-.063-.162-.031-.209-.11l-.008-.007a.477.477 0 0 1-.11-.1l-.003-.003a1.606 1.606 0 0 1-.111-.107h-.001a.317.317 0 0 0-.15-.099c-.034.007-.059-.005-.075-.036a.162.162 0 0 1-.083-.082c-.03-.016-.042-.04-.037-.073-.024-.105-.151-.081-.198-.158l-.008-.006c-.048-.025-.08-.068-.125-.097l.007.005a.352.352 0 0 0-.11-.097.223.223 0 0 0-.15-.119c-.031.008-.056-.002-.073-.03-.042-.024-.074-.063-.119-.081-.05-.075-.155-.058-.211-.125a.644.644 0 0 1-.095-.107c-.028-.02-.038-.046-.029-.08-.076-.109.004-.265-.106-.365l.005.007c-.029-.044-.072-.078-.1-.124l-.006-.006a.415.415 0 0 1-.104-.105l-.006-.006a.411.411 0 0 1-.104-.104l-.007-.006c-.045-.028-.079-.07-.124-.1l.007.005a.338.338 0 0 0-.121-.104c-.051-.075-.154-.063-.214-.123l.003.001c-.068-.075-.173-.06-.254-.103-.031.012-.057.006-.078-.019-.074-.063-.174-.051-.255-.092a10.001 10.001 0 0 1-.173-.007.2.2 0 0 1-.251 0l-.171.008c-.084.042-.194.025-.257.115l-.022.207c-.02.04-.054.071-.073.111a.224.224 0 0 0-.116.149c.004.034-.009.058-.04.071a.701.701 0 0 0-.189.237v.525c.093.097 0 .255.113.346l-.004-.007a.79.79 0 0 1 .083.116c.031.017.043.042.037.077.012.057.05.1.082.146.028.018.038.042.03.073a.246.246 0 0 0 .105.149l-.005-.007c.029.044.072.077.099.124l.006.007c.064.08.135.152.214.217l.007.008c.079.045.052.159.132.203.04.071.031.162.089.227.025.021.031.047.019.078.043.082.028.186.103.255l-.001-.003c.06.063.043.156.091.224.029.02.038.046.029.08.042.081.03.182.092.255.025.02.031.045.018.074.012.058.05.101.083.146.028.019.037.044.028.076.012.057.05.1.08.146a.1.1 0 0 1 .026.099c.056.068.039.163.088.234.028.018.038.043.029.075.012.057.05.1.08.147.07.25.034.505.029.759.088.058.041.173.103.243l-.01.334c-.01 0-.016.016-.017.045 0 .026.019.044.057.054l.027-.009.027.008c.39.061.08.405.227.563.039.075.039.15.001.225-.081.086-.217.101-.277.213a.298.298 0 0 0-.012.142c.02.108.181.175.089.314l.001-.002a.26.26 0 0 0-.103.15l-.023.627c-.05.186-.096.372.018.552.029.036.063.041.103.011l.136-.124a.166.166 0 0 1 .083-.082l.104-.06c.104.082.069.171.014.261l.001-.003c-.073.061-.052.167-.109.236a.094.094 0 0 1-.033.099.14.14 0 0 1-.08.08h-.119c-.053-.026-.101-.063-.161-.075l-.084.33a1.37 1.37 0 0 1-.077.126c.012.144.033.288-.026.427-.029.047-.067.09-.079.146.009.033-.001.058-.029.076-.046.073-.042.163-.081.238l.007-.021c-.167.172-.004.41-.119.592.007.036-.006.063-.038.081a.722.722 0 0 1-.083.116l.004-.006a.31.31 0 0 0-.103.121c-.076.051-.063.154-.123.214l.001-.003c-.071.052-.042.161-.121.208l-.007.008a.53.53 0 0 1-.1.111l-.002.003c-.041.045-.082.09-.096.151.013.029.007.053-.018.073-.063.066-.041.168-.099.236-.023.121-.113.112-.202.103-.093.045-.073.158-.132.223l.002-.005c-.074.05-.045.161-.124.208l-.004.008c-.035.048-.076.092-.09.153.009.138.026.276-.031.408-.044.069-.029.161-.088.224l.001-.003c-.109.088-.013.245-.112.336l.001-.003c-.071.059-.05.162-.112.225l.001-.003c-.108.093-.017.249-.109.347a.108.108 0 0 1-.016.098c-.086.096-.002.242-.098.336l.001-.003c-.073.061-.052.167-.109.235a.1.1 0 0 1-.026.1c-.095.217.034.463-.085.678l.004.512c.027.052.04.104-.004.154v.192c.124.214-.021.465.095.68l.022.301c.085.148.001.326.082.475.028.019.038.044.029.076.013.057.05.101.083.146.028.018.037.042.028.074.017.067.06.114.113.154l-.01-.015a.3.3 0 0 0 .12.109c.025.05.063.088.113.113.023.045.057.08.101.104.085.125.247.035.346.119l-.015-.006a.23.23 0 0 0 .15.116c.032-.007.056.002.074.03.078.047.172.042.253.082l.284.007c.069-.06.194-.033.226-.147-.005-.033.008-.056.039-.069.051-.061.138-.059.193-.113.067-.054.04-.161.118-.209l.006-.008c.028-.047.068-.086.093-.135a.08.08 0 0 1 .036-.09c.156-.132.369.017.526-.107l.003-.002a.631.631 0 0 1 .11-.103l.006-.006a.252.252 0 0 1 .097-.089c.018-.032.045-.044.081-.037.074-.04.17-.036.231-.1h-.007c.008-.003.012-.008.018-.012.005-.006.012-.009.016-.017l-.001.007c.092-.074.009-.23.116-.297l.008-.008c.041-.072.142-.061.188-.125.083-.049.067-.157.128-.219l-.001.003c.066-.083.085-.159-.037-.209-.137-.116.008-.165.057-.236.051-.066.033-.162.093-.224l-.001.003c.071-.058.051-.162.113-.225l-.001.003a.367.367 0 0 0 .098-.117c.083-.053.066-.162.123-.229a.098.098 0 0 1 .034-.1.24.24 0 0 1 .086-.098l.006-.006a.411.411 0 0 1 .104-.104l.006-.006a.436.436 0 0 1 .105-.105l.006-.006c.028-.045.07-.08.1-.124l-.005.007a.24.24 0 0 0 .105-.149.067.067 0 0 1 .038-.075.79.79 0 0 1 .083-.116l-.004.006a.242.242 0 0 0 .105-.149c-.005-.034.007-.059.038-.075a.309.309 0 0 1 .087-.103l.002-.003c.049-.054.048-.138.107-.186.01-.034.034-.051.07-.049a.238.238 0 0 0 .145-.104.361.361 0 0 0 .111-.119.247.247 0 0 0 .105-.112c.072-.051.062-.153.121-.212l-.001.003c.07-.058.052-.16.111-.223a.518.518 0 0 0 .114-.124l-.012.014c.081-.054.059-.162.122-.226l-.001.003c.071-.059.051-.162.112-.225l-.001.003a.4.4 0 0 0 .094-.111.224.224 0 0 0 .12-.15c-.005-.034.007-.059.038-.074a.32.32 0 0 1 .087-.103l.002-.003c.032-.038.068-.073.092-.117a.225.225 0 0 0 .113-.147c-.012-.028-.005-.052.019-.072.062-.063.04-.163.102-.226l-.001.003c.071-.052.043-.161.12-.211l.004-.006c.034-.046.073-.088.093-.143a.076.076 0 0 1 .027-.084c.022-.042.06-.073.079-.117.077-.052.062-.157.122-.218l-.001.003c.074-.062.052-.167.11-.235a.099.099 0 0 1 .029-.1c.024-.046.062-.085.078-.136a.076.076 0 0 1 .028-.085c.07-.105 0-.245.086-.345l.016-.208c.057-.064.037-.163.098-.225l-.001.002c.132-.072.164.044.219.116l.003.004c.074.053.045.156.108.214.024.019.03.043.019.072a.244.244 0 0 0 .111.151l-.015-.012a.28.28 0 0 0 .153.113l.186.031c.105.067.244 0 .345.085l.053-.001.046.026a.205.205 0 0 0 .216 0c.173-.063.352-.039.529-.031.052-.026.104-.04.154.005l.618-.006c.149-.084.325-.004.475-.079l.185-.033a.24.24 0 0 0 .148-.107c.122-.075.246-.05.37-.003l.192.032c.105.067.244 0 .345.085a.088.088 0 0 1 .096.036c.096.07.03.149.012.225.009.034 0 .061-.029.081-.047.078-.042.173-.082.253a.07.07 0 0 1-.029.081c-.049.07-.032.166-.088.234a.098.098 0 0 1-.026.099c-.044.072-.03.166-.085.234a.1.1 0 0 1-.026.099c-.029.047-.067.089-.079.146.008.032-.001.057-.029.076-.033.046-.07.089-.083.146.013.029.007.054-.018.074-.092.099-.009.248-.1.347a.1.1 0 0 1-.025.099c-.03.047-.067.09-.079.146.011.031.003.056-.025.075-.034.042-.068.083-.09.133l.003.503c.027.052.04.104-.005.154a.103.103 0 0 1-.026.1c-.089.225.022.473-.079.697v.376c.039.081.036.173.079.253a.507.507 0 0 1 .032.298c.012.057.05.099.079.146a.098.098 0 0 1 .026.099c.055.068.041.162.085.234a.099.099 0 0 1 .025.099c.058.068.037.168.095.236a.092.092 0 0 1 .018.087.21.21 0 0 0 .144.126c.034-.007.059.005.074.036a.255.255 0 0 1 .098.089l.006.006a.227.227 0 0 1 .086.098.088.088 0 0 1 .035.089c.046.096.162.072.229.131l.051-.004.047.02a.322.322 0 0 0 .149.087l.186.034c.096.071.237-.013.323.094l.004.003c.038.028.071.062.112.086.094.128.258.038.368.118l.042-.004.036.023c.043.042.088.08.15.092l.501.007c.088-.071.179-.045.27-.007l.301.023c.108.064.218.056.329.007l.038-.029.048.001c.05-.024.099-.042.144.008l-.003-.001c.111.073.219.094.32-.008.046-.017.077-.058.12-.079a1.5 1.5 0 0 1 .67-.01c.101.084.247.006.346.095l.507-.006c.148-.084.324-.004.475-.079l.197-.031c.052-.027.104-.04.154.005l.209.016c.075.057.173.047.254.089l.042-.005.036.023c.073.063.174.051.254.093l.19.023c.098.085.245.001.339.097l.422-.002c.151-.067.301-.089.448.01l.007.006c.042.03.08.063.116.099l-.001-.001c.039.041.077.082.125.111l-.013-.012c.049.08.162.054.214.127l.005.003c.066.055.157.05.229.09.047.081.159.056.21.129l.005.003c.184.112.405-.009.591.093h.147a.263.263 0 0 0 .15-.103c.209-.123.452.009.664-.087l.211-.026c.069-.057.171-.038.238-.102l.003-.002a.321.321 0 0 1 .103-.087.067.067 0 0 1 .075-.038.229.229 0 0 0 .15-.116l-.015.006c.176-.118.409.046.575-.118l-.025.015a.375.375 0 0 0 .129-.115c.065-.053.158-.038.223-.092l.032-.025.041.001a.23.23 0 0 0 .149-.114c.048-.024.097-.019.146.003h.155c.083-.042.183-.032.258-.092l.005-.003c.084-.11.236-.013.325-.108l.033-.023.041.005c.057-.013.101-.05.146-.083.018-.028.043-.037.075-.028a.287.287 0 0 0 .149-.102c.039-.037.077-.073.11-.115l-.003.002c.063-.062.174-.041.222-.13l-.007-.278c-.034-.089-.07-.178.009-.262a.112.112 0 0 1 .013-.105.324.324 0 0 0 .088-.149c-.007-.032.002-.057.03-.075.123-.256-.124-.246-.238-.33l-.004-.208c-.03-.044-.068-.083-.096-.129l-.009-.005c-.06-.056-.163-.029-.21-.109l-.008-.008c-.077-.044-.057-.149-.124-.199a.382.382 0 0 0-.105-.107.385.385 0 0 0-.131-.123l.02.021c-.051-.085-.152-.076-.226-.117a.262.262 0 0 0-.117-.111.25.25 0 0 0-.112-.113.253.253 0 0 0-.111-.111.243.243 0 0 0-.115-.113.355.355 0 0 0-.099-.119l.001.003a.68.68 0 0 0-.213-.23l-.004-.003c-.072-.06-.172-.046-.248-.096-.066-.015-.101-.049-.077-.121.057-.075.047-.174.088-.254-.007-.036.006-.063.038-.082a.781.781 0 0 1 .083-.115l-.004.007c.077-.06.055-.167.112-.235a.1.1 0 0 1 .026-.099c.067-.105 0-.244.085-.345a.1.1 0 0 1 .025-.099c.045-.072.03-.166.085-.234l.026-.21c.069-.101-.004-.24.088-.334l-.001.003c.109-.088.014-.245.113-.336l-.001.003c.068-.06.06-.154.101-.226a.298.298 0 0 0 .12-.121c.071-.039.16-.032.226-.085l.328-.013c.04-.039.079-.036.116.003h.001c.062.064.164.046.227.107l-.003-.001c.1.105.254.026.362.105l.048-.001c.125-.044.249-.08.371.009l-.003-.001c.09.105.239.022.336.104.03.039.059.079.086.119a.094.094 0 0 1 .026.094c.028.041.053.083.077.126.031.026.042.06.033.1.045.171.216.164.332.235l-.003-.001c.059.073.166.048.229.112l.311-.003c.068-.059.193-.032.226-.147.086-.134.274-.064.368-.184a.157.157 0 0 1 .084-.08l.206-.034c.049-.027.09-.064.132-.101l.002-.003c.033-.04.071-.076.107-.114h-.001a.416.416 0 0 1 .109-.082.09.09 0 0 1 .09-.035c.109-.096.108-.2.01-.302zm-12.351-.111c-.292.99-.36 2.034-.737 3.002-.12.309-.215.628-.336.937-.172.438-.217.461-.693.451-.055-.001-.109-.012-.102-.011-.524.112-.967-.084-1.424-.101-.447-.016-.531-.19-.554-.646-.011-.222-.066-.454.033-.656.117-.24.15-.44-.056-.645-.066-.066-.067-.166-.031-.261.026-.068.055-.142.056-.213 0-.7.273-1.307.61-1.902.085-.15.144-.222.321-.213.555.028 1.096-.101 1.639-.183.367-.055.708-.068 1.072.072.222.086.25.205.202.369zm.696-3.899c-.035.499-.188.977-.21 1.476-.009.193-.144.297-.333.304a5.253 5.253 0 0 1-.664-.007c-.42-.037-.839-.082-1.262-.026-.165.014-.331.035-.496.039-.123.002-.275.046-.346-.096a.322.322 0 0 1 .101-.402c.247-.168.329-.425.459-.664.247-.451.518-.888.767-1.337.146-.263.505-.302.611-.601.282.049.585.071.816.238.352.257.591.583.557 1.076zm-.789-4.853c-.13.267-.281.524-.552.677-.117.066-.219.147-.264.273-.082.224-.188.379-.469.384-.167.003-.352.16-.26.339.273.534.026.959-.224 1.393-.515.894-1.031 1.786-1.551 2.676-.074.126-.2.225-.26.356-.33.717-.979.764-1.627.756-.495-.006-.996-.054-1.463-.245-.287-.118-.584-.064-.877-.075-.461-.016-.486-.033-.538-.503-.054-.49-.002-.946.311-1.365.485-.65.813-1.406 1.325-2.042a.624.624 0 0 0 .114-.189c.242-.771.747-1.396 1.16-2.071.262-.429.408-.91.593-1.37.176-.436.485-.809.558-1.302.035-.233.187-.56.581-.374.052.024.12.005.143-.048.21-.5.778-.338 1.128-.609.343-.266.771-.425 1.165-.624 1.097-.553 2.275-.841 3.478-1.042.051-.009.106.013.156.021.031.109-.018.188-.068.265-.979 1.507-1.769 3.113-2.559 4.719zm4.512 9.719c-.28.989-.567 1.976-.847 2.965-.029.103-.082.15-.177.182-.178.06-.362.101-.543.059a3.703 3.703 0 0 0-1.748-.011c-.227.055-.316-.065-.206-.28.221-.433.36-.883.391-1.369a.786.786 0 0 1 .099-.371c.274-.417.331-.9.379-1.367.052-.503.506-.759.632-1.205.025-.089.143-.043.238-.015.384.116.762.242 1.179.232.457-.01.699.286.672.782-.017.108-.03.257-.069.398zm2.25-7.372c-.079.446-.07.914-.361 1.312-.125.172-.167.407-.239.616-.029.087-.005.215-.06.265-.347.318-.303.765-.413 1.162-.191.694-.496.92-1.237.902-.311-.007-.621.043-.936-.048-.198-.058-.249-.135-.276-.328-.037-.27-.024-.514.124-.744.145-.225.223-.472.186-.736-.041-.29.161-.519.162-.805.001-.326-.065-.575-.371-.731-.296-.15-.511-.423-.824-.55a.288.288 0 0 1-.131-.098c-.076-.124-.248-.209-.229-.362.023-.193.235-.165.36-.188.575-.105 1.129-.362 1.701-.253.507-.035.975.093 1.458-.016.249-.056.543.063.812.125.246.057.31.275.274.477zM21.873 145.451l-.002-.003c-.081-.075-.057-.153-.009-.233l.001-.191c-.059-.069-.037-.18-.119-.237l.016.012a.274.274 0 0 0-.154-.113l-.185-.031c-.062-.047-.159-.018-.205-.097l-.008-.008c-.08-.046-.052-.168-.146-.204l.033.021c-.116-.163-.325-.01-.453-.133l.003.001c-.058-.071-.162-.051-.225-.113l.003.001c-.048-.067-.15-.041-.193-.115-.031-.013-.044-.036-.039-.069a.177.177 0 0 0-.141-.141c-.028.012-.052.006-.071-.019a5.432 5.432 0 0 0-.114-.1.397.397 0 0 0-.128-.11l-.205-.025c-.07-.041-.154-.039-.225-.076-.063-.084-.139-.077-.219-.024l-.004.006c-.063.068-.126.068-.191.003l-.139-.237c-.099-.077-.24.001-.334-.093l.003.001c-.102-.105-.255-.028-.366-.104l-.191-.032c-.105-.067-.244.001-.344-.085a.119.119 0 0 1-.083 0c-.153.069-.306.088-.457-.006l-.001-.001c-.043-.074-.078-.071-.104.005-.037.031-.076.06-.117.087-.169.063-.345.037-.519.032-.057.012-.1.05-.146.08-.186.06-.372.049-.56.01-.113-.056-.224-.075-.331.015l.002-.001c-.125.086-.201-.059-.307-.064-.093.102-.213.078-.33.073-.091.038-.182.064-.27-.006a.108.108 0 0 1-.098-.016c-.075-.057-.174-.047-.254-.089-.033.012-.059.003-.079-.025a1.284 1.284 0 0 1-.111-.097l.001.001c-.061-.07-.166-.046-.229-.11-.185.014-.372.047-.552-.03a1.37 1.37 0 0 1-.126-.077.096.096 0 0 1-.096-.034.235.235 0 0 1-.098-.087l-.006-.006a.255.255 0 0 1-.089-.098c-.031-.016-.043-.042-.037-.076-.012-.057-.049-.1-.079-.147l-.026-.21c-.103-.138-.004-.313-.085-.456l-.031-.197c-.027-.052-.04-.104.005-.154v-.192c-.068-.087-.048-.176-.005-.266l-.001-.049c-.048-.128-.074-.256.006-.381l.026-.21c.091-.125-.039-.302.1-.415l-.013-.031c.069-.071.069-.141 0-.212l.024-.119c.03-.046.067-.09.079-.146-.008-.033.001-.058.029-.077.089-.187-.014-.4.082-.586l.032-.19c.03-.047.068-.09.08-.146a.063.063 0 0 1 .029-.076c.032-.046.07-.089.083-.146-.017-.019-.016-.036.003-.052-.009 0-.018-.015-.024-.043-.007-.027.006-.053.038-.075l.005-.01c.028-.047.073-.083.094-.134.033-.021.066-.043.097-.068a.227.227 0 0 0 .075-.176c.001-.11-.007-.222.044-.326l-.001-.153c-.065-.114-.016-.251-.078-.366a.734.734 0 0 1-.01-.447c.1-.149.064-.298-.004-.446l-.003-.004c-.141-.203.01-.449-.097-.656-.028-.019-.038-.044-.029-.076-.012-.057-.05-.099-.079-.146a.098.098 0 0 1-.026-.099c-.049-.169-.21-.17-.335-.227a5.147 5.147 0 0 0-.086-.119c-.028-.018-.038-.043-.029-.076-.012-.057-.05-.1-.083-.146-.027-.018-.037-.042-.029-.073a.225.225 0 0 0-.124-.153l.021.029c-.036-.094-.159-.065-.205-.146l-.008-.008c-.08-.045-.05-.157-.125-.205l.006.007c-.031-.044-.072-.08-.105-.122l-.003-.002c-.064-.061-.163-.046-.229-.102-.059-.067-.039-.181-.133-.227l.029.023a.233.233 0 0 0-.153-.124c-.032.008-.056-.002-.073-.029-.046-.033-.089-.07-.146-.083-.029.013-.054.007-.074-.018-.094-.093-.243-.004-.336-.102l.003.001c-.036-.04-.072-.08-.123-.101a.327.327 0 0 0-.104-.123l.005.007c-.03-.045-.071-.08-.105-.122l-.003-.002c-.074-.064-.175-.053-.257-.095-.036.007-.063-.006-.082-.038a2.06 2.06 0 0 1-.126-.08l-.175.005c-.049.025-.098.041-.144-.008l.003.001c-.062-.074-.167-.052-.235-.11h-.304c-.171.129-.406-.041-.57.121-.164.034-.284.119-.333.288-.063.049-.134.046-.207.036-.068.055-.162.041-.234.085l-.184.033a.224.224 0 0 0-.148.117.246.246 0 0 0-.102.105c-.077.054-.063.159-.119.225a.105.105 0 0 1-.016.098.324.324 0 0 0-.088.149c.012.029.005.053-.019.073-.062.063-.04.163-.102.226l.001-.003c-.107.097-.022.252-.106.356a13.89 13.89 0 0 1-.029.201c-.045.072-.03.166-.085.234a.1.1 0 0 1-.026.099c-.106.401.047.821-.087 1.221-.074.069-.06.173-.102.254l-.022.189a.324.324 0 0 0-.088.149c.021.1.03.199-.02.294-.087.108-.021.254-.092.366.013.031.006.057-.019.079-.108.136.01.322-.099.458l-.016.208c-.096.146 0 .329-.089.477l-.022.19a2.355 2.355 0 0 0 0 .996c.045.26.045.52 0 .78-.059.068-.038.167-.095.235l-.002.2c.063.064.041.167.104.231l.002.003a.29.29 0 0 1 .084.103l.04.192c.071.112.009.256.089.365l.022.301c.063.46.083.921-.006 1.381l-.016.209c-.11.223.018.476-.089.699.006.175.028.351-.027.523-.067.96-.061 1.921-.005 2.881.068.208.034.423.032.635.067.113.017.25.079.364a.102.102 0 0 1 .026.1c.126.291-.017.607.085.9.077.434.029.871.031 1.307.027.052.04.104-.005.154.013.145.03.29-.021.432-.121.517.047 1.05-.09 1.567l-.016.208c-.12.253.033.539-.095.791a.105.105 0 0 1-.016.098c-.058.075-.047.173-.089.254l.003.047c.048.079.03.189.116.25.061.123.046.246-.003.37.008.139.025.279-.033.413-.01.151-.158.273-.094.441l-.024.115a1.37 1.37 0 0 1-.077.126.096.096 0 0 1-.026.095c-.073.092.017.235-.097.315l-.008.008c-.046.08-.143.05-.205.097l-.107.023c-.04.038-.079.038-.116-.003h-.001c-.04-.036-.074-.079-.127-.096-.089-.115-.203-.063-.314-.031-.018.027-.042.038-.074.03-.061.011-.105.049-.149.087a.1.1 0 0 1-.093.017 1.632 1.632 0 0 1-.126.077.098.098 0 0 1-.1.034c-.068.058-.169.036-.236.097a.084.084 0 0 1-.088.018c-.105.081-.252.006-.356.096-.02.024-.045.03-.074.018-.057.012-.099.05-.146.08l-.187.032c-.057.012-.1.05-.146.079l-.191.033c-.113.066-.25.016-.364.078l-.116.01c-.075-.057-.173-.047-.254-.088h-.147a.178.178 0 0 0-.141.141c.006.033-.007.056-.037.069-.051.061-.138.054-.195.103a.113.113 0 0 1-.098.014c-.068.058-.168.036-.235.095a.106.106 0 0 1-.097.016c-.172.131-.411-.046-.574.125l.026-.014c-.053.015-.085.062-.13.088-.018.028-.043.037-.075.028-.062.015-.106.056-.151.097l-.003.002a.534.534 0 0 1-.111.101l-.008.007c-.077.074-.167.136-.205.242l.006.28c.012.057.05.1.08.146l.023.106c.01 0 .019.013.027.038.008.024-.004.046-.036.067l-.005.01c-.051.072-.051.146-.009.223.057.136.042.278.03.419.027.052.04.104-.005.154v.304c.056.068.039.163.088.234a.062.062 0 0 1 .029.073.228.228 0 0 0 .118.149.26.26 0 0 0 .104.104c.024.046.063.082.096.122l.002.002a.534.534 0 0 1 .101.111l.007.008c.076.047.053.174.158.199.031-.008.056.001.073.029.102.067.231.017.335.076a.26.26 0 0 0 .117.115.253.253 0 0 0 .112.112.244.244 0 0 0 .111.111.245.245 0 0 0 .115.114c.052.069.152.06.21.118l-.003-.001c.08.111.242.005.32.121l.008.007c.04.023.069.055.091.095l.139.131c.138.09.315-.015.451.089l-.009-.004c.098.116.256.031.366.109.036-.007.063.006.082.038.043.025.085.052.126.08l.049-.004.044.02c.058.058.161.028.209.106l.008.007a.5.5 0 0 1 .11.1l.003.002c.045.041.09.082.151.096l.169.006c.118-.068.235-.077.352.002l-.003-.001c.062.073.167.051.235.109h.053l.046.026c.047.029.09.067.146.079h.15c.081-.041.179-.031.254-.089a.27.27 0 0 1 .227.01.397.397 0 0 0 .327 0c.104-.051.212-.039.321-.026.069-.057.17-.039.239-.099l.005-.003c.158-.15.399.041.552-.134l-.026.016c.054-.021.091-.067.136-.101l.004-.003c.052-.073.164-.048.21-.129.07-.037.156-.034.224-.078.02-.028.046-.039.08-.029.081-.042.179-.032.254-.089l.182-.022c.105-.024.082-.151.158-.199l.004-.013a.226.226 0 0 1 .095-.089c.018-.032.045-.044.081-.038.223-.106.476.021.699-.088l.183-.023a.263.263 0 0 0 .15-.103l-.003.001a.937.937 0 0 0 .227-.189.083.083 0 0 1 .086-.038.208.208 0 0 0 .125-.145c-.007-.033.004-.058.035-.074a.164.164 0 0 1 .082-.082c.016-.031.042-.043.076-.037.062-.014.106-.055.152-.094l.005-.001c.053-.072.148-.048.212-.094l.187-.032c.057-.012.099-.05.146-.08l.191-.032c.081-.039.174-.036.253-.079l.191-.032c.083-.044.193-.027.255-.116.07-.035.153-.033.22-.077.018-.028.043-.037.076-.028.057-.013.101-.05.146-.083.326-.077.656-.025.984-.023.214-.127.471.032.684-.104h.001c.117-.094.238-.06.36-.011l.048-.002c.112-.067.25-.016.363-.079l.21-.025c.07-.058.171-.04.239-.1l.005-.003c.116-.103.238-.056.359-.016l.048.002c.146-.089.322-.004.471-.08.104-.051.213-.038.322-.026.068-.056.162-.041.234-.085l.21-.026c.067-.056.163-.039.233-.088.02-.028.046-.038.08-.029.081-.043.189-.028.251-.113.363-.123.755.052 1.115-.104l-.005.004c.063-.061.169-.041.226-.115l-.005.002c.065-.056.157-.043.227-.086l.21-.026a.683.683 0 0 0 .237-.19l.096-.104c-.069-.137.05-.189.118-.266.095-.125-.05-.149-.099-.214l-.002-.001c-.063-.041-.03-.091-.015-.139l.007-.175c-.101-.09.02-.278-.149-.338-.03.009-.054 0-.07-.028-.06-.039-.141-.033-.189-.094a.089.089 0 0 1-.036-.095c-.095-.096.003-.261-.122-.346-.024-.043-.06-.077-.091-.115l-.003-.003c-.042-.037-.083-.074-.132-.101a.089.089 0 0 1-.094-.034.151.151 0 0 1-.083-.08c-.03-.015-.042-.04-.037-.073a.177.177 0 0 0-.141-.141c-.028.012-.052.006-.071-.018a.29.29 0 0 0-.149-.091c-.034.005-.059-.008-.075-.039a.309.309 0 0 1-.103-.087l-.003-.002c-.067-.063-.168-.044-.238-.102-.099-.005-.155-.072-.211-.141a.335.335 0 0 1-.103-.088l-.003-.002c-.067-.063-.169-.044-.238-.102a.108.108 0 0 1-.098-.016c-.293-.076-.588-.062-.883-.01l-.211.025c-.101.086-.239.018-.344.085l-.21.026c-.1.089-.246.011-.346.095a.47.47 0 0 1-.338-.01c-.08-.042-.172-.041-.253-.079h-.266c-.08.039-.173.037-.252.079a.474.474 0 0 1-.338.01c-.134-.102-.315.016-.447-.098l.003.001c-.104-.091-.216-.065-.329-.021-.019.028-.044.038-.076.029-.057.012-.099.05-.146.08-.371.066-.743.051-1.115.01-.355-.13-.741.049-1.094-.107l-.008-.008c-.099-.073-.042-.158-.019-.24-.012-.031-.006-.057.019-.079.044-.116.117-.237-.049-.321-.127-.101-.091-.223-.048-.347.082-.142-.018-.318.085-.456a.105.105 0 0 1 .016-.098c.053-.07.051-.143.01-.218v-.117c.03-.047.068-.09.08-.147l.032-.187c.082-.142-.018-.318.085-.456l.016-.208a.24.24 0 0 0 .101-.101l.198-.018c.09-.038.063-.157.141-.203l.007-.008c.024-.047.067-.08.097-.124l-.005.007a.322.322 0 0 0 .102-.118c.078-.052.071-.149.115-.22.041-.028.081-.058.121-.088l.138-.131a.347.347 0 0 1 .088-.103l.002-.003a.335.335 0 0 0 .096-.151c-.003-.036.013-.06.048-.071.109-.103.226-.043.341-.016l.103-.096c.041-.071.154-.058.174-.152-.005-.034.007-.058.037-.074a.164.164 0 0 1 .082-.082c.016-.03.041-.043.074-.038a.22.22 0 0 0 .147-.117.248.248 0 0 0 .103-.105.238.238 0 0 0 .105-.103.222.222 0 0 0 .117-.147c-.005-.034.007-.059.037-.074a.162.162 0 0 1 .083-.082c.016-.03.04-.043.074-.038a.225.225 0 0 0 .153-.124l-.029.021c.094-.037.065-.159.145-.207l.006-.008a.368.368 0 0 1 .103-.105l.006-.006a.26.26 0 0 1 .097-.089c.018-.032.045-.044.081-.037.083-.046.205-.022.246-.142.003-.05.03-.077.081-.081.104-.024.081-.151.159-.196l.008-.008c.046-.08.152-.052.208-.113l.003-.002a.321.321 0 0 1 .103-.087c.016-.03.04-.043.074-.038.104-.024.081-.151.159-.196l.008-.008c.045-.08.155-.05.206-.121l-.003.001c.084-.104.271.014.326-.151-.006-.033.006-.057.037-.072a.255.255 0 0 1 .089-.098l.006-.006a.378.378 0 0 1 .105-.102l.008-.007c.075-.113.245-.012.315-.134a.27.27 0 0 0 .112-.108c.075-.042.179-.031.227-.124l-.024.029a.227.227 0 0 0 .123-.153c-.004-.034.009-.057.04-.07.042-.07.146-.054.183-.13.099-.083.07-.266.231-.298l.14-.126c.043-.074.148-.048.193-.118l-.006.004a.838.838 0 0 1 .115-.083.07.07 0 0 1 .076-.039.319.319 0 0 0 .149-.088.74.74 0 0 1 .449.01c.064.039.136.034.207.034.221-.052.467.09.673-.085l-.021.028a.231.231 0 0 0 .133-.139l-.022.012c.1-.111.245-.035.359-.088.067-.051.119-.135.224-.104a.324.324 0 0 0 .149.088c.032-.008.057.002.074.03.149.05.297.068.442-.014l-.011-.014c.093-.055.135-.156.205-.231.06-.045.117-.008.175.004l.17.009c.05-.044.102-.032.154-.005l.17.002a.307.307 0 0 0 .133-.114c.068-.048.173-.036.217-.126a.092.092 0 0 1 .018-.087c.03-.039.067-.073.092-.116.045-.026.079-.067.123-.095l.006-.005c.049-.075.175-.051.201-.157l.022-.182a.723.723 0 0 0-.005-.55zm-7.223 1.668c-.108.412-.47.645-.693.977a14.83 14.83 0 0 1-2.679 2.991c-.146.126-.313.378-.502.223-.126-.104-.374-.307-.17-.594.051-.073-.033-.242-.055-.366.081-.102.039-.238.094-.347.189-.204-.18-.278-.105-.473.061-.159.016-.329-.088-.47-.195-.264-.137-.497.072-.714-.161-.638.187-1.202.811-1.323.125-.024.378.043.211-.244-.068-.07-.068-.139.002-.208.188.001.31-.306.539-.115.193.188.386.281.579.001.431-.121.846-.26 1.319-.166.246.049.461.098.648.261-.048.084.012.155.028.23a.278.278 0 0 1-.017.118c-.035.076-.068.149.006.219zM148.786 149.456v-.117c.043-.111.059-.222-.014-.329-.025-.021-.031-.048-.018-.078-.044-.082-.029-.191-.116-.253-.02-.041-.054-.072-.074-.112l-.032-.183a.176.176 0 0 0-.141-.141c-.055-.012-.08-.047-.075-.103a.481.481 0 0 0-.107-.131l.001.001c-.037-.038-.072-.076-.119-.102-.026-.048-.065-.084-.104-.122l.001.001a.3.3 0 0 0-.15-.102c-.032.009-.056 0-.074-.028-.046-.032-.089-.07-.146-.083-.035.007-.061-.005-.077-.037a.731.731 0 0 1-.115-.083l.006.004c-.056-.074-.162-.053-.224-.115l.002.001c-.058-.071-.162-.05-.225-.112l.003.001c-.093-.108-.249-.017-.346-.109a.1.1 0 0 1-.099-.026c-.047-.029-.09-.067-.146-.079l-.186-.022c-.075-.057-.174-.047-.254-.088-.031.013-.057.006-.079-.019-.145-.103-.33-.002-.477-.093-.176.004-.353.031-.524-.032-.33-.104-.682.043-1.011-.085-.108.013-.218.025-.321-.026-.105-.067-.244.001-.345-.085a.108.108 0 0 1-.098-.016c-.177-.109-.394.022-.569-.095h-.303c-.366.137-.757-.031-1.124.095a1.75 1.75 0 0 1-.669 0c-.036-.032-.072-.032-.109 0a1.07 1.07 0 0 1-.559-.01c-.072-.044-.166-.03-.234-.085a.1.1 0 0 1-.099-.026c-.047-.029-.09-.067-.146-.079-.038.003-.064-.013-.079-.048-.043-.002-.066-.025-.069-.068a.073.073 0 0 1-.049-.077c-.012-.061-.05-.105-.088-.149a.108.108 0 0 1-.016-.098c-.057-.068-.036-.168-.095-.235l-.022-.189a2.469 2.469 0 0 1 .006-1.048.105.105 0 0 1 .016-.098c.084-.101.006-.247.095-.346a.1.1 0 0 1 .026-.099c.029-.047.067-.089.079-.146-.013-.029-.006-.054.018-.074a.297.297 0 0 0 .092-.15c-.012-.029-.005-.053.019-.072.064-.066.042-.167.099-.236a.1.1 0 0 1 .026-.099c.042-.079.041-.172.079-.253-.013-.03-.007-.057.018-.078.064-.066.042-.168.099-.236a.1.1 0 0 1 .026-.099c.047-.063.019-.159.096-.207l.007-.008c.025-.047.068-.08.097-.124l-.005.007c.075-.056.054-.162.115-.224l-.001.003c.074-.061.052-.167.11-.236a.098.098 0 0 1 .025-.098c.021-.043.061-.074.079-.12.074-.045.053-.154.13-.197l.008-.008c.074-.076.166-.137.202-.243a.098.098 0 0 1 .034-.1.29.29 0 0 1 .084-.103l.002-.003c.035-.042.076-.078.099-.127.067-.048.051-.151.125-.195l.007-.008a.53.53 0 0 1 .1-.111l.002-.003c.062-.058.035-.163.113-.211l.007-.008a.503.503 0 0 1 .1-.111l.002-.003c.034-.041.074-.077.098-.125.071-.053.059-.154.118-.213l-.001.003a.26.26 0 0 0 .103-.149c-.005-.034.008-.06.038-.075a.79.79 0 0 1 .083-.116l-.004.006c.074-.054.05-.161.119-.218l.001-.001a.564.564 0 0 1 .107-.094c.018-.028.043-.037.075-.028.062-.014.106-.055.151-.096l.003-.002a.565.565 0 0 1 .11-.103l.006-.006a.22.22 0 0 1 .098-.086.096.096 0 0 1 .1-.033c.106-.04.172-.126.24-.21l.003-.005c.039-.046.08-.09.094-.152-.011-.031-.003-.056.024-.074a.292.292 0 0 1 .096-.089l.045-.026.053.001a.718.718 0 0 0 .237-.187c.071-.049.146-.047.223-.02.082.049.157.063.213-.036l.018-.199c.059-.068.038-.167.095-.235a.102.102 0 0 1 .025-.1.39.39 0 0 0 0-.327.1.1 0 0 1-.025-.099c-.058-.068-.036-.17-.099-.236-.025-.022-.031-.048-.019-.079-.041-.081-.032-.179-.089-.254l-.022-.183a.224.224 0 0 0-.117-.148.24.24 0 0 0-.109-.105.333.333 0 0 0-.102-.119l.005.007c-.029-.044-.072-.078-.1-.124l-.006-.006c-.045-.028-.079-.07-.124-.1l.007.005c-.045-.07-.149-.043-.192-.118-.032-.013-.044-.037-.038-.071a.279.279 0 0 0-.113-.154l.011.016c-.054-.08-.162-.059-.225-.122l.002.001c-.068-.074-.173-.06-.254-.103-.031.013-.057.006-.078-.019-.099-.091-.248-.009-.347-.099a.105.105 0 0 1-.1-.026c-.226-.088-.473.022-.697-.079l-.047-.002c-.109.075-.253.01-.361.09a.108.108 0 0 1-.098.016.701.701 0 0 0-.237.189c-.015.033-.041.046-.076.04-.124.021-.188.117-.26.204l-.003.004c-.031.041-.069.076-.093.123a.253.253 0 0 0-.109.113.243.243 0 0 0-.112.112.248.248 0 0 0-.112.112.262.262 0 0 0-.115.111c-.044.019-.076.056-.116.08-.019.028-.043.037-.075.028-.058.013-.101.05-.146.083-.018.028-.043.037-.074.028-.062.014-.107.055-.153.094l-.004.003c-.048.068-.15.056-.198.125a.251.251 0 0 0-.118.112c-.047.024-.083.063-.123.096l-.003.002a.597.597 0 0 1-.11.103l-.006.006a.4.4 0 0 1-.105.104l-.007.006c-.043.069-.144.058-.189.125a.232.232 0 0 0-.122.115.25.25 0 0 0-.111.112.278.278 0 0 0-.115.108.45.45 0 0 0-.118.104l.004-.002c-.041.032-.075.073-.12.1l-.006.006a.45.45 0 0 1-.104.105l-.006.006a.378.378 0 0 1-.105.102l-.008.007c-.043.071-.144.059-.19.124a.25.25 0 0 0-.12.118.263.263 0 0 0-.112.107c-.047.025-.084.064-.121.103a2.905 2.905 0 0 0-.111.111h.001a.437.437 0 0 1-.108.084c-.016.031-.041.043-.075.039a.256.256 0 0 0-.149.102l.002-.001c-.063.062-.161.041-.225.098a.108.108 0 0 1-.098.016c-.099.089-.245.011-.346.095l-.19.022a.187.187 0 0 1-.178 0h-.265c-.098.035-.198.068-.163.208.029.02.038.046.029.08.099.146-.028.344.112.479l-.014-.015a.388.388 0 0 0 .12.115.222.222 0 0 0 .143.108l.04-.004.032.023c.043.042.088.08.15.091a.066.066 0 0 1 .075.03c.141.087.318-.016.456.088l.051-.004.047.021c.107.065.218.054.329.01l.046-.026h.053c.068-.058.174-.037.235-.11l-.003.001c.095-.096.244-.011.34-.102l.005-.003c.052-.074.16-.047.214-.118l-.003.001c.093-.096.239-.012.335-.098l.047-.02.051.004c.067-.056.172-.041.228-.117.046-.024.082-.062.123-.093l.004-.003c.053-.073.16-.047.214-.118l-.003.001c.063-.059.155-.044.224-.088l.046-.026.053.001c.068-.058.174-.037.235-.109.131-.058.263-.117.229.127a.107.107 0 0 1-.026.101c-.069.102.005.242-.088.337l-.022.107c-.042.079-.041.172-.079.252l-.032.191c-.042.08-.041.172-.079.253l-.032.191c-.045.072-.03.166-.085.234a.098.098 0 0 1-.026.099c-.044.072-.03.166-.085.234a.1.1 0 0 1-.026.099c-.042.079-.041.172-.079.253.013.03.006.057-.019.079-.087.107-.021.254-.093.365.013.031.006.057-.019.079-.087.108-.021.254-.092.366.013.031.006.057-.019.079-.108.136.01.321-.099.458a.108.108 0 0 1-.016.098c-.085.097-.002.243-.098.336l.001-.003c-.071.059-.051.162-.113.225l.001-.003c-.074.068-.06.173-.103.254.009.034-.001.061-.029.08-.047.078-.042.172-.082.253-.011.063-.021.128-.033.191-.067.105.001.244-.085.345l-.016.32c-.058.064-.037.163-.098.225l.001-.003c-.105.102-.028.255-.104.366.009.034 0 .06-.029.08-.033.046-.07.089-.083.146-.007.173-.015.345-.021.518-.032.041-.07.076-.096.121-.071.066-.069.136 0 .209l-.002-.002c.061.062.043.156.091.223.027.018.038.042.03.073a.203.203 0 0 0 .105.133l.004-.017c.001.009.004.016.007.024.006.002.009.008.016.01l-.013-.003c.018.048.058.08.095.113l-.001-.003c.061.063.042.166.109.226.06.067.163.048.225.109l-.002-.001c.035.039.07.077.119.099a.25.25 0 0 0 .114.115.234.234 0 0 0 .115.113c.052.07.152.06.21.119l-.003-.001c.069.074.173.06.255.103.036-.007.063.005.081.037.04.022.074.051.103.087l.003.002c.066.063.168.044.238.102l.051-.004.046.02c.076.057.174.048.254.089l.043-.005.036.023c.479.14.979-.044 1.457.099.44-.013.88-.038 1.319.016.073.053.146.053.22 0l.189-.022c.275-.064.551-.077.825.006l.211.026c.176.09.385-.031.556.088l-.003-.001c.108.088.221.074.334.01l.005-.003c.035-.041.073-.042.114-.01l-.007-.003a.237.237 0 0 0 .148.109l.04-.004.032.023c.037.033.072.068.12.087.051.079.148.073.22.114.025.05.066.088.108.124l-.001-.003c.06.065.045.162.097.23l.005.01c.08.046.05.156.121.207l-.001-.003c.062.063.041.161.098.225.042.186.042.372 0 .558-.065.107-.055.217-.01.328l.01.116c-.084.101-.006.247-.095.346a.1.1 0 0 1-.025.099c-.021.042-.059.073-.077.117a.288.288 0 0 0-.12.117c-.073.041-.171.034-.222.117-.062.047-.052.146-.123.187l-.008.008c-.045.08-.145.049-.205.1a.065.065 0 0 1-.074.03.298.298 0 0 0-.151.097h-.001c-.09.054-.156.135-.226.211l-.007.008a.327.327 0 0 1-.103.103l-.008.007c-.048.078-.157.049-.209.12l.003-.001c-.063.062-.168.041-.225.115l.007-.005c-.044.029-.077.072-.124.097l-.008.007c-.048.079-.151.048-.209.106h-.225c-.116-.038-.238-.111-.321.053.006.033-.006.058-.036.073a.17.17 0 0 1-.082.083l-.119.136c-.037.039-.077.075-.1.125-.073.04-.165.034-.23.093l-.003.002a.918.918 0 0 1-.108.108l-.002.003c-.064.074-.053.175-.095.257.013.03.007.056-.019.078l-.098.113a.421.421 0 0 0-.112.129l-.016.313c-.029.04-.071.072-.086.121a.25.25 0 0 0-.113.112.25.25 0 0 0-.121.125l.024-.017c-.088.068-.158.156-.245.226l.008-.018c-.136.139-.015.336-.11.485l-.001.481c.012.057.05.1.08.146a.1.1 0 0 1 .025.099c.058.068.038.175.116.233.253.108.509.069.766.015a.27.27 0 0 1 .227.01c.072.044.166.03.233.085l.292-.005c.047-.03.091-.026.131.014l.005.003c.114.063.226.081.333-.013l-.006.004a.607.607 0 0 1 .115-.08l.192-.04c.223-.108.477.024.699-.091l.327-.011c.063-.063.159-.041.227-.091.018-.028.042-.038.073-.03a.26.26 0 0 0 .15-.103l-.003.001c.061-.06.165-.045.217-.121.045-.019.078-.057.118-.083l.14-.126c.039-.064.13-.058.174-.116.085-.049.077-.149.118-.222a.268.268 0 0 0 .112-.119.251.251 0 0 0 .117-.113c.043-.019.075-.056.116-.08.02-.029.046-.039.08-.029.081-.039.174-.037.253-.079l.201-.028a.327.327 0 0 0 .133-.114.474.474 0 0 0 .222-.216l-.001.003a.41.41 0 0 0 .108-.123c.073-.042.175-.032.222-.122a.082.082 0 0 1 .037-.086c.128-.068.107-.229.198-.319l.008-.008c.045-.078.172-.054.196-.158-.012-.028-.006-.052.018-.071.036-.04.074-.076.101-.123l-.008.017c.142-.128.003-.329.118-.464a.1.1 0 0 1 .025-.099c.09-.147.149-.308.19-.475l.001-.049c-.007 0-.014-.017-.022-.049a.097.097 0 0 1 .026-.1l-.004.008c.078-.054.057-.162.119-.224l-.002.003c.075-.068.061-.173.104-.255l.032-.19c.044-.072.03-.166.085-.234l.026-.21c.044-.069.029-.161.088-.224l-.002.003c.105-.102.028-.255.104-.366-.011-.033-.001-.059.028-.078.242-.138.092-.405.194-.589l.006-.173c-.057-.065-.042-.159-.087-.231z\"/><path d=\"M139.76 152.928c-.067-.112-.017-.25-.079-.364-.051-.104-.039-.212-.026-.321-.086-.101-.019-.239-.085-.345l-.026-.21c-.126-.124.052-.349-.148-.448-.028.013-.05.007-.069-.017-.109-.076-.227-.138-.337-.213l.003.001c-.054-.07-.161-.044-.214-.118l-.004-.003c-.086-.051-.166-.074-.212.047.005.034-.007.058-.038.074a.227.227 0 0 1-.089.095l-.008.007c-.047.078-.159.05-.208.124l.005-.005a.384.384 0 0 0-.098.107c-.129.093-.041.258-.12.368l-.032.191c-.044.068-.029.161-.088.224l.001-.003c-.074.069-.06.173-.103.254.007.036-.006.063-.038.082a2.675 2.675 0 0 1-.079.126.098.098 0 0 1-.017.093c-.057.075-.047.174-.088.254.009.034-.001.06-.029.08-.032.046-.07.089-.083.146l-.022.186c-.065.107-.054.217-.01.329l.01.115c-.057.076-.048.174-.088.255.011.032.003.058-.024.079-.057.068-.037.167-.094.235a.098.098 0 0 1-.026.099c-.029.047-.067.09-.079.146.006.035-.006.061-.038.078a2.046 2.046 0 0 1-.079.126.095.095 0 0 1-.026.094c-.03.047-.067.09-.08.146l-.032.187c-.029.047-.067.089-.079.146a.063.063 0 0 1-.029.076c-.032.046-.07.089-.083.146.009.032 0 .058-.028.076-.033.046-.07.089-.083.146.013.029.007.054-.018.074-.062.063-.041.163-.103.226l.001-.003c-.074.069-.06.173-.103.254.007.036-.006.063-.038.082a2.932 2.932 0 0 1-.08.126.095.095 0 0 1-.026.094c-.029.047-.067.09-.08.146a.064.064 0 0 1-.028.076c-.032.046-.07.089-.083.146.013.029.007.054-.018.074a.297.297 0 0 0-.092.15c.007.031-.002.056-.03.074-.032.046-.07.089-.083.146.009.032-.001.057-.028.075-.024.042-.063.074-.082.119a.393.393 0 0 0-.122.104l.003-.001c-.102.06-.19.13-.215.254.007.036-.006.063-.038.081a2.046 2.046 0 0 1-.079.126.09.09 0 0 1-.034.095.14.14 0 0 1-.08.08c-.063.047-.1.02-.126-.042-.142-.145-.146.031-.2.087l.008-.016c-.112.105-.087.218-.02.333l.001.001c.039.04.041.081.006.124a.098.098 0 0 1-.034.1.233.233 0 0 1-.086.098l-.006.006c-.028.045-.07.08-.1.124l.005-.007a.242.242 0 0 0-.105.149c.005.034-.008.059-.039.075a2.046 2.046 0 0 1-.079.126.1.1 0 0 1-.016.093c-.03.038-.064.073-.083.119-.078.05-.074.144-.112.215-.088.063-.072.172-.116.255.013.03.007.056-.018.078-.095.088.002.241-.108.325l-.003.004c-.106.143-.201.29-.201.478l-.037.193a5.71 5.71 0 0 0-.082.13.083.083 0 0 1-.037.088c-.041.074-.151.052-.185.136a.1.1 0 0 1-.008.087c.211.292.034.72.343.977l.174.01a.306.306 0 0 0 .15-.092l.033-.022.04.005a.282.282 0 0 0 .154-.113l-.016.012a.24.24 0 0 0 .111-.151c-.005-.034.007-.059.038-.075a.722.722 0 0 1 .083-.116l-.004.006c.074-.05.045-.16.124-.208l.007-.008a.481.481 0 0 1 .101-.11l.002-.003c.041-.045.082-.09.096-.151-.009-.032 0-.057.028-.075.026-.045.071-.077.087-.129.075-.074.152-.146.219-.229l-.019.024c.094-.036.065-.159.146-.205l.008-.008c.076-.067.148-.137.214-.214l.008-.008c.045-.08.145-.049.205-.1a.063.063 0 0 1 .073-.03.262.262 0 0 0 .15-.102l-.003.001a.687.687 0 0 0 .23-.212l.003-.004c.031-.041.069-.077.093-.123a.26.26 0 0 0 .111-.116c.072-.052.062-.153.12-.212l-.001.003a.367.367 0 0 0 .099-.119.244.244 0 0 0 .119-.12c.066-.049.055-.149.123-.197l.002-.004c.039-.046.08-.091.094-.152-.007-.035.005-.06.037-.077a.672.672 0 0 1 .083-.115l-.004.006a.32.32 0 0 0 .105-.123c.072-.047.058-.152.127-.2l.004-.005a.377.377 0 0 1 .101-.094l.118-.131c.065-.055.034-.162.113-.209l.007-.008c.024-.047.068-.08.097-.124l-.005.006a.308.308 0 0 0 .101-.117c.083-.053.065-.161.123-.229a.1.1 0 0 1 .025-.099c.021-.042.059-.073.077-.117.078-.051.062-.157.123-.218l-.001.003c.074-.069.061-.173.103-.254-.009-.034.001-.06.029-.08.032-.046.07-.089.083-.146-.013-.029-.007-.054.018-.074.059-.064.05-.155.09-.227.08-.045.054-.158.131-.205l.007-.008a.365.365 0 0 1 .102-.105l.007-.007c.027-.045.069-.079.099-.123l-.005.007c.075-.059.057-.162.112-.23l-.004.008c.074-.056.066-.151.106-.224.078-.053.071-.15.111-.222.081-.052.062-.16.124-.223l-.001.003c.074-.069.06-.173.103-.255-.011-.032-.003-.059.024-.079.082-.102.005-.246.094-.346a.1.1 0 0 1 .025-.099c.044-.069.029-.161.088-.224l-.001.003c.071-.059.051-.162.112-.225l-.001.003c.074-.068.06-.173.103-.254v-.154c-.059-.202-.08-.403.006-.604 0-.093-.003-.188-.005-.283zM133.438 155.211a.403.403 0 0 0 .114-.1l-.003.001c.169-.126.388.017.559-.102l.032-.022.04.004c.104-.025.08-.152.157-.199l.007-.008a.327.327 0 0 1 .103-.103l.008-.007c.048-.078.145-.05.207-.096a.095.095 0 0 1 .09-.028.467.467 0 0 0 .135-.102h.001c.057-.069.181-.046.209-.154-.008-.031.002-.055.029-.072.024-.042.062-.073.081-.118a.37.37 0 0 0 .122-.108l-.007.006a.648.648 0 0 0 .117-.117c.073-.067.061-.169.103-.249-.013-.031-.006-.057.019-.079.062-.06.037-.162.105-.219v-.001c.064-.06.043-.163.111-.221l.001-.001c.036-.04.077-.076.108-.121l-.005.007a.25.25 0 0 0 .105-.149l.001-.144c-.013-.057-.05-.1-.083-.146-.028-.018-.037-.043-.028-.075-.015-.062-.056-.106-.097-.151l-.002-.003a.321.321 0 0 1-.087-.103c-.032-.018-.044-.045-.038-.081-.042-.082-.029-.183-.095-.256l-.118-.127c-.04-.025-.072-.062-.117-.082a.259.259 0 0 0-.105-.105.225.225 0 0 0-.149-.118c-.034.005-.059-.007-.075-.038a.665.665 0 0 1-.116-.083l.006.004a.352.352 0 0 0-.11-.097.224.224 0 0 0-.15-.12c-.032.007-.057-.002-.074-.03-.095-.077-.238.011-.323-.097l-.003-.001c-.076-.06-.176-.052-.258-.092-.032.011-.058.003-.078-.024-.035-.03-.071-.031-.108-.003-.207.027-.188.218-.254.348-.049.062-.137.055-.191.107l-.116.116a.292.292 0 0 0-.095.15c.012.029.005.053-.019.072-.062.058-.034.162-.108.214l-.003.004c-.058.066-.042.165-.102.229l.001-.003c-.104.102-.028.255-.103.366l-.032.191c-.042.08-.041.172-.079.253.013.03.006.057-.019.078-.063.073-.051.174-.092.255.012.03.006.057-.019.078-.089.103-.015.25-.096.355l-.029.202c-.044.072-.03.166-.085.233.01.027.01.055 0 .082.045.05.032.102.005.154l.002.153c.013.063.051.11.097.151a4.194 4.194 0 0 1-.005.112c-.063.066-.042.167-.099.236l-.025.207c-.04.077-.044.148.022.21.064.08.138.075.218.023h.225a.333.333 0 0 0 .149.088l.209-.098c.043-.075.151-.048.193-.124l-.011.013a.35.35 0 0 0 .12-.125zM132.442 141.455l-.002.001c.063-.062.167-.041.225-.112l-.003.001c.063-.063.184-.042.215-.15-.006-.033.006-.058.037-.073a.255.255 0 0 1 .089-.098l.006-.007a.597.597 0 0 1 .103-.11l.002-.003c.033-.041.075-.076.101-.123l.115-.08.046-.026.053.001c.068-.059.17-.036.235-.099l.033-.023.04.005a.291.291 0 0 0 .149-.101.3.3 0 0 0 .101-.149c.002-.053.03-.08.083-.083a.337.337 0 0 0 .151-.097l.003-.002a.918.918 0 0 1 .108-.108l.002-.003c.061-.074.059-.149.008-.227l-.009-.005c-.042-.029-.077-.067-.123-.09a.257.257 0 0 0-.105-.104.225.225 0 0 0-.149-.118c-.034.005-.059-.007-.074-.038a.321.321 0 0 1-.103-.087l-.003-.002a.332.332 0 0 0-.151-.096l-.186-.031c-.068-.044-.161-.029-.224-.088l.003.001c-.103-.092-.215-.063-.329-.024a4.102 4.102 0 0 0-.115.01c-.06-.058-.162-.03-.214-.104l-.005-.003c-.077-.06-.177-.052-.261-.091a.072.072 0 0 1-.079-.039.781.781 0 0 1-.115-.083l.006.004c-.057-.07-.148-.063-.22-.101-.082-.126-.245-.028-.339-.122-.088-.097-.01-.24-.095-.338a.108.108 0 0 1-.016-.098c-.086-.1-.016-.241-.088-.345-.028-.02-.038-.046-.029-.08-.046-.083-.022-.205-.141-.246-.051-.004-.078-.031-.081-.082a.227.227 0 0 0-.123-.153l.024.029c-.048-.094-.154-.081-.229-.125-.022-.049-.062-.083-.095-.124a.069.069 0 0 1-.017-.078c-.166-.174-.358-.075-.543-.055-.293.069-.589.038-.884.023-.062.063-.172.045-.223.127-.045.019-.081.054-.117.086-.019.024-.042.03-.071.018-.123.05-.103.125-.037.209l-.001-.003c.096.093.012.24.098.336v.114c-.089.091.005.241-.104.325l-.003.004c-.057.077-.061.152.011.223l-.001-.003c.048.045.033.094.008.144.011.035.002.064-.028.086-.049.07-.032.166-.088.234a.098.098 0 0 1-.026.099c-.042.079-.04.172-.079.253.009.034 0 .06-.029.08-.049.071-.032.166-.088.234l-.016.208c-.114.169.03.386-.102.552v.001a.465.465 0 0 1-.107.091.1.1 0 0 1-.099.025c-.098.093-.253.001-.346.109l.003-.001c-.063.062-.16.042-.225.097-.019.026-.044.034-.075.023-.057.012-.1.05-.146.08a.1.1 0 0 1-.099.025c-.068.059-.17.036-.235.099-.022.025-.048.031-.079.019-.081.043-.186.028-.254.103l.003-.001c-.063.062-.161.041-.225.098a.11.11 0 0 1-.098.016.327.327 0 0 1-.353.003c-.028-.045-.068-.08-.101-.121l-.002-.003c-.041-.032-.076-.071-.114-.106h.001c-.036-.038-.074-.073-.107-.114l-.002-.003a.534.534 0 0 1-.101-.111l-.007-.008c-.078-.047-.047-.15-.105-.208a.108.108 0 0 1-.016-.098c-.058-.068-.036-.168-.095-.235v-.114c.11-.176-.022-.393.095-.568a.104.104 0 0 1 0-.081c-.119-.214.009-.46-.085-.678a.27.27 0 0 1-.01-.227c.125-.286-.04-.604.097-.889a.26.26 0 0 0 .102-.149c-.007-.032.002-.057.03-.074.059-.22.059-.44 0-.66-.028-.019-.038-.044-.029-.077-.012-.057-.05-.099-.079-.146a.095.095 0 0 1-.026-.094 1.632 1.632 0 0 1-.077-.126c-.062-.1-.045-.209-.034-.317a.722.722 0 0 0-.101-.132l-.003-.002c-.107-.09-.256-.023-.368-.095l-.19-.023c-.109-.08-.253-.018-.365-.088-.036.007-.063-.006-.082-.038a2.675 2.675 0 0 1-.126-.079.096.096 0 0 1-.094-.026c-.047-.029-.09-.067-.146-.08l-.27-.004c-.091.037-.064.157-.142.203l-.007.008c-.028.047-.068.086-.093.135a.092.092 0 0 1 0 .076c.132.29-.028.611.095.902l.022.301c.039.081.036.174.079.253l.032.191c.084.149.004.325.079.475a.105.105 0 0 1 .026.1c.044.05.032.102.005.154l.001.604c.071.112.007.257.091.366.045.217.029.435.014.652.056.068.039.164.088.234.028.02.038.046.029.08.039.081.036.173.079.253l.026.21c.117.175-.015.392.095.568l.016.32c.058.068.036.168.095.236.021.03.027.062.016.097.056.068.039.164.088.234a.065.065 0 0 1 .03.074.26.26 0 0 0 .104.149l-.002-.004c.095.162.226.297.336.447l-.004-.006a.79.79 0 0 1 .083.116c.031.016.043.041.038.075a.246.246 0 0 0 .11.15.626.626 0 0 0 .101.111l-.001-.001c.036.037.07.075.101.116l.006.006a.27.27 0 0 1 .09.097l.138.131c.045.034.089.072.147.084.034-.006.06.006.076.037.041.024.08.052.115.083l-.006-.004c.066.078.173.063.254.106l.042-.005.036.023c.219.083.44.061.662.014.179-.064.362-.037.544-.026.043-.034.086-.033.129-.003a.239.239 0 0 0 .147.107l.04-.004.033.023c.055.05.141.044.19.105.049.073.048.148.01.225-.063.113-.012.251-.079.364l-.033.191c-.042.079-.04.172-.079.252l-.022.19c-.11.176.022.394-.095.568a.11.11 0 0 1-.013.098c-.089.1-.008.247-.098.347a.1.1 0 0 1-.026.1c-.075.15.005.326-.079.475 0 .249.039.5-.032.746-.029.047-.067.09-.079.146.008.032-.001.057-.029.076-.023.039-.057.07-.077.111a.228.228 0 0 0-.116.148c.008.032-.002.056-.029.073-.023.041-.061.072-.08.116a.258.258 0 0 0-.106.106.223.223 0 0 0-.118.148c.012.029.006.052-.019.071-.034.038-.071.074-.089.123-.076.046-.06.153-.13.203l-.003.004c-.029.039-.065.074-.089.117a.225.225 0 0 0-.114.147.067.067 0 0 1-.038.075.79.79 0 0 1-.083.116l.004-.006a.333.333 0 0 0-.097.111.228.228 0 0 0-.12.149c.005.034-.007.059-.038.074a.255.255 0 0 1-.089.098l-.006.006c-.028.045-.07.079-.1.124l.005-.007c-.074.05-.045.161-.124.208l-.007.008a.481.481 0 0 1-.101.11l-.002.003c-.033.04-.072.076-.096.123a.251.251 0 0 0-.109.112.252.252 0 0 0-.114.114c-.049.016-.081.057-.121.086a.092.092 0 0 1-.087.018c-.142.068-.029.243-.137.325v.001a1.01 1.01 0 0 1-.112.105l-.004.003c-.267.041-.265.265-.313.455-.077.048-.055.157-.127.208l-.003.004c-.032.042-.071.078-.095.125-.072.052-.059.154-.119.214l.001-.003c-.075.068-.061.173-.103.255.013.03.007.056-.019.078-.063.056-.03.162-.111.208l-.004.01c-.034.048-.076.092-.089.153.006.035-.005.06-.037.077a.32.32 0 0 1-.087.103l-.002.003c-.064.073-.053.175-.095.257l-.032.191c-.029.047-.067.089-.079.146.013.029.006.054-.018.074a.302.302 0 0 0-.092.15c.007.032-.003.057-.03.074-.049.071-.032.166-.088.234.011.03.01.06-.003.089.01 0 .019.014.029.042.009.028 0 .056-.029.084l-.011.327c-.056.071-.054.144-.01.219l.03.19c.067.113.017.25.079.364l.032.191c.042.081.031.179.089.254l.022.189c.07.112.009.256.088.366.043.142.031.287.016.431.114.176-.007.388.088.567a.062.062 0 0 1 .029.073.224.224 0 0 0 .117.148c.025.045.06.081.107.104.016.049.057.081.086.121a.094.094 0 0 1 .018.088.31.31 0 0 0 .115.134c.046.068.035.164.104.222l-.001-.003c.103.087-.008.26.134.331.071-.008.141-.012.196.046.071.035.057.131.123.17.018.047.058.079.083.122.028.019.037.043.028.076.012.057.05.099.08.146a.094.094 0 0 1 .026.094c.027.049.064.091.101.133l.003.002c.04.033.075.072.122.096a.255.255 0 0 0 .115.11.3.3 0 0 0 .11.122l-.013-.013c.043.076.15.053.196.126l.139.121c.067.06.167.038.235.096l.041-.008.041.008c.175-.118.392.015.568-.095l.209-.016c.07-.059.185-.037.235-.13.058-.049.05-.145.119-.186l.007-.008c.024-.047.068-.08.097-.124l-.005.007c.074-.049.044-.161.124-.206l.008-.008c.045-.08.153-.051.206-.118.148-.333-.025-.697.101-1.032l.022-.301c.065-.107.054-.217.01-.329l-.01-.115c.098-.143-.006-.325.092-.467-.01-.142-.029-.285.029-.422.029-.047.067-.09.08-.146-.006-.035.006-.061.037-.078.025-.043.052-.085.079-.126a.097.097 0 0 1 .026-.094c.041-.074.043-.147-.01-.218a.73.73 0 0 1 .01-.448c.045-.072.03-.166.085-.234-.011-.182-.039-.365.026-.543.044-.069.029-.161.088-.224l-.001.003c.044-.039.09-.077.109-.136l-.018.031c.136-.092.043-.26.124-.371-.009-.034 0-.061.029-.081.047-.076.04-.171.083-.249l-.001-.047c-.063-.272-.08-.543.008-.814.073-.068.06-.172.102-.253l.007-.618a.2.2 0 0 1 0-.251c-.013-.109-.025-.218.026-.322a.646.646 0 0 0 0-.438c-.051-.114-.072-.228.005-.34a.321.321 0 0 1 .087-.103l.002-.003c.083-.145.061-.293.016-.442a.102.102 0 0 1-.026-.1c-.036-.045-.035-.09-.001-.136l-.004.008c.081-.058.058-.167.116-.235-.011-.182-.039-.365.026-.543.03-.047.067-.09.08-.146-.013-.029-.007-.054.018-.075.118-.173-.019-.391.098-.564l-.003.008a.234.234 0 0 0 .108-.149c-.007-.032.002-.056.03-.074.033-.046.07-.089.083-.146-.009-.032.001-.057.028-.075.024-.042.063-.074.082-.119.075-.048.056-.155.127-.205l.003-.005c.058-.065.041-.165.102-.229l-.001.003a.266.266 0 0 0 .103-.149c-.012-.029-.005-.053.019-.072.059-.064.049-.157.091-.229a.15.15 0 0 0 .067-.109 1.77 1.77 0 0 0-.003-.206c-.029-.106-.036-.216-.045-.324a.248.248 0 0 0-.117-.163c-.188-.045-.188-.167-.129-.314l.016.012c.071-.058.051-.162.113-.225l-.001.003c.075-.068.06-.173.103-.254-.013-.03-.007-.057.019-.078.057-.063.05-.151.087-.222.089-.063.071-.173.116-.255-.005-.176-.032-.353.032-.524.021-.041.057-.072.076-.115.082-.055.063-.163.121-.231l.026-.209c.03-.047.067-.09.08-.146-.013-.029-.007-.054.018-.074.064-.065.041-.167.099-.236a.096.096 0 0 1 .034-.1.29.29 0 0 1 .084-.103l.002-.003c.034-.041.073-.076.097-.125a.363.363 0 0 0 .119-.105l-.006.004a.781.781 0 0 1 .115-.083c.017-.031.042-.043.077-.037.057-.013.101-.05.146-.083.019-.028.043-.038.076-.029.058-.012.101-.05.146-.082.017-.027.041-.037.073-.029.104-.025.081-.151.158-.199l.007-.007a.365.365 0 0 1 .102-.105l.006-.006a.252.252 0 0 1 .097-.089c.017-.031.042-.043.077-.037.057-.012.099-.05.146-.079l.043-.026h.051a2.4 2.4 0 0 1 .126-.079c.016-.031.041-.043.075-.039a.245.245 0 0 0 .148-.1zm-5.583 12.002c-.158.886-.342 1.767-.847 2.583-.037.06-.13.055-.161-.009-.382-.797-.535-1.595-.119-2.417.15-.297.319-.588.481-.881.088-.159.19-.352.428-.292.271.067.208.37.236.549a1.41 1.41 0 0 1-.018.467z\"/></g><g class=\"en\"><path d=\"M10.989 178.212v5.819h-.459c-.252-2.08-1.065-3.495-2.439-4.244a4.542 4.542 0 0 0-2.208-.583c-.856 0-1.567.261-2.131.785-.565.523-.847 1.116-.847 1.777 0 .525.178 1.001.534 1.428.497.595 1.716 1.417 3.661 2.463 1.622.873 2.697 1.517 3.227 1.93a4.706 4.706 0 0 1 1.321 1.601c.306.608.459 1.254.459 1.937 0 1.262-.49 2.354-1.471 3.275-.993.931-2.265 1.396-3.816 1.396-.53 0-.987-.033-1.372-.1-.235-.041-.771-.2-1.607-.478-.732-.24-1.239-.36-1.52-.36-.219 0-.381.061-.484.181-.132.115-.225.368-.279.757H1.08l.025-5.764h.453c.232 1.231.521 2.138.869 2.717.36.596.918 1.097 1.676 1.502.724.389 1.545.583 2.463.583.897 0 1.659-.229 2.283-.688.699-.509 1.048-1.195 1.048-2.06 0-.438-.109-.86-.329-1.267-.219-.405-.575-.796-1.067-1.173-.406-.31-1.287-.844-2.644-1.6-1.526-.854-2.552-1.487-3.078-1.905-.587-.468-1.043-.999-1.368-1.595s-.487-1.232-.487-1.911c0-1.212.463-2.253 1.39-3.121.927-.869 2.107-1.303 3.543-1.303.885 0 1.833.221 2.842.664.463.203.794.304.993.304a.84.84 0 0 0 .534-.18c.136-.136.238-.399.304-.788h.459zM17.623 177.777v8.314c.922-1.03 1.65-1.684 2.184-1.961a3.402 3.402 0 0 1 1.601-.403c.633 0 1.183.178 1.65.534.484.368.832.919 1.042 1.651.153.53.229 1.504.229 2.924v4.017c0 .704.06 1.196.18 1.478a.997.997 0 0 0 .428.484c.178.1.542.149 1.092.149v.452h-5.591v-.452l.255-.007c.542 0 .914-.076 1.117-.229.202-.152.348-.389.434-.707.017-.137.025-.528.025-1.173v-4.015c0-1.277-.058-2.091-.174-2.438-.256-.777-.809-1.166-1.657-1.166-.881 0-1.82.542-2.816 1.626v5.998c0 .612.01.977.031 1.093.07.394.262.675.577.845.215.115.622.174 1.222.174v.452h-5.646v-.452c.5 0 .899-.077 1.197-.229a.914.914 0 0 0 .403-.454c.104-.235.156-.711.156-1.427v-10.298c0-1.287-.036-2.086-.109-2.396-.072-.311-.164-.511-.276-.602-.124-.099-.301-.149-.533-.149-.17 0-.449.058-.837.174l-.174-.428 3.4-1.377h.59zM33.426 193.792c-1.158.889-1.895 1.406-2.209 1.551-.446.202-.92.304-1.421.304-.79 0-1.438-.265-1.942-.794s-.757-1.239-.757-2.128c0-.551.128-1.034.385-1.452.447-.728 1.351-1.423 2.711-2.085.645-.314 1.723-.744 3.233-1.29v-.46c0-1.146-.18-1.927-.54-2.345-.36-.418-.883-.627-1.57-.627-.517 0-.931.144-1.241.428-.335.307-.496.63-.484.969l.025.713c.013.385-.08.68-.276.885-.196.204-.452.308-.767.308-.322 0-.577-.103-.763-.305-.186-.203-.279-.499-.279-.888 0-.707.366-1.362 1.098-1.966.732-.604 1.748-.906 3.047-.906.992 0 1.822.178 2.488.533.492.261.848.657 1.067 1.191.153.368.229 1.098.229 2.19v3.859c0 1.051.025 1.713.075 1.985.045.24.112.401.202.483a.466.466 0 0 0 .332.125c.12 0 .231-.025.335-.075.186-.119.523-.426 1.011-.918v.714c-.93 1.236-1.82 1.854-2.668 1.854-.393 0-.711-.143-.956-.428s-.365-.759-.365-1.425zm0-.813v-4.351c-1.266.514-2.079.869-2.438 1.067-.617.34-1.072.719-1.365 1.139s-.44.855-.44 1.306c0 .584.18 1.076.54 1.478.36.401.766.602 1.216.602.627 0 1.457-.413 2.487-1.241zM41.591 186.116c1.319-1.593 2.589-2.389 3.81-2.389 1.294 0 2.184.66 2.668 1.98.169.464.254 1.228.254 2.291v4.854c0 .704.06 1.196.18 1.478a.97.97 0 0 0 .453.484c.182.1.557.149 1.123.149v.452h-5.646v-.452l.254-.007c.542 0 .915-.076 1.117-.229.203-.152.34-.389.41-.707.033-.145.05-.536.05-1.173V188.2c0-1.063-.127-1.82-.381-2.271-.254-.451-.71-.677-1.368-.677-.985 0-1.959.534-2.922 1.602v5.998c0 .778.042 1.254.124 1.428.116.244.277.423.484.534.182.1.587.149 1.216.149v.452H37.8v-.452l.254-.007c.646 0 1.07-.2 1.272-.602.136-.269.205-.771.205-1.508v-4.22c0-1.39-.027-2.219-.081-2.487-.062-.303-.163-.505-.304-.608-.116-.12-.285-.18-.509-.18-.236 0-.515.068-.837.205l-.174-.459 3.432-1.372h.534v2.391zM54.013 191.272c-1.44-.707-2.159-1.851-2.159-3.432 0-1.146.424-2.119 1.272-2.922.835-.794 1.919-1.191 3.251-1.191 1.087 0 2.029.263 2.823.788h2.414c.347 0 .553.008.617.024.063.017.104.05.121.1.05.087.075.224.075.409 0 .203-.025.346-.075.429a.15.15 0 0 1-.099.105c-.07.033-.283.05-.639.05h-1.471c.455.592.682 1.354.682 2.289 0 1.059-.403 1.963-1.21 2.712-.806.749-1.894 1.123-3.263 1.123a6.07 6.07 0 0 1-1.726-.255c-.628.546-.942 1.022-.942 1.428 0 .14.068.274.205.402.149.142.419.242.813.305.174.029.751.056 1.731.081 1.663.045 2.763.103 3.301.173.769.104 1.386.392 1.849.863.463.472.695 1.04.695 1.706 0 .935-.44 1.815-1.322 2.644-1.287 1.203-2.964 1.805-5.032 1.805-1.618 0-2.974-.364-4.07-1.092-.608-.405-.912-.829-.912-1.271a1.5 1.5 0 0 1 .124-.608c.12-.281.409-.705.869-1.272.091-.115.513-.564 1.266-1.346-.438-.269-.742-.5-.912-.692a1 1 0 0 1-.254-.685c-.001-.667.658-1.556 1.978-2.67zm-.124 4.145c-.422.46-.718.849-.887 1.167-.187.352-.279.69-.279 1.018 0 .4.236.749.707 1.042.815.51 2.011.764 3.586.764 1.498 0 2.595-.262 3.294-.785s1.049-1.082 1.049-1.679c0-.434-.203-.74-.608-.918-.422-.187-1.278-.296-2.568-.329-1.858-.051-3.289-.143-4.294-.28zm2.29-11.106c-.621 0-1.137.244-1.548.732s-.617 1.234-.617 2.24c0 1.311.281 2.329.843 3.052.422.543.973.813 1.651.813 1.439 0 2.16-.975 2.16-2.922 0-1.328-.288-2.362-.863-3.104-.423-.54-.965-.811-1.626-.811zM67.031 177.777v8.314c.922-1.03 1.65-1.684 2.184-1.961a3.402 3.402 0 0 1 1.601-.403c.633 0 1.183.178 1.651.534.484.368.831.919 1.042 1.651.153.53.229 1.504.229 2.924v4.017c0 .704.06 1.196.18 1.478a.992.992 0 0 0 .428.484c.178.1.542.149 1.093.149v.452h-5.591v-.452l.254-.007c.542 0 .914-.076 1.117-.229.203-.152.348-.389.434-.707.017-.137.025-.528.025-1.173v-4.015c0-1.277-.058-2.091-.173-2.438-.257-.777-.809-1.166-1.657-1.166-.881 0-1.82.542-2.817 1.626v5.998c0 .612.01.977.031 1.093.07.394.262.675.577.845.215.115.623.174 1.223.174v.452h-5.646v-.452c.5 0 .9-.077 1.197-.229a.914.914 0 0 0 .403-.454c.104-.235.155-.711.155-1.427v-10.298c0-1.287-.036-2.086-.109-2.396-.072-.311-.165-.511-.276-.602-.124-.099-.301-.149-.533-.149-.17 0-.449.058-.837.174l-.174-.428 3.4-1.377h.589zM82.833 193.792c-1.158.889-1.895 1.406-2.208 1.551a3.41 3.41 0 0 1-1.421.304c-.79 0-1.438-.265-1.941-.794-.505-.529-.757-1.239-.757-2.128 0-.551.128-1.034.384-1.452.447-.728 1.351-1.423 2.711-2.085.646-.314 1.723-.744 3.233-1.29v-.46c0-1.146-.18-1.927-.54-2.345-.36-.418-.883-.627-1.57-.627-.517 0-.931.144-1.24.428-.335.307-.497.63-.484.969l.025.713c.013.385-.08.68-.276.885a1.02 1.02 0 0 1-.767.308c-.323 0-.577-.103-.763-.305-.186-.203-.279-.499-.279-.888 0-.707.366-1.362 1.098-1.966.732-.604 1.748-.906 3.047-.906.992 0 1.822.178 2.488.533.492.261.848.657 1.067 1.191.153.368.229 1.098.229 2.19v3.859c0 1.051.025 1.713.075 1.985.045.24.112.401.202.483a.466.466 0 0 0 .332.125c.12 0 .232-.025.335-.075.186-.119.523-.426 1.011-.918v.714c-.93 1.236-1.82 1.854-2.667 1.854a1.2 1.2 0 0 1-.956-.428c-.245-.283-.368-.759-.368-1.425zm0-.813v-4.351c-1.266.514-2.079.869-2.438 1.067-.617.34-1.072.719-1.365 1.139-.294.42-.44.855-.44 1.306 0 .584.18 1.076.539 1.478.36.401.766.602 1.217.602.628 0 1.458-.413 2.487-1.241zM91.607 183.728v9.126c0 .741.042 1.217.125 1.428.095.24.248.418.459.534.182.1.554.149 1.117.149v.452h-5.516v-.452c.451 0 .761-.025.931-.075.294-.091.509-.294.646-.608.103-.24.155-.716.155-1.428v-4.371c0-1.263-.033-2.067-.099-2.415-.091-.476-.354-.714-.788-.714-.223 0-.504.068-.844.205l-.173-.459 3.431-1.372h.556zm-1.042-5.951c.355 0 .652.119.89.356.238.238.356.535.356.891 0 .348-.121.646-.363.896s-.537.376-.884.376c-.344 0-.642-.127-.894-.379a1.223 1.223 0 0 1-.379-.894c0-.343.126-.637.379-.881.254-.243.552-.365.895-.365zM110.699 195.417l-6.502-14.153V192.5c0 1.022.118 1.666.354 1.931.318.356.803.534 1.452.534h.583v.452h-5.845v-.452h.583c.728 0 1.237-.211 1.526-.634.169-.248.254-.859.254-1.832v-10.991c0-.761-.077-1.304-.229-1.626-.116-.248-.326-.45-.63-.605-.303-.156-.805-.233-1.504-.233v-.453h4.754l6.099 13.172 6.017-13.172h4.753v.453l-.583.006c-.724 0-1.232.213-1.526.639-.169.249-.254.856-.254 1.825V192.5c0 1.026.112 1.67.335 1.931.306.356.788.534 1.445.534h.583v.452h-7.136v-.452h.588c.726 0 1.231-.211 1.516-.634.186-.272.279-.884.279-1.831v-11.236l-6.502 14.153h-.41zM133.669 184.057v6.887c0 1.337.025 2.133.075 2.389.104.543.366.813.789.813.252 0 .539-.076.862-.229l.18.435-3.406 1.42h-.559v-2.413c-1.001 1.071-1.747 1.741-2.237 2.01a3.314 3.314 0 0 1-1.628.403c-.633 0-1.183-.186-1.651-.558-.488-.389-.818-.86-.99-1.415-.171-.554-.257-1.378-.257-2.47v-5.063c0-.849-.228-1.382-.683-1.602-.207-.099-.554-.148-1.042-.148h-.205v-.459h3.99v7.601c0 1.051.186 1.746.559 2.085.372.339.813.509 1.321.509.347 0 .755-.12 1.223-.36.45-.231.984-.655 1.601-1.271v-6.428c0-.654-.116-1.092-.348-1.315-.231-.224-.726-.344-1.482-.36v-.459h3.888zM143.733 183.703v3.884h-.409c-.257-1.01-.573-1.748-.95-2.215-.505-.621-1.212-.931-2.122-.931-.483 0-.916.12-1.297.359-.442.282-.664.651-.664 1.111 0 .455.137.854.409 1.197.29.364.815.729 1.576 1.092l1.799.862c1.68.807 2.519 1.891 2.519 3.252 0 .996-.387 1.83-1.16 2.5-.736.637-1.611.955-2.625.955-.687 0-1.53-.141-2.532-.422a2.327 2.327 0 0 0-.545-.086c-.187 0-.331.111-.435.335h-.403v-4.07h.403c.208 1.001.588 1.813 1.142 2.438.646.716 1.444 1.074 2.396 1.074.566 0 1.03-.168 1.39-.503.359-.335.54-.744.54-1.229 0-.563-.196-1.037-.586-1.424s-1.195-.878-2.41-1.474c-1.196-.587-1.984-1.129-2.364-1.626-.372-.483-.559-1.077-.559-1.78 0-.972.335-1.769 1.005-2.389.653-.608 1.471-.912 2.451-.912.467 0 1.009.093 1.625.278.451.137.73.206.838.206.137 0 .237-.036.304-.106.087-.05.172-.176.255-.378h.409zM148.176 188.325c0 1.688.416 3.01 1.248 3.965.839.969 1.814 1.452 2.922 1.452 1.526 0 2.626-.908 3.301-2.725l.384.255c-.166 1.117-.666 2.143-1.501 3.078-.848.947-1.898 1.42-3.152 1.42-1.348 0-2.511-.535-3.487-1.606-.976-1.071-1.464-2.5-1.464-4.288 0-1.745.43-3.181 1.291-4.306.952-1.245 2.273-1.867 3.965-1.867 1.282 0 2.324.413 3.127 1.24.815.84 1.222 1.968 1.222 3.382h-7.856zm0-.707h5.262c-.033-.728-.118-1.245-.254-1.552-.211-.472-.515-.835-.912-1.092s-.829-.385-1.296-.385c-.687 0-1.299.266-1.837.794-.539.531-.86 1.275-.963 2.235zM167.547 184.057v6.887c0 1.337.025 2.133.075 2.389.104.543.366.813.788.813.252 0 .54-.076.862-.229l.18.435-3.406 1.42h-.558v-2.413c-1.001 1.071-1.747 1.741-2.237 2.01-.49.27-1.033.403-1.628.403-.633 0-1.183-.186-1.65-.558-.488-.389-.818-.86-.99-1.415-.172-.554-.258-1.378-.258-2.47v-5.063c0-.849-.228-1.382-.683-1.602-.207-.099-.554-.148-1.042-.148h-.205v-.459h3.989v7.601c0 1.051.186 1.746.559 2.085.372.339.813.509 1.322.509.347 0 .755-.12 1.222-.36.451-.231.984-.655 1.601-1.271v-6.428c0-.654-.116-1.092-.348-1.315-.232-.224-.726-.344-1.483-.36v-.459h3.89zM173.646 186.142c.757-.762 1.247-1.235 1.47-1.421.417-.352.817-.606 1.198-.764.405-.17.829-.254 1.271-.254 1.576 0 2.532.813 2.867 2.438.86-1.019 1.58-1.679 2.159-1.982a3.823 3.823 0 0 1 1.805-.456c.637 0 1.179.149 1.626.449.447.301.813.819 1.098 1.556.186.479.279 1.235.279 2.266v4.88c0 .712.05 1.205.148 1.478.087.17.24.323.459.46.236.115.6.174 1.092.174v.452h-5.59v-.452l.229-.007c.86 0 1.378-.304 1.551-.912.033-.115.05-.515.05-1.197v-4.877c0-.951-.11-1.613-.329-1.985-.31-.525-.827-.788-1.551-.788-.856 0-1.83.518-2.922 1.552l-.025.155.025.534v5.414c0 .786.042 1.271.125 1.453.091.198.252.359.484.484.219.115.627.174 1.222.174v.452h-5.746v-.452c.646 0 1.081-.068 1.307-.205.225-.137.392-.364.499-.683.033-.138.05-.545.05-1.224v-4.88c0-.952-.134-1.622-.403-2.012-.364-.526-.873-.789-1.526-.789-.431 0-.871.121-1.322.36-.715.381-1.249.787-1.601 1.217v6.104c0 1.088.203 1.742.608 1.962.182.1.598.149 1.247.149v.452h-5.615v-.452c.504 0 .869-.05 1.092-.149.406-.24.608-.895.608-1.962v-4.347c0-1.263-.033-2.067-.1-2.415-.095-.492-.357-.738-.788-.738-.224 0-.494.068-.813.205l-.205-.459 3.432-1.396h.534v2.438z\"/></g></g></svg>";


(0, $54598d203dd72198$export$99ee26438460406a).registerPlugin((0, $d2b48baa8290cfe7$export$6953cc323644330b));
(0, $b3211a456c41491f$export$2e2bcd8739ae039)(location.href, "\u738B\u8C22\u5802\u71D5", "\u65B0\u65F6\u4EE3\u6700\u597D\u7684\u65E7\u6587\u4EBA", (0, (/*@__PURE__*/$parcel$interopDefault($02fc47684f44c282$exports))));
(0, (/*@__PURE__*/$parcel$interopDefault($jk9Tw)))(".m-cover").on("click", ".foreword-btn", function() {
    (0, $fLHXI.Fancybox).show([
        {
            src: "#foreword",
            type: "clone"
        }
    ], {
        autoFocus: false
    });
});
(0, (/*@__PURE__*/$parcel$interopDefault($jk9Tw)))(".m-cover").on("click", ".one", function() {
    (0, $54598d203dd72198$export$99ee26438460406a).to(window, {
        scrollTo: ".m-h1-home",
        duration: 1
    });
});
(0, (/*@__PURE__*/$parcel$interopDefault($jk9Tw)))(".m-cover").on("click", ".two", function() {
    (0, $54598d203dd72198$export$99ee26438460406a).to(window, {
        scrollTo: ".m-h1-sight",
        duration: 1
    });
});
(0, (/*@__PURE__*/$parcel$interopDefault($jk9Tw)))(".m-cover").on("click", ".three", function() {
    (0, $54598d203dd72198$export$99ee26438460406a).to(window, {
        scrollTo: ".m-h1-life",
        duration: 1
    });
});
(0, (/*@__PURE__*/$parcel$interopDefault($jk9Tw)))(".m-cover").on("click", ".four", function() {
    (0, $54598d203dd72198$export$99ee26438460406a).to(window, {
        scrollTo: ".m-h1-pen",
        duration: 1
    });
});
(0, (/*@__PURE__*/$parcel$interopDefault($jk9Tw)))(".m-h1").on("click", ".to-top-btn", function() {
    (0, $54598d203dd72198$export$99ee26438460406a).to(window, {
        scrollTo: 0,
        duration: 1
    });
});
const $dd635f89e8894e27$var$slideTemplate = (0, (/*@__PURE__*/$parcel$interopDefault($adylO))).compile((0, (/*@__PURE__*/$parcel$interopDefault($jk9Tw)))("#slide-template").html());
function $dd635f89e8894e27$var$slide(type, target) {
    (0, (/*@__PURE__*/$parcel$interopDefault($jk9Tw)))($dd635f89e8894e27$var$slideTemplate((0, (/*@__PURE__*/$parcel$interopDefault($2Dfnu))).pickBy((0, $6Mm5x.default), function(v, k) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($2Dfnu))).startsWith(k, type);
    }))).insertAfter(target);
}
$dd635f89e8894e27$var$slide("life1", "#slide-title-life1");
$dd635f89e8894e27$var$slide("life2", "#slide-title-life2");
$dd635f89e8894e27$var$slide("life3", "#slide-title-life3");
$dd635f89e8894e27$var$slide("life4", "#slide-title-life4");
$dd635f89e8894e27$var$slide("pen1", "#slide-intro-pen1");
$dd635f89e8894e27$var$slide("pen2", "#slide-intro-pen2");
(0, (/*@__PURE__*/$parcel$interopDefault($jk9Tw)))(".f-carousel").each(function(i, el) {
    new (0, $5MibD.Carousel)(el, {
        Dots: false,
        Navigation: false,
        Autoplay: {
            showProgress: false,
            timeout: 5000
        }
    }, {
        Autoplay: $58535dd16cea4d69$export$6c96167f46662e38
    });
});
(0, (/*@__PURE__*/$parcel$interopDefault($jk9Tw)))(".f-carousel").on("click", ".m-image", function(e) {
    new (0, $fLHXI.Fancybox)([
        {
            src: "collection.html#" + (0, (/*@__PURE__*/$parcel$interopDefault($jk9Tw)))(e.target).data("id"),
            type: "iframe"
        }
    ], {
        Html: {
            autoSize: false
        }
    });
});
(0, (/*@__PURE__*/$parcel$interopDefault($jk9Tw)))(".m-logo").html((0, (/*@__PURE__*/$parcel$interopDefault($bf1a0ed6c4f03446$exports))));

})();
//# sourceMappingURL=index.5a08f2d0.js.map
